webpackJsonp([1],{

/***/ "++Es":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/38I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/files/DeleteLinkedFiles.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var DeleteLinkedFiles = ({
    data: function data() {
        return {
            dialog: false,
            item: '',
            entity: '',
            entity_id: '',
            loading: false
        };
    },

    methods: {
        // when modal is open
        open: function open(field, item, entity_id) {
            this.dialog = true;
            this.entity = field;
            this.item = item;
            this.entity_id = entity_id;
        },

        // when form is validate
        onValidate: function onValidate() {
            var _this = this;

            this.loading = true;
            if (this.item.id) {
                this.axios.delete('/api/' + this.entity + '/' + this.entity_id + '/file/' + this.item.id).then(function (response) {
                    _this.$emit('deleted', _this.entity_id, _this.item.id);
                    _this.dialog = false;
                    _this.loading = false;
                });
            } else {
                this.$emit('deleted', this.entity_id, this.item);
                this.dialog = false;
                this.loading = false;
            }
        },
        onClose: function onClose() {
            // reset the form on close
            if (this.$refs.form) {
                this.$refs.form.reset();
            }
            this.dialog = false;
            this.loading = false;
        }
    },
    mounted: function mounted() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a6bc122","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/files/DeleteLinkedFiles.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"750px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"warning"},[_c('h2',[_c('v-icon',{staticClass:"mr-2",attrs:{"dark":""}},[_vm._v("warning")]),_vm._v(" "),_c('span',[_vm._v("Supprimer un fichier joint")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","icon":""},on:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("close")])],1)],1),_vm._v(" "),_c('div',{staticClass:"pa-3"},[_c('p',[_vm._v("Êtes-vous sur de vouloir supprimer le Fichier "),(_vm.item.label)?[_vm._v("suivant :")]:_vm._e()],2),_vm._v(" "),(_vm.item.label)?_c('ul',{staticClass:"ml-3"},[_c('li',[_vm._v("\n                "+_vm._s(_vm.item.label)+"\n            ")])]):_vm._e()]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"warning","small":"","round":"","outline":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"warning","small":"","round":"","text-color":"white","loading":_vm.loading},on:{"click":_vm.onValidate}},[_vm._v("Valider")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var files_DeleteLinkedFiles = (esExports);
// CONCATENATED MODULE: ./src/components/files/DeleteLinkedFiles.vue
function injectStyle (ssrContext) {
  __webpack_require__("sgbh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9a6bc122"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  DeleteLinkedFiles,
  files_DeleteLinkedFiles,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_files_DeleteLinkedFiles = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/3V0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/WHI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/filters/pluralize.js
var pluralize = __webpack_require__("21OC");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DataTable.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var DataTable = ({

    props: {
        headers: {
            type: Array, required: true
        },
        endpoint: {
            type: Object, required: false
        },
        toolbar: {
            type: Array, required: false
        },
        actions: {
            type: Array, required: false
        },
        views: {
            type: Array, required: false
        },
        selectable: {
            type: Boolean, default: false
        },
        storeId: {
            type: String, required: true
        },
        isFixed: {
            type: Boolean, required: false, default: true
        },
        customRouteName: {
            type: String, required: false, default: ''
        }
    },

    data: function data() {
        return {
            items: [],
            selected: [],
            loading: true,
            totalItems: 0,
            pagination: {
                page: 1,
                sortBy: 'updated_at',
                descending: true
            },
            pagination_watching: false,
            per_page: [10, 20, 50],
            noDataText: 'Chargement des données en cours...',
            scrollPosition: ''
        };
    },


    computed: {
        // get the name of the catual view -- for the breadcrumbs
        name: function name() {
            var _this = this;

            var title = void 0;
            this.views.forEach(function (v) {
                if (v.link == _this.$route.name) {
                    title = v.text;
                }
            });
            return title;
        },
        type: function type() {
            var type = this.$route.path.split('/');
            return type[1];
        }
    },

    methods: {
        // Create the axios get request from props given
        getDataFromApi: function getDataFromApi() {
            var _this2 = this;

            if (this.endpoint) {

                this.loading = 'accent';

                var _pagination = this.pagination,
                    sortBy = _pagination.sortBy,
                    descending = _pagination.descending,
                    page = _pagination.page,
                    rowsPerPage = _pagination.rowsPerPage;


                var api_url = this.endpoint.base + '?';

                var cPage = page;
                if (this.$store.state.datatable[this.storeId] && this.$store.state.datatable[this.storeId].page) {
                    cPage = this.$store.state.datatable[this.storeId].page;
                    this.pagination.page = cPage;
                }

                if (rowsPerPage > -1) {
                    api_url += '&page=' + cPage + '&per_page=' + rowsPerPage;
                }

                if (this.endpoint.filters) {
                    api_url += '&filters=' + this.endpoint.filters;
                }

                if (this.endpoint.metas) {
                    api_url += '&metas=' + this.endpoint.metas;
                }

                if (this.endpoint.embed) {
                    api_url += '&embed=' + this.endpoint.embed;
                }

                var cSortBy = sortBy;
                var cDescending = descending;
                if (this.$store.state.datatable[this.storeId] && this.$store.state.datatable[this.storeId].sortBy) {
                    cSortBy = this.$store.state.datatable[this.storeId].sortBy;
                    this.pagination.sortBy = cSortBy;

                    cDescending = this.$store.state.datatable[this.storeId].descending;
                    this.pagination.descending = cDescending;
                }

                if (this.endpoint.order) {
                    cSortBy = this.endpoint.order;
                    cDescending = this.endpoint.cDescending;
                }

                if (cSortBy != null) {
                    api_url += '&order=' + cSortBy + '|';
                    api_url += cDescending ? 'DESC' : 'ASC';
                }
                this.axios.get(api_url).then(function (response) {
                    _this2.totalItems = response.data.count;
                    if (_this2.endpoint.dataRoot) {
                        _this2.items = response.data.data[_this2.endpoint.dataRoot];
                    } else {
                        _this2.items = response.data.data;
                    }
                    _this2.loading = false;
                    _this2.pagination_watching = true;

                    if (_this2.totalItems == 0) {
                        _this2.noDataText = 'Aucune donnée...';
                    }

                    _this2.$emit('total_updated', _this2.totalItems);
                    _this2.$eventHub.$emit('getItems', _this2.items);
                }).catch(function (error) {
                    _this2.loading = 'warning';
                    _this2.noDataText = 'Le chargement des données a échoué !';
                });
            } else {
                return null;
            }
        },
        rowClick: function rowClick(item) {
            // when click on row
            this.$emit('rowClick', item);
        },
        setPagination: function setPagination() {
            var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
            var sortBy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'updated_at';
            var descending = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

            this.pagination.page = page;

            if (sortBy != 'updated_at') {
                this.pagination.sortBy = sortBy;
            }

            if (descending != true) {
                this.pagination.descending = descending;
            }

            this.$store.dispatch('setPagination', { tableId: this.storeId, page: page, sortBy: sortBy, descending: descending });
        },
        onScroll: function onScroll(e) {
            this.scrollPosition = e.target.scrollTop;
        },
        reload: function reload() {
            this.getDataFromApi();
            this.selected = [];
        }
    },

    watch: {
        pagination: function pagination() {
            if (this.pagination_watching) {
                this.setPagination(this.pagination.page, this.pagination.sortBy, this.pagination.descending);
                this.getDataFromApi();
            }
        },

        selected: function selected(val) {
            this.$store.dispatch('setSelected', { tableId: this.storeId, selected: val });
        }
    },

    created: function created() {
        this.$store.dispatch('clearSelected', { tableId: this.storeId });
    },
    mounted: function mounted() {
        this.getDataFromApi();
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5da63767","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DataTable.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"datatable"},[(_vm.toolbar)?_c('transition',{attrs:{"name":"fade"}},[(_vm.selectable && _vm.selected.length)?_c('v-toolbar',{attrs:{"fixed":"","flat":"","color":"primary","transition":"slide-y-transition"}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.selected = []}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.selected.length)+" "+_vm._s(_vm._f("pluralize")(_vm.selected.length,'sélectionné'))+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_vm._l((_vm.toolbar),function(tool){return [((tool.level && tool.level <= _vm.$store.state.auth.user.level) || !tool.level)?[(tool.text)?[_c('v-btn',{attrs:{"round":"","light":"","depressed":"","small":""},on:{"click":tool.callback}},[_vm._v(_vm._s(tool.text))])]:[(tool.dropdown)?[_c('v-menu',{staticClass:"select_action",attrs:{"offset-y":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":""},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v(_vm._s(tool.icon))])],1),_vm._v(" "),_vm._l((tool.dropdown),function(dropdown,index){return _c('v-list',{key:index},[_c('v-list-tile',{staticClass:"li",on:{"click":dropdown.callback}},[_vm._v(_vm._s(dropdown.text))])],1)})],2)]:[_c('v-btn',{staticClass:"select_action",attrs:{"flat":""},on:{"click":tool.callback}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v(_vm._s(tool.icon))])],1)]]]:_vm._e()]})],2):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.views)?_c('v-breadcrumbs',{attrs:{"id":"breadcrumbs"}},[_c('v-icon',{attrs:{"slot":"divider"},slot:"divider"},[_vm._v("chevron_right")]),_vm._v(" "),_c('v-breadcrumbs-item',[_c('router-link',{attrs:{"to":{ name: _vm.views[0].link }}},[_vm._v(_vm._s(_vm.type)+_vm._s(_vm.customRouteName))])],1),_vm._v(" "),_c('v-breadcrumbs-item',[_vm._v("\n            "+_vm._s(_vm.name)+"\n        ")])],1):_vm._e(),_vm._v(" "),(_vm.views || _vm.actions)?_c('div',{directives:[{name:"scroll",rawName:"v-scroll",value:({target: '#scroll-target', callback: this.onScroll}),expression:"{target: '#scroll-target', callback: this.onScroll}"}],staticClass:"action_bar",class:{'fixed': _vm.scrollPosition > 90 && _vm.isFixed}},[(_vm.views)?_c('div',{staticClass:"views"},[_c('v-menu',{attrs:{"offset-y":""}},[_c('div',{staticClass:"view_title",attrs:{"slot":"activator"},slot:"activator"},[_vm._v(_vm._s(_vm.name)+" ("+_vm._s(_vm.totalItems)+")\n                    "),_c('v-icon',[_vm._v("arrow_drop_down")])],1),_vm._v(" "),(_vm.views && _vm.views.length)?_c('v-list',{staticClass:"view-list"},_vm._l((_vm.views),function(view,index){return _c('v-list-tile',{key:index,staticClass:"li"},[[_c('router-link',{staticClass:"view_menu",attrs:{"to":{ name: view.link }},nativeOn:{"click":function($event){_vm.selected = []}}},[_vm._v("\n                                "+_vm._s(view.text)+"\n                            ")])],_vm._v(" "),(index > 0 && index < (view.length - 1))?_c('v-divider'):_vm._e()],2)})):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.actions)?_c('div',{staticClass:"actions"},[_vm._l((_vm.actions),function(action){return [((action.level && action.level <= _vm.$store.state.auth.user.level) || !action.level)?[(action.dropdown)?[_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{staticClass:"dropdown",attrs:{"slot":"activator","round":"","color":"primary","depressed":"","small":""},slot:"activator"},[_vm._v("\n                                "+_vm._s(action.text)+"\n                                "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v(_vm._s(action.icon))])],1),_vm._v(" "),_vm._l((action.dropdown),function(dropdown,index){return _c('v-list',{key:index},[_c('v-list-tile',{staticClass:"li"},[_c('v-list-tile-content',{on:{"click":dropdown.callback}},[_vm._v(_vm._s(dropdown.text))])],1)],1)})],2)]:[_c('v-btn',{staticClass:"normal",attrs:{"round":"","outline":"","color":"primary","small":""},on:{"click":action.callback}},[_c('v-icon',{attrs:{"left":"","color":"primary"}},[_vm._v(_vm._s(action.icon))]),_vm._v("\n                            "+_vm._s(action.text)+"\n                        ")],1)]]:_vm._e()]})],2):_vm._e()],1):_vm._e(),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"pagination":_vm.pagination,"total-items":_vm.totalItems,"loading":_vm.loading,"rows-per-page-items":_vm.per_page,"select-all":_vm.selectable ? 'accent' : false,"hide-actions":_vm.totalItems <= _vm.per_page[0],"no-data-text":_vm.noDataText,"rows-per-page-text":"Eléments par page :"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{on:{"click":function($event){$event.stopPropagation();_vm.rowClick(props.item)}}},[(_vm.selectable)?_c('td',{staticClass:"checkbox",on:{"click":function($event){$event.stopPropagation();}}},[_c('v-checkbox',{attrs:{"hide-details":"","color":"accent"},model:{value:(props.selected),callback:function ($$v) {_vm.$set(props, "selected", $$v)},expression:"props.selected"}})],1):_vm._e(),_vm._v(" "),_vm._t("items",null,null,props)],2)]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_DataTable = (esExports);
// CONCATENATED MODULE: ./src/components/DataTable.vue
function injectStyle (ssrContext) {
  __webpack_require__("lH7U")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5da63767"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  DataTable,
  components_DataTable,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_DataTable = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/bO6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/iAd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/files/CreateFiles.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var CreateFiles = ({
    props: {
        params: {
            required: false
        }
    },
    data: function data() {
        return {
            title: 'Ajouter un fichier',
            icon: 'file_upload',
            warning: false,
            isValid: false,
            disableEnter: false,
            model: {
                label: ''
            },
            file: '',
            rules: {
                name: [function (v) {
                    return !!v || 'Nom du fichier obligatoire';
                }]
            },
            file_name: 'Choisir un fichier',
            tags: []
        };
    },

    methods: {
        // when file chage in input
        UploadFile: function UploadFile(event) {
            this.file = event.target.files[0];
            this.file_name = this.file.name;
            this.model.label = this.file.name.split('.')[0];
        },

        // on click on btn -- click on hidden input
        openInput: function openInput() {
            this.$refs.fileInput.click();
        },

        // when form is validate
        onValidate: function onValidate() {
            var _this = this;

            if (this.$refs.form.validate()) {
                this.attachment = this.file;
                // create data object
                var data = new FormData();
                // put file & size inside (resize on back)
                data.append('file', this.attachment);
                data.append('size', 750);
                // post file
                this.axios.post('/api/' + this.params.entity + '/' + this.$route.params.id + '/file', data, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(function (response) {
                    // modify the file with name
                    _this.axios.put('/api/files/' + response.data.id, _this.model).then(function (response) {
                        _this.$eventHub.$emit('reload-list');
                        _this.$store.dispatch('updateSingleData', { key: 'files_count', value: _this.$store.state.single.data.files_count + 1 });
                        _this.onClose();
                    });
                }).catch(function (error) {});
            }
        },
        onClose: function onClose() {
            // reset the form on close
            if (this.$refs.form) {
                this.$refs.form.reset();
            }
            this.$eventHub.$emit('close-modal');
        }
    },
    mounted: function mounted() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06918ad4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/files/CreateFiles.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();}},model:{value:(_vm.isValid),callback:function ($$v) {_vm.isValid=$$v},expression:"isValid"}},[_c('v-container',{attrs:{"grid-list-xs":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[_c('v-btn',{attrs:{"color":"primary","outline":"","round":""},nativeOn:{"click":function($event){_vm.openInput($event)}}},[_vm._v("\n                    "+_vm._s(_vm.file_name)+"\n                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("cloud_upload")])],1),_vm._v(" "),_c('input',{ref:"fileInput",staticStyle:{"display":"none"},attrs:{"type":"file"},on:{"change":_vm.UploadFile}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Nom","rules":_vm.rules.name,"required":"","autofocus":""},model:{value:(_vm.model.label),callback:function ($$v) {_vm.$set(_vm.model, "label", $$v)},expression:"model.label"}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var files_CreateFiles = (esExports);
// CONCATENATED MODULE: ./src/components/files/CreateFiles.vue
function injectStyle (ssrContext) {
  __webpack_require__("YlpI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06918ad4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  CreateFiles,
  files_CreateFiles,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_files_CreateFiles = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/kPH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "08vo":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNjYgODciPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuYSB7CiAgICAgICAgZmlsbDogI2YyZjRmNTsKICAgICAgfQoKICAgICAgLmIgewogICAgICAgIGZpbGw6ICNlM2U0ZWE7CiAgICAgIH0KCiAgICAgIC5jIHsKICAgICAgICBmaWxsOiAjZDBkNGQ3OwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8dGl0bGU+U3BsaXQ8L3RpdGxlPgogIDxnPgogICAgPGc+CiAgICAgIDxyZWN0IGNsYXNzPSJhIiB4PSIxIiB5PSIxIiB3aWR0aD0iMTY0IiBoZWlnaHQ9Ijg1IiByeD0iMTkuNjgzNTkiIHJ5PSIxOS42ODM1OSIvPgogICAgICA8cGF0aCBjbGFzcz0iYiIgZD0iTTE0NS4zMTY0MSwyQTE4LjcwNDc0LDE4LjcwNDc0LDAsMCwxLDE2NCwyMC42ODM1OVY2Ni4zMTY0MUExOC43MDQ3NSwxOC43MDQ3NSwwLDAsMSwxNDUuMzE2NDEsODVIMjAuNjgzNTlBMTguNzA0NzcsMTguNzA0NzcsMCwwLDEsMiw2Ni4zMTY0MVYyMC42ODM1OUExOC43MDQ3NiwxOC43MDQ3NiwwLDAsMSwyMC42ODM1OSwySDE0NS4zMTY0MW0wLTJIMjAuNjgzNTlBMjAuNjgzNTgsMjAuNjgzNTgsMCwwLDAsMCwyMC42ODM1OVY2Ni4zMTY0MUEyMC42ODM1OCwyMC42ODM1OCwwLDAsMCwyMC42ODM1OSw4N0gxNDUuMzE2NDFBMjAuNjgzNiwyMC42ODM2LDAsMCwwLDE2Niw2Ni4zMTY0MVYyMC42ODM1OUEyMC42ODM2LDIwLjY4MzYsMCwwLDAsMTQ1LjMxNjQxLDBaIi8+CiAgICA8L2c+CiAgICA8cmVjdCBjbGFzcz0iYyIgeD0iMjAiIHk9IjE2IiB3aWR0aD0iNTgiIGhlaWdodD0iNTUiIHJ4PSIxMi43MzA0MiIgcnk9IjEyLjczMDQyIi8+CiAgICA8cmVjdCBjbGFzcz0iYyIgeD0iODkiIHk9IjE2IiB3aWR0aD0iNTgiIGhlaWdodD0iNTUiIHJ4PSIxMi43MzA0MiIgcnk9IjEyLjczMDQyIi8+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "0T99":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0iIH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0xHd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "21OC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('pluralize', function (value, singular, plural) {
    if (value > 1) {
        if (plural) {
            return plural;
        } else {
            return singular + 's';
        }
    } else {
        return singular;
    }
});

/***/ }),

/***/ "22+B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CommentTypes; });
var CommentTypes = [{ color: '#8BEA67', value: 'positiv', label: 'Positive' }, { color: '#FF3D62', value: 'negativ', label: 'Négative' }, { color: '#D4DCE5', value: 'all', label: 'Neutre' }];

/***/ }),

/***/ "2HSc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2XbI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/single/SingleCard.vue + 2 modules
var SingleCard = __webpack_require__("teBh");

// EXTERNAL MODULE: ./src/components/SingleField.vue + 3 modules
var SingleField = __webpack_require__("SIDS");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/products/single/features/Delete.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Delete = ({
    props: {
        params: {
            required: true
        }
    },

    data: function data() {
        return {
            title: 'Supression d\'une information',
            icon: 'delete',
            warning: true
        };
    },


    methods: {
        onClose: function onClose() {
            this.$eventHub.$emit('close-modal');
        },
        onValidate: function onValidate() {
            var _this = this;

            this.axios.delete('/api/features/' + this.params.feature.id).then(function (response) {
                _this.$eventHub.$emit('close-modal');
                _this.$eventHub.$emit('reload-single');
            }).catch(function (error) {
                console.log(error.response.data || error);
            });
        }
    }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a7678e4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/single/features/Delete.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('p',[_vm._v("Êtes-vous sûr de vouloir supprimer cette information ?")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.params.feature.label))])])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var features_Delete = (esExports);
// CONCATENATED MODULE: ./src/views/products/single/features/Delete.vue
function injectStyle (ssrContext) {
  __webpack_require__("V28u")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a7678e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Delete,
  features_Delete,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var single_features_Delete = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/products/single/features/Feature.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Feature = ({
    props: {
        index: {
            required: true,
            type: Number
        }
    },

    data: function data() {
        return {
            model: {},
            buffer: {},
            editing: false,
            loading: false,

            rules: {
                label: [function (v) {
                    return !!v || 'Libellé obligatoire';
                }]
            },

            Delete: single_features_Delete
        };
    },


    methods: {
        cancel: function cancel() {
            if (this.model.id) {
                this.buffer = {};
                this.editing = false;
            } else {
                this.$store.dispatch('removeSingleData', { key: 'features[' + this.index + ']' });
            }
        },
        validate: function validate() {
            var _this = this;

            // when modify a prevouisly created feature
            if (this.buffer.id) {
                delete this.buffer.id;

                this.axios.put('/api/features/' + this.model.id, this.buffer).then(function (res) {
                    _this.$store.dispatch('updateSingleData', { key: 'features[' + _this.index + ']', value: res.data });
                    _this.model = res.data;
                    _this.editing = false;
                }).catch(function (err) {
                    return console.log(err.response.data);
                });
            } else {
                // create a new feature
                this.axios.post('/api/features', this.buffer).then(function (res) {
                    _this.$store.dispatch('updateSingleData', { key: 'features[' + _this.index + ']', value: res.data });
                    _this.model = res.data;
                    _this.editing = false;
                }).catch(function (err) {
                    return console.log(err.response.data);
                });
            }
        },

        // set the visibility in the export of this feature
        setVisibility: function setVisibility(is_visible) {
            var _this2 = this;

            this.axios.put('/api/features/' + this.model.id, { is_exportable: is_visible ? 1 : 0 }).then(function (res) {
                _this2.$store.dispatch('updateSingleData', { key: 'features[' + _this2.index + ']', value: res.data });
                _this2.model = res.data;
            }).catch(function (err) {
                return console.log(err.response.data);
            });
        },
        edit: function edit() {
            this.buffer = assign_default()({}, this.model);
            this.editing = true;
        }
    },

    created: function created() {
        if (Array.isArray(this.$store.state.single.data.features)) {
            this.model = this.$store.state.single.data.features[this.index];

            if (this.model.id == undefined) {
                this.edit();
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6485c9e8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/single/features/Feature.vue
var Feature_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feature field",class:{ 'edit': _vm.editing, 'view' : !_vm.editing },attrs:{"data-group":"1"}},[(_vm.editing)?[_c('div',{staticClass:"label"},[_c('v-text-field',{attrs:{"placeholder":"Libellé","rules":_vm.rules.label,"required":"","autofocus":""},model:{value:(_vm.buffer.label),callback:function ($$v) {_vm.$set(_vm.buffer, "label", $$v)},expression:"buffer.label"}})],1),_vm._v(" "),_c('div',{staticClass:"value"},[_c('v-text-field',{attrs:{"placeholder":"Valeur"},model:{value:(_vm.buffer.value),callback:function ($$v) {_vm.$set(_vm.buffer, "value", $$v)},expression:"buffer.value"}})],1),_vm._v(" "),_c('div',{staticClass:"actions"},[(_vm.model.id != undefined)?_c('v-btn',{attrs:{"icon":"","small":"","loading":_vm.loading},on:{"click":function($event){$event.stopPropagation();_vm.$eventHub.$emit('open-modal', _vm.Delete, { feature: _vm.model })}}},[_c('v-icon',{attrs:{"color":"error"}},[_vm._v("delete")])],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","small":""},on:{"click":function($event){$event.stopPropagation();_vm.cancel($event)}}},[_c('v-icon',{attrs:{"color":"error"}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","small":"","loading":_vm.loading},on:{"click":function($event){$event.stopPropagation();_vm.validate($event)}}},[_c('v-icon',{attrs:{"color":"success"}},[_vm._v("check")])],1)],1)]:[_c('div',{staticClass:"label"},[_vm._v("\n            "+_vm._s(_vm.model.label)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("\n            "+_vm._s(_vm.model.value)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"actions"},[(_vm.model.is_exportable)?_c('v-btn',{attrs:{"icon":"","small":""},on:{"click":function($event){_vm.setVisibility(false)}}},[_c('v-icon',[_vm._v("mdi-eye")])],1):_c('v-btn',{attrs:{"icon":"","small":""},on:{"click":function($event){_vm.setVisibility(true)}}},[_c('v-icon',[_vm._v("mdi-eye-off")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","small":""},on:{"click":_vm.edit}},[_c('v-icon',[_vm._v("mode_edit")])],1)],1)]],2)}
var Feature_staticRenderFns = []
var Feature_esExports = { render: Feature_render, staticRenderFns: Feature_staticRenderFns }
/* harmony default export */ var features_Feature = (Feature_esExports);
// CONCATENATED MODULE: ./src/views/products/single/features/Feature.vue
function Feature_injectStyle (ssrContext) {
  __webpack_require__("otcH")
}
var Feature_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Feature___vue_template_functional__ = false
/* styles */
var Feature___vue_styles__ = Feature_injectStyle
/* scopeId */
var Feature___vue_scopeId__ = "data-v-6485c9e8"
/* moduleIdentifier (server only) */
var Feature___vue_module_identifier__ = null
var Feature_Component = Feature_normalizeComponent(
  Feature,
  features_Feature,
  Feature___vue_template_functional__,
  Feature___vue_styles__,
  Feature___vue_scopeId__,
  Feature___vue_module_identifier__
)

/* harmony default export */ var single_features_Feature = (Feature_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/products/single/features/FeaturesList.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var FeaturesList = ({
    components: { Feature: single_features_Feature },

    data: function data() {
        return {
            features: []
        };
    },


    methods: {
        add: function add() {
            this.$store.dispatch('addSingleData', {
                key: 'features.[]',
                value: {
                    label: null,
                    value: null,
                    is_exportable: true,
                    product_id: this.$route.params.id
                }
            });
        }
    },

    watch: {
        '$store.state.single.data.features': function $storeStateSingleDataFeatures(val) {
            this.features = val;
        }
    },

    created: function created() {
        this.features = this.$store.state.single.data.features;
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de214f94","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/single/features/FeaturesList.vue
var FeaturesList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"features-list"},[_vm._l((_vm.features),function(f,i){return _c('feature',{key:i,attrs:{"index":i}})}),_vm._v(" "),_c('v-btn',{attrs:{"small":"","flat":"","round":"","depressed":"","color":"primary","disabled":_vm.$store.state.auth.user.level < 60},on:{"click":function($event){_vm.add()}}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("add_circle")]),_vm._v("\n        Ajouter une information\n    ")],1)],2)}
var FeaturesList_staticRenderFns = []
var FeaturesList_esExports = { render: FeaturesList_render, staticRenderFns: FeaturesList_staticRenderFns }
/* harmony default export */ var features_FeaturesList = (FeaturesList_esExports);
// CONCATENATED MODULE: ./src/views/products/single/features/FeaturesList.vue
function FeaturesList_injectStyle (ssrContext) {
  __webpack_require__("yaQ0")
}
var FeaturesList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var FeaturesList___vue_template_functional__ = false
/* styles */
var FeaturesList___vue_styles__ = FeaturesList_injectStyle
/* scopeId */
var FeaturesList___vue_scopeId__ = "data-v-de214f94"
/* moduleIdentifier (server only) */
var FeaturesList___vue_module_identifier__ = null
var FeaturesList_Component = FeaturesList_normalizeComponent(
  FeaturesList,
  features_FeaturesList,
  FeaturesList___vue_template_functional__,
  FeaturesList___vue_styles__,
  FeaturesList___vue_scopeId__,
  FeaturesList___vue_module_identifier__
)

/* harmony default export */ var single_features_FeaturesList = (FeaturesList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/products/single/DataSheet.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var DataSheet = ({
    components: { SingleCard: SingleCard["a" /* default */], SingleField: SingleField["a" /* default */], FeaturesList: single_features_FeaturesList },

    data: function data() {
        return {
            row: 0
        };
    },


    computed: {
        fields: function fields() {
            var fields = this.$store.state.single.data.fields;
            return this.$_.orderBy(fields, function (f) {
                return f.pivot.position;
            });
        },
        data: function data() {
            return this.$store.state.single.data;
        }
    },

    methods: {
        // method called when valide a single field
        updateField: function updateField(key, value) {
            var _this = this;

            var route = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'products/' + this.$route.params.id;
            var storeKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

            var model = {};
            model[key] = value;
            // put the data in database & store new value in store
            this.axios.put('/api/' + route, model).then(function (res) {
                return _this.$store.dispatch('updateSingleData', { key: storeKey != null ? storeKey : key, value: value });
            }).catch(function (err) {
                return _this.$refs[key].setError(err.response.data.errors[key][0]);
            });
        },

        // methods called whe, clicked on the eye single field
        hideField: function hideField(key, value) {
            var _this2 = this;

            var route = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'products/' + this.$route.params.id;
            var storeKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

            var model = {};
            model[key] = value;

            this.axios.put('/api/' + route, model).then(function (res) {
                return _this2.$store.dispatch('updateSingleData', { key: storeKey != null ? storeKey : key, value: value });
            }).catch(function (err) {
                return _this2.$refs[key].setError(err.response.data.errors[key][0]);
            });
        }
    },
    mounted: function mounted() {
        if (this.data.textarea) {
            // get the nomber of row of a multiline texterea
            var textarea = document.querySelector('.value.textarea');
            this.row = Math.ceil(textarea.scrollHeight / 24);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-079387af","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/single/DataSheet.vue
var DataSheet_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"single"},[_c('v-layout',[_c('v-flex',{staticClass:"pr-3",attrs:{"xs6":""}},[(_vm.fields)?_c('single-card',[_c('template',{slot:"content"},[_c('div',{staticClass:"subtitle subtitle--top"},[_vm._v("Caractéristiques")]),_vm._v(" "),_vm._l((_vm.fields),function(field,index){return (field)?_c('div',{key:index,staticClass:"field",attrs:{"data-group":"1"}},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(field.label))]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('single-field',{ref:"pivot",refInFor:true,attrs:{"model":field.pivot,"model-text":"value","model-value":"value","readonly":_vm.data.type == 'sidamo',"hide_eye":_vm.data.type != 'sidamo',"export_button":field.pivot.is_visible == 1 ? 'visibility' : 'visibility_off'},on:{"validate":function($event){_vm.updateField('value', $event, ("productfields/" + (field.pivot.id)), 'fields[' + index + '].pivot.value')},"hide":function($event){_vm.hideField('is_visible', $event, ("productfields/" + (field.pivot.id)), 'fields[' + index + '].pivot.is_visible')}}})],1)]):_vm._e()})],2)],2):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-3",attrs:{"xs6":""}},[_c('single-card',[_c('template',{slot:"content"},[_c('div',{staticClass:"subtitle subtitle--top"},[_vm._v("Produit")]),_vm._v(" "),_c('div',{staticClass:"field",attrs:{"data-group":"1"}},[_c('div',{staticClass:"label"},[_vm._v("Désignation")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('single-field',{ref:"label",attrs:{"model":_vm.data.label,"type":"text","readonly":_vm.data.type == 'sidamo',"hide_eye":true},on:{"validate":function($event){_vm.updateField('label', $event)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"field",attrs:{"data-group":"1"}},[_c('div',{staticClass:"label"},[_vm._v("Désignation 2")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('single-field',{ref:"label_2",attrs:{"model":_vm.data.label_2,"type":"text","readonly":_vm.data.type == 'sidamo',"hide_eye":true},on:{"validate":function($event){_vm.updateField('label_2', $event)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"field",attrs:{"data-group":"1"}},[_c('div',{staticClass:"label"},[_vm._v("Poids brut")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('single-field',{ref:"gross_weight",attrs:{"model":_vm.data.gross_weight,"type":"text","readonly":_vm.data.type == 'sidamo',"hide_eye":true},on:{"validate":function($event){_vm.updateField('gross_weight', $event)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"field",attrs:{"data-group":"1"}},[_c('div',{staticClass:"label"},[_vm._v("Poids net")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('single-field',{ref:"net_weight",attrs:{"model":_vm.data.net_weight,"type":"text","readonly":_vm.data.type == 'sidamo',"hide_eye":true},on:{"validate":function($event){_vm.updateField('net_weight', $event)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"field",attrs:{"data-group":"1"}},[_c('div',{staticClass:"label"},[_vm._v("Longueur")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('single-field',{ref:"length",attrs:{"model":_vm.data.length,"type":"text","readonly":_vm.data.type == 'sidamo',"hide_eye":true},on:{"validate":function($event){_vm.updateField('length', $event)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"field",attrs:{"data-group":"1"}},[_c('div',{staticClass:"label"},[_vm._v("Largeur")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('single-field',{ref:"width",attrs:{"model":_vm.data.width,"type":"text","readonly":_vm.data.type == 'sidamo',"hide_eye":true},on:{"validate":function($event){_vm.updateField('width', $event)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"field",attrs:{"data-group":"1"}},[_c('div',{staticClass:"label"},[_vm._v("Epaisseur")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('single-field',{ref:"thickness",attrs:{"model":_vm.data.thickness,"type":"text","readonly":_vm.data.type == 'sidamo',"hide_eye":true},on:{"validate":function($event){_vm.updateField('thickness', $event)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"field",attrs:{"data-group":"1"}},[_c('div',{staticClass:"label"},[_vm._v("Coût unitaire")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('single-field',{ref:"unit_cost",attrs:{"model":_vm.data.unit_cost,"type":"number","special_mask":"round","readonly":_vm.data.type == 'sidamo',"hide_eye":true},on:{"validate":function($event){_vm.updateField('unit_cost', $event)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"field",attrs:{"data-group":"1"}},[_c('div',{staticClass:"label"},[_vm._v("Prix tarif")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('single-field',{ref:"price",attrs:{"model":_vm.data.price,"type":"number","special_mask":"round","readonly":_vm.data.type == 'sidamo',"hide_eye":true},on:{"validate":function($event){_vm.updateField('price', $event)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"field",attrs:{"data-group":"1"}},[_c('div',{staticClass:"label"},[_vm._v("Référence externe")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('single-field',{ref:"ref_externe",attrs:{"model":_vm.data.ref_externe,"type":"text","readonly":_vm.data.type == 'sidamo',"hide_eye":true},on:{"validate":function($event){_vm.updateField('ref_externe', $event)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"field",attrs:{"data-group":"1"}},[_c('div',{staticClass:"label"},[_vm._v("Libellé fournisseur")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('single-field',{ref:"vendor_description",attrs:{"model":_vm.data.vendor_description,"type":"text","readonly":_vm.data.type == 'sidamo',"hide_eye":true},on:{"validate":function($event){_vm.updateField('vendor_description', $event)}}})],1)])])],2),_vm._v(" "),_c('single-card',[_c('template',{slot:"content"},[_c('div',{staticClass:"subtitle subtitle--top"},[_vm._v("Supp")]),_vm._v(" "),_c('div',{staticClass:"field",attrs:{"data-group":"1"}},[_c('div',{staticClass:"value textarea"},[_c('single-field',{attrs:{"model":_vm.data.textarea,"type":"text","multiline":"","rows":_vm.row,"hide_eye":true},on:{"validate":function($event){_vm.updateField('textarea', $event)}}})],1)])])],2)],1)],1),_vm._v(" "),(_vm.fields && _vm.data.type == 'sidamo')?_c('single-card',[_c('template',{slot:"content"},[_c('div',{staticClass:"subtitle subtitle--top"},[_vm._v("Informations complémentaires")]),_vm._v(" "),_c('features-list')],1)],2):_vm._e()],1)}
var DataSheet_staticRenderFns = []
var DataSheet_esExports = { render: DataSheet_render, staticRenderFns: DataSheet_staticRenderFns }
/* harmony default export */ var single_DataSheet = (DataSheet_esExports);
// CONCATENATED MODULE: ./src/views/products/single/DataSheet.vue
function DataSheet_injectStyle (ssrContext) {
  __webpack_require__("Jenm")
}
var DataSheet_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var DataSheet___vue_template_functional__ = false
/* styles */
var DataSheet___vue_styles__ = DataSheet_injectStyle
/* scopeId */
var DataSheet___vue_scopeId__ = "data-v-079387af"
/* moduleIdentifier (server only) */
var DataSheet___vue_module_identifier__ = null
var DataSheet_Component = DataSheet_normalizeComponent(
  DataSheet,
  single_DataSheet,
  DataSheet___vue_template_functional__,
  DataSheet___vue_styles__,
  DataSheet___vue_scopeId__,
  DataSheet___vue_module_identifier__
)

/* harmony default export */ var products_single_DataSheet = __webpack_exports__["default"] = (DataSheet_Component.exports);


/***/ }),

/***/ "2w37":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2zFI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3BMk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/components/avatar/Avatar.vue + 3 modules
var Avatar = __webpack_require__("Be47");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/symbols/list/Delete.vue
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Delete = ({
    data: function data() {
        return {
            title: 'Supression d\'un symbol',
            icon: 'delete',
            warning: true,
            exist: false
        };
    },


    methods: {
        onClose: function onClose() {
            this.exist = false;
            this.$eventHub.$emit('close-modal2');
        },
        onValidate: function onValidate() {
            var _this = this;

            if (!this.exist) {
                this.axios.delete('/api/symbols/' + this.$store.state.single.data.id).then(function (response) {
                    _this.$eventHub.$emit('close-modal2');
                    _this.$eventHub.$emit('reload-list');
                    _this.$eventHub.$emit('close-modal');
                }).catch(function (error) {
                    console.log(error.response.data || error);
                });
            } else {
                this.$eventHub.$emit('close-modal2');
            }
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        this.axios.get('/api/requests?filters=symbol_id|=|' + this.$store.state.single.data.id).then(function (response) {
            if (response.data.length > 0) {
                _this2.exist = true;
            }
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dfbc0f6a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/symbols/list/Delete.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.exist)?[_c('p',[_vm._v("Êtes-vous sûr de vouloir supprimer ce symbol ?")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$store.state.single.data.label))])])]:[_c('p',{staticClass:"text-xs-center"},[_vm._v("Vous ne pouvez pas supprimer ce symbol car il est déja utilisé dans une demande")])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var list_Delete = (esExports);
// CONCATENATED MODULE: ./src/views/symbols/list/Delete.vue
function injectStyle (ssrContext) {
  __webpack_require__("NKCU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dfbc0f6a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Delete,
  list_Delete,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var symbols_list_Delete = (Component.exports);

// EXTERNAL MODULE: ./src/components/files/CreateLinkedFiles.vue + 2 modules
var CreateLinkedFiles = __webpack_require__("cD6D");

// EXTERNAL MODULE: ./src/components/files/DeleteLinkedFiles.vue + 2 modules
var DeleteLinkedFiles = __webpack_require__("/38I");

// EXTERNAL MODULE: ./src/filters/nl2br.js
var nl2br = __webpack_require__("sTpe");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/symbols/list/Single.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var Single = ({
    props: {
        params: {
            required: true
        }
    },
    components: {
        Avatar: Avatar["a" /* default */], Delete: symbols_list_Delete, DeleteLinkedFile: DeleteLinkedFiles["a" /* default */], CreateLinkedFiles: CreateLinkedFiles["a" /* default */]
    },
    data: function data() {
        return {
            moment: moment_default.a,
            display: true,
            symbol: null,
            fullscreen: true,
            card_text_class: 'fullscreen-modal-text',
            valid_button: false,
            cancel_button: false,
            imgFullPath: null,
            isEditing: false,
            nb_column: 1,
            valid_title: false,
            valid_message: false,
            savedSymbol: null,
            error: false,
            error_2: false,
            removeCol: false,
            loading: false,
            rules: {
                title: [function (v) {
                    if (!!v && v.length <= 0) {
                        return 'Titre obligatoire';
                    } else if (v.length >= 150) {
                        return 'Le titre ne dois pas contenir plus de 150 caractères';
                    } else {
                        return true;
                    }
                }],
                title_2: [function (v) {
                    if (v) {
                        if (v.length >= 150) {
                            return 'Le titre ne dois pas contenir plus de 150 caractères';
                        } else {
                            return true;
                        }
                    } else {
                        return true;
                    }
                }]
            }
        };
    },

    methods: {
        deleteFile: function deleteFile(entity, item) {
            this.display = false;
            var index = '';
            var file_array = '';
            //if file already saved
            if (typeof entity == 'number') {
                this.$_.find(this.symbol.files_1, function (i) {
                    return i.id == item;
                }) ? file_array = 'files_1' : file_array = 'files_2';
                this.$_.find(this.symbol.files, function (i) {
                    return i.id == item;
                }) && this.$_.find(this.symbol.files, function (i) {
                    return i.id == item;
                }).pivot.file_type == 'attachment' ? file_array = 'files' : file_array = file_array;
                index = this.symbol[file_array].findIndex(function (el) {
                    return el.id === item;
                });
            } else {
                index = this.symbol[entity].findIndex(function (el) {
                    return el.path === item;
                });
                file_array = entity;
            }
            this.symbol[file_array].splice(index, 1);
            this.display = true;
        },
        addFile: function addFile(entity_id, entity) {
            var _this = this;

            this.display = false;
            if (entity_id != 0) {
                this.axios.get('/api/' + entity + '?embed=files&filters=id|=|' + entity_id).then(function (response) {
                    _this.symbol.files = response.data[0].files;
                });
            }
            this.display = true;
        },

        onClose: function onClose() {
            this.$eventHub.$emit('close-modal');
            this.$eventHub.$emit('reload-single');
            this.$eventHub.$emit('reload-list');
        },
        openImg: function openImg(file) {
            this.$eventHub.$emit('view-file', file);
        },
        onFileChange: function onFileChange(evt, fileArray, fileIndex) {
            this.display = false;
            var array = this.symbol['files_' + fileArray];
            if (fileIndex >= 0) {
                if (evt.target.files[0]) {
                    array[fileIndex].path = URL.createObjectURL(evt.target.files[0]);
                    array[fileIndex].file = evt.target.files[0];
                    array[fileIndex].toUpdate = true;
                }
            } else {
                fileIndex = array.length;
                if (evt.target.files[0]) {
                    array.push({
                        path: URL.createObjectURL(evt.target.files[0]),
                        file: evt.target.files[0],
                        toUpdate: true
                    });
                }
            }
            this.display = true;
        },
        addImgPath: function addImgPath() {
            return __webpack_require__("c8ny");
        },
        setColumnNumber: function setColumnNumber(nb_column) {
            this.nb_column = nb_column;
        },
        isCol: function isCol(number, symbol) {
            if (!this.isEditing) {
                if (number === 1) {
                    return false;
                } else {
                    return true;
                }
            } else {
                if (this.nb_column === number) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        deleteCol: function deleteCol() {
            this.symbol.message_2 = null;
            this.symbol.title_2 = null;
            this.removeCol = false;
            this.nb_column = 1;
        },

        cancel: function cancel() {
            this.isEditing = false;
            this.getDataFromApi();
        },
        startEditing: function startEditing() {
            this.isEditing = true;
            if (this.symbol && (this.symbol.title_2 != null || this.symbol.message_2 != null)) {
                this.nb_column = 2;
            }
        },
        deleteSymbol: function deleteSymbol() {
            this.$eventHub.$emit('open-modal2', symbols_list_Delete);
        },
        saveElement: function saveElement() {
            var _this2 = this;

            if (this.valid_title && this.valid_message) {
                if (this.nb_column == 2 && this.symbol.title_2 == null || this.nb_column == 2 && this.symbol.message_2 == null) {
                    this.error_2 = true;
                } else {
                    this.loading = true;
                    var savePhotoRec = function savePhotoRec(symboleId, arrayId, index) {
                        if (arrayId < 3) {
                            if (index < _this2.symbol['files_' + arrayId].length) {
                                var file = _this2.symbol['files_' + arrayId][index];

                                if (file.file !== null && file.file !== undefined) {
                                    var data = new FormData();
                                    data.append('file', file.file), data.append('location', 'area-' + arrayId);

                                    if (file.id > 0) {
                                        _this2.axios.delete('/api/symbols/' + symboleId + '/file/' + file.id, data).then(function (response) {
                                            _this2.axios.post('/api/symbols/' + symboleId + '/file', data).then(function (response) {
                                                savePhotoRec(symboleId, arrayId, ++index);
                                                _this2.loading = false;
                                            });
                                        });
                                    } else {
                                        _this2.axios.post('/api/symbols/' + symboleId + '/file', data).then(function (response) {
                                            savePhotoRec(symboleId, arrayId, ++index);
                                            _this2.loading = false;
                                        });
                                    }
                                } else {
                                    savePhotoRec(symboleId, arrayId, ++index);
                                    _this2.loading = false;
                                }
                            } else {
                                savePhotoRec(symboleId, ++arrayId, 0);
                                _this2.loading = false;
                            }
                        }
                    };
                    this.axios.put('/api/symbols/' + this.symbol.id, {
                        label: this.symbol.title,
                        title: this.symbol.title,
                        title_2: this.symbol.title_2,
                        message: this.symbol.message,
                        message_2: this.symbol.message_2,
                        user_id: this.$store.state.auth.user.id
                    }).then(function (response) {
                        _this2.isEditing = false;
                        savePhotoRec(response.data.id, 1, 0);
                        _this2.loading = false;
                    });
                }
            } else {
                this.error = true;
            }
        },
        getDataFromApi: function getDataFromApi() {
            var _this3 = this;

            this.axios.get('/api/symbols/' + this.params.id + '?embed=requests,files,user').then(function (response) {
                _this3.symbol = response.data;
                _this3.symbol.files_1 = _this3.symbol.files.filter(function (file) {
                    return file.pivot.location === 'area-1';
                });
                _this3.symbol.files_2 = _this3.symbol.files.filter(function (file) {
                    return file.pivot.location === 'area-2';
                });
                if (_this3.symbol && (_this3.symbol.title_2 != null || _this3.symbol.message_2 != null)) {
                    _this3.nb_column = 2;
                }
                _this3.$store.dispatch('setSingleData', { data: _this3.symbol });
            });
        }
    },
    created: function created() {
        this.getDataFromApi();
        this.isEditing = this.params.isEditing;
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-698e8ea9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/symbols/list/Single.vue
var Single_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single-container"},[_c('v-toolbar',{staticClass:"modal-header"},[_c('div',{staticClass:"app-logo"},[_c('img',{attrs:{"src":__webpack_require__("p91O")}})]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.onClose($event)}}},[_c('v-icon',[_vm._v("arrow_back")])],1),_vm._v(" "),(_vm.symbol !== null && _vm.symbol !== undefined)?_c('v-toolbar-title',[_vm._v("Symbole / "+_vm._s(_vm.symbol.label))]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.symbol !== null && _vm.symbol !== undefined)?_c('div',{staticClass:"header-purple"},[_vm._v("\n            "+_vm._s(_vm.symbol.requests.length)+" produits liés\n       ")]):_vm._e()],1),_vm._v(" "),(_vm.symbol !== null && _vm.symbol !== undefined)?_c('v-toolbar',{staticClass:"single-toolbar",attrs:{"flat":""}},[_c('avatar',{staticClass:"single-avatar",attrs:{"item":_vm.symbol.user,"size":"5rem"}}),_vm._v(" "),_c('v-layout',{attrs:{"column":"","justify-space-around":"","align-content-space-around":""}},[_c('v-flex',[_c('b',[_vm._v(_vm._s(_vm.symbol.user.first_name)+" "+_vm._s(_vm.symbol.user.last_name))])]),_vm._v(" "),_c('div',{staticClass:"date"},[_c('pre',{staticClass:"date-line"},[_vm._v("  ")]),_vm._v("Le "+_vm._s(_vm.moment(_vm.symbol.updated_at).format('DD/MM/YYYY'))+"\n            ")])],1),_vm._v(" "),(_vm.isEditing)?_c('v-btn',{attrs:{"outline":"","round":"","depressed":"","small":"","color":'primary'},on:{"click":function($event){_vm.$refs.modal.open('symbols',_vm.symbol.id)}}},[_vm._v("Ajouter une pièce jointe")]):_vm._e(),_vm._v(" "),(_vm.isEditing)?_c('v-btn',{attrs:{"round":"","small":"","flat":"","color":'primary'},on:{"click":function($event){_vm.cancel()}}},[_vm._v("Annuler")]):_vm._e(),_vm._v(" "),(_vm.isEditing)?_c('v-btn',{attrs:{"round":"","depressed":"","small":"","color":'primary',"loading":_vm.loading},on:{"click":function($event){_vm.saveElement()}}},[_vm._v("Enregistrer")]):_vm._e(),_vm._v(" "),(!_vm.isEditing && (_vm.$store.state.auth.user.level >= 60 || _vm.symbol.user_id == _vm.$store.state.auth.user.id))?_c('v-btn',{attrs:{"round":"","small":"","flat":"","color":'primary'},on:{"click":function($event){_vm.deleteSymbol()}}},[_vm._v("Supprimer le symbole")]):_vm._e(),_vm._v(" "),(!_vm.isEditing && (_vm.$store.state.auth.user.level >= 60 || _vm.symbol.user_id == _vm.$store.state.auth.user.id))?_c('v-btn',{attrs:{"round":"","depressed":"","small":"","color":'primary'},on:{"click":function($event){_vm.startEditing()}}},[_vm._v("Modifier")]):_vm._e()],1):_vm._e(),_vm._v(" "),(!_vm.isEditing && _vm.symbol !== null && _vm.symbol !== undefined)?_c('div',{staticClass:"center-content",class:[_vm.isCol(2,_vm.symbol) ? 'doubleCol' : '']},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":_vm.isCol(1,_vm.symbol),"sm12":_vm.isCol(2,_vm.symbol),"md6":_vm.isCol(2,_vm.symbol)}},[_c('div',{staticClass:"comment-title on-left"},[_vm._v("\n                    "+_vm._s(_vm.symbol.title)+"\n                ")])]),_vm._v(" "),(_vm.isCol(2,_vm.symbol))?_c('v-flex',{attrs:{"sm12":"","md6":""}},[_c('div',{staticClass:"comment-title on-right"},[_vm._v("\n                    "+_vm._s(_vm.symbol.title_2)+"\n                ")])]):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":_vm.isCol(1,_vm.symbol),"sm12":_vm.isCol(2,_vm.symbol),"md6":_vm.isCol(2,_vm.symbol)}},[_c('p',{staticClass:"comment-message on-left"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$options.filters.nl2br(_vm.symbol.message))}})])]),_vm._v(" "),(_vm.isCol(2,_vm.symbol))?_c('v-flex',{attrs:{"sm12":"","md6":""}},[_c('p',{staticClass:"comment-message on-right"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$options.filters.nl2br(_vm.symbol.message_2))}})])]):_vm._e()],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":_vm.isCol(1,_vm.symbol),"sm12":_vm.isCol(2,_vm.symbol),"md6":_vm.isCol(2,_vm.symbol)}},[_c('v-layout',{attrs:{"wrap":""}},_vm._l((_vm.symbol.files_1),function(file,index){return _c('v-flex',{key:file.id,on:{"click":function($event){_vm.imgFullPath === null && _vm.openImg(file)}}},[_c('label',{staticClass:"comment-image"},[_c('img',{attrs:{"src":file.path}})])])}))],1),_vm._v(" "),(_vm.isCol(2,_vm.symbol))?_c('v-flex',{attrs:{"sm12":"","md6":""}},[_c('v-layout',{attrs:{"wrap":""}},_vm._l((_vm.symbol.files_2),function(file,index){return _c('v-flex',{key:file.id,on:{"click":function($event){_vm.imgFullPath === null && _vm.openImg(file)}}},[_c('label',{staticClass:"comment-image"},[_c('img',{attrs:{"src":file.path}})])])}))],1):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(_vm.isEditing && _vm.symbol !== null && _vm.symbol !== undefined)?_c('div',{staticClass:"center-content",class:[_vm.nb_column == 2 ? 'doubleCol' : '']},[_c('v-form',{model:{value:(_vm.valid_title),callback:function ($$v) {_vm.valid_title=$$v},expression:"valid_title"}},[_c('v-layout',{staticClass:"title-row",attrs:{"row":""}},[_c('v-flex',{staticClass:"edit-title",attrs:{"xs12":_vm.isCol(1,_vm.symbol),"sm12":_vm.isCol(2,_vm.symbol),"md6":_vm.isCol(2,_vm.symbol)}},[_c('v-text-field',{attrs:{"name":"titre1_text_field","label":"Titre","hint":"Titre de votre commentaire","rules":_vm.rules.title,"error":_vm.error,"persistent-hint":_vm.error},model:{value:(_vm.symbol.title),callback:function ($$v) {_vm.$set(_vm.symbol, "title", $$v)},expression:"symbol.title"}})],1),_vm._v(" "),(_vm.isCol(2,_vm.symbol))?_c('v-flex',{staticClass:"edit-title",attrs:{"sm12":"","md6":""}},[_c('v-text-field',{attrs:{"name":"titre2_text_field","label":"Titre 2","hint":"Titre de votre commentaire 2","rules":_vm.rules.title_2,"error":_vm.error_2,"persistent-hint":_vm.error_2},model:{value:(_vm.symbol.title_2),callback:function ($$v) {_vm.$set(_vm.symbol, "title_2", $$v)},expression:"symbol.title_2"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('v-form',{model:{value:(_vm.valid_message),callback:function ($$v) {_vm.valid_message=$$v},expression:"valid_message"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"edit-message",attrs:{"xs12":_vm.isCol(1,_vm.symbol),"sm12":_vm.isCol(2,_vm.symbol),"md6":_vm.isCol(2,_vm.symbol)}},[_c('v-text-field',{attrs:{"name":"message_text_field","label":"Message","hint":"Contenu du message","multi-line":"","error":_vm.error,"persistent-hint":_vm.error},model:{value:(_vm.symbol.message),callback:function ($$v) {_vm.$set(_vm.symbol, "message", $$v)},expression:"symbol.message"}})],1),_vm._v(" "),(_vm.isCol(2,_vm.symbol))?_c('v-flex',{staticClass:"edit-message",attrs:{"sm12":"","md6":""}},[_c('v-text-field',{attrs:{"name":"message_text_field2","label":"Message 2","hint":"Contenu du message 2","multi-line":"","error":_vm.error_2,"persistent-hint":_vm.error_2},model:{value:(_vm.symbol.message_2),callback:function ($$v) {_vm.$set(_vm.symbol, "message_2", $$v)},expression:"symbol.message_2"}})],1):_vm._e()],1)],1),_vm._v(" "),(_vm.display)?_c('v-layout',{staticClass:"imgs"},[_c('v-flex',{attrs:{"xs12":_vm.isCol(1,_vm.symbol),"sm12":_vm.isCol(2,_vm.symbol),"md6":_vm.isCol(2,_vm.symbol)}},[_c('v-layout',[_vm._l((_vm.symbol.files_1),function(file,index){return _c('v-flex',{key:file.id,attrs:{"xs2":""}},[_c('v-menu',{attrs:{"offset-y":"","content-class":"files"}},[_c('div',{attrs:{"slot":"activator"},slot:"activator"},[_c('label',{staticClass:"comment-image"},[_c('v-icon',{staticClass:"hover-alpha"},[_vm._v("mode_edit")]),_vm._v(" "),_c('img',{attrs:{"src":file.path}})],1)]),_vm._v(" "),_c('v-list',[_c('v-list-tile',{staticClass:"li"},[_c('label',{attrs:{"for":'file1-input-'+index}},[_vm._v("Modifier l'image")]),_vm._v(" "),_c('input',{staticClass:"input-img",staticStyle:{"display":"none"},attrs:{"id":'file1-input-'+index,"type":"file"},on:{"change":function (event){_vm.onFileChange(event,1,index)}}})]),_vm._v(" "),_c('v-list-tile',{staticClass:"li",on:{"click":function($event){file.id ? _vm.$refs.deletefile.open('symbols',file, _vm.symbol.id) : _vm.$refs.deletefile.open('symbols',file,'files_1')}}},[_c('v-list-tile-title',[_vm._v("Supprimer l'image")])],1)],1)],1)],1)}),_vm._v(" "),(_vm.symbol.files_1.length < 2)?_c('v-flex',{attrs:{"xs2":""}},[_c('v-menu',{attrs:{"offset-y":"","content-class":"files"}},[_c('div',{attrs:{"slot":"activator"},slot:"activator"},[_c('label',{staticClass:"comment-image"},[_c('img',{staticClass:"add-img",attrs:{"src":_vm.addImgPath()}})])]),_vm._v(" "),_c('v-list',[_c('v-list-tile',{staticClass:"li"},[_c('label',{attrs:{"for":'file1-input'}},[_vm._v("Ajouter une image")]),_vm._v(" "),_c('input',{staticClass:"input-img",staticStyle:{"display":"none"},attrs:{"id":"file1-input","type":"file"},on:{"change":function (event){_vm.onFileChange(event,1)}}})])],1)],1)],1):_vm._e()],2)],1),_vm._v(" "),(_vm.isCol(2,_vm.symbol))?_c('v-flex',{attrs:{"sm12":"","md6":""}},[_c('v-layout',[_vm._l((_vm.symbol.files_2),function(file,index){return _c('v-flex',{key:file.id,attrs:{"xs2":""}},[_c('v-menu',{attrs:{"offset-y":"","content-class":"files"}},[_c('div',{attrs:{"slot":"activator"},slot:"activator"},[_c('label',{staticClass:"comment-image"},[_c('v-icon',{staticClass:"hover-alpha"},[_vm._v("mode_edit")]),_vm._v(" "),_c('img',{attrs:{"src":file.path}})],1)]),_vm._v(" "),_c('v-list',[_c('v-list-tile',{staticClass:"li"},[_c('label',{attrs:{"for":'file2-input-'+index}},[_vm._v("Modifier l'image")]),_vm._v(" "),_c('input',{staticClass:"input-img",staticStyle:{"display":"none"},attrs:{"id":'file2-input-'+index,"type":"file"},on:{"change":function (event){_vm.onFileChange(event,2,index)}}})]),_vm._v(" "),_c('v-list-tile',{staticClass:"li",on:{"click":function($event){file.id ? _vm.$refs.deletefile.open('symbols',file, _vm.symbol.id) : _vm.$refs.deletefile.open('symbols',file,'files_2')}}},[_c('v-list-tile-title',[_vm._v("Supprimer l'image")])],1)],1)],1)],1)}),_vm._v(" "),(_vm.isCol(2,_vm.symbol) && _vm.symbol.files_2.length < 2)?_c('v-flex',{attrs:{"xs2":""}},[_c('v-menu',{attrs:{"offset-y":"","content-class":"files"}},[_c('div',{attrs:{"slot":"activator"},slot:"activator"},[_c('label',{staticClass:"comment-image"},[_c('img',{staticClass:"add-img",attrs:{"src":_vm.addImgPath()}})])]),_vm._v(" "),_c('v-list',[_c('v-list-tile',{staticClass:"li"},[_c('label',{attrs:{"for":'file2-input'}},[_vm._v("Ajouter une image")]),_vm._v(" "),_c('input',{staticClass:"input-img",staticStyle:{"display":"none"},attrs:{"id":"file2-input","type":"file"},on:{"change":function (event){_vm.onFileChange(event,2)}}})])],1)],1)],1):_vm._e()],2)],1):_vm._e()],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.symbol && _vm.symbol.files)?[_vm._l((_vm.symbol.files),function(file,index){return (file.pivot && file.pivot.file_type == 'attachment' && _vm.display)?[_c('div',{staticClass:"files-list-container",on:{"click":function($event){_vm.$eventHub.$emit('view-file',file)}}},[_c('div',{staticClass:"files-list-container-title"},[_vm._v("\n                    Pièces jointes :\n                ")]),_vm._v(" "),[_vm._v(_vm._s(file.label)+"."+_vm._s(file.type))],_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.isEditing)?_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();_vm.$refs.deletefile.open('symbols',file,_vm.symbol.id)}}},[_c('v-icon',[_vm._v("close")])],1):_vm._e()],2)]:_vm._e()})]:_vm._e(),_vm._v(" "),(_vm.isEditing)?_c('div',{staticClass:"column-display-choice"},[_c('div',{staticClass:"col-choice-title"},[_vm._v("\n            Affichage :\n        ")]),_vm._v(" "),_c('div',{staticClass:"column-display-buttons"},[_c('div',[_c('div',{staticClass:"image-and-overlay-left",on:{"click":function($event){_vm.setColumnNumber(1)}}},[_c('img',{staticClass:"col-chose-image",attrs:{"src":__webpack_require__("NdJc")}}),_vm._v(" "),(_vm.nb_column===1)?_c('div',{staticClass:"col-choice-overlay"}):_vm._e()])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"image-and-overlay-right",on:{"click":function($event){_vm.setColumnNumber(2)}}},[_c('img',{staticClass:"col-chose-image",attrs:{"src":__webpack_require__("08vo")}}),_vm._v(" "),(_vm.nb_column===2)?_c('div',{staticClass:"col-choice-overlay"}):_vm._e()])])])]):_vm._e(),_vm._v(" "),(_vm.imgFullPath !== null)?_c('div',{staticClass:"overlay"},[_c('div',{staticClass:"overlay-container",on:{"click":function($event){_vm.openImg(null)}}},[_c('img',{staticClass:"overlay-image",attrs:{"src":_vm.imgFullPath}})])]):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"750px"},model:{value:(_vm.removeCol),callback:function ($$v) {_vm.removeCol=$$v},expression:"removeCol"}},[_c('v-card',[_c('v-card-title',{staticClass:"warning"},[_c('h2',[_c('v-icon',{staticClass:"mr-2",attrs:{"dark":""}},[_vm._v("warning")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("Attention")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","icon":""},on:{"click":function($event){_vm.removeCol = false}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_vm._v("\n                Voulez vous vraiment supprimer la deuxième colonne ?\n            ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"round":"","small":"","outline":"","color":"warning"},nativeOn:{"click":function($event){_vm.removeCol = false;}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"round":"","depressed":"","small":"","color":"warning"},nativeOn:{"click":function($event){_vm.deleteCol()}}},[_vm._v("Valider")])],1)],1)],1),_vm._v(" "),_c('create-linked-files',{ref:"modal",on:{"added":function (entity_id,entity) { _vm.addFile(entity_id,entity) }}}),_vm._v(" "),_c('delete-linked-file',{ref:"deletefile",on:{"deleted":function (entity_id,item_id) { _vm.deleteFile(entity_id,item_id) }}})],2)}
var Single_staticRenderFns = []
var Single_esExports = { render: Single_render, staticRenderFns: Single_staticRenderFns }
/* harmony default export */ var list_Single = (Single_esExports);
// CONCATENATED MODULE: ./src/views/symbols/list/Single.vue
function Single_injectStyle (ssrContext) {
  __webpack_require__("jwTm")
}
var Single_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Single___vue_template_functional__ = false
/* styles */
var Single___vue_styles__ = Single_injectStyle
/* scopeId */
var Single___vue_scopeId__ = "data-v-698e8ea9"
/* moduleIdentifier (server only) */
var Single___vue_module_identifier__ = null
var Single_Component = Single_normalizeComponent(
  Single,
  list_Single,
  Single___vue_template_functional__,
  Single___vue_styles__,
  Single___vue_scopeId__,
  Single___vue_module_identifier__
)

/* harmony default export */ var symbols_list_Single = __webpack_exports__["a"] = (Single_Component.exports);


/***/ }),

/***/ "3F3K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Jfp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/auth/Login.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Login = ({
    data: function data() {
        return {
            valid: false,

            model: {
                email: '',
                password: ''
            },

            rules: {
                email: [function (v) {
                    return !!v || 'Adresse email obligatoire';
                }, function (v) {
                    return (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'L\'adresse email n\'est pas valide'
                    );
                }],
                password: [function (v) {
                    return !!v || 'Mot de passe obligatoire';
                }]
            },

            loading: false,
            snackbar: false
        };
    },


    methods: {
        submit: function submit() {
            if (this.$refs.form.validate()) {
                this.loading = true;
                this.$store.dispatch('clearLoginError');
                this.$store.dispatch('login', this.model);
            }
        }
    },

    watch: {
        '$store.state.auth.error': function $storeStateAuthError(val) {
            if (val !== null) {
                this.loading = false;
                this.snackbar = true;
            }
        },
        '$store.state.auth.isConnected': function $storeStateAuthIsConnected(val) {
            if (val === true) {
                this.$router.push('/');
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab048d3c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/Login.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"auth-login"},[_c('v-flex',{attrs:{"xs8":"","offset-xs2":"","sm6":"","offset-sm3":"","md4":"","offset-md4":"","lg4":"","offset-lg4":""}},[_c('v-card',[_c('v-card-title',[_c('img',{attrs:{"src":__webpack_require__("ufes")}})]),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();_vm.submit($event)}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"color":"accent","label":"Adresse email","rules":_vm.rules.email,"required":""},model:{value:(_vm.model.email),callback:function ($$v) {_vm.$set(_vm.model, "email", $$v)},expression:"model.email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"color":"accent","label":"Mot de passe","type":"password","rules":_vm.rules.password,"required":""},model:{value:(_vm.model.password),callback:function ($$v) {_vm.$set(_vm.model, "password", $$v)},expression:"model.password"}}),_vm._v(" "),_c('v-btn',{attrs:{"round":"","color":"primary","type":"submit","loading":_vm.loading}},[_vm._v("Se connecter")])],1)],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"bottom":"","color":"error"},nativeOn:{"click":function($event){_vm.snackbar = false}},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_c('v-icon',{staticClass:"mr-3",attrs:{"dark":""}},[_vm._v("warning")]),_vm._v("\n        "+_vm._s(_vm.$store.state.auth.error)+"\n    ")],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var auth_Login = (esExports);
// CONCATENATED MODULE: ./src/views/auth/Login.vue
function injectStyle (ssrContext) {
  __webpack_require__("5j49")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ab048d3c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Login,
  auth_Login,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var views_auth_Login = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "4SFm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/DataTable.vue + 2 modules
var DataTable = __webpack_require__("/WHI");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/components/avatar/Avatar.vue + 3 modules
var Avatar = __webpack_require__("Be47");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/products/single/Accessories.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Accessories = ({
	components: { DataTable: DataTable["a" /* default */], Avatar: Avatar["a" /* default */] },

	data: function data() {
		return {
			moment: moment_default.a,
			datatable: {
				headers: [{ text: 'Désignation', sortable: true, value: 'label', align: 'left' }, { text: 'Désignation 2', sortable: true, value: 'label_2', align: 'right' }, { text: 'Code', sortable: true, value: 'code', align: 'right' }, { text: 'Ref externe', sortable: true, value: 'ref_externe', align: 'right' }, { text: 'De série', sortable: true, value: 'de_serie', align: 'right' }],
				endpoint: {
					base: '/api/products',
					filters: 'parents.linked_product.product_id|=|' + this.$route.params.id + ',group|=|accessory'
				}
			},
			hide_demand: false
		};
	},

	methods: {
		rowClick: function rowClick(item) {}
	},
	created: function created() {
		var _this = this;

		this.$eventHub.$on('reload-list', function () {
			if (_this.$refs.list) {
				_this.$refs.list.reload();
			}
		});
	},
	mounted: function mounted() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03e97182","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/single/Accessories.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-table',{ref:"list",attrs:{"headers":_vm.datatable.headers,"toolbar":_vm.datatable.toolbar,"actions":_vm.datatable.actions,"endpoint":_vm.datatable.endpoint,"storeId":"comments"},on:{"rowClick":_vm.rowClick},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left author"},[_c('avatar',{attrs:{"item":props.item,"field":"photo"}}),_vm._v("\n            "+_vm._s(props.item.label)+"\n        ")],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n            "+_vm._s(props.item.label_2)+"\n        ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n            "+_vm._s(props.item.code)+"\n        ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n            "+_vm._s(props.item.ref_externe)+"\n        ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[(props.item.de_serie)?[_vm._v("\n                Oui\n            ")]:[_vm._v("\n                Non\n            ")]],2)]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var single_Accessories = (esExports);
// CONCATENATED MODULE: ./src/views/products/single/Accessories.vue
function injectStyle (ssrContext) {
  __webpack_require__("WJD/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03e97182"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Accessories,
  single_Accessories,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var products_single_Accessories = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "4uzA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5j49":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "61XD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6cZL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "85XS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8S3P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9Amq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9B81":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/config/enum/ProductTypes.js
var ProductTypes = __webpack_require__("mdcO");

// EXTERNAL MODULE: ./src/config/enum/CommentTypes.js
var CommentTypes = __webpack_require__("22+B");

// EXTERNAL MODULE: ./src/components/avatar/UploadAvatar.vue + 2 modules
var UploadAvatar = __webpack_require__("wRGB");

// EXTERNAL MODULE: ./src/components/avatar/Avatar.vue + 3 modules
var Avatar = __webpack_require__("Be47");

// EXTERNAL MODULE: ./src/views/products/single/CreateComment.vue + 8 modules
var CreateComment = __webpack_require__("dgM2");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/projects/single/ProductAside.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var ProductAside = ({
    components: { UploadAvatar: UploadAvatar["a" /* default */], Avatar: Avatar["a" /* default */], CreateComment: CreateComment["a" /* default */] },
    props: {
        params: {
            required: false
        }
    },
    data: function data() {
        return {
            moment: moment_default.a,
            CreateComment: CreateComment["a" /* default */]
        };
    },

    computed: {
        productTypeLabel: function productTypeLabel() {
            var _this = this;

            return ProductTypes["a" /* ProductTypes */].find(function (el) {
                return el.value === _this.product.type;
            }).label;
        },

        comments: function comments() {
            if (this.product.comments) {
                return this.product.comments.sort(function (a, b) {
                    return a.created_at > b.created_at;
                });
            }
        },

        product: function product() {
            if (this.params.product_type !== null && this.params.product_index !== null) {
                return this.$store.state.single.data[this.params.product_type + '_products'][this.params.product_index];
            }
        },

        user_id: function user_id() {
            return this.$store.state.auth.user.id;
        },

        fields: function fields() {
            var fields = this.product.fields;
            return this.$_.orderBy(fields, function (f) {
                return f.pivot.position;
            });
        }
    },
    methods: {
        goToProduct: function goToProduct(productId, groupLabel) {
            this.$router.push({ name: 'single-product', params: { id: productId, group: groupLabel } });
        },

        getCommentColor: function getCommentColor(type) {
            var commentType = CommentTypes["a" /* CommentTypes */].find(function (el) {
                return el.value === type;
            });
            return commentType ? commentType.color : '';
        },

        goToComments: function goToComments(productId, groupLabel) {
            this.$router.push({ name: 'product-comments', params: { id: productId, group: groupLabel } });
        },
        createComment: function createComment(product) {
            var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            this.$eventHub.$emit('open-modal', CreateComment["a" /* default */], {
                product_id: product.id,
                product_label: product.label, //this.$store.state.single.data.label
                element_type: 'comment',
                create_query: create,
                hide_demand: true,
                store_path: this.params.product_type + '_products[' + this.params.product_index + '].comments'
            });
        },
        open: function open() {
            this.$refs.modal.open();
        },
        scrollBottomComments: function scrollBottomComments() {
            var element = document.getElementById("comments");
            if (element) {
                element.scrollTop = element.scrollHeight;
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07dbd61c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/projects/single/ProductAside.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.product)?_c('div',{staticClass:"product-aside",attrs:{"title":"Détails du produit"}},[_c('div',{staticClass:"contain product-detail-header-container"},[_c('div',{staticClass:"top"},[_c('upload-avatar',{attrs:{"defaultImg":__webpack_require__("jfOg"),"item":_vm.product,"item-id":_vm.product.id,"store-key":_vm.product.type + '_products[' + _vm.params.product_index + '].photo',"entities":"products","field":"photo"}})],1),_vm._v(" "),_c('div',{staticClass:"name"},[_c('h2',[_c('a',{on:{"click":function($event){$event.stopPropagation();_vm.goToProduct(_vm.product.id, _vm.product.group)}}},[_vm._v(_vm._s(_vm.product.label))])]),_vm._v(" "),(_vm.product.supplier)?_c('p',[_vm._v(_vm._s(_vm.product.supplier.name))]):_vm._e(),_vm._v(" "),(_vm.product.category && _vm.product.category.parent)?_c('span',[_vm._v("\n                    "+_vm._s(_vm.product.category.parent.label)+"\n                ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"tab product-details-tab"},[_c('v-tabs',{attrs:{"grow":"","fixed":"","centered":"","slider-color":"primary","show-arrows":true},on:{"input":_vm.scrollBottomComments}},[_c('v-tab',{attrs:{"href":'#specs',"ripple":""}},[_vm._v("Informations")]),_vm._v(" "),(_vm.comments)?_c('v-tab',{attrs:{"href":'#comments',"ripple":""}},[_vm._v("Commentaires")]):_vm._e(),_vm._v(" "),_c('v-tab-item',{key:'specs',attrs:{"id":'specs'}},[_c('div',{staticClass:"tab-title"},[_c('p',[_vm._v("\n                            A propos\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"specs-container"},[_c('div',{staticClass:"field",attrs:{"data-group":"1"}},[_c('div',{staticClass:"label"},[_vm._v("Type de produit")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(" "+_vm._s(_vm.productTypeLabel))])]),_vm._v(" "),_c('div',{staticClass:"field",attrs:{"data-group":"1"}},[_c('div',{staticClass:"label"},[_vm._v("Produit")]),_vm._v(" "),(_vm.product.type != 'sidamo')?_c('div',{staticClass:"value"},[_c('a',{on:{"click":function($event){$event.stopPropagation();_vm.goToProduct(_vm.product.id, _vm.product.group)}}},[_vm._v(_vm._s(_vm.product.label))])]):_c('div',{staticClass:"value"},[_c('a',{on:{"click":function($event){$event.stopPropagation();_vm.goToProduct(_vm.product.id, _vm.product.group)}}},[_vm._v(_vm._s(_vm.product.label))])])]),_vm._v(" "),(_vm.product.type != 'sidamo')?_c('div',{staticClass:"field",attrs:{"data-group":"1"}},[_c('div',{staticClass:"label"},[_vm._v("Lien externe")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.product.external_link)?_c('a',{attrs:{"href":_vm.product.external_link}},[_vm._v("Ouvrir le lien")]):[_vm._v(" - ")]],2)]):_c('div',{staticClass:"field",attrs:{"data-group":"1"}},[_c('div',{staticClass:"label"},[_vm._v("Code")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("\n                                "+_vm._s(_vm.product.code)+"\n                            ")])])]),_vm._v(" "),_c('div',{staticClass:"tab-title mt-3"},[_c('p',[_vm._v("\n                            Caractéristiques Techniques\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"specs-container"},_vm._l((_vm.fields),function(field){return _c('div',{key:field.id,staticClass:"field mb-1",attrs:{"data-group":"1"}},[_c('div',{staticClass:"label"},[_vm._v("\n                                "+_vm._s(field.label)+"\n                            ")]),_vm._v(" "),(field.pivot)?_c('div',{staticClass:"value"},[_vm._v("\n                                "+_vm._s(field.pivot.value)+"\n                            ")]):_vm._e()])}))]),_vm._v(" "),(_vm.comments)?_c('v-tab-item',{key:'comments',staticClass:"comments-container",attrs:{"id":'comments'}},[_c('div',{staticClass:"tab-title"},[_c('p',[_vm._v("\n                            "+_vm._s(_vm.comments.length)+" "+_vm._s(_vm._f("pluralize")(_vm.comments.length,'Commentaire'))+"\n                        ")]),_vm._v(" "),_c('v-menu',[_c('div',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-icon',{attrs:{"flat":""}},[_vm._v("more_horiz")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{staticClass:"li",on:{"click":function($event){_vm.createComment(_vm.product,true)}}},[_vm._v("\n                                    Ajouter un commentaire\n                                ")])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"column":""}},_vm._l((_vm.comments),function(comment){return _c('v-flex',{key:_vm.comments.id,staticClass:"comment"},[_c('v-layout',{attrs:{"justify-center":"","align-content-center":""}},[_c('v-flex',{staticClass:"mx-2",attrs:{"xs2":""}},[_c('v-layout',[(comment.user)?_c('avatar',{attrs:{"item":comment.user}}):_vm._e(),_vm._v(" "),_c('v-icon',{staticClass:"comment-type",style:({color: _vm.getCommentColor(comment.type)})},[_vm._v("fiber_manual_record")])],1)],1),_vm._v(" "),_c('v-flex',[_c('p',{staticClass:"mb-0"},[_vm._v("\n                                        "+_vm._s(comment.title)+"\n                                    ")]),_vm._v(" "),_c('p',{staticClass:"mb-2 grey--text"},[_vm._v("\n                                        "+_vm._s(comment.message)+"\n                                    ")]),_vm._v(" "),_c('p',{staticClass:"comment-date mb-0"},[_vm._v("\n                                        "+_vm._s(_vm.moment(comment.updated_at).format('DD/MM/YYYY h:mm'))+"\n                                    ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[(_vm.user_id === comment.user_id)?_c('v-menu',[_c('div',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-icon',{attrs:{"flat":""}},[_vm._v("more_horiz")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{staticClass:"li",on:{"click":function($event){_vm.createComment(_vm.product)}}},[_vm._v("\n                                      Modifier...\n                                    ")])],1)],1):_vm._e()],1)],1)],1)}))],1):_vm._e()],1)],1)]):_c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var single_ProductAside = (esExports);
// CONCATENATED MODULE: ./src/views/projects/single/ProductAside.vue
function injectStyle (ssrContext) {
  __webpack_require__("xb2K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-07dbd61c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  ProductAside,
  single_ProductAside,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var projects_single_ProductAside = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Be47":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./src/config/enum/Colors.js
var Colors = [{ value: 'yellow lighten-4' }, { value: 'light-green lighten-4' }, { value: 'orange lighten-4' }, { value: 'deep-purple lighten-4' }, { value: 'amber lighten-4' }, { value: 'pink lighten-4' }, { value: 'deep-orange lighten-4' }, { value: 'teal lighten-4' }, { value: 'light-blue lighten-4' }, { value: 'red lighten-4' }];
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/avatar/Avatar.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Avatar = ({

    props: {
        size: {
            type: String,
            required: false,
            default: '5rem'
        },
        item: {
            type: Object,
            required: true
        },
        field: {
            type: String,
            required: false,
            default: 'avatar'
        },
        zIndex: {
            type: Number,
            required: false
        },
        tooltip: {
            type: Boolean,
            required: false
        },
        defaultImg: {
            required: false
        }
    },

    data: function data() {
        return {
            show: false
        };
    },


    computed: {
        // if no images -- get first letter of item
        content: function content() {
            if (this.item.name) {
                return this.item.name[0];
            } else if (this.item.first_name) {
                if (this.item.last_name) {
                    return this.item.first_name[0] + this.item.last_name[0];
                } else {
                    return this.item.first_name[0];
                }
            } else if (this.item.label) {
                return this.item.label[0];
            } else {
                return null;
            }
        },

        // if no images -- generate a background-color
        bgColor: function bgColor() {
            var color = null;

            if (!this.item.avatar && this.item.id) {
                color = Colors[this.item.id % 10]['value'];
            }

            return color;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57cc2eca","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/avatar/Avatar.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar"},[_c('v-avatar',{class:_vm.defaultImg ? '' : _vm.bgColor,style:({zIndex: _vm.zIndex, 'min-width':_vm.size}),attrs:{"size":_vm.size}},[(_vm.tooltip)?[_c('v-tooltip',{attrs:{"right":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[(_vm.item[_vm.field])?[_c('img',{attrs:{"slot":"activator","src":_vm.item[_vm.field]},slot:"activator"})]:[_c('div',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v("\n                    "+_vm._s(_vm.content)+"\n                    ")])],_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.item.first_name)+" "+_vm._s(_vm.item.last_name))])],2)]:[(_vm.item[_vm.field])?[(_vm.item[_vm.field])?_c('img',{attrs:{"src":_vm.item[_vm.field]}}):_vm._e()]:[(_vm.defaultImg)?[(_vm.defaultImg)?_c('img',{attrs:{"src":_vm.defaultImg}}):_vm._e()]:[_c('div',[_vm._v("\n                        "+_vm._s(_vm.content)+"\n                    ")])]]]],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var avatar_Avatar = (esExports);
// CONCATENATED MODULE: ./src/components/avatar/Avatar.vue
function injectStyle (ssrContext) {
  __webpack_require__("4uzA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57cc2eca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Avatar,
  avatar_Avatar,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_avatar_Avatar = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Bw5V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/DataTable.vue + 2 modules
var DataTable = __webpack_require__("/WHI");

// EXTERNAL MODULE: ./src/components/avatar/Avatar.vue + 3 modules
var Avatar = __webpack_require__("Be47");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/products/list/Delete.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Delete = ({
    data: function data() {
        return {
            title: 'Suppression de produits',
            icon: 'delete',
            warning: true
        };
    },


    methods: {
        onClose: function onClose() {
            this.$eventHub.$emit('close-modal');
        },
        onValidate: function onValidate() {
            var _this = this;

            this.$store.state.datatable.products.selected.forEach(function (item, index) {
                _this.axios.delete('/api/products/' + item.id).then(function (response) {
                    _this.$eventHub.$emit('close-modal');
                    _this.$eventHub.$emit('reload-list');
                }).catch(function (err) {
                    return console.log(err.response.data);
                });
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-120778b6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/list/Delete.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Êtes-vous sûr de vouloir supprimer les produits suivants :")]),_vm._v(" "),_c('ul',_vm._l((_vm.$store.state.datatable.products.selected),function(project){return _c('li',[_vm._v("\n            "+_vm._s(project.label)+"\n        ")])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var list_Delete = (esExports);
// CONCATENATED MODULE: ./src/views/products/list/Delete.vue
function injectStyle (ssrContext) {
  __webpack_require__("mjAP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-120778b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Delete,
  list_Delete,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var products_list_Delete = (Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./src/config/enum/CommentTypes.js
var CommentTypes = __webpack_require__("22+B");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/products/list/Create.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Create = ({
    components: { DataTable: DataTable["a" /* default */] },
    data: function data() {
        return {
            title: 'Ajouter un produit',
            icon: 'add_circle',
            isValid: false,
            width: '1000px',
            model: {},
            ERP_color: 'primary',
            ERP_error: false,
            ERP_message: null,
            ERP_loading: false,
            step: 1,
            product_code: '',
            valid_button: false,
            next_button: true,
            created_product_id: '',
            code_ok: false,
            code_accepted: false,
            project_id: null,
            supplier_id: null,
            projects: [],
            suppliers: [],
            comments: [],
            requests: [],
            add_new: false,
            moment: moment_default.a,
            disableEnter: true,
            rules: {
                product_code: [function (v) {
                    return !!v && !isNaN(v) && v.length > 5 || 'Code de 6 chiffres obligatoire';
                }]
            },
            datatable: {
                headers: [{ text: 'Demandes', sortable: false, value: 'is_request', align: 'right' }, { text: 'Commentaires', sortable: false, value: 'is_comment', align: 'right' }, { text: 'Auteur', sortable: true, value: 'user_id', align: 'right' }, { text: 'Date', sortable: true, value: 'created_at', align: 'right' }, { text: 'Tonalite', sortable: false, value: 'type', align: 'center' }, { text: 'Message', sortable: false, align: 'right' }],
                endpoint: {
                    base: '/api/comments',
                    filters: 'product_id|=|',
                    embed: 'user'
                }
            }
        };
    },

    watch: {
        project_id: function project_id(val) {
            var _this = this;

            if (val) {
                this.suppliers = this.$_.find(this.projects, function (p) {
                    return p.id == _this.project_id;
                }).supplier_products;
            }
        },
        supplier_id: function supplier_id(val) {
            if (val && this.project_id != null) {
                this.$eventHub.$emit('set-next-button', true);
                this.$eventHub.$emit('set-valid-button', false);
                this.datatable.endpoint.filters = 'product_id|=|' + val;
            } else {
                this.$eventHub.$emit('set-next-button', false);
                this.$eventHub.$emit('set-valid-button', true);
            }
        }
    },
    methods: defineProperty_default()({
        onCodeInput: function onCodeInput() {
            var isValidLength = !!this.product_code && !isNaN(this.product_code) && this.product_code.length > 5;

            if (!isValidLength) {
                this.ERP_error = true;
                this.ERP_color = 'error';
                this.ERP_message = 'Code de 6 chiffres obligatoire';
                return;
            }

            this.sendCode(this.product_code);
        },
        sendCode: function sendCode(value) {
            var _this2 = this;

            this.ERP_loading = true;

            this.axios.get('/api/products/erp-synchro/' + value).then(function (res) {
                _this2.ERP_error = false;
                _this2.ERP_color = 'success';
                _this2.ERP_loading = false;
                _this2.ERP_message = res.data.label;

                _this2.code_accepted = true;
                _this2.$eventHub.$emit('set-next-button', true);
            }).catch(function (err) {
                if (err.response.data.status_code == 422) {
                    _this2.ERP_color = 'primary';
                    _this2.ERP_error = true;
                    _this2.ERP_loading = false;
                    _this2.ERP_message = err.response.data.message;
                } else {
                    console.log(err.response.data);
                }

                _this2.$eventHub.$emit('set-next-button', false);
                _this2.code_accepted = false;
            });
        },
        onClose: function onClose() {
            this.$eventHub.$emit('close-modal');
        },
        onNextStep: function onNextStep() {
            this.step++;
            this.$eventHub.$emit('set-valid-button', false);
            this.$eventHub.$emit('set-next-button', true);
        },
        onValidate: function onValidate() {},
        getProjects: function getProjects() {
            var _this3 = this;

            this.axios.get('/api/projects?embed=supplier_products').then(function (response) {
                _this3.projects = response.data;
            });
        },
        supplier_product_avatar: function supplier_product_avatar(data) {
            if (data.item.photo === null) {
                return __webpack_require__("jfOg");
            } else {
                return data.item.photo;
            }
        },


        getCommentColor: function getCommentColor(type) {
            var commentType = CommentTypes["a" /* CommentTypes */].find(function (el) {
                return el.value === type;
            });
            return commentType ? commentType.color : '';
        },

        setComment: function setComment(item) {
            var index = this.comments.indexOf(item.id);

            if (item.comment_selected) {
                if (index == -1) {
                    this.comments.push(item.id);
                }
            } else {
                if (index > -1) {
                    this.comments.splice(index, 1);
                }
            }
        },
        addTag: function addTag(val) {
            var _this4 = this;

            if (val.target.value != "" && this.suppliers.filter(function (s) {
                return s.name == val.target.value.toLowerCase();
            }).length == 0 && this.suppliers.filter(function (s) {
                return s.name == val.target.value.toUpperCase();
            }).length == 0) {
                this.add_new = true;
                this.axios.post('/api/suppliers', { name: val.target.value }).then(function (response) {
                    _this4.suppliers.push(response.data);
                    _this4.supplier_id = response.data.id;
                    if (_this4.$refs.select) {
                        _this4.$refs.select.searchValue = null;
                    }
                    _this4.add_new = false;
                });
            }
        },
        getSuppliers: function getSuppliers() {
            var _this5 = this;

            this.axios.get('/api/suppliers').then(function (response) {
                _this5.suppliers = response.data;
                _this5.loading = false;
            });
        },
        setRequest: function setRequest(item) {
            var index = this.requests.indexOf(item.id);

            if (item.request_selected) {
                if (index == -1) {
                    this.requests.push(item.id);
                }
            } else {
                if (index > -1) {
                    this.requests.splice(index, 1);
                }
            }
        }
    }, 'onValidate', function onValidate() {
        var _this6 = this;

        this.step = 4;
        this.$eventHub.$emit('hide-modal-actions');
        if (this.project_id != null && this.supplier_id != null) {
            this.model = {
                num: this.product_code,
                root_product_id: this.supplier_id,
                comment_ids: this.comments,
                request_ids: this.requests
            };
        } else if (this.project_id != null) {
            this.model = {
                num: this.product_code,
                project_id: this.project_id
            };
        } else if (this.project_id == null && this.supplier_id != null) {
            this.model = {
                num: this.product_code,
                supplier_id: this.supplier_id
            };
        } else {
            this.model = {
                num: this.product_code
            };
        }

        this.axios.post('/api/products/erp-synchro', this.model).then(function (res) {
            var interval = setInterval(function () {
                _this6.axios.get('/api/products/' + res.data.id).then(function (r) {
                    if (!r.data.is_syncing) {
                        clearInterval(interval);
                        _this6.axios.get('/api/products/' + res.data.id + '?embed=category.parent.parent').then(function (response) {
                            _this6.$eventHub.$emit('close-modal');

                            _this6.$router.push({
                                name: 'single-product',
                                params: {
                                    super_family: response.data.category.parent.parent.label,
                                    id: res.data.id
                                }
                            });
                        });
                    }
                });
            }, 3000);
        }).catch(function (err) {
            return console.log(err.response.data);
        });
    }),
    created: function created() {
        this.$eventHub.$emit('set-next-button', false);
        this.$eventHub.$emit('set-valid-button', false);
    },
    mounted: function mounted() {
        this.getProjects();
        this.getSuppliers();
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e90c99a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/list/Create.vue
var Create_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form"},[_c('v-container',{attrs:{"grid-list-xs":""}},[_c('v-layout',{attrs:{"wrap":""}},[(_vm.step===1)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-form',{model:{value:(_vm.code_ok),callback:function ($$v) {_vm.code_ok=$$v},expression:"code_ok"}},[_c('v-text-field',{attrs:{"label":"Code article","required":"","color":_vm.ERP_color,"loading":_vm.ERP_loading,"error":_vm.ERP_error,"hint":_vm.ERP_message,"rules":_vm.rules.product_code},on:{"input":_vm.onCodeInput},model:{value:(_vm.product_code),callback:function ($$v) {_vm.product_code=$$v},expression:"product_code"}})],1)],1)],1)],1):_vm._e(),_vm._v(" "),(this.step===2)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"label":"Relier à un projet","autocomplete":"","chips":"","clearable":"","items":_vm.projects,"item-text":"label","item-value":"id"},model:{value:(_vm.project_id),callback:function ($$v) {_vm.project_id=$$v},expression:"project_id"}}),_vm._v(" "),(_vm.project_id != null)?_c('v-select',{attrs:{"label":"Produit Fournisseur","autocomplete":"","chips":"","clearable":"","items":_vm.suppliers,"item-text":"label","item-value":"id"},on:{"change":function($event){}},scopedSlots:_vm._u([{key:"item",fn:function(data){return [(typeof data.item === 'object')?[_c('v-avatar',[_c('img',{attrs:{"src":_vm.supplier_product_avatar(data)}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(data.item.label))])],1)]:_vm._e()]}}]),model:{value:(_vm.supplier_id),callback:function ($$v) {_vm.supplier_id=$$v},expression:"supplier_id"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.step===3 && this.project_id != null)?_c('v-flex',{attrs:{"xs12":""}},[_c('data-table',{ref:"list",attrs:{"headers":_vm.datatable.headers,"endpoint":_vm.datatable.endpoint,"storeId":"comments"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-right"},[_c('v-checkbox',{attrs:{"hide-details":"","color":"accent"},on:{"change":function($event){_vm.setRequest(props.item)}},model:{value:(props.item.request_selected),callback:function ($$v) {_vm.$set(props.item, "request_selected", $$v)},expression:"props.item.request_selected"}})],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('v-checkbox',{attrs:{"hide-details":"","color":"accent"},on:{"change":function($event){_vm.setComment(props.item)}},model:{value:(props.item.comment_selected),callback:function ($$v) {_vm.$set(props.item, "comment_selected", $$v)},expression:"props.item.comment_selected"}})],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n                        "+_vm._s(props.item.user.first_name)+" "+_vm._s(props.item.user.last_name)+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n                        "+_vm._s(_vm.moment(props.item.created_at).format('DD/MM/YYYY'))+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-icon',{style:({color: _vm.getCommentColor(props.item.type)})},[_vm._v("fiber_manual_record")])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n                        "+_vm._s(props.item.message)+"\n                    ")])]}}])})],1):_vm._e(),_vm._v(" "),(this.step === 3 && _vm.project_id == null)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{ref:"select",attrs:{"items":_vm.suppliers,"label":"Fournisseur","item-text":"name","item-value":"id","autocomplete":"","autofocus":"","loading":_vm.add_new,"clearable":""},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.addTag($event)}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',[_vm._v("\n                        "+_vm._s(data.item.name)+"\n                    ")])]}},{key:"item",fn:function(data){return [(typeof data.item === 'object')?[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(data.item.name))])],1)]:_vm._e()]}}]),model:{value:(_vm.supplier_id),callback:function ($$v) {_vm.supplier_id=$$v},expression:"supplier_id"}},[_c('template',{slot:"no-data"},[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Appuyer sur Entrer pour ajouter")])],1)],1)],1)],2)],1):_vm._e(),_vm._v(" "),(_vm.step === 4)?_c('div',{staticClass:"loader"},[_c('img',{attrs:{"src":__webpack_require__("bwqQ")}}),_vm._v(" "),_c('p',[_vm._v("Ajout du produit en cours")])]):_vm._e()],1)],1)],1)}
var Create_staticRenderFns = []
var Create_esExports = { render: Create_render, staticRenderFns: Create_staticRenderFns }
/* harmony default export */ var list_Create = (Create_esExports);
// CONCATENATED MODULE: ./src/views/products/list/Create.vue
function Create_injectStyle (ssrContext) {
  __webpack_require__("3F3K")
}
var Create_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Create___vue_template_functional__ = false
/* styles */
var Create___vue_styles__ = Create_injectStyle
/* scopeId */
var Create___vue_scopeId__ = "data-v-7e90c99a"
/* moduleIdentifier (server only) */
var Create___vue_module_identifier__ = null
var Create_Component = Create_normalizeComponent(
  Create,
  list_Create,
  Create___vue_template_functional__,
  Create___vue_styles__,
  Create___vue_scopeId__,
  Create___vue_module_identifier__
)

/* harmony default export */ var products_list_Create = (Create_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/products/list/List.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






moment_default.a.locale('fr');

/* harmony default export */ var List = ({
	components: { DataTable: DataTable["a" /* default */], Avatar: Avatar["a" /* default */] },

	props: {
		filter: {
			required: false
		}
	},

	data: function data() {
		var _this = this;

		return {
			datatable: {
				toolbar: [{ icon: 'delete', callback: function callback() {
						_this.$eventHub.$emit('open-modal', products_list_Delete);
					}, level: 60 }],
				actions: [{ text: 'Ajouter un produit', icon: 'add_circle', callback: function callback() {
						_this.$eventHub.$emit('open-modal', products_list_Create);
					}, level: 60 }],
				views: [{ text: this.$route.params.group + ' Sidamo', link: 'products-group',
					params: { group: this.$route.params.group }
				}, { text: this.$route.params.group + ' Fournisseurs', link: 'products-suppliers',
					params: { group: this.$route.params.group }
				}, { text: this.$route.params.group + ' Concurrents', link: 'products-competitors',
					params: { group: this.$route.params.group }
				}],
				headers: [{ text: 'DESIGNATION', sortable: true, value: 'label', align: 'left' }, { text: 'FOURNISSEUR', sortable: false, value: 'supplier.name', align: 'right' }, { text: 'CODE ARTICLE', sortable: true, value: 'code', align: 'right' }, { text: 'DERNIÈRE MODIFICATION', sortable: true, value: 'updated_at', align: 'right' }, { text: 'FAMILLE', sortable: false, value: 'category.parent.label', align: 'right' }, { text: 'CODE SOUS FAMILLE', sortable: false, value: 'category.code', align: 'right' }, { text: 'PHOTO', sortable: false, align: 'right' }],
				endpoint: {
					base: '/api/products',
					filters: this.setFilters,
					embed: 'supplier,category.parent.parent,group'
				}
			},
			moment: moment_default.a
		};
	},


	methods: {
		rowClick: function rowClick(item) {
			this.$router.push({ name: 'single-product', params: { group: this.$route.params.group, id: item.id } });
		},
		setFilters: function setFilters() {
			var filter = '';
			if (this.filter && this.fixed_filters) {
				filter = this.fixed_filters + ',' + this.filter;
			} else if (this.filter) {
				filter = this.filter;
			} else if (this.fixed_filters) {
				filter = this.fixed_filters;
			}
			filter = filter + ',group|=|' + this.$route.params.group;

			this.datatable.endpoint.filters = filter;
		}
	},

	watch: {
		$route: function $route(val) {
			this.setFilters();
			this.$refs.list.reload();
			this.datatable.views[0].text = val.params.group + ' Sidamo';
			this.datatable.views[1].text = val.params.group + ' Fournisseurs';
			this.datatable.views[2].text = val.params.group + ' Concurrents';
		}
	},

	created: function created() {
		var _this2 = this;

		this.$eventHub.$on('reload-list', function () {
			if (_this2.$refs.list) {
				_this2.$refs.list.reload();
			}
		});

		this.setFilters();
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecd3dab6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/list/List.vue
var List_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-table',{ref:"list",attrs:{"headers":_vm.datatable.headers,"endpoint":_vm.datatable.endpoint,"toolbar":_vm.datatable.toolbar,"actions":_vm.datatable.actions,"views":_vm.datatable.views,"customRouteName":' ' + decodeURIComponent(this.$route.path.split('/')[2]),"storeId":"products","selectable":""},on:{"rowClick":_vm.rowClick},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v("\n            "+_vm._s(props.item.label)+"\n        ")]),_vm._v(" "),(props.item.supplier)?_c('td',{staticClass:"text-xs-right"},[_vm._v("\n            "+_vm._s(props.item.supplier.name)+"\n        ")]):_c('td'),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n            "+_vm._s(props.item.code)+"\n        ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n            "+_vm._s(_vm.moment(props.item.updated_at).format('L'))+"\n        ")]),_vm._v(" "),(props.item.category && props.item.category.parent)?_c('td',{staticClass:"text-xs-right"},[_vm._v("\n            "+_vm._s(props.item.category.parent.label)+"\n        ")]):_c('td'),_vm._v(" "),(props.item.category)?_c('td',{staticClass:"text-xs-right"},[_vm._v("\n            "+_vm._s(props.item.category.code)+"\n        ")]):_c('td'),_vm._v(" "),(props.item)?_c('td',{staticClass:"text-xs-right"},[_c('avatar',{attrs:{"defaultImg":__webpack_require__("jfOg"),"item":props.item,"field":"photo"}})],1):_vm._e()]}}])})}
var List_staticRenderFns = []
var List_esExports = { render: List_render, staticRenderFns: List_staticRenderFns }
/* harmony default export */ var list_List = (List_esExports);
// CONCATENATED MODULE: ./src/views/products/list/List.vue
function List_injectStyle (ssrContext) {
  __webpack_require__("JNbn")
}
var List_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var List___vue_template_functional__ = false
/* styles */
var List___vue_styles__ = List_injectStyle
/* scopeId */
var List___vue_scopeId__ = "data-v-ecd3dab6"
/* moduleIdentifier (server only) */
var List___vue_module_identifier__ = null
var List_Component = List_normalizeComponent(
  List,
  list_List,
  List___vue_template_functional__,
  List___vue_styles__,
  List___vue_scopeId__,
  List___vue_module_identifier__
)

/* harmony default export */ var products_list_List = __webpack_exports__["default"] = (List_Component.exports);


/***/ }),

/***/ "CI9P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DT1r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ED5W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/layouts/auth/Layout.vue
//
//
//
//
//
//

/* harmony default export */ var Layout = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-349d7ac3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/auth/Layout.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-layout"},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var auth_Layout = (esExports);
// CONCATENATED MODULE: ./src/layouts/auth/Layout.vue
function injectStyle (ssrContext) {
  __webpack_require__("Mb5K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-349d7ac3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Layout,
  auth_Layout,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var layouts_auth_Layout = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "EOLm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/single/SingleCard.vue + 2 modules
var SingleCard = __webpack_require__("teBh");

// EXTERNAL MODULE: ./src/components/SingleField.vue + 3 modules
var SingleField = __webpack_require__("SIDS");

// EXTERNAL MODULE: ./src/components/avatar/Avatar.vue + 3 modules
var Avatar = __webpack_require__("Be47");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/admin/users/single/ResetPassword.vue
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var ResetPassword = ({
    components: { Avatar: Avatar["a" /* default */] },

    data: function data() {
        var _this = this;

        return {
            title: 'Réinitialiser le mot de passe',
            icon: 'vpn_key',

            isValid: false,
            newPassword: '',
            newPassword2: '',
            rules: {
                Password: [function (v) {
                    return !!v || 'Mot de passe obligatoire';
                }, function (v) {
                    var rstr = null;
                    if (!/^(?=.*[a-z])[A-Za-z\d$@$!%*?&]{8,}$/.test(v)) {
                        rstr = 'Le mot de passe doit contenir au moins 8 caractères';
                    }
                    if (!/^(?=.*[A-Z])/.test(v)) {
                        if (!rstr) {
                            rstr = 'Le mot de passe doit contenir au moins une majuscule';
                        } else {
                            rstr += ', au moins une majuscule';
                        }
                    }
                    if (!/^(?=.*\d)/.test(v)) {
                        if (!rstr) {
                            rstr = 'Le mot de passe doit contenir au moins 1 chiffre';
                        } else {
                            rstr += ', au moins 1 chiffre';
                        }
                    }
                    if (/^(?=.*[$@$!%*?&])/.test(v)) {
                        if (!rstr) {
                            rstr = 'Le mot de passe ne doit pas contenir de caractère spéciaux';
                        } else {
                            rstr += 'et ne doit pas contenir de caractère spéciaux';
                        }
                    }
                    if (rstr) {
                        return rstr;
                    } else {
                        return true;
                    }
                }],
                confirmPass: [function (v) {
                    return !!v || 'Confirmation de mot de passe obligatoire';
                }, function (v) {
                    return v == _this.newPassword || 'Les mots de passe ne correspondent pas';
                }]
            }
        };
    },


    methods: {
        onClose: function onClose() {
            if (this.$refs.form) {
                this.$refs.form.reset();
            }

            this.$eventHub.$emit('close-modal');
        },
        onValidate: function onValidate() {
            var _this2 = this;

            if (this.$refs.form.validate()) {
                this.axios.put('/api/users/' + this.$store.state.single.data.id + '/password', { password: this.newPassword2 }).then(function (response) {
                    _this2.$eventHub.$emit('open-snackbar', 'primary', 'Le mot de passe à bien été mis à jour');
                    _this2.$eventHub.$emit('close-modal');
                    _this2.$refs.form.reset();
                }).catch(function (error) {
                    _this2.$eventHub.$emit('open-snackbar', 'error', 'Le mot de passe n\'à pas pu être mis à jour');
                });
            } else {
                return false;
            }
        }
    },

    mounted: function mounted() {
        var _this3 = this;

        this.$nextTick(function () {
            return _this3.$refs.input.$refs.input.focus();
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d2741c9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/users/single/ResetPassword.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();}},model:{value:(_vm.isValid),callback:function ($$v) {_vm.isValid=$$v},expression:"isValid"}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{ref:"input",attrs:{"label":"Nouveau mot de passe","type":"password","rules":_vm.rules.Password,"required":""},model:{value:(_vm.newPassword),callback:function ($$v) {_vm.newPassword=$$v},expression:"newPassword"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Confirmer le nouveau mot de passe","type":"password","rules":_vm.rules.confirmPass,"required":""},model:{value:(_vm.newPassword2),callback:function ($$v) {_vm.newPassword2=$$v},expression:"newPassword2"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var single_ResetPassword = (esExports);
// CONCATENATED MODULE: ./src/views/admin/users/single/ResetPassword.vue
function injectStyle (ssrContext) {
  __webpack_require__("SM1q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  ResetPassword,
  single_ResetPassword,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var users_single_ResetPassword = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/admin/users/single/General.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var General = ({
    components: { SingleCard: SingleCard["a" /* default */], SingleField: SingleField["a" /* default */] },

    data: function data() {
        return {
            ResetPassword: users_single_ResetPassword
        };
    },


    computed: {
        data: function data() {
            return this.$store.state.single.data;
        }
    },

    methods: {
        updateField: function updateField(key, value) {
            var _this = this;

            var resource = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'users';

            var model = {};
            model[key] = value;

            this.axios.put('/api/' + resource + '/' + this.$route.params.id, model).then(function (res) {
                return _this.$store.dispatch('updateSingleData', { key: key, value: value });
            }).catch(function (err) {
                return _this.$refs[key].setError(error.response.data.errors[key][0]);
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55a42c1a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/users/single/General.vue
var General_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single-information mt-3 text-xs-center"},[_c('v-flex',{attrs:{"xs12":""}},[_c('single-card',{staticClass:"general-infos"},[_c('template',{slot:"content"},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"subtitle"},[_vm._v(" Changer le mot de passe ")])])],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"mt-4",attrs:{"color":"primary","round":"","outline":"","disabled":_vm.$store.state.auth.user.level < 60 && _vm.$store.state.auth.user.id != _vm.$store.state.single.data.id},on:{"click":function($event){_vm.$eventHub.$emit('open-modal', _vm.ResetPassword)}}},[_vm._v("\n                          Reinitialiser le mot de passe\n                          "),_c('v-icon',{attrs:{"right":""}},[_vm._v("vpn_key")])],1)],1)],1)],1)],2)],1)],1)}
var General_staticRenderFns = []
var General_esExports = { render: General_render, staticRenderFns: General_staticRenderFns }
/* harmony default export */ var single_General = (General_esExports);
// CONCATENATED MODULE: ./src/views/admin/users/single/General.vue
function General_injectStyle (ssrContext) {
  __webpack_require__("T6DQ")
}
var General_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var General___vue_template_functional__ = false
/* styles */
var General___vue_styles__ = General_injectStyle
/* scopeId */
var General___vue_scopeId__ = "data-v-55a42c1a"
/* moduleIdentifier (server only) */
var General___vue_module_identifier__ = null
var General_Component = General_normalizeComponent(
  General,
  single_General,
  General___vue_template_functional__,
  General___vue_styles__,
  General___vue_scopeId__,
  General___vue_module_identifier__
)

/* harmony default export */ var users_single_General = __webpack_exports__["default"] = (General_Component.exports);


/***/ }),

/***/ "EwH+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fp4c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/DataTable.vue + 2 modules
var DataTable = __webpack_require__("/WHI");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/components/avatar/Avatar.vue + 3 modules
var Avatar = __webpack_require__("Be47");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/products/single/Components.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Components = ({
	components: { DataTable: DataTable["a" /* default */], Avatar: Avatar["a" /* default */] },

	data: function data() {
		return {
			moment: moment_default.a,
			datatable: {
				headers: [{ text: 'Nom', sortable: true, value: 'label', align: 'left' }, { text: 'Code', sortable: true, value: 'code', align: 'right' }],
				endpoint: {
					base: '/api/products',
					filters: 'parents.linked_product.product_id|=|' + this.$route.params.id + ',group|=|component'
				}
			},
			hide_demand: false
		};
	},

	methods: {
		rowClick: function rowClick(item) {}
	},
	created: function created() {
		var _this = this;

		this.$eventHub.$on('reload-list', function () {
			if (_this.$refs.list) {
				_this.$refs.list.reload();
			}
		});
	},
	mounted: function mounted() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd91a3a2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/single/Components.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-table',{ref:"list",attrs:{"headers":_vm.datatable.headers,"toolbar":_vm.datatable.toolbar,"actions":_vm.datatable.actions,"endpoint":_vm.datatable.endpoint,"storeId":"comments"},on:{"rowClick":_vm.rowClick},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left author"},[_c('avatar',{attrs:{"item":props.item,"field":"photo"}}),_vm._v("\n            "+_vm._s(props.item.label)+"\n        ")],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n            "+_vm._s(props.item.code)+"\n        ")])]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var single_Components = (esExports);
// CONCATENATED MODULE: ./src/views/products/single/Components.vue
function injectStyle (ssrContext) {
  __webpack_require__("sKkj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dd91a3a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Components,
  single_Components,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var products_single_Components = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "GIJl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GnW9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/DataTable.vue + 2 modules
var DataTable = __webpack_require__("/WHI");

// EXTERNAL MODULE: ./src/components/files/DeleteFiles.vue + 2 modules
var DeleteFiles = __webpack_require__("MJ/k");

// EXTERNAL MODULE: ./src/components/files/CreateFiles.vue + 2 modules
var CreateFiles = __webpack_require__("/iAd");

// EXTERNAL MODULE: ./src/components/files/UpdateFiles.vue + 2 modules
var UpdateFiles = __webpack_require__("Hhha");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/projects/single/Files.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






moment_default.a.locale('fr');

/* harmony default export */ var Files = ({

    components: { DataTable: DataTable["a" /* default */], UpdateFiles: UpdateFiles["a" /* default */], CreateFiles: CreateFiles["a" /* default */], DeleteFiles: DeleteFiles["a" /* default */] },

    data: function data() {
        var _this = this;

        return {
            moment: moment_default.a,
            datatable: {
                toolbar: [{ icon: 'delete', callback: function callback() {
                        _this.$eventHub.$emit('open-modal', DeleteFiles["a" /* default */], { entity: 'projects' });
                    }, level: 60 }],
                actions: [{ text: 'Ajouter un fichier', icon: "add_circle", callback: function callback() {
                        _this.$eventHub.$emit('open-modal', CreateFiles["a" /* default */], { entity: 'projects' });
                    }, level: 60 }],
                headers: [{ text: 'Nom', sortable: true, value: 'name', align: 'left' }, { text: 'Date de l\'ajout', sortable: true, value: 'created_at', align: 'right' }, { text: 'Auteur', sortable: false, value: 'created_by', align: 'right' }, { text: 'Type', sortable: true, value: 'type', align: 'right' }, { text: 'Action', sortable: false, value: 'action' }],
                endpoint: {
                    base: '/api/files',
                    filters: 'projects.id|=|' + this.$route.params.id,
                    embed: ''
                }
            },
            users: [],
            items: []
        };
    },


    methods: {
        rowClick: function rowClick(item) {
            this.$eventHub.$emit('view-file', item, this.items);
        },
        update_count: function update_count(count) {
            this.$store.dispatch('updateSingleData', { key: 'files_count', value: count });
            this.$store.dispatch('updateSingleData', { key: 'files', value: this.$refs.list.items });
        }
    },
    created: function created() {
        var _this2 = this;

        this.$eventHub.$on('reload-list', function () {
            if (_this2.$refs.list) {
                _this2.$refs.list.reload();
            }
        });
        this.$eventHub.$on('getItems', function (items) {
            _this2.items = items;
        });
    },
    mounted: function mounted() {
        var _this3 = this;

        this.axios.get('/api/users').then(function (response) {
            _this3.users = response.data;
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e2f143a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/projects/single/Files.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-files"},[_c('data-table',{ref:"list",attrs:{"headers":_vm.datatable.headers,"endpoint":_vm.datatable.endpoint,"toolbar":_vm.datatable.toolbar,"actions":_vm.datatable.actions,"views":_vm.datatable.views,"storeId":"files","selectable":"","isFixed":false},on:{"rowClick":_vm.rowClick,"total_updated":_vm.update_count},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v("\n                "+_vm._s(props.item.label)+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n                "+_vm._s(_vm.moment(props.item.created_at).format('L'))+"\n            ")]),_vm._v(" "),(_vm.$_.find(_vm.users,function (u) { return u.id == props.item.created_by; }))?_c('td',{staticClass:"text-xs-right"},[_vm._v("\n                "+_vm._s(_vm.$_.find(_vm.users,function (u) { return u.id == props.item.created_by; }).first_name)+" "+_vm._s(_vm.$_.find(_vm.users,function (u) { return u.id == props.item.created_by; }).last_name)+"\n            ")]):_c('td',{staticClass:"text-xs-right"},[_vm._v("\n                -\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n                "+_vm._s(props.item.type)+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-btn',{attrs:{"small":"","icon":"","disabled":_vm.$store.state.auth.user.level < 60},on:{"click":function($event){$event.stopPropagation();_vm.$refs.updatefile.open(props.item)}}},[_c('v-icon',[_vm._v("mode_edit")])],1)],1)]}}])}),_vm._v(" "),_c('update-files',{ref:"updatefile",attrs:{"entity":"projects"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var single_Files = (esExports);
// CONCATENATED MODULE: ./src/views/projects/single/Files.vue
function injectStyle (ssrContext) {
  __webpack_require__("N+fi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e2f143a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Files,
  single_Files,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var projects_single_Files = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Hhha":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/components/files/DeleteFiles.vue + 2 modules
var DeleteFiles = __webpack_require__("MJ/k");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/files/UpdateFiles.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var UpdateFiles = ({
    props: {
        entity: {
            required: true
        }
    },
    data: function data() {
        return {
            DeleteFiles: DeleteFiles["a" /* default */],
            dialog: false,
            model: {
                label: ''
            },
            rules: {
                name: [function (v) {
                    return !!v || 'Nom du fichier obligatoire';
                }]
            },
            tags: [],
            item: ''
        };
    },

    methods: {
        // when modal is open
        open: function open(item) {
            this.dialog = true;
            this.model.label = item.label;
            this.item = item;
            this.$store.dispatch('setSelected', { tableId: 'files', selected: item });
        },

        // when form is validate
        onValidate: function onValidate() {
            var _this = this;

            this.axios.put('/api/files/' + this.item.id, this.model).then(function (response) {
                _this.$eventHub.$emit('reload-list');
                _this.onClose();
            });
        },

        // reset the form on close 
        onClose: function onClose() {
            if (this.$refs.form) {
                this.$refs.form.reset();
            }
            this.dialog = false;
            this.$store.dispatch('clearSelected', { tableId: 'files' });
        }
    },
    created: function created() {
        var _this2 = this;

        this.$eventHub.$on('close-modal', function () {
            _this2.onClose();
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44f0d940","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/files/UpdateFiles.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"750px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary"},[_c('h2',[_c('v-icon',{attrs:{"dark":""}},[_vm._v("file_upload")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("Modifier un fichier")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","icon":""},on:{"click":_vm.onClose}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();}}},[_c('v-container',{attrs:{"grid-list-xs":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Nom","rules":_vm.rules.name,"required":"","autofocus":""},model:{value:(_vm.model.label),callback:function ($$v) {_vm.$set(_vm.model, "label", $$v)},expression:"model.label"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"round":"","small":"","outline":"","color":"primary"},nativeOn:{"click":function($event){_vm.$eventHub.$emit('open-modal', _vm.DeleteFiles,{ entity: _vm.entity })}}},[_c('v-icon',[_vm._v("delete")]),_vm._v("Supprimer")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"round":"","small":"","outline":"","color":"primary"},nativeOn:{"click":function($event){_vm.onClose($event)}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"round":"","depressed":"","small":"","color":"primary"},nativeOn:{"click":function($event){_vm.onValidate($event)}}},[_vm._v("Valider")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var files_UpdateFiles = (esExports);
// CONCATENATED MODULE: ./src/components/files/UpdateFiles.vue
function injectStyle (ssrContext) {
  __webpack_require__("CI9P")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44f0d940"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  UpdateFiles,
  files_UpdateFiles,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_files_UpdateFiles = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I8Uc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IuYO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/DataTable.vue + 2 modules
var DataTable = __webpack_require__("/WHI");

// EXTERNAL MODULE: ./src/components/avatar/Avatar.vue + 3 modules
var Avatar = __webpack_require__("Be47");

// CONCATENATED MODULE: ./src/config/enum/TestElementStatuses.js
var TestElementStatuses = [{ label: 'Non validé', value: 'failed', color: '#FF3D62' }, { label: 'Validé', value: 'validated', color: '#8BEA67' }, { label: 'En cours', value: 'pending', color: '#D4DCE5' }];
// EXTERNAL MODULE: ./src/config/enum/TestStatuses.js
var TestStatuses = __webpack_require__("KxZN");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/products/single/RunTest.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





moment_default.a.locale('fr');

/* harmony default export */ var RunTest = ({
    components: {
        Avatar: Avatar["a" /* default */]
    },
    props: {
        params: {
            required: true
        }
    },
    data: function data() {
        return {
            test_id: null,
            imgFullPath: null,
            selectedRequest: {
                id: 0,
                comment: '',
                status: 'pending',
                invalidation_files: [],
                files_1: [],
                files_2: []
            },
            moment: moment_default.a,
            first_not_saved: 0,
            product_name: '',
            valid_button: false,
            cancel_button: false,
            fullscreen: true,
            card_text_class: 'fullscreen-modal-text',
            requests: [],
            model: {
                status: 'pending',
                comment: '',
                invalidation_files: []
            },
            TestElementStatuses: TestElementStatuses,
            TestStatuses: TestStatuses["a" /* TestStatuses */],
            display: true,
            test_status: null,
            selected_carac: [],
            caracts: [],
            selected_accessory: [],
            accessories: [],
            final: false,
            product: '',
            loading: false,
            loadingRequests: false,
            final_comment: null
        };
    },

    methods: {
        addImgPath: function addImgPath() {
            return __webpack_require__("c8ny");
        },

        // delete image front teh invalidation comment
        deleteImg: function deleteImg(fileIndex) {
            var _this = this;

            this.display = false;
            var fileId = undefined;
            //Get the id of the file to delete
            if (this.selectedRequest.invalidation_files[fileIndex] !== undefined) {
                fileId = this.selectedRequest.invalidation_files[fileIndex].id;
            }
            if (fileId == undefined) {
                this.axios.get('/api/elements/' + this.selectedRequest.id + '/file').then(function (response) {
                    fileId = response[fileIndex] ? response[fileIndex].id : undefined;
                });
            }
            //Delete the file from DB and storage
            if (fileId) {
                this.axios.delete('/api/elements/' + this.selectedRequest.id + '/file/' + fileId).then(function (response) {}).catch(function (error) {
                    _this.$eventHub.$emit('open-snackbar', 'error', 'Un problème est survenu lors de la suppression du fichier');
                });
            } else {
                this.model.invalidation_files.splice(fileIndex, 1);
            }
            //update the requests list
            var get_index = this.requests.findIndex(function (r) {
                return r.id == _this.selectedRequest.id;
            });
            this.selectedRequest.invalidation_files.splice(fileIndex, 1);
            this.requests[get_index].invalidation_files = this.selectedRequest.invalidation_files;
            this.display = true;
        },

        // upload invalidation image
        onFileChange: function onFileChange(evt, fileIndex) {
            var _this2 = this;

            if (fileIndex >= 0) {
                this.model.invalidation_files[fileIndex].path = URL.createObjectURL(evt.target.files[0]);
                this.model.invalidation_files[fileIndex].file = evt.target.files[0];
                this.model.invalidation_files[fileIndex].toUpdate = true;

                this.selectedRequest.invalidation_files[fileIndex].path = URL.createObjectURL(evt.target.files[0]);
                this.selectedRequest.invalidation_files[fileIndex].file = evt.target.files[0];
                this.selectedRequest.invalidation_files[fileIndex].toUpdate = true;

                var get_index = this.requests.findIndex(function (r) {
                    return r.id == _this2.selectedRequest.id;
                });
                this.requests[get_index].invalidation_files = this.selectedRequest.invalidation_files;
            } else {
                this.model.invalidation_files.push({
                    path: URL.createObjectURL(evt.target.files[0]),
                    file: evt.target.files[0],
                    toUpdate: true
                });

                this.selectedRequest.invalidation_files.push({
                    path: URL.createObjectURL(evt.target.files[0]),
                    file: evt.target.files[0],
                    toUpdate: true
                });
            }
        },
        // get teh status of an element
        getStatus: function getStatus(element, index) {
            if (index < this.first_not_saved) {
                return '';
            } else if (element.status != null) {
                return '';
            } else {
                return ' - Non validé';
            }
        },

        // select the request
        selectRequest: function selectRequest(index) {
            if (index != null || index != undefined) {
                // on click on item
                this.final = false;
                var selectedRequestToCopy = this.requests[index];
                if (selectedRequestToCopy.status == null || selectedRequestToCopy.status == 'pending') {
                    this.first_not_saved = index;
                }
                this.selectedRequest.id = selectedRequestToCopy.id;
                this.model.status = selectedRequestToCopy.status ? selectedRequestToCopy.status : selectedRequest.status;
                this.selectedRequest.status = this.model.status;
                this.selectedRequest.title = selectedRequestToCopy.title;
                this.selectedRequest.title_2 = selectedRequestToCopy.title_2;
                this.selectedRequest.message = selectedRequestToCopy.message;
                this.selectedRequest.message_2 = selectedRequestToCopy.message_2;
                if (selectedRequestToCopy.title_2 !== '' && selectedRequestToCopy.message_2 !== '') {
                    this.selectedRequest.nbCol = 2;
                } else {
                    this.selectedRequest.nbCol = 1;
                }
                this.selectedRequest.index = index;
                this.selectedRequest.files_1 = selectedRequestToCopy.files_1;
                this.selectedRequest.files_2 = selectedRequestToCopy.files_2;
                this.selectedRequest.attachment_files = selectedRequestToCopy.attachment_files;
                this.selectedRequest.invalidation_files = selectedRequestToCopy.invalidation_files;
                this.selectedRequest.comment = selectedRequestToCopy.comment;
                if (this.selectedRequest.title.includes(this.params.product_id)) {
                    if (this.selectedRequest.status == null || this.selectedRequest.status == 'pending') {
                        this.model.status = 'validated';
                    } else {
                        this.model.status = this.selectedRequest.status;
                    }
                }
            } else {
                if (this.test_status != 'pending') {
                    this.final = true;
                } else {
                    if (this.requests.filter(function (r) {
                        return r.status != 'pending' && r.status != null;
                    }).length == this.requests.length) {
                        this.final = true;
                        // this.test_status = this.requests.filter(r => r.status == 'failed').length > 0 ? 'failed' : 'finished'
                        this.test_status = 'to_validate';
                    }
                }
            }
        },
        setStatus: function setStatus(status) {
            var _this3 = this;

            // set the sttaus of a request
            if (this.selectedRequest.title.includes('Features')) {
                if (this.caracts.filter(function (x) {
                    return !_this3.selected_carac.includes(x);
                }).length > 0) {
                    this.model.status = 'failed';
                } else {
                    this.model.status = 'validated';
                }
            } else {
                this.model.status = status;
            }
            //when invalidation box is open -- scroll to this one
            if (this.model.status == 'failed') {
                var body = document.querySelector('.content-container');
                setTimeout(function () {
                    body.scroll({
                        top: body.scrollHeight - body.clientHeight,
                        left: 0,
                        behavior: 'smooth'
                    });
                }, 5);
            }
        },
        saveRequest: function saveRequest() {
            var _this4 = this;

            var save = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            this.loading = true;
            if (!save) {
                var data = {
                    status: this.model.status,
                    comment: this.model.status === 'failed' ? this.selectedRequest.comment : null
                };
                if (this.selectedRequest.title.includes(this.params.product_id)) {
                    if (this.selectedRequest.title.includes('Features')) {
                        data.message = this.caracts.filter(function (x) {
                            return !_this4.selected_carac.includes(x);
                        }).join(',');
                    } else {
                        data.message = this.accessories.filter(function (x) {
                            return !_this4.selected_accessory.includes(x);
                        }).join(',');
                    }
                }
                this.axios.put('/api/elements/' + this.selectedRequest.id, data).then(function (response) {
                    var savePhotoRec = function savePhotoRec(index) {
                        if (_this4.model.invalidation_files[index]) {
                            var _data = new FormData();
                            _data.append('file', _this4.model.invalidation_files[index].file), _data.append('location', 'invalidation-comment');
                            _data.append('size', 750);
                            _this4.axios.post('/api/elements/' + _this4.selectedRequest.id + '/file', _data).then(function (response) {
                                savePhotoRec(++index);
                            }).catch(function (err) {
                                return console.log(err);
                            });
                        }
                    };
                    if (_this4.model.status === 'failed') {
                        savePhotoRec(0);
                    }
                    _this4.selectedRequest.status = _this4.model.status;
                    if (response.status === 200 || response.status === 204) {
                        var get_index = _this4.requests.findIndex(function (r) {
                            return r.id == _this4.selectedRequest.id;
                        });
                        if (_this4.requests[get_index]) {
                            _this4.requests[get_index].comment = _this4.selectedRequest.comment;
                            _this4.requests[get_index].invalidation_files = _this4.selectedRequest.invalidation_files;
                            _this4.requests[get_index].status = _this4.selectedRequest.status;
                        }
                        // this.selectedRequest.invalidation_files =  this.model.invalidation_files;

                        _this4.first_not_saved++;
                        if (_this4.selectedRequest.index === _this4.requests.length - 1) {
                            _this4.final = true;
                            _this4.test_status = 'to_validate';
                            // if(this.requests.filter(r => r.status == 'failed').length > 0){
                            //     this.test_status = 'failed'
                            // }
                        } else {
                            _this4.model = {
                                status: 'pending',
                                comment: '',
                                invalidation_files: []
                            };
                            _this4.selectNextRequest();
                        }
                        _this4.loading = false;
                    }
                });
            } else {
                this.axios.put('/api/tests/' + this.test_id, { status: this.test_status, final_comment: this.final_comment }).then(function (response) {
                    _this4.onClose();
                    _this4.loading = false;
                });
            }
        },
        selectNextRequest: function selectNextRequest() {
            var current_index = this.selectedRequest.index;
            if (current_index < this.requests.length - 1) {
                this.selectRequest(current_index + 1);
            }
        },
        onClose: function onClose() {
            this.$eventHub.$emit('close-modal');
            this.$eventHub.$emit('reload-list');
            this.$router.push({ name: this.$route.name });
        },
        getElements: function getElements() {
            var _this5 = this;

            this.loadingRequests = true;
            this.axios.get('/api/elements?filters=test_id|=|' + this.test_id + '&embed=files,symbol.files').then(function (response) {
                _this5.requests = response.data.map(function (el) {
                    el.files_1 = el.files.filter(function (file) {
                        return file.pivot.location === 'area-1' && file.pivot.file_type != 'attachment';
                    });
                    el.files_2 = el.files.filter(function (file) {
                        return file.pivot.location === 'area-2' && file.pivot.file_type != 'attachment';
                    });
                    el.attachment_files = el.files.filter(function (file) {
                        return file.pivot.file_type === 'attachment';
                    });
                    el.invalidation_files = el.files.filter(function (file) {
                        return file.pivot.location === 'invalidation-comment';
                    });
                    return el;
                });

                _this5.fields.forEach(function (f) {
                    _this5.caracts.push(f.id);
                });
                _this5.caracts.push(0);
                _this5.selected_carac = _this5.caracts;
                if (_this5.$_.find(_this5.requests, function (r) {
                    return r.title == 'Features_' + _this5.params.product_id;
                }) && _this5.$_.find(_this5.requests, function (r) {
                    return r.title == 'Features_' + _this5.params.product_id;
                }).message) {
                    var message = _this5.$_.find(_this5.requests, function (r) {
                        return r.title == 'Features_' + _this5.params.product_id;
                    }).message.split(',').map(Number);
                    _this5.selected_carac = _this5.caracts.filter(function (x) {
                        return !message.includes(x);
                    });
                }

                _this5.accessoriesList.forEach(function (f) {
                    _this5.accessories.push(f.id);
                });
                _this5.selected_accessory = _this5.accessories;
                if (_this5.$_.find(_this5.requests, function (r) {
                    return r.title == 'Accessories_' + _this5.params.product_id;
                }) && _this5.$_.find(_this5.requests, function (r) {
                    return r.title == 'Accessories_' + _this5.params.product_id;
                }).message) {
                    var _message = _this5.$_.find(_this5.requests, function (r) {
                        return r.title == 'Accessories_' + _this5.params.product_id;
                    }).message.split(',').map(Number);
                    _this5.selected_accessory = _this5.accessories.filter(function (x) {
                        return !_message.includes(x);
                    });
                }

                var firstNotAnsweredIndex = _this5.requests.findIndex(function (el) {
                    return el.status === 'pending';
                });
                if (firstNotAnsweredIndex > -1) {
                    _this5.first_not_saved = firstNotAnsweredIndex;
                    _this5.selectRequest(firstNotAnsweredIndex);
                } else {
                    _this5.first_not_saved = _this5.requests.length;
                    if (!_this5.requests[_this5.first_not_saved - 1] || _this5.requests[_this5.first_not_saved - 1].status == 'pending' || _this5.requests[_this5.first_not_saved - 1].status == null) {
                        _this5.selectRequest(0);
                    } else {
                        _this5.selectRequest();
                    }
                }
                _this5.loadingRequests = false;
            });
        },
        get_product: function get_product() {
            var _this6 = this;

            if (this.params.product_id) {
                this.axios.get('/api/products/' + this.params.product_id).then(function (response) {
                    _this6.product = response.data;
                });
            }
        }
    },
    created: function created() {
        var _this7 = this;

        this.product_name = this.params.product_label;
        this.get_product();
        // when it's new test
        if (this.params.run_new_test) {
            this.first_not_saved = 0;
            var test_to_post = {
                status: 'pending',
                user_id: this.$store.state.auth.user.id,
                product_id: this.params.product_id
            };

            this.axios.post('/api/tests', test_to_post).then(function (response) {
                _this7.test_id = response.data.id;
                _this7.getElements();
            });
        } else if (this.params.id) {
            // else to read or continue one
            this.test_id = this.params.id;
            this.test_status = this.params.status;
            this.final_comment = this.params.final_comment;
            this.getElements();
        }
    },

    computed: {
        fields: function fields() {
            var fields = this.$store.state.single.data.fields;
            fields = this.$_.orderBy(fields, function (f) {
                return f.pivot.position;
            });
            return fields.concat(this.$store.state.single.data.features);
        },
        accessoriesList: function accessoriesList() {
            return this.$store.state.single.data.accessories;
        },
        failedRequests: function failedRequests() {
            var _this8 = this;

            var request = [];
            this.requests.filter(function (r) {
                return r.status == 'failed';
            }).forEach(function (rr) {
                if (!rr.title.includes(_this8.params.product_id)) {
                    request.push(rr);
                }
            });
            return request;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6930da76","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/single/RunTest.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-container"},[_c('v-toolbar',{staticClass:"modal-header"},[_c('div',{staticClass:"app-logo"},[_c('img',{attrs:{"src":__webpack_require__("p91O")}})]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.onClose($event)}}},[_c('v-icon',[_vm._v("arrow_back")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Contrôle - "+_vm._s(_vm.product_name))])],1),_vm._v(" "),_c('div',{staticClass:"comments-aside"},[_c('div',{staticClass:"scroll-y",attrs:{"column":""}},[_c('ul',[(_vm.$_.find(_vm.requests, function (r) { return r.title == 'Features_'+_vm.params.product_id; }))?_c('li',{staticClass:"item"},[_c('a',{on:{"click":function($event){_vm.selectRequest(0)}}},[_c('v-layout',{class:{'current-item': _vm.selectedRequest.id == _vm.$_.find(_vm.requests, function (r) { return r.title == 'Features_'+_vm.params.product_id; }).id && _vm.final == false, 'item-container': true},attrs:{"column":"","justify-space-around":"","align-content-space-around":""}},[_c('v-flex',{staticClass:"item-title"},[_vm._v("\n                                Caractéristiques produit\n                                "),_c('v-spacer'),_vm._v(" "),(_vm.$_.find(_vm.requests, function (r) { return r.title == 'Features_'+_vm.params.product_id; }))?[_c('span',{staticClass:"status",style:('backgroundColor:'+_vm.$_.find(_vm.TestElementStatuses,function (e) { return e.value == _vm.$_.find(_vm.requests, function (r) { return r.title == 'Features_'+_vm.params.product_id; }).status; }).color)})]:_vm._e()],2)],1)],1)]):_vm._e(),_vm._v(" "),(_vm.$_.find(_vm.requests, function (r) { return r.title == 'Accessories_'+_vm.params.product_id; }))?_c('li',{staticClass:"item"},[_c('a',{on:{"click":function($event){_vm.selectRequest(1)}}},[_c('v-layout',{class:{'current-item':_vm.selectedRequest.id == _vm.$_.find(_vm.requests, function (r) { return r.title == 'Accessories_'+_vm.params.product_id; }).id && _vm.final == false, 'item-container': true},attrs:{"column":"","justify-space-around":"","align-content-space-around":""}},[_c('v-flex',{staticClass:"item-title"},[_vm._v("\n                                Accessoires\n                                "),_c('v-spacer'),_vm._v(" "),(_vm.$_.find(_vm.requests, function (r) { return r.title == 'Accessories_'+_vm.params.product_id; }))?[_c('span',{staticClass:"status",style:('backgroundColor:'+_vm.$_.find(_vm.TestElementStatuses,function (e) { return e.value == _vm.$_.find(_vm.requests, function (r) { return r.title == 'Accessories_'+_vm.params.product_id; }).status; }).color)})]:_vm._e()],2)],1)],1)]):_vm._e(),_vm._v(" "),_c('li',{staticClass:"item"},[_c('v-layout',{class:{'item-container': true},attrs:{"column":"","justify-space-around":"","align-content-space-around":""}},[_c('v-flex',{staticClass:"item-title"},[_c('b',[_vm._v("Demandes")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('ul',_vm._l((_vm.requests),function(element,index){return (!element.title.includes(_vm.params.product_id))?_c('li',{key:index,staticClass:"item"},[_c('a',{on:{"click":function($event){_vm.selectRequest(index)}}},[_c('v-layout',{class:{'current-item': element.id === _vm.selectedRequest.id && _vm.final == false, 'item-container': true, 'unclick' : index > _vm.first_not_saved},attrs:{"column":"","justify-space-around":"","align-content-space-around":""}},[_c('v-flex',{staticClass:"item-title"},[_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(element.title))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(element.status !== 'pending')?_c('span',{staticClass:"status",style:('backgroundColor:'+_vm.$_.find(_vm.TestElementStatuses,function (e) { return e.value == element.status; }).color)}):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"item-status"},[_vm._v("Dernière modification le "+_vm._s(_vm.moment(element.updated_at).format('DD/MM/YYYY')))]),_vm._v(" "),_c('v-flex',{staticClass:"item-status"},[_vm._v(_vm._s(_vm.getStatus(element,index)))])],1)],1)]):_vm._e()}))],1)],1),_vm._v(" "),_c('li',{staticClass:"item"},[_c('a',{on:{"click":function($event){_vm.selectRequest()}}},[_c('v-layout',{class:{'current-item':_vm.final == true, 'item-container': true},attrs:{"column":"","justify-space-around":"","align-content-space-around":""}},[_c('v-flex',{staticClass:"item-title"},[_vm._v("\n                                Récapitulatif\n                            ")])],1)],1)])])])]),_vm._v(" "),(_vm.loadingRequests)?_c('div',{staticClass:"loader"},[_c('img',{attrs:{"src":__webpack_require__("bwqQ")}})]):_vm._e(),_vm._v(" "),(!_vm.loadingRequests)?_c('div',{staticClass:"content-container scroll-y",attrs:{"id":"scroll-container"}},[(_vm.$_.find(_vm.requests, function (r) { return r.title == 'Features_'+_vm.params.product_id; }) && _vm.selectedRequest.id == _vm.$_.find(_vm.requests, function (r) { return r.title == 'Features_'+_vm.params.product_id; }).id && _vm.final == false)?_c('div',{directives:[{name:"scroll",rawName:"v-scroll",value:({target: '#scroll-container'}),expression:"{target: '#scroll-container'}"}]},[_c('v-flex',{staticClass:"pt-5",attrs:{"xs10":"","offset-xs1":""}},[_c('v-layout',{attrs:{"column":""}},[_c('h2',{staticClass:"mb-3"},[_vm._v("Produit : ")]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","mb-5":""}},[_c('v-layout',{staticClass:"feature_info",attrs:{"row":"","wrap":""}},[_c('div',{staticClass:"mr-4 zoom",on:{"click":function($event){_vm.$eventHub.$emit('view-file', _vm.product.photo, 'avatar')}}},[(_vm.product)?_c('avatar',{attrs:{"item":_vm.product,"size":"15rem","field":"photo"}}):_vm._e()],1),_vm._v(" "),_c('div',[_c('p',[_c('span',[_vm._v("Label: ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.product_name))])]),_vm._v(" "),_c('p',[_c('span',[_vm._v("Code: ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.product.code))])]),_vm._v(" "),_c('p',[_c('span',[_vm._v("Ean: ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.product.ean))])])]),_vm._v(" "),_c('v-checkbox',{attrs:{"value":0,"disabled":_vm.test_status != null && _vm.test_status != 'pending'},on:{"change":_vm.setStatus},model:{value:(_vm.selected_carac),callback:function ($$v) {_vm.selected_carac=$$v},expression:"selected_carac"}})],1)],1),_vm._v(" "),_c('h2',{staticClass:"mb-3"},[_vm._v("Caractéristiques : ")]),_vm._v(" "),_vm._l((_vm.fields),function(field,index){return _c('v-flex',{key:index,attrs:{"xs5":""}},[(field.pivot && field.pivot.is_visible == 1)?_c('v-layout',{staticClass:"features",attrs:{"row":"","wrap":""}},[_c('p',[_c('span',[_vm._v(_vm._s(field.label))]),_vm._v(" "),(field.pivot)?_c('span',[_vm._v(_vm._s(field.pivot.value))]):_vm._e()]),_vm._v(" "),_c('v-checkbox',{attrs:{"value":field.id,"disabled":_vm.test_status != null && _vm.test_status != 'pending'},on:{"change":_vm.setStatus},model:{value:(_vm.selected_carac),callback:function ($$v) {_vm.selected_carac=$$v},expression:"selected_carac"}})],1):(field.is_exportable == 1)?_c('v-layout',{staticClass:"features",attrs:{"row":"","wrap":""}},[_c('p',[_c('span',[_vm._v(_vm._s(field.label))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(field.value))])]),_vm._v(" "),_c('v-checkbox',{attrs:{"value":field.id,"disabled":_vm.test_status != null && _vm.test_status != 'pending'},on:{"change":_vm.setStatus},model:{value:(_vm.selected_carac),callback:function ($$v) {_vm.selected_carac=$$v},expression:"selected_carac"}})],1):_vm._e()],1)})],2),_vm._v(" "),(_vm.final == false && _vm.model.status === 'failed' && _vm.display && (_vm.selectedRequest.status == 'pending' || _vm.selectedRequest.status == null))?_c('div',{staticClass:"invalidation-box mt-3"},[_c('div',{staticClass:"invalidation-comment"},[_c('v-text-field',{staticClass:"comment-text",attrs:{"name":"message_text_field","label":"Votre remarque (laissez vide si vous n'en avez pas)","hint":"","multi-line":"","rows":"2"},model:{value:(_vm.selectedRequest.comment),callback:function ($$v) {_vm.$set(_vm.selectedRequest, "comment", $$v)},expression:"selectedRequest.comment"}}),_vm._v(" "),_c('v-layout',{staticClass:"comment-text"},[_vm._l((_vm.selectedRequest.invalidation_files),function(file,index){return _c('div',{key:file.id,staticClass:"mr-2"},[_c('v-menu',{staticStyle:{"zIndex":"204"},attrs:{"offset-y":"","content-class":"files"}},[_c('div',{attrs:{"slot":"activator"},slot:"activator"},[_c('label',{staticClass:"invalidation-image"},[_c('v-icon',{staticClass:"hover-alpha"},[_vm._v("mode_edit")]),_vm._v(" "),_c('img',{attrs:{"src":file.path},on:{"click":function($event){_vm.$eventHub.$emit('view-file',file)}}})],1)]),_vm._v(" "),_c('v-list',[_c('v-list-tile',{staticClass:"li"},[_c('label',{attrs:{"for":'file-input-'+index}},[_vm._v("Modifier l'image")]),_vm._v(" "),_c('input',{staticClass:"input-img",staticStyle:{"display":"none"},attrs:{"id":'file-input-'+index,"type":"file"},on:{"change":function (event){_vm.onFileChange(event,index)}}})]),_vm._v(" "),_c('v-list-tile',{staticClass:"li",on:{"click":function($event){_vm.deleteImg(index)}}},[_c('v-list-tile-title',[_vm._v("Supprimer l'image")])],1)],1)],1)],1)}),_vm._v(" "),(!_vm.selectedRequest.invalidation_files || _vm.selectedRequest.invalidation_files.length < 2)?_c('div',{staticClass:"mr-2"},[_c('v-menu',{staticStyle:{"zIndex":"204"},attrs:{"offset-y":"","content-class":"files"}},[_c('div',{attrs:{"slot":"activator"},slot:"activator"},[_c('label',{staticClass:"invalidation-image"},[_c('img',{staticClass:"add-image",attrs:{"src":_vm.addImgPath()}})])]),_vm._v(" "),_c('v-list',[_c('v-list-tile',[_c('label',{attrs:{"for":'file-input'}},[_vm._v("Ajouter une image")]),_vm._v(" "),_c('input',{staticClass:"input-img",staticStyle:{"display":"none"},attrs:{"id":"file-input","type":"file"},on:{"change":function (event){_vm.onFileChange(event)}}})])],1)],1)],1):_vm._e()],2)],1)]):_vm._e(),_vm._v(" "),(_vm.final == true && this.selectedRequest.status === 'failed' && ((!!this.selectedRequest.comment && this.selectedRequest.comment!=='') || (!!this.selectedRequest.invalidation_files && this.selectedRequest.invalidation_files.length>0)))?_c('div',{staticClass:"invalidation-box mt-3"},[_c('div',{staticClass:"invalidation-comment"},[_c('div',{staticClass:"comment-text"},[_vm._v("\n                              "+_vm._s(_vm.selectedRequest.comment)+"\n                        ")]),_vm._v(" "),_c('v-layout',{staticClass:"comment-text"},_vm._l((_vm.selectedRequest.invalidation_files),function(file,index){return _c('div',{key:file.id,staticClass:"mr-2"},[_c('label',{staticClass:"comment-image"},[_c('img',{attrs:{"src":file.path},on:{"click":function($event){_vm.$eventHub.$emit('view-file',file)}}})])])}))],1)]):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(_vm.$_.find(_vm.requests, function (r) { return r.title == 'Accessories_'+_vm.params.product_id; }) && _vm.selectedRequest.id == _vm.$_.find(_vm.requests, function (r) { return r.title == 'Accessories_'+_vm.params.product_id; }).id && _vm.final == false)?_c('div',{directives:[{name:"scroll",rawName:"v-scroll",value:({target: '#scroll-container'}),expression:"{target: '#scroll-container'}"}]},[_c('v-flex',{staticClass:"pt-5",attrs:{"xs10":"","offset-xs1":""}},[_c('v-layout',{attrs:{"column":""}},[_c('h2',{staticClass:"mb-3"},[_vm._v("Accessoires : ")]),_vm._v(" "),_c('h3',{staticClass:"mb-3"},[_vm._v("De série : ")]),_vm._v(" "),_vm._l((_vm.accessoriesList),function(accessory,index){return (accessory.de_serie != null)?_c('v-flex',{key:index,attrs:{"xs5":""}},[_c('v-layout',{staticClass:"accessories",attrs:{"row":"","wrap":""}},[_c('div',[_c('div',{class:{'zoom' : accessory.photo},on:{"click":function($event){accessory.photo ? _vm.$eventHub.$emit('view-file', accessory.photo, 'avatar') : ''}}},[_c('avatar',{attrs:{"item":accessory,"field":"photo","size":"3rem"}})],1),_vm._v(" "),_c('p',{staticClass:"caract_title mb-0"},[_vm._v(_vm._s(accessory.label))]),_vm._v(" "),_c('p',{staticClass:"caract_title mb-0",staticStyle:{"margin-left":"3rem"}},[_vm._v(_vm._s(accessory.label_2))])]),_vm._v(" "),_c('v-checkbox',{attrs:{"value":accessory.id,"disabled":_vm.test_status != null && _vm.test_status != 'pending'},on:{"change":_vm.setStatus},model:{value:(_vm.selected_accessory),callback:function ($$v) {_vm.selected_accessory=$$v},expression:"selected_accessory"}})],1)],1):_vm._e()}),_vm._v(" "),_c('h3',{staticClass:"mb-3"},[_vm._v("Option : ")]),_vm._v(" "),_vm._l((_vm.accessoriesList),function(accessory,index){return (accessory.de_serie == null)?_c('v-flex',{key:index,attrs:{"xs5":""}},[_c('v-layout',{staticClass:"accessories",attrs:{"row":"","wrap":""}},[_c('div',[_c('div',{class:{'zoom' : accessory.photo},on:{"click":function($event){accessory.photo ? _vm.$eventHub.$emit('view-file', accessory.photo, 'avatar') : ''}}},[_c('avatar',{attrs:{"item":accessory,"field":"photo","size":"3rem"}})],1),_vm._v(" "),_c('p',{staticClass:"caract_title mb-0"},[_vm._v(_vm._s(accessory.label))]),_vm._v(" "),_c('p',{staticClass:"caract_title mb-0",staticStyle:{"margin-left":"3rem"}},[_vm._v(_vm._s(accessory.label_2))])]),_vm._v(" "),_c('v-checkbox',{attrs:{"value":accessory.id,"disabled":_vm.test_status != null && _vm.test_status != 'pending'},on:{"change":_vm.setStatus},model:{value:(_vm.selected_accessory),callback:function ($$v) {_vm.selected_accessory=$$v},expression:"selected_accessory"}})],1)],1):_vm._e()})],2),_vm._v(" "),(_vm.final == false && _vm.selectedRequest.status === 'failed' && _vm.display && (_vm.selectedRequest.status == 'pending' || _vm.selectedRequest.status == null))?_c('div',{staticClass:"invalidation-box mt-3"},[_c('div',{staticClass:"invalidation-comment"},[_c('v-text-field',{staticClass:"comment-text",attrs:{"name":"message_text_field","label":"Votre remarque (laissez vide si vous n'en avez pas)","hint":"","multi-line":"","rows":"2"},model:{value:(_vm.selectedRequest.comment),callback:function ($$v) {_vm.$set(_vm.selectedRequest, "comment", $$v)},expression:"selectedRequest.comment"}}),_vm._v(" "),_c('v-layout',{staticClass:"comment-text"},[_vm._l((_vm.selectedRequest.invalidation_files),function(file,index){return _c('div',{key:file.id,staticClass:"mr-2"},[_c('v-menu',{staticStyle:{"zIndex":"204"},attrs:{"offset-y":"","content-class":"files"}},[_c('div',{attrs:{"slot":"activator"},slot:"activator"},[_c('label',{staticClass:"invalidation-image"},[_c('v-icon',{staticClass:"hover-alpha"},[_vm._v("mode_edit")]),_vm._v(" "),_c('img',{attrs:{"src":file.path},on:{"click":function($event){_vm.$eventHub.$emit('view-file',file)}}})],1)]),_vm._v(" "),_c('v-list',[_c('v-list-tile',{staticClass:"li"},[_c('label',{attrs:{"for":'file-input-'+index}},[_vm._v("Modifier l'image")]),_vm._v(" "),_c('input',{staticClass:"input-img",staticStyle:{"display":"none"},attrs:{"id":'file-input-'+index,"type":"file"},on:{"change":function (event){_vm.onFileChange(event,index)}}})]),_vm._v(" "),_c('v-list-tile',{staticClass:"li",on:{"click":function($event){_vm.deleteImg(index)}}},[_c('v-list-tile-title',[_vm._v("Supprimer l'image")])],1)],1)],1)],1)}),_vm._v(" "),(!_vm.selectedRequest.invalidation_files || _vm.selectedRequest.invalidation_files.length < 2)?_c('div',{staticClass:"mr-2"},[_c('v-menu',{staticStyle:{"zIndex":"204"},attrs:{"offset-y":"","content-class":"files"}},[_c('div',{attrs:{"slot":"activator"},slot:"activator"},[_c('label',{staticClass:"invalidation-image"},[_c('img',{staticClass:"add-image",attrs:{"src":_vm.addImgPath()}})])]),_vm._v(" "),_c('v-list',[_c('v-list-tile',[_c('label',{attrs:{"for":'file-input'}},[_vm._v("Ajouter une image")]),_vm._v(" "),_c('input',{staticClass:"input-img",staticStyle:{"display":"none"},attrs:{"id":"file-input","type":"file"},on:{"change":function (event){_vm.onFileChange(event)}}})])],1)],1)],1):_vm._e()],2)],1)]):_vm._e(),_vm._v(" "),(_vm.final == true && this.selectedRequest.status === 'failed' && ((!!this.selectedRequest.comment && this.selectedRequest.comment!=='') || (!!this.selectedRequest.invalidation_files && this.selectedRequest.invalidation_files.length>0)))?_c('div',{staticClass:"invalidation-box mt-3"},[_c('div',{staticClass:"invalidation-comment"},[_c('div',{staticClass:"comment-text"},[_vm._v("\n                              "+_vm._s(_vm.selectedRequest.comment)+"\n                        ")]),_vm._v(" "),_c('v-layout',{staticClass:"comment-text"},_vm._l((_vm.selectedRequest.invalidation_files),function(file,index){return _c('div',{key:file.id,staticClass:"mr-2"},[_c('label',{staticClass:"comment-image"},[_c('img',{attrs:{"src":file.path},on:{"click":function($event){_vm.$eventHub.$emit('view-file',file)}}})])])}))],1)]):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(_vm.final == false && _vm.selectedRequest.title && !_vm.selectedRequest.title.includes(_vm.params.product_id) || _vm.final == false && !_vm.selectedRequest.title)?_c('div',{directives:[{name:"scroll",rawName:"v-scroll",value:({target: '#scroll-container'}),expression:"{target: '#scroll-container'}"}]},[[_c('div',{staticClass:"status-choice-bar"},[_c('v-layout',{staticClass:"all-choices-container"},[_c('v-layout',{attrs:{"column":""}},[_c('v-layout',{staticClass:"one-choice-container",attrs:{"column":""}},[(_vm.model.status === 'failed')?_c('div',{staticClass:"button-title"},[_vm._v("\n                                    Non validé\n                                ")]):_c('div',{staticClass:"button-title"}),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-btn',{class:{
                                        'status-choice-button': true,
                                        'failed': _vm.model.status === 'failed',
                                        'not-selected': _vm.model.status !== 'failed'},attrs:{"outline":"","large":"","fab":""},on:{"click":function($event){_vm.setStatus('failed')}}},[_c('v-icon',[_vm._v("clear")])],1)],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"column":""}},[_c('v-layout',{staticClass:"one-choice-container",attrs:{"column":""}},[(_vm.model.status === 'validated')?_c('div',{staticClass:"button-title"},[_vm._v("\n                                    Validé\n                                ")]):_c('div',{staticClass:"button-title"}),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-btn',{class:{
                                        'status-choice-button': true,
                                        'validated': _vm.model.status === 'validated',
                                        'not-selected': _vm.model.status !== 'validated'},attrs:{"outline":"","large":"","fab":""},on:{"click":function($event){_vm.setStatus('validated')}}},[_c('v-icon',[_vm._v("done")])],1)],1)])],1)],1)],1)],_vm._v(" "),_c('div',{staticClass:"content-text",class:[_vm.selectedRequest.nbCol === 2 ? 'doubleCol' : '']},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{class:_vm.selectedRequest.nbCol === 2 ? 'sm12 md6' : 'xs12'},[_c('div',{staticClass:"request-title on-left"},[_vm._v("\n                            "+_vm._s(_vm.selectedRequest.title)+"\n                        ")])]),_vm._v(" "),(_vm.selectedRequest.nbCol===2)?_c('v-flex',{attrs:{"sm12":"","md6":""}},[_c('div',{staticClass:"request-title on-right"},[_vm._v("\n                            "+_vm._s(_vm.selectedRequest.title_2)+"\n                        ")])]):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{class:_vm.selectedRequest.nbCol===2 ? 'sm12 md6' : 'xs12'},[_c('div',{staticClass:"request-message on-left"},[_vm._v("\n                            "+_vm._s(_vm.selectedRequest.message)+"\n                        ")])]),_vm._v(" "),(_vm.selectedRequest.nbCol===2)?_c('v-flex',{attrs:{"sm12":"","md6":""}},[_c('div',{staticClass:"request-message on-right"},[_vm._v("\n                            "+_vm._s(_vm.selectedRequest.message_2)+"\n                        ")])]):_vm._e()],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{class:_vm.selectedRequest.nbCol===2 ? 'sm12 md6' : 'xs12'},[_c('v-layout',{attrs:{"wrap":""}},_vm._l((_vm.selectedRequest.files_1),function(file,index){return _c('div',{key:file.id,staticClass:"mr-2"},[_c('label',{staticClass:"comment-image"},[_c('img',{attrs:{"src":file.path},on:{"click":function($event){_vm.$eventHub.$emit('view-file',file)}}})])])}))],1),_vm._v(" "),(_vm.selectedRequest.nbCol===2)?_c('v-flex',{attrs:{"sm12":"","md6":""}},[_c('v-layout',{attrs:{"wrap":""}},_vm._l((_vm.selectedRequest.files_2),function(file,index){return _c('div',{key:file.id,staticClass:"mr-2"},[_c('label',{staticClass:"comment-image"},[_c('img',{attrs:{"src":file.path},on:{"click":function($event){_vm.$eventHub.$emit('view-file',file)}}})])])}))],1):_vm._e()],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-3 mb-3",attrs:{"row":"","wrap":""}},[_vm._l((_vm.selectedRequest.attachment_files),function(file,index){return [_c('div',{staticClass:"files-list-container",on:{"click":function($event){_vm.$eventHub.$emit('view-file',file,_vm.selectedRequest.attachment_files)}}},[_c('div',{staticClass:"files-list-container-title"},[_vm._v("\n                                Pièces jointes :\n                            ")]),_vm._v(" "),[_vm._v(_vm._s(file.label)+"."+_vm._s(file.type))]],2)]})],2)],1),_vm._v(" "),(_vm.final == false && _vm.selectedRequest.title && !_vm.selectedRequest.title.includes(_vm.$route.params.id) && _vm.model.status === 'failed' && _vm.display)?_c('div',{staticClass:"invalidation-box mt-2"},[_c('div',{staticClass:"invalidation-comment"},[_c('v-text-field',{staticClass:"comment-text",attrs:{"name":"message_text_field","label":"Votre remarque (laissez vide si vous n'en avez pas)","hint":"","multi-line":"","rows":"2"},model:{value:(_vm.selectedRequest.comment),callback:function ($$v) {_vm.$set(_vm.selectedRequest, "comment", $$v)},expression:"selectedRequest.comment"}}),_vm._v(" "),_c('v-layout',{staticClass:"comment-text"},[_vm._l((_vm.selectedRequest.invalidation_files),function(file,index){return _c('div',{key:file.id,staticClass:"mr-2"},[_c('v-menu',{staticStyle:{"zIndex":"204"},attrs:{"offset-y":"","content-class":"files"}},[_c('div',{attrs:{"slot":"activator"},slot:"activator"},[_c('label',{staticClass:"invalidation-image"},[_c('v-icon',{staticClass:"hover-alpha"},[_vm._v("mode_edit")]),_vm._v(" "),_c('img',{attrs:{"src":file.path},on:{"click":function($event){_vm.$eventHub.$emit('view-file',file)}}})],1)]),_vm._v(" "),_c('v-list',[_c('v-list-tile',{staticClass:"li"},[_c('label',{attrs:{"for":'file-input-'+index}},[_vm._v("Modifier l'image")]),_vm._v(" "),_c('input',{staticClass:"input-img",staticStyle:{"display":"none"},attrs:{"id":'file-input-'+index,"accept":"image/*","capture":"camera","type":"file"},on:{"change":function (event){_vm.onFileChange(event,index)}}})]),_vm._v(" "),_c('v-list-tile',{staticClass:"li",on:{"click":function($event){_vm.deleteImg(index)}}},[_c('v-list-tile-title',[_vm._v("Supprimer l'image")])],1)],1)],1)],1)}),_vm._v(" "),(!_vm.selectedRequest.invalidation_files || _vm.selectedRequest.invalidation_files.length < 2)?_c('div',{staticClass:"mr-2"},[_c('v-menu',{staticStyle:{"zIndex":"204"},attrs:{"offset-y":"","content-class":"files"}},[_c('div',{attrs:{"slot":"activator"},slot:"activator"},[_c('label',{staticClass:"invalidation-image"},[_c('img',{staticClass:"add-image",attrs:{"src":_vm.addImgPath()}})])]),_vm._v(" "),_c('v-list',[_c('v-list-tile',[_c('label',{attrs:{"for":'file-input'}},[_vm._v("Ajouter une image")]),_vm._v(" "),_c('input',{staticClass:"input-img",staticStyle:{"display":"none"},attrs:{"id":"file-input","accept":"image/*","capture":"camera","type":"file"},on:{"change":function (event){_vm.onFileChange(event)}}})])],1)],1)],1):_vm._e()],2)],1)]):_vm._e(),_vm._v(" "),(_vm.final == true && this.selectedRequest.status === 'failed' && ((!!this.selectedRequest.comment && this.selectedRequest.comment!=='') || (!!this.selectedRequest.invalidation_files && this.selectedRequest.invalidation_files.length>0)))?_c('div',{staticClass:"invalidation-box"},[_c('div',{staticClass:"invalidation-comment"},[_c('div',{staticClass:"comment-text"},[_vm._v("\n                          "+_vm._s(_vm.selectedRequest.comment)+"\n                    ")]),_vm._v(" "),_c('v-layout',{staticClass:"comment-text"},_vm._l((_vm.selectedRequest.invalidation_files),function(file,index){return _c('div',{key:file.id,staticClass:"mr-2"},[_c('label',{staticClass:"comment-image"},[_c('img',{attrs:{"src":file.path},on:{"click":function($event){_vm.$eventHub.$emit('view-file',file)}}})])])}))],1)]):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.final == true)?_c('div',{directives:[{name:"scroll",rawName:"v-scroll",value:({target: '#scroll-container'}),expression:"{target: '#scroll-container'}"}]},[_c('v-flex',{staticClass:"pt-5",attrs:{"xs10":"","offset-xs1":""}},[_c('v-layout',{attrs:{"column":""}},[_c('p',{staticClass:"score"},[_c('span',{staticClass:"numbers"},[(_vm.requests.length - _vm.requests.filter(function (r) { return r.status == 'failed'; }).length == _vm.requests.length)?_c('span',{staticClass:"success--text"},[_vm._v(_vm._s(_vm.requests.length - _vm.requests.filter(function (r) { return r.status == 'failed'; }).length))]):_c('span',{staticClass:"error--text"},[_vm._v(_vm._s(_vm.requests.length - _vm.requests.filter(function (r) { return r.status == 'failed'; }).length))]),_vm._v("\n                                / "+_vm._s(_vm.requests.length)+"\n                            ")]),_vm._v(" "),_c('span',[_vm._v("\n                                Points validés\n                            ")])]),_vm._v(" "),_c('h2',{staticClass:"mt-2"},[_vm._v("Récapitulatif :")]),_vm._v(" "),_vm._l((_vm.requests.filter(function (r) { return r.status == 'failed'; })),function(request){return [(request.title.includes('Features'))?_c('div',{staticClass:"recap"},[_c('p',{staticClass:"mb-0"},[_vm._v("Caractéristiques :")]),_vm._v(" "),_vm._l((request.message.split(',').map(Number)),function(id){return (request.message)?[(_vm.$_.find(_vm.fields, function (c) { return c.id == id; }))?_c('span',[_vm._v(_vm._s(_vm.$_.find(_vm.fields, function (c) { return c.id == id; }).label))]):(!_vm.$_.find(_vm.caracts, function (c) { return c.id == id; }))?_c('span',[_vm._v("Infos générales du produit")]):_vm._e()]:_vm._e()})],2):_vm._e(),_vm._v(" "),(request.title.includes('Accessories'))?_c('div',{staticClass:"recap"},[_c('p',{staticClass:"mb-0"},[_vm._v("Accessoires :")]),_vm._v(" "),_vm._l((request.message.split(',').map(Number)),function(id){return (request.message)?[(_vm.$_.find(_vm.accessoriesList, function (c) { return c.id == id; }))?_c('span',[_vm._v(_vm._s(_vm.$_.find(_vm.accessoriesList, function (c) { return c.id == id; }).label))]):_vm._e()]:_vm._e()})],2):_vm._e()]}),_vm._v(" "),(_vm.failedRequests.length > 0)?_c('div',{staticClass:"recap"},[_c('p',{staticClass:"mb-0"},[_vm._v("Demandes :")]),_vm._v(" "),_vm._l((_vm.failedRequests),function(faile){return [_c('span',[_vm._v(_vm._s(faile.title))])]})],2):_vm._e(),_vm._v(" "),_c('v-layout',{staticClass:"mt-5 pt-5",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs10":"","offset-xs1":"","mb-2":""}},[_c('v-text-field',{attrs:{"label":"Commentaire","multi-line":"","auto-grow":"","rows":5,"disabled":_vm.params.read_only == true},model:{value:(_vm.final_comment),callback:function ($$v) {_vm.final_comment=$$v},expression:"final_comment"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs10":"","offset-xs1":""}},[_c('v-select',{attrs:{"items":_vm.TestStatuses.filter(function (ts) { return ts.value != 'pending'; }),"item-text":"label","item-value":"value","label":"Choisir le status du test","content-class":"menu-status","disabled":_vm.params.read_only == true},model:{value:(_vm.test_status),callback:function ($$v) {_vm.test_status=$$v},expression:"test_status"}})],1)],1)],2)],1)],1):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[(_vm.test_status != 'finished' && _vm.test_status != 'failed' && _vm.final != true)?_c('v-btn',{staticClass:"footer-button",attrs:{"disabled":_vm.model.status === 'pending',"depressed":_vm.model.status!=='pending',"round":"","depressed":"","small":"","color":'primary',"loading":_vm.loading},on:{"click":function($event){_vm.saveRequest()}}},[_vm._v("Enregistrer &\n            "),(_vm.selectedRequest.index !== _vm.requests.length-1)?[_vm._v("Demande suivante")]:[_vm._v("Voir le récapitulatif")]],2):_c('v-btn',{staticClass:"footer-button",attrs:{"disabled":_vm.test_status == 'pending',"depressed":_vm.model.status!=='pending',"loading":_vm.loading,"round":"","depressed":"","small":"","color":'primary'},on:{"click":function($event){_vm.saveRequest(true)}}},[_vm._v("Enregistrer & Fermer\n        ")])],1),_vm._v(" "),(_vm.imgFullPath !== null)?_c('div',{staticClass:"overlay"},[_c('div',{staticClass:"overlay-container"},[_c('img',{staticClass:"overlay-image",attrs:{"src":_vm.imgFullPath}})])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var single_RunTest = (esExports);
// CONCATENATED MODULE: ./src/views/products/single/RunTest.vue
function injectStyle (ssrContext) {
  __webpack_require__("dK9h")
  __webpack_require__("um4F")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6930da76"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  RunTest,
  single_RunTest,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var products_single_RunTest = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/products/single/DeleteTest.vue
//
//
//
//
//
//

/* harmony default export */ var DeleteTest = ({
    data: function data() {
        return {
            title: 'Suppression de contrôles',
            icon: 'delete',
            warning: true
        };
    },


    methods: {
        onClose: function onClose() {
            this.$eventHub.$emit('close-modal');
        },
        onValidate: function onValidate() {
            var _this = this;

            this.$store.state.datatable.tests.selected.forEach(function (item, index) {
                _this.axios.delete('/api/tests/' + item.id).then(function (response) {
                    _this.$eventHub.$emit('close-modal');
                    _this.$eventHub.$emit('reload-list');
                    _this.$store.dispatch('updateSingleData', { key: 'tests_count', value: _this.$store.state.single.data.tests_count - _this.$store.state.datatable.tests.selected.length });
                }).catch(function (err) {
                    return console.log(err.response.data);
                });
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d01aa5e6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/single/DeleteTest.vue
var DeleteTest_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"text-xs-center"},[_vm._v("Êtes-vous sûr de vouloir supprimer les "+_vm._s(_vm.$store.state.datatable.tests.selected.length)+" contrôles selectionnés")])])}
var DeleteTest_staticRenderFns = []
var DeleteTest_esExports = { render: DeleteTest_render, staticRenderFns: DeleteTest_staticRenderFns }
/* harmony default export */ var single_DeleteTest = (DeleteTest_esExports);
// CONCATENATED MODULE: ./src/views/products/single/DeleteTest.vue
function DeleteTest_injectStyle (ssrContext) {
  __webpack_require__("ogdx")
}
var DeleteTest_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var DeleteTest___vue_template_functional__ = false
/* styles */
var DeleteTest___vue_styles__ = DeleteTest_injectStyle
/* scopeId */
var DeleteTest___vue_scopeId__ = "data-v-d01aa5e6"
/* moduleIdentifier (server only) */
var DeleteTest___vue_module_identifier__ = null
var DeleteTest_Component = DeleteTest_normalizeComponent(
  DeleteTest,
  single_DeleteTest,
  DeleteTest___vue_template_functional__,
  DeleteTest___vue_styles__,
  DeleteTest___vue_scopeId__,
  DeleteTest___vue_module_identifier__
)

/* harmony default export */ var products_single_DeleteTest = (DeleteTest_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/products/single/TestPDF.vue
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var TestPDF = ({
    props: {
        params: {
            required: false
        }
    },
    data: function data() {
        return {
            title: 'Création d\'une fiche produit',
            icon: 'sync'
        };
    },


    methods: {
        onClose: function onClose() {
            this.$eventHub.$emit('close-modal');
        },
        onValidate: function onValidate() {
            this.onClose();
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.$eventHub.$emit('hide-modal-actions');

        var downloadLink = document.createElement('A');
        this.axios.get('/api/test-pdf/' + this.params.id, {
            responseType: 'blob'
        }).then(function (response) {
            _this.onClose();
            var data = window.URL.createObjectURL(response.data);
            // window.open(data)

            downloadLink.href = data;
            downloadLink.download = "controle_" + _this.$store.state.single.data.code + ".pdf";
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e4375ed","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/single/TestPDF.vue
var TestPDF_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[[_vm._m(0)]],2)}
var TestPDF_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('img',{attrs:{"src":__webpack_require__("bwqQ")}}),_vm._v(" "),_c('p',[_vm._v("Génération du compte rendu en cours")])])}]
var TestPDF_esExports = { render: TestPDF_render, staticRenderFns: TestPDF_staticRenderFns }
/* harmony default export */ var single_TestPDF = (TestPDF_esExports);
// CONCATENATED MODULE: ./src/views/products/single/TestPDF.vue
function TestPDF_injectStyle (ssrContext) {
  __webpack_require__("++Es")
}
var TestPDF_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var TestPDF___vue_template_functional__ = false
/* styles */
var TestPDF___vue_styles__ = TestPDF_injectStyle
/* scopeId */
var TestPDF___vue_scopeId__ = "data-v-3e4375ed"
/* moduleIdentifier (server only) */
var TestPDF___vue_module_identifier__ = null
var TestPDF_Component = TestPDF_normalizeComponent(
  TestPDF,
  single_TestPDF,
  TestPDF___vue_template_functional__,
  TestPDF___vue_styles__,
  TestPDF___vue_scopeId__,
  TestPDF___vue_module_identifier__
)

/* harmony default export */ var products_single_TestPDF = (TestPDF_Component.exports);

// EXTERNAL MODULE: ./src/config/enum/CommentTypes.js
var CommentTypes = __webpack_require__("22+B");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/products/single/Tests.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ var Tests = ({
    components: { DataTable: DataTable["a" /* default */], Avatar: Avatar["a" /* default */] },

    data: function data() {
        var _this = this;

        return {
            moment: moment_default.a,
            TestPDF: products_single_TestPDF,
            datatable: {
                actions: [{ text: 'Réaliser un contrôle du produit', icon: 'add_circle', callback: function callback() {
                        _this.$eventHub.$emit('open-modal', products_single_RunTest, {
                            product_id: _this.$store.state.single.data.id,
                            product_label: _this.$store.state.single.data.label,
                            element_type: 'comment',
                            run_new_test: true
                        });
                    }
                }],
                toolbar: [{ icon: 'delete', callback: function callback() {
                        _this.$eventHub.$emit('open-modal', products_single_DeleteTest);
                    } }],
                headers: [{ text: 'Auteur', sortable: true, value: 'user_id', align: 'center', width: '25%' }, { text: 'Date', sortable: true, value: 'created_at', width: '15%' }, { text: 'Statut', sortable: true, value: 'status', align: 'center', width: '15%' }, { text: 'Demandes validées', sortable: true, value: 'validated_elements_count', width: '15%' }, { text: 'Demandes\n\n non validées', sortable: true, value: 'failed_elements_count', width: '15%' }, { text: 'Compte rendu', sortable: false, align: 'right', width: '15%' }],
                endpoint: {
                    base: '/api/tests',
                    filters: 'product_id|=|' + this.$route.params.id,
                    embed: 'user,elements,validated_elements,failed_elements',
                    order: 'updated_at|DESC'
                }
            }
        };
    },

    methods: {
        getTestStatusLabel: function getTestStatusLabel(test) {
            if (!!test && !!test.status) {
                var testStatus = TestStatuses["a" /* TestStatuses */].find(function (el) {
                    return el.value === test.status;
                });
                return testStatus ? testStatus.label : '';
            } else {
                return '';
            }
        },
        getTestStatusColor: function getTestStatusColor(test) {
            if (!!test && !!test.status) {
                var testStatus = TestStatuses["a" /* TestStatuses */].find(function (el) {
                    return el.value === test.status;
                });
                return testStatus ? testStatus.color : '';
            } else {
                return '';
            }
        },
        getNbNotValidRequests: function getNbNotValidRequests(test) {
            if (!!test && !!test.elements) {
                return test.elements.filter(function (el) {
                    return el.status === TestElementStatuses[0].value;
                }).length;
            } else {
                return '';
            }
        },
        getNbValidRequests: function getNbValidRequests(test) {
            if (!!test && !!test.elements) {

                return test.elements.filter(function (el) {
                    return el.status === TestElementStatuses[1].value;
                }).length;
            } else {
                return '';
            }
        },
        rowClick: function rowClick(item) {
            if (this.$store.state.auth.user.id === item.user_id || item.status != 'pending') {
                this.$eventHub.$emit('open-modal', products_single_RunTest, {
                    product_id: this.$store.state.single.data.id,
                    product_label: this.$store.state.single.data.label,
                    id: item.id,
                    status: item.status,
                    final_comment: item.final_comment,
                    read_only: false
                });
            } else {
                this.$eventHub.$emit('open-snackbar', 'warning', 'Vous n\'êtes pas le créateur de ce test');
            }
        },
        update_count: function update_count(count) {
            this.$store.dispatch('updateSingleData', { key: 'tests_count', value: count });
            this.$store.dispatch('updateSingleData', { key: 'tests', value: this.$refs.list.items });
        },
        exportTestResult: function exportTestResult(id) {
            this.$eventHub.$emit('open-modal', products_single_TestPDF, { id: id });
        }
    },
    created: function created() {
        var _this2 = this;

        this.$eventHub.$on('reload-list', function () {
            if (_this2.$refs.list) {
                _this2.$refs.list.reload();
            }
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a3d7650","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/single/Tests.vue
var Tests_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-table',{ref:"list",attrs:{"headers":_vm.datatable.headers,"toolbar":_vm.datatable.toolbar,"actions":_vm.datatable.actions,"endpoint":_vm.datatable.endpoint,"storeId":"tests","selectable":""},on:{"rowClick":_vm.rowClick,"total_updated":_vm.update_count},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left author"},[_c('avatar',{attrs:{"item":props.item.user}}),_vm._v("\n                "+_vm._s(props.item.user.first_name)+" "+_vm._s(props.item.user.last_name)+"\n            ")],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n                "+_vm._s(_vm.moment(props.item.created_at).format('DD/MM/YYYY'))+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-left status-box"},[(_vm.getTestStatusColor(props.item) == '#FFFFFF')?[_c('v-icon',{staticClass:"ml-2 mr-2"},[_vm._v("mdi-checkbox-blank-circle-outline")])]:[_c('v-icon',{staticClass:"ml-2 mr-2",style:({color: _vm.getTestStatusColor(props.item)})},[_vm._v("mdi-checkbox-blank-circle")])],_vm._v("\n                "+_vm._s(_vm.getTestStatusLabel(props.item))+"\n            ")],2),_vm._v(" "),_c('td',{staticClass:"text-xs-center smaller-box"},[_vm._v("\n                "+_vm._s(props.item.validated_elements_count)+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v("\n                "+_vm._s(props.item.failed_elements_count)+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[(props.item.status !== 'pending')?_c('v-btn',{attrs:{"icon":"","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.exportTestResult(props.item.id)}}},[_c('v-icon',{attrs:{"color":"grey"}},[_vm._v("file_download")])],1):_vm._e()],1)]}}])})}
var Tests_staticRenderFns = []
var Tests_esExports = { render: Tests_render, staticRenderFns: Tests_staticRenderFns }
/* harmony default export */ var single_Tests = (Tests_esExports);
// CONCATENATED MODULE: ./src/views/products/single/Tests.vue
function Tests_injectStyle (ssrContext) {
  __webpack_require__("RHqM")
}
var Tests_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Tests___vue_template_functional__ = false
/* styles */
var Tests___vue_styles__ = Tests_injectStyle
/* scopeId */
var Tests___vue_scopeId__ = "data-v-4a3d7650"
/* moduleIdentifier (server only) */
var Tests___vue_module_identifier__ = null
var Tests_Component = Tests_normalizeComponent(
  Tests,
  single_Tests,
  Tests___vue_template_functional__,
  Tests___vue_styles__,
  Tests___vue_scopeId__,
  Tests___vue_module_identifier__
)

/* harmony default export */ var products_single_Tests = __webpack_exports__["default"] = (Tests_Component.exports);


/***/ }),

/***/ "JCHG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JLdM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JNbn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jenm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KOwa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KsjB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KxZN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TestStatuses; });
var TestStatuses = [{ label: 'Echoué', value: 'failed', color: '#FF3D62' }, { label: 'Terminé', value: 'finished', color: '#8BEA67' }, { label: 'Dérogation', value: 'exemption', color: '#FFA907' }, { label: 'En cours', value: 'pending', color: '#FFFFFF' }, { label: 'À valider', value: 'to_validate', color: '#039BE5' }];

/***/ }),

/***/ "LElz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Lf0E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Groups; });
var Groups = [{ label: 'consumable' }, { label: 'equipment' }, { label: 'accessory' }];

/***/ }),

/***/ "MJ/k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/files/DeleteFiles.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var DeleteFiles = ({
    props: {
        params: {
            required: false
        }
    },
    data: function data() {
        return {
            title: 'Supression de fichiers',
            icon: 'delete',
            warning: true
        };
    },


    methods: {
        onClose: function onClose() {
            this.$eventHub.$emit('close-modal');
        },

        // when form validate
        onValidate: function onValidate() {
            var _this = this;

            if (this.params.entity) {
                // when multiple files selected
                if (this.$store.state.datatable.files.selected.length > 0) {
                    this.$store.state.datatable.files.selected.forEach(function (item, index) {
                        _this.axios.delete('/api/' + _this.params.entity + '/' + _this.$route.params.id + '/file/' + item.id).then(function (response) {
                            _this.$store.dispatch('removeSingleData', { key: 'files', id: _this.$store.state.datatable.files.selected.id });
                            _this.$store.dispatch('updateSingleData', { key: 'files_count', value: _this.$store.state.single.data.files_count - 1 });
                            _this.$eventHub.$emit('close-modal');
                            _this.$eventHub.$emit('reload-list');
                        }).catch(function (error) {
                            console.log(error.response.data);
                        });
                    });
                } else {
                    // just on file selected
                    this.axios.delete('/api/' + this.params.entity + '/' + this.$route.params.id + '/file/' + this.$store.state.datatable.files.selected.id).then(function (response) {
                        _this.$store.dispatch('removeSingleData', { key: 'files', id: _this.$store.state.datatable.files.selected.id });
                        _this.$store.dispatch('updateSingleData', { key: 'files_count', value: _this.$store.state.single.data.files_count - 1 });
                        _this.$eventHub.$emit('close-modal');
                        _this.$eventHub.$emit('reload-list');
                    }).catch(function (error) {
                        console.log(error.response.data);
                    });
                }
            }
        }
    }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b99edf8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/files/DeleteFiles.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$store.state.datatable.files.selected.length > 0)?[_c('p',[_vm._v("Êtes-vous sûr de vouloir supprimer les fichiers suivants :")]),_vm._v(" "),_c('ul',_vm._l((_vm.$store.state.datatable.files.selected),function(file){return _c('li',[_vm._v("\n                "+_vm._s(file.label)+"\n            ")])}))]:[_c('p',[_vm._v("Êtes-vous sûr de vouloir supprimer le fichier suivant :")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("\n                "+_vm._s(_vm.$store.state.datatable.files.selected.label)+"\n            ")])])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var files_DeleteFiles = (esExports);
// CONCATENATED MODULE: ./src/components/files/DeleteFiles.vue
function injectStyle (ssrContext) {
  __webpack_require__("TQ6S")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b99edf8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  DeleteFiles,
  files_DeleteFiles,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_files_DeleteFiles = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mb5K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mj+3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/layouts/admin/Nav.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Nav = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fc7b0bd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/admin/Nav.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"admin-layout-nav"},[_c('router-link',{staticClass:"back",attrs:{"to":{ name: 'app' }}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("keyboard_backspace")]),_vm._v("\n        Retour\n    ")],1),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'admin-users' }}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("mdi-account-settings-variant")]),_vm._v("\n        Utilisateurs\n    ")],1),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'admin-sync' }}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("cached")]),_vm._v("\n        Synchro\n    ")],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var admin_Nav = (esExports);
// CONCATENATED MODULE: ./src/layouts/admin/Nav.vue
function injectStyle (ssrContext) {
  __webpack_require__("/kPH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6fc7b0bd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Nav,
  admin_Nav,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var layouts_admin_Nav = (Component.exports);

// EXTERNAL MODULE: ./src/layouts/app/Header.vue + 11 modules
var Header = __webpack_require__("O/Lb");

// EXTERNAL MODULE: ./src/layouts/app/Content.vue + 2 modules
var Content = __webpack_require__("j0mG");

// EXTERNAL MODULE: ./src/layouts/app/Modal.vue + 2 modules
var Modal = __webpack_require__("w+IP");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/layouts/admin/Layout.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var Layout = ({
    components: { AdminNav: layouts_admin_Nav, AppHeader: Header["a" /* default */], AppContent: Content["a" /* default */], AppModal: Modal["a" /* default */] }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bd5ef1e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/admin/Layout.vue
var Layout_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-layout"},[_c('admin-nav'),_vm._v(" "),_c('div',{staticClass:"admin-layout-body",attrs:{"id":"scroll-target"}},[_c('app-header'),_vm._v(" "),_c('app-content')],1),_vm._v(" "),_c('app-modal')],1)}
var Layout_staticRenderFns = []
var Layout_esExports = { render: Layout_render, staticRenderFns: Layout_staticRenderFns }
/* harmony default export */ var admin_Layout = (Layout_esExports);
// CONCATENATED MODULE: ./src/layouts/admin/Layout.vue
function Layout_injectStyle (ssrContext) {
  __webpack_require__("Zw7L")
}
var Layout_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Layout___vue_template_functional__ = false
/* styles */
var Layout___vue_styles__ = Layout_injectStyle
/* scopeId */
var Layout___vue_scopeId__ = "data-v-6bd5ef1e"
/* moduleIdentifier (server only) */
var Layout___vue_module_identifier__ = null
var Layout_Component = Layout_normalizeComponent(
  Layout,
  admin_Layout,
  Layout___vue_template_functional__,
  Layout___vue_styles__,
  Layout___vue_scopeId__,
  Layout___vue_module_identifier__
)

/* harmony default export */ var layouts_admin_Layout = __webpack_exports__["default"] = (Layout_Component.exports);


/***/ }),

/***/ "MzQT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/projects/single/DeleteProduct.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var DeleteProduct = ({
	props: {
		params: {
			required: false
		}
	},

	data: function data() {
		return {
			title: 'Supression d\'un produit',
			icon: 'delete',
			warning: true
		};
	},


	methods: {
		onClose: function onClose() {
			this.$eventHub.$emit('close-modal');
		},
		onValidate: function onValidate() {
			var _this = this;

			this.axios.delete('/api/products/' + this.params.product.id).then(function (response) {
				_this.$eventHub.$emit('close-modal');
				if (response.status === 200) {
					_this.$eventHub.$emit('reload-single');
				}
			}).catch(function (error) {
				console.log(error.response.data || error);
			});
		}
	}

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c626362","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/projects/single/DeleteProduct.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('p',[_vm._v("Êtes-vous sûr de vouloir supprimer ce produit ?")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.params.product.label))])])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var single_DeleteProduct = (esExports);
// CONCATENATED MODULE: ./src/views/projects/single/DeleteProduct.vue
function injectStyle (ssrContext) {
  __webpack_require__("0xHd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5c626362"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  DeleteProduct,
  single_DeleteProduct,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var projects_single_DeleteProduct = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N+fi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N0FO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/idle-vue/dist/build.js
var build = __webpack_require__("VsiT");
var build_default = /*#__PURE__*/__webpack_require__.n(build);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var App = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-204586a3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("Us+Y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/jwt-decode/lib/index.js
var lib = __webpack_require__("ytdl");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./src/store/modules/auth.js




/* harmony default export */ var auth = ({
    state: {
        isConnected: false,
        token: null,
        error: null,

        user: {
            id: null,
            email: null,
            first_name: null,
            last_name: null,
            avatar: null,
            level: null
        }
    },

    getters: {},

    actions: {
        loadUserState: function loadUserState(context) {

            if (!context.state.isConnected) {

                if (localStorage.token) {

                    var decodedToken = lib_default()(localStorage.token);

                    if (decodedToken.exp > Math.ceil(Date.now() / 1000)) {
                        context.commit('loginFromLocalStorage', { token: localStorage.token });
                    } else {
                        context.commit('logout');
                    }
                }
            }
        },
        login: function login(context, params) {
            vue_esm["a" /* default */].axios.post('/api/login', {
                email: params.email,
                password: params.password

            }).then(function (response) {
                var token = response.data.token;
                var user = lib_default()(token).user;

                context.commit('loginSuccess', { user: user, token: token });
            }).catch(function (error) {
                context.commit('loginError', { error: 'Email ou mot de passe incorrect' });
            });
        },
        clearLoginError: function clearLoginError(context) {
            context.commit('loginError', { error: null });
        },
        logout: function logout(context) {
            vue_esm["a" /* default */].axios.get('/api/logout');
            context.commit('logout');
            router.push('/auth/login');
        }
    },

    mutations: {
        loginFromLocalStorage: function loginFromLocalStorage(state, event) {
            var token = lib_default()(event.token);

            if (token) {
                state.isConnected = true;
                state.token = localStorage.token;
                state.user.id = token.user.id;
                state.user.email = token.user.email;
                state.user.first_name = token.user.first_name;
                state.user.last_name = token.user.last_name;
                state.user.avatar = token.user.avatar;
                state.user.level = token.user.level;

                vue_esm["a" /* default */].axios.defaults.baseURL = "https://cdc-api.sidamo.com";
                vue_esm["a" /* default */].axios.defaults.headers.common.Authorization = 'Bearer ' + localStorage.token;
            }
        },
        loginSuccess: function loginSuccess(state, event) {
            var decodedToken = lib_default()(event.token);

            state.token = event.token;
            state.isConnected = true;
            state.user.id = decodedToken.user.id;
            state.user.email = decodedToken.user.email;
            state.user.first_name = decodedToken.user.first_name;
            state.user.last_name = decodedToken.user.last_name;
            state.user.avatar = decodedToken.user.avatar;
            state.user.level = decodedToken.user.level;

            localStorage.token = state.token;
            localStorage.userId = state.user.id;

            vue_esm["a" /* default */].axios.defaults.baseURL = "https://cdc-api.sidamo.com";
            vue_esm["a" /* default */].axios.defaults.headers.common.Authorization = 'Bearer ' + event.token;
        },
        loginError: function loginError(state, event) {
            state.error = event.error;
        },
        logout: function logout(state) {
            state.token = null;
            state.isConnected = false;
            state.user.id = null;
            state.user.email = null;
            state.user.first_name = null;
            state.user.last_name = null;
            state.user.avatar = null;
            state.user.level = null;

            localStorage.clear();
        }
    }
});
// CONCATENATED MODULE: ./src/store/modules/layout.js


/* harmony default export */ var layout = ({
    state: {
        isNotifOpen: false
    },

    getters: {},

    actions: {
        toggleNotif: function toggleNotif(context) {
            context.commit('toggleNotif');
        }
    },

    mutations: {
        toggleNotif: function toggleNotif(state) {
            state.isNotifOpen = !state.isNotifOpen;
        }
    }
});
// CONCATENATED MODULE: ./src/store/modules/datatable.js


/* harmony default export */ var datatable = ({
    state: {},

    getters: {},

    actions: {
        setPagination: function setPagination(context, params) {
            context.commit('setPagination', { tableId: params.tableId, page: params.page, sortBy: params.sortBy, descending: params.descending });
        },
        setSelected: function setSelected(context, params) {
            context.commit('setSelected', { tableId: params.tableId, selected: params.selected });
        },
        clearSelected: function clearSelected(context, params) {
            context.commit('clearSelected', { tableId: params.tableId });
        }
    },

    mutations: {
        setPagination: function setPagination(state, event) {
            if (!state[event.tableId]) {
                state[event.tableId] = {};
            }

            state[event.tableId].page = event.page;
            state[event.tableId].sortBy = event.sortBy;
            state[event.tableId].descending = event.descending;
        },
        setSelected: function setSelected(state, event) {
            if (!state[event.tableId]) {
                state[event.tableId] = {};
            }

            state[event.tableId].selected = event.selected;
        },
        clearSelected: function clearSelected(state, event) {
            if (state[event.tableId]) {
                state[event.tableId].selected = [];
            }
        }
    }
});
// EXTERNAL MODULE: ./node_modules/vuex-loading/dist/vuex-loading.js
var vuex_loading = __webpack_require__("W/lP");
var vuex_loading_default = /*#__PURE__*/__webpack_require__.n(vuex_loading);

// CONCATENATED MODULE: ./src/store/modules/single.js





var _createActionHelpers = Object(vuex_loading["createActionHelpers"])({
    moduleName: 'loading'
}),
    startLoading = _createActionHelpers.startLoading,
    endLoading = _createActionHelpers.endLoading;

/* harmony default export */ var single = ({
    state: {
        data: {}
    },

    getters: {},

    actions: {
        clearSingleData: function clearSingleData(context) {
            context.commit('clearSingleData');
        },
        setSingleData: function setSingleData(context, params) {
            context.commit('setSingleData', { data: params.data });
        },
        updateSingleData: function updateSingleData(context, params) {
            context.commit('updateSingleData', { key: params.key, value: params.value });
        },
        addSingleData: function addSingleData(context, params) {
            context.commit('addSingleData', { key: params.key, value: params.value });
        },
        removeSingleData: function removeSingleData(context, params) {
            context.commit('removeSingleData', { key: params.key });
        }
    },

    mutations: {
        clearSingleData: function clearSingleData(state) {
            state.data = {};
        },
        setSingleData: function setSingleData(state, event) {
            state.data = event.data;
        },
        updateSingleData: function updateSingleData(state, event) {
            var path = state.data;
            var split = event.key.split('.');

            split.forEach(function (item, index) {
                if (index + 1 < split.length) {
                    var start = item.indexOf('[');
                    var end = item.indexOf(']');

                    if (start > -1 && end > -1) {
                        var i = item.substring(start + 1, end);
                        path = path[item.substring(0, start)];
                        path = path[i];
                    } else {
                        path = path[item];
                    }
                } else {
                    var _start = item.indexOf('[');
                    var _end = item.indexOf(']');

                    if (_start > -1 && _end > -1) {
                        var _i = item.substring(_start + 1, _end);
                        path = path[item.substring(0, _start)];
                        path[_i] = event.value;
                    } else {
                        path[item] = event.value;
                    }
                }
            });
        },
        addSingleData: function addSingleData(state, event) {
            var path = state.data;
            var split = event.key.split('.');

            split.forEach(function (item, index) {
                if (index + 1 < split.length) {
                    path = path[item];
                } else if (item == '[]', Array.isArray(path)) {
                    path.push(event.value);
                } else {
                    path[item] = event.value;
                }
            });
        },
        removeSingleData: function removeSingleData(state, event) {
            var path = state.data;
            var split = event.key.split('.');

            split.forEach(function (item, index) {
                if (index + 1 < split.length) {
                    var start = item.indexOf('[');
                    var end = item.indexOf(']');

                    if (start > -1 && end > -1) {
                        var i = item.substring(start + 1, end);
                        path = path[item.substring(0, start)];
                        path = path[i];
                    } else {
                        path = path[item];
                    }
                } else {
                    var _start2 = item.indexOf('[');
                    var _end2 = item.indexOf(']');

                    if (_start2 > -1 && _end2 > -1) {
                        var _i2 = item.substring(_start2 + 1, _end2);
                        path = path[item.substring(0, _start2)];

                        if (Array.isArray(path)) {
                            path.splice(_i2, 1);
                        } else {
                            // Ne devrait jamais servir...
                            delete path[_i2];
                        }
                    } else {
                        delete path[item];
                    }
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./src/store/index.js







vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
    modules: {
        auth: auth, layout: layout, datatable: datatable, single: single
    }
}));
// CONCATENATED MODULE: ./src/router/filters/auth.js


/* harmony default export */ var filters_auth = ({
    isConnected: function isConnected(to, from, next) {
        store.dispatch('loadUserState');

        if (to.path === '/auth/login' && store.state.auth.isConnected) {
            next({ path: '/' });
        } else if (to.path === '/auth/login' || store.state.auth.isConnected) {
            next();
        } else {
            next({ path: '/auth/login' });
        }
    }
});
// EXTERNAL MODULE: ./src/config/enum/Groups.js
var Groups = __webpack_require__("Lf0E");

// EXTERNAL MODULE: ./src/config/enum/ProductTypes.js
var ProductTypes = __webpack_require__("mdcO");

// EXTERNAL MODULE: ./src/config/enum/ProjectStatuses.js
var ProjectStatuses = __webpack_require__("TnFP");

// CONCATENATED MODULE: ./src/config/enum/SuperFamilies.js
var SuperFamilies = [{ label: 'consumable' }, { label: 'equipment' }, { label: 'consumable accessories' }];
// CONCATENATED MODULE: ./src/router/index.js








vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

var router = new vue_router_esm["a" /* default */]({
    mode: 'history',
    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return { selector: to.hash };
        } else {
            return { x: 0, y: 0 };
        }
    },

    routes: [{
        path: '/',
        name: 'app',
        redirect: { name: 'projects' },

        component: __webpack_require__("reDO").default,

        children: [
        //#region - Projects
        {
            path: 'projets',
            name: 'projects',
            components: {
                app_content: __webpack_require__("Xax2").default
            },
            props: {
                app_content: { filter: 'status|<>|' + ProjectStatuses["a" /* ProjectStatuses */][3].value + ',status|<>|' + ProjectStatuses["a" /* ProjectStatuses */][4].value }
            }
        }, {
            path: 'projets/tous',
            name: 'all-projects',
            components: {
                app_content: __webpack_require__("Xax2").default
            }
        }, {
            path: 'projets/mes-projets',
            name: 'my-projects',
            components: {
                app_content: __webpack_require__("Xax2").default
            },
            props: {
                //app_content: { filter: 'user_id|=|' + store.auth.state.user.id }
                app_content: { filter: 'user_id|=|' + localStorage.userId
                    //app_content:{ filter: `${console.log(store)}`}
                } }
        }, {
            path: 'projets/archives',
            name: 'archived-projects',
            components: {
                app_content: __webpack_require__("Xax2").default
            },
            props: {
                app_content: { filter: 'status|=|' + ProjectStatuses["a" /* ProjectStatuses */][4].value }
            }
        }, {
            path: 'projets/:id',
            name: 'single-project',
            redirect: { name: 'project-products-suppliers' },
            components: {
                app_content: __webpack_require__("kGbq").default
            },

            children: [{
                path: 'produits-concurrents',
                name: 'project-products-competitors',
                components: {
                    default: __webpack_require__("uOwT").default
                }
            }, {
                path: 'produits-fournisseurs',
                name: 'project-products-suppliers',
                components: {
                    default: __webpack_require__("gNrJ").default
                }
            }, {
                path: 'produits-sidamos',
                name: 'project-products-sidamos',
                components: {
                    default: __webpack_require__("ikV/").default
                }
            }, {
                path: 'fichiers',
                name: 'project-files',
                components: {
                    default: __webpack_require__("GnW9").default
                }
            }]
        },
        //#endregion


        //#region - Products
        // {
        //     path: 'produits',
        //     name: 'products_wf',
        //     redirect: { path: 'produits/' + SuperFamilies[0].label}
        // },
        //{
        //    path: 'produits/:super_family',
        //    name: 'products',
        //    components: {
        //        app_content: require('../views/products/list/List.vue').default
        //    },
        //    props: {
        //        app_content: {
        //            filter: 'type|=|' + ProductTypes[0].value ,
        //        }
        //    }
        //},
        {
            path: 'produits/groupe/:group',
            name: 'products-group',
            components: {
                app_content: __webpack_require__("Bw5V").default
            },
            props: {
                app_content: {
                    filter: 'type|=|' + ProductTypes["a" /* ProductTypes */][0].value
                }
            }
        }, {
            path: 'produits/:group/fournisseurs',
            name: 'products-suppliers',
            components: {
                app_content: __webpack_require__("Bw5V").default
            },
            props: {
                app_content: { filter: 'type|=|' + ProductTypes["a" /* ProductTypes */][1].value }
            }
        }, {
            path: 'produits/:group/concurrents',
            name: 'products-competitors',
            components: {
                app_content: __webpack_require__("Bw5V").default
            },
            props: {
                app_content: { filter: 'type|=|' + ProductTypes["a" /* ProductTypes */][2].value }
            }
        }, {
            path: 'produits/:group/:id',
            name: 'single-product',
            redirect: { name: 'product-data-sheet' },
            components: {
                app_content: __webpack_require__("kKnX").default
            },

            children: [{
                path: 'fiche-technique',
                name: 'product-data-sheet',
                components: {
                    default: __webpack_require__("2XbI").default
                }
            }, {
                path: 'accessoires',
                name: 'product-accessories',
                components: {
                    default: __webpack_require__("4SFm").default
                }
            }, {
                path: 'pieces-detaches',
                name: 'product-components',
                components: {
                    default: __webpack_require__("Fp4c").default
                }
            }, {
                path: 'consomables',
                name: 'product-consumables',
                components: {
                    default: __webpack_require__("dj3g").default
                }
            }, {
                path: 'fichiers',
                name: 'product-files',
                components: {
                    default: __webpack_require__("twT4").default
                }
            }, {
                path: 'commentaires',
                name: 'product-comments',
                components: {
                    default: __webpack_require__("qqvJ").default
                }
            }, {
                path: 'demandes',
                name: 'product-requests',
                components: {
                    default: __webpack_require__("hkv7").default
                }
            }, {
                path: 'controles',
                name: 'product-tests',
                components: {
                    default: __webpack_require__("IuYO").default
                }
            }]
        },
        //#endregion


        //#region - Symbols
        {
            path: 'symboles',
            name: 'list-symbols',
            components: {
                app_content: __webpack_require__("pYO/").default
            }
            //#endregion

        }]
    }, {
        path: '/auth',
        component: __webpack_require__("ED5W").default,

        //#region - auth
        children: [{
            path: 'login',
            component: __webpack_require__("3Jfp").default
        }]
        //#endregion
    }, {
        path: '/admin',
        name: 'admin',
        redirect: { name: 'admin-users' },
        component: __webpack_require__("Mj+3").default,

        children: [

        //#region - users
        {
            path: 'utilisateurs',
            name: 'admin-users',
            components: {
                app_content: __webpack_require__("msiX").default
            }
        }, {
            path: 'utilisateurs/:id',
            name: 'admin-single-user',
            redirect: { name: 'admin-single-user-general' },
            components: {
                app_content: __webpack_require__("UVP8").default
            },

            children: [{
                path: 'general',
                name: 'admin-single-user-general',
                components: {
                    default: __webpack_require__("EOLm").default
                }
            }]
        },
        //#endregion

        //#region - sync
        {
            path: 'synchro',
            name: 'admin-sync',
            components: {
                app_content: __webpack_require__("V28l").default
            }
        }]
    }]
});

router.beforeResolve(filters_auth.isConnected);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/vue-axios/dist/vue-axios.min.js
var vue_axios_min = __webpack_require__("Rf8U");
var vue_axios_min_default = /*#__PURE__*/__webpack_require__.n(vue_axios_min);

// EXTERNAL MODULE: ./node_modules/vuetify/dist/vuetify.js
var vuetify = __webpack_require__("3EgV");
var vuetify_default = /*#__PURE__*/__webpack_require__.n(vuetify);

// EXTERNAL MODULE: ./node_modules/mdi/css/materialdesignicons.css
var materialdesignicons = __webpack_require__("JCHG");
var materialdesignicons_default = /*#__PURE__*/__webpack_require__.n(materialdesignicons);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./node_modules/vue2-touch-events/index.js
var vue2_touch_events = __webpack_require__("ufW0");
var vue2_touch_events_default = /*#__PURE__*/__webpack_require__.n(vue2_touch_events);

// CONCATENATED MODULE: ./src/main.js













// (
//     function () {
//         if ('serviceWorker' in navigator) {
//             navigator.serviceWorker.register('./service-worker.js', {scope: '/'})
//             .then(() => console.log('Service Worker registered successfully.'))
//             .catch(error => console.log('Service Worker registration failed:', error));
//         }
//     }
// )();

var eventsHub = new vue_esm["a" /* default */]();
vue_esm["a" /* default */].use(build_default.a, {
    eventEmitter: eventsHub,
    idleTime: 1000 * 3600 * 2
});

vue_esm["a" /* default */].use(vue_axios_min_default.a, axios_default.a);

vue_esm["a" /* default */].use(vuetify_default.a, {
    theme: {
        primary: '#CE7DD6'
    }
});

vue_esm["a" /* default */].use(vue2_touch_events_default.a, {
    disableClick: false,
    touchClass: '',
    tapTolerance: 10,
    swipeTolerance: 30,
    longTapTimeInterval: 400
});

vue_esm["a" /* default */].use(vuex_loading_default.a);

vue_esm["a" /* default */].config.productionTip = false;

vue_esm["a" /* default */].prototype.$eventHub = new vue_esm["a" /* default */]();

vue_esm["a" /* default */].prototype.$_ = lodash_default.a;

new vue_esm["a" /* default */]({
    el: '#app',
    router: router,
    store: store,
    vueLoading: new vuex_loading_default.a({ useVuex: true, moduleName: 'loading' }),
    template: '<App/>',
    components: { App: src_App },

    onIdle: function onIdle() {
        store.dispatch('logout');
    }
});

/***/ }),

/***/ "NKCU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NKxF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NdJc":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNjYgODciPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuYSB7CiAgICAgICAgZmlsbDogI2YyZjRmNTsKICAgICAgfQoKICAgICAgLmIgewogICAgICAgIGZpbGw6ICNlM2U0ZWE7CiAgICAgIH0KCiAgICAgIC5jIHsKICAgICAgICBmaWxsOiAjZDBkNGQ3OwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8dGl0bGU+ZnVsbDwvdGl0bGU+CiAgPGc+CiAgICA8Zz4KICAgICAgPHJlY3QgY2xhc3M9ImEiIHg9IjEiIHk9IjEiIHdpZHRoPSIxNjQiIGhlaWdodD0iODUiIHJ4PSIxOS42ODM1OSIgcnk9IjE5LjY4MzU5Ii8+CiAgICAgIDxwYXRoIGNsYXNzPSJiIiBkPSJNMTQ1LjMxNjQxLDJBMTguNzA0NzYsMTguNzA0NzYsMCwwLDEsMTY0LDIwLjY4MzU5VjY2LjMxNjQxQTE4LjcwNDc3LDE4LjcwNDc3LDAsMCwxLDE0NS4zMTY0MSw4NUgyMC42ODM1OUExOC43MDQ3NiwxOC43MDQ3NiwwLDAsMSwyLDY2LjMxNjQxVjIwLjY4MzU5QTE4LjcwNDc1LDE4LjcwNDc1LDAsMCwxLDIwLjY4MzU5LDJIMTQ1LjMxNjQxbTAtMkgyMC42ODM1OUEyMC42ODM1OCwyMC42ODM1OCwwLDAsMCwwLDIwLjY4MzU5VjY2LjMxNjQxQTIwLjY4MzU4LDIwLjY4MzU4LDAsMCwwLDIwLjY4MzU5LDg3SDE0NS4zMTY0MUEyMC42ODM1OCwyMC42ODM1OCwwLDAsMCwxNjYsNjYuMzE2NDFWMjAuNjgzNTlBMjAuNjgzNTgsMjAuNjgzNTgsMCwwLDAsMTQ1LjMxNjQxLDBaIi8+CiAgICA8L2c+CiAgICA8cmVjdCBjbGFzcz0iYyIgeD0iMjAiIHk9IjE2IiB3aWR0aD0iMTI2IiBoZWlnaHQ9IjU1IiByeD0iMTIuNzMwNDIiIHJ5PSIxMi43MzA0MiIvPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "O/Lb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/components/avatar/Avatar.vue + 3 modules
var Avatar = __webpack_require__("Be47");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./src/config/enum/ProductTypes.js
var ProductTypes = __webpack_require__("mdcO");

// EXTERNAL MODULE: ./src/config/enum/ProjectStatuses.js
var ProjectStatuses = __webpack_require__("TnFP");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/layouts/app/Search.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Search = ({

    components: { Avatar: Avatar["a" /* default */] },

    data: function data() {
        return {
            search_active: false,
            search: null,
            result: [],
            pastSearches: [],
            exist: false,
            hint: 'Taper au moins 3 caractères',
            loading: false,
            ProductTypes: ProductTypes["a" /* ProductTypes */],
            ProjectStatuses: ProjectStatuses["a" /* ProjectStatuses */]
        };
    },

    computed: {
        color: function color() {
            if (this.search_active == true) {
                return 'active';
            }
        }
    },
    methods: {
        // when open search -- remove breadcrumbs and focus the menu with results
        open_search: function open_search() {
            var _this = this;

            this.search_active = !this.search_active;
            this.loading = false;
            if (this.search_active == true) {
                this.hint = "Taper au moins 3 caractères";
                document.getElementById("breadcrumbs").classList.add('remove');
                this.$nextTick(function () {
                    return _this.$refs.menu.isActive = true;
                });
                this.$nextTick(function () {
                    return _this.$refs.input.focus();
                });
            } else {
                this.search_active = false;
                this.search = null;
                document.getElementById("breadcrumbs").classList.remove('remove');
                this.$nextTick(function () {
                    return _this.$refs.menu.isActive = false;
                });
            }
        },

        // on close show breadcrumbs
        close_search: function close_search() {
            var _this2 = this;

            this.loading = false;
            this.search_active = false;
            this.search = null;
            document.getElementById("breadcrumbs").classList.remove('remove');
            this.$nextTick(function () {
                return _this2.$refs.menu.isActive = false;
            });
        },

        // when the search input is blur
        unfocused: function unfocused() {
            var _this3 = this;

            setTimeout(function () {
                return _this3.close_search();
            }, 200);
        },

        // on click in old search
        oldSearch: function oldSearch(route, id) {
            var group = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            if (group != null) {
                this.$router.push({ name: 'single-' + route, params: { group: group, id: id } });
            } else {
                this.$router.push({ name: 'single-' + route, params: { id: id } });
            }
            this.search = null;
            this.dialog = false;
        },

        // when click on recent search result
        searchClick: function searchClick(item, route, id) {
            var group = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

            if (group == 'consumable') {
                group = 'consumable';
            } else if (group == 'equipment') {
                group = 'equipment';
            } else if (group == 'accessory') {
                group = 'accessory';
            }
            this.storeSearch(item, route, id, group);
            if (group != null) {
                this.$router.push({ name: 'single-' + route, params: { group: group, id: id } });
            } else {
                this.$router.push({ name: 'single-' + route, params: { id: id } });
            }
            this.search = null;
            this.dialog = false;
        },

        // store the clicked result in localStorage
        storeSearch: function storeSearch(item, route, id) {
            var _this4 = this;

            var group = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

            var pastSearches = [];
            // check if the localStorage pastSearch exist
            if (localStorage["pastSearches"]) {
                pastSearches = JSON.parse(localStorage["pastSearches"]);
                this.exist = false;
            }
            // chekc if the item is already store
            pastSearches.forEach(function (key) {
                if (key.id == id) {
                    _this4.exist = true;
                }
            });

            item['route'] = route;
            item['group'] = group;

            if (this.exist == false) {
                // if not put the item in the array
                pastSearches.unshift(item);
                // store only 10 last results, if length is supp, pop the last one
                if (pastSearches.length > 10) {
                    pastSearches.pop();
                }

                localStorage["pastSearches"] = stringify_default()(pastSearches);
                this.pastSearches = JSON.parse(localStorage["pastSearches"]);
            }
        },

        //debounce search fonction
        debounceInput: lodash_default.a.debounce(function (val) {
            var _this5 = this;

            if (val && val.length >= 3) {
                this.hint = '';
                this.axios.get('/api/search/' + val).then(function (response) {
                    _this5.result = response.data;
                    _this5.loading = false;
                }).catch(function (error) {
                    console.log(error.response.data);
                });
            } else {
                this.result = [];
            }
        }, 500)
    },
    watch: {
        search: function search(val) {
            if (val) {
                this.loading = true;
                this.debounceInput(val);
            }
        }
    },
    mounted: function mounted() {
        if (localStorage["pastSearches"]) {
            this.pastSearches = JSON.parse(localStorage["pastSearches"]);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ba8f776","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/app/Search.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search"},[_c('v-btn',{class:_vm.color,attrs:{"flat":"","loading":_vm.loading},on:{"click":function($event){_vm.open_search()}}},[_c('v-icon',[_vm._v("search")])],1),_vm._v(" "),_c('v-menu',{ref:"menu",attrs:{"offset-y":""}},[_c('v-text-field',{directives:[{name:"show",rawName:"v-show",value:(_vm.search_active),expression:"search_active"}],ref:"input",attrs:{"slot":"activator","placeholder":"Taper au moins 2 caractères","hide-details":"","loading":_vm.loading,"hint":_vm.hint,"type":"text"},on:{"blur":function($event){_vm.unfocused()}},slot:"activator",model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),(!_vm.search && _vm.pastSearches)?_c('div',{staticClass:"last_search"},[_c('v-list',_vm._l((_vm.pastSearches),function(pastSearch,index){return _c('v-list-tile',{key:index,class:pastSearch.first_name ?  'profile' : 'category',on:{"click":function($event){_vm.oldSearch(pastSearch.route, pastSearch.id, pastSearch.group)}}},[_c('v-icon',[_vm._v("search")]),_vm._v(" "),_c('div',[_c('p',[_vm._v(_vm._s(pastSearch.label))])])],1)}))],1):[(_vm.search != null && _vm.result.projects && _vm.result.products)?[_c('div',{staticClass:"active_search"},[(_vm.result.projects.length > 0)?_c('v-subheader',[_vm._v("\n                        Projets ("+_vm._s(_vm.result.projects.length)+")\n                        "),_c('v-spacer')],1):_vm._e(),_vm._v(" "),(_vm.result.projects.length > 0)?_c('v-list',_vm._l((_vm.result.projects.slice(0, 3)),function(projects,index){return _c('v-list-tile',{key:index,staticClass:"li",on:{"click":function($event){_vm.searchClick(projects, 'project', projects.id)}}},[_c('avatar',{attrs:{"item":projects}}),_vm._v(" "),_c('div',[_c('p',[_vm._v(_vm._s(projects.label))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$_.find(_vm.ProjectStatuses,function (p) { return p.value == projects.status; }).label))])])],1)})):_vm._e(),_vm._v(" "),(_vm.result.products.filter(function (p) { return p.group == 'consumable' || p.group == 'equipment' || p.group == 'accessory'; }).length > 0)?_c('v-subheader',[_vm._v("\n                        Produits ("+_vm._s(_vm.result.products.filter(function (p) { return p.group == 'consumable' || p.group == 'equipment' || p.group == 'accessory'; }).length)+")\n                        "),_c('v-spacer')],1):_vm._e(),_vm._v(" "),(_vm.result.products.filter(function (p) { return p.group == 'consumable' || p.group == 'equipment' || p.group == 'accessory'; }).length > 0)?_c('v-list',_vm._l((_vm.result.products.filter(function (p) { return p.group == 'consumable' || p.group == 'equipment' || p.group == 'accessory'; }).slice(0, 3)),function(products,index){return _c('v-list-tile',{key:index,staticClass:"li",on:{"click":function($event){_vm.searchClick(products, 'product', products.id, products.group)}}},[_c('avatar',{attrs:{"item":products}}),_vm._v(" "),_c('div',[_c('p',[_vm._v(_vm._s(products.label))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$_.find(_vm.ProductTypes,function (p) { return p.value == products.type; }).label))])])],1)})):_vm._e(),_vm._v(" "),(_vm.result.projects.length <= 0 && _vm.result.products.length <= 0)?_c('div',[_vm._v("\n                        Il n'y a pas de résultat pour cette recherche\n                    ")]):_vm._e()],1)]:_vm._e()]],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var app_Search = (esExports);
// CONCATENATED MODULE: ./src/layouts/app/Search.vue
function injectStyle (ssrContext) {
  __webpack_require__("8S3P")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ba8f776"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Search,
  app_Search,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var layouts_app_Search = (Component.exports);

// EXTERNAL MODULE: ./src/config/enum/TestStatuses.js
var TestStatuses = __webpack_require__("KxZN");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/aside/Notifications.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




moment_default.a.locale('fr');

/* harmony default export */ var Notifications = ({
    components: { Avatar: Avatar["a" /* default */] },
    data: function data() {
        return {
            title: 'Notifications',
            icon: 'notifications',
            notifs: [],
            moment: moment_default.a,
            Olds: [],
            TestStatuses: TestStatuses["a" /* TestStatuses */],
            loading: false
        };
    },


    methods: {
        // on click on new notif
        markAsRead: function markAsRead(id, item, type, index) {
            var _this = this;

            this.axios.post('/api/notification/read', { id: id }).then(function (response) {
                _this.notifs.splice(index, 1);
                _this.$eventHub.$emit('update-notifs');
                _this.go(item, type);
            });
        },
        go: function go(item, type) {
            this.$eventHub.$emit('close-aside');
            if (type.includes('Test')) {
                this.$router.push({ name: 'single-product', params: { super_family: item.group, id: item.id } });
            }
        },

        // method to get all new notifs
        getNotifs: function getNotifs() {
            var _this2 = this;

            this.loading = true;
            this.axios.get('/api/notification/get').then(function (response) {
                _this2.notifs = response.data;
                _this2.$eventHub.$emit('update-total', _this2.notifs.length);
                _this2.loading = false;
            });
        },

        // method to get all olds notifs
        getOld: function getOld() {
            var _this3 = this;

            this.axios.get('/api/notification/getold').then(function (response) {
                _this3.Olds = response.data;
                _this3.Olds = _this3.$_.orderBy(_this3.Olds, 'read_at', 'desc');
            });
        }
    },
    created: function created() {
        var _this4 = this;

        // Bus to get all notifs (old and new)
        this.$eventHub.$on('get-notifications', function () {
            _this4.getNotifs();
            _this4.getOld();
        });
    },
    mounted: function mounted() {
        this.getNotifs();
        this.getOld();
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28a8510e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/aside/Notifications.vue
var Notifications_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aside-notifs"},[(_vm.loading)?_c('div',{staticClass:"loader"},[_c('img',{attrs:{"src":__webpack_require__("bwqQ")}})]):_vm._e(),_vm._v(" "),(_vm.notifs && _vm.notifs.length > 0 && !_vm.loading)?_c('v-list',{staticClass:"notif"},[_c('p',[_vm._v("Nouvelles Notifications")]),_vm._v(" "),_vm._l((_vm.notifs),function(notif,index){return _c('v-list-tile',{key:notif.id,staticClass:"li",on:{"click":function($event){_vm.markAsRead(notif.id,notif.data.product,notif.type,index)}}},[_c('avatar',{attrs:{"item":notif.data.product,"size":"4rem"}}),_vm._v(" "),_c('v-list-tile-content',[(notif.type.includes('Test'))?_c('v-list-tile-title',[_vm._v("Un contrôle effectué par : "),_c('span',[_vm._v(_vm._s(notif.data.user.first_name)+" "+_vm._s(notif.data.user.last_name))]),_vm._v(" "),(notif.data.status == 'failed')?[_vm._v("a "),_c('span',{staticClass:"status"},[_vm._v(_vm._s(_vm.$_.find(_vm.TestStatuses,function (ts) { return ts.value == notif.data.status; }).label))])]:_vm._e(),_vm._v(" "),(notif.data.status == 'finished')?[_vm._v("est "),_c('span',{staticClass:"status"},[_vm._v(_vm._s(_vm.$_.find(_vm.TestStatuses,function (ts) { return ts.value == notif.data.status; }).label))])]:_vm._e(),_vm._v("\n                    sur le produit : "),_c('span',[_vm._v(_vm._s(notif.data.product.label))])],2):_vm._e(),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.moment(notif.created_at).calendar()))])],1)],1)})],2):_vm._e(),_vm._v(" "),(_vm.Olds && _vm.Olds.length > 0 && !_vm.loading)?_c('v-list',{staticClass:"notif"},[_c('p',[_vm._v("Anciennes Notifications")]),_vm._v(" "),_vm._l((_vm.Olds),function(notif,index){return _c('v-list-tile',{key:notif.id,staticClass:"li",on:{"click":function($event){_vm.go(notif.data.product,notif.type)}}},[_c('avatar',{attrs:{"item":notif.data.product,"size":"4rem"}}),_vm._v(" "),_c('v-list-tile-content',[(notif.type.includes('Test'))?_c('v-list-tile-title',[_vm._v("Un contrôle effectué par : "),_c('span',[_vm._v(_vm._s(notif.data.user.first_name)+" "+_vm._s(notif.data.user.last_name))]),_vm._v(" "),(notif.data.status == 'failed')?[_vm._v("a "),_c('span',{staticClass:"status"},[_vm._v(_vm._s(_vm.$_.find(_vm.TestStatuses,function (ts) { return ts.value == notif.data.status; }).label))])]:_vm._e(),_vm._v(" "),(notif.data.status == 'finished')?[_vm._v("est "),_c('span',{staticClass:"status"},[_vm._v(_vm._s(_vm.$_.find(_vm.TestStatuses,function (ts) { return ts.value == notif.data.status; }).label))])]:_vm._e(),_vm._v("\n                    sur le produit :\n                    "),_c('span',[_vm._v(_vm._s(notif.data.product.label))])],2):_vm._e(),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Lu : "+_vm._s(_vm.moment(notif.read_at).calendar()))])],1)],1)})],2):_vm._e()],1)}
var Notifications_staticRenderFns = []
var Notifications_esExports = { render: Notifications_render, staticRenderFns: Notifications_staticRenderFns }
/* harmony default export */ var aside_Notifications = (Notifications_esExports);
// CONCATENATED MODULE: ./src/components/aside/Notifications.vue
function Notifications_injectStyle (ssrContext) {
  __webpack_require__("NKxF")
}
var Notifications_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Notifications___vue_template_functional__ = false
/* styles */
var Notifications___vue_styles__ = Notifications_injectStyle
/* scopeId */
var Notifications___vue_scopeId__ = "data-v-28a8510e"
/* moduleIdentifier (server only) */
var Notifications___vue_module_identifier__ = null
var Notifications_Component = Notifications_normalizeComponent(
  Notifications,
  aside_Notifications,
  Notifications___vue_template_functional__,
  Notifications___vue_styles__,
  Notifications___vue_scopeId__,
  Notifications___vue_module_identifier__
)

/* harmony default export */ var components_aside_Notifications = (Notifications_Component.exports);

// EXTERNAL MODULE: ./node_modules/quagga/dist/quagga.min.js
var quagga_min = __webpack_require__("SGD2");
var quagga_min_default = /*#__PURE__*/__webpack_require__.n(quagga_min);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/layouts/app/Scan.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Scan = ({
    compoenents: {
        Quagga: quagga_min_default.a
    },
    data: function data() {
        return {
            title: 'Scanner un codebar',
            icon: 'mdi-barcode',
            dialog: false,
            loading: false
        };
    },


    methods: {
        onClose: function onClose() {
            quagga_min_default.a.stop();
            this.$eventHub.$emit('close-modal');
        },

        // init the barcode reader plugin
        init_quagga: function init_quagga() {
            var _this = this;
            quagga_min_default.a.init({
                inputStream: {
                    name: "Live",
                    type: "LiveStream",
                    target: document.querySelector('#interactive') // Or '#yourElement' (optional)
                },
                decoder: {
                    readers: ["ean_reader"],
                    debug: {
                        drawBoundingBox: false,
                        showFrequency: false,
                        drawScanline: false,
                        showPattern: false
                    },
                    multiple: false
                },
                locator: {
                    patchSize: "large" // x-small, small, medium, large, x-large
                },
                constraints: {
                    width: 640,
                    height: 480,
                    facingMode: { exact: "environment" },
                    aspectRatio: { min: 1, max: 100 },
                    deviceId: _this.backCamID
                },
                area: {
                    // defines rectangle of the detection/localization area
                    top: "0%", // top offset
                    right: "0%", // right offset
                    left: "0%", // left offset
                    bottom: "0%" // bottom offset
                },
                singleChannel: false // true: only the red color-channel is read
            }, function (err) {
                if (err) {
                    console.log(err);
                    return;
                }
                _this.loading = false;
                quagga_min_default.a.start();
            });

            quagga_min_default.a.onProcessed(function (result) {
                var drawingCtx = quagga_min_default.a.canvas.ctx.overlay,
                    drawingCanvas = quagga_min_default.a.canvas.dom.overlay;

                if (result) {
                    if (result.boxes) {
                        drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute("width")), parseInt(drawingCanvas.getAttribute("height")));
                        result.boxes.filter(function (box) {
                            return box !== result.box;
                        }).forEach(function (box) {
                            quagga_min_default.a.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, {
                                color: "green",
                                lineWidth: 2
                            });
                        });
                    }

                    if (result.box) {
                        quagga_min_default.a.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, {
                            color: "#00F",
                            lineWidth: 2
                        });
                    }

                    if (result.codeResult && result.codeResult.code) {
                        quagga_min_default.a.ImageDebug.drawPath(result.line, { x: "x", y: "y" }, drawingCtx, { color: "red", lineWidth: 3 });
                    }
                }
            });
            // when barcode is detected
            quagga_min_default.a.onDetected(function (result) {
                if (result.codeResult.code) {
                    //get the code of the barcode
                    var code = result.codeResult.code;
                    _this.dialog = true;
                    //debouce fonction -- check if the code exist
                    _this.debounceInput(code);
                }
            });
        },


        debounceInput: _.debounce(function (code) {
            var _this2 = this;

            if (code) {
                //get request to check if the code exist
                this.axios.get('/api/products?filters=ean|=|' + code).then(function (response) {
                    if (response.data[0]) {
                        // if exist stop the reader, close the modal and open single product page
                        quagga_min_default.a.stop();
                        _this2.$router.push({ name: 'single-product', params: { super_family: response.data[0].group, id: response.data[0].id } });
                        _this2.$eventHub.$emit('close-modal');
                    } else {
                        // else open an error snackbar that tell the code doesn't exist
                        _this2.$eventHub.$emit('open-snackbar', 'error', 'code bar non trouvé, veuillé réessayer');
                        _this2.dialog = false;
                    }
                });
            }
        }, 200)
    },
    created: function created() {
        var _this = this;
        // alert(navigator.mediaDevices)
        if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
            // alert("Doesn't work");
            return;

            navigator.mediaDevices.enumerateDevices().then(function (devices) {
                devices.forEach(function (device) {
                    // alert( JSON.stringify(device) );
                    if (device.kind == "videoinput" && device.label.match(/back/) != null) {
                        // alert("Back found!");
                        _this.backCamID = device.deviceId;
                        // console.log("device id", device)
                        // alert("backCamID", _this.backCamID);
                    }
                });
            }).catch(function (err) {
                alert("Error");
            });

            if (_this.backCamID == null) {
                _this.backCamID = ""; // fallback value
                // console.log("backCamID is null")
            }
        }
    },
    mounted: function mounted() {
        this.loading = true;
        this.$eventHub.$emit('hide-modal-actions');
        if (document.querySelector('#interactive')) {
            this.init_quagga();
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54b77c8a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/app/Scan.vue
var Scan_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"loader"},[_c('img',{attrs:{"src":__webpack_require__("bwqQ")}})]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],staticClass:"viewport",attrs:{"id":"interactive"}}),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","overlay":false,"max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{staticClass:"found"},[_c('v-card-title',{staticClass:"primary"},[_c('h2',{staticClass:"white--text"},[_c('v-icon',{staticClass:"mr-2",attrs:{"dark":""}},[_vm._v("mdi-barcode")]),_vm._v(" "),_c('span',[_vm._v("Redirection")])],1)]),_vm._v(" "),_c('v-card-text',[_c('img',{attrs:{"src":__webpack_require__("bwqQ")}}),_vm._v(" "),_c('p',{staticClass:"mt-2"},[_vm._v("Vous allez être redirigé sur la fiche ...")])])],1)],1)],1)}
var Scan_staticRenderFns = []
var Scan_esExports = { render: Scan_render, staticRenderFns: Scan_staticRenderFns }
/* harmony default export */ var app_Scan = (Scan_esExports);
// CONCATENATED MODULE: ./src/layouts/app/Scan.vue
function Scan_injectStyle (ssrContext) {
  __webpack_require__("vwCv")
}
var Scan_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Scan___vue_template_functional__ = false
/* styles */
var Scan___vue_styles__ = Scan_injectStyle
/* scopeId */
var Scan___vue_scopeId__ = "data-v-54b77c8a"
/* moduleIdentifier (server only) */
var Scan___vue_module_identifier__ = null
var Scan_Component = Scan_normalizeComponent(
  Scan,
  app_Scan,
  Scan___vue_template_functional__,
  Scan___vue_styles__,
  Scan___vue_scopeId__,
  Scan___vue_module_identifier__
)

/* harmony default export */ var layouts_app_Scan = (Scan_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/layouts/app/Header.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var Header = ({
    components: { Avatar: Avatar["a" /* default */], Search: layouts_app_Search },
    data: function data() {
        return {
            Notifications: components_aside_Notifications,
            notifs: 0,
            interval: null,
            Scan: layouts_app_Scan
        };
    },


    computed: {
        data: function data() {
            return this.$store.state.auth.user;
        }
    },

    methods: {
        logout: function logout() {
            this.$store.dispatch('logout');
        },

        // get notifs method
        getNotifs: function getNotifs() {
            var _this = this;

            this.axios.get('/api/notification/count').then(function (response) {
                _this.notifs = response.data;
            });
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        this.getNotifs();
        // get notifs at regular interval
        this.interval = setInterval(function () {
            _this2.getNotifs();
        }, 100000);
    },
    beforeDestroy: function beforeDestroy() {
        clearInterval(this.interval);
    },
    created: function created() {
        var _this3 = this;

        // when open notif panel, if counter notifs diff counter in header => update
        this.$eventHub.$on('update-notifs', function () {
            _this3.notifs > 0 ? _this3.notifs = _this3.notifs - 1 : _this3.notifs = 0;
        });
        this.$eventHub.$on('update-total', function (total) {
            _this3.notifs = total;
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f16d4d7a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/app/Header.vue
var Header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-header"},[_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.$router.go(-1)}}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("arrow_back")])],1),_vm._v(" "),_c('search'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"header-actions"},[_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.$eventHub.$emit('open-modal', _vm.Scan)}}},[_c('v-icon',[_vm._v("mdi-barcode-scan")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){$event.stopPropagation();_vm.$eventHub.$emit('open-aside', _vm.Notifications)}}},[_c('v-badge',{attrs:{"overlap":"","top":""}},[(_vm.notifs>0)?_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(_vm.notifs))]):_vm._e(),_vm._v(" "),_c('v-icon',[_vm._v("notifications")])],1)],1)],1),_vm._v(" "),_c('v-menu',{attrs:{"offset-y":"","offset-x":""}},[_c('div',{staticClass:"user",attrs:{"slot":"activator"},slot:"activator"},[_c('avatar',{attrs:{"size":"3rem","item":_vm.data}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.data.first_name))]),_vm._v(" "),_c('v-icon',[_vm._v("arrow_drop_down")])],1),_vm._v(" "),_c('v-list',{staticClass:"user_menu"},[_c('v-list-tile',{staticClass:"li"},[_c('router-link',{attrs:{"to":{ name: 'admin' }}},[_c('v-icon',[_vm._v("settings")]),_vm._v("\n                        Paramètres\n                    ")],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":_vm.logout}},[_c('v-icon',[_vm._v("exit_to_app")]),_vm._v("\n                    Déconnexion\n                ")],1)],1)],1)],1)],1)}
var Header_staticRenderFns = []
var Header_esExports = { render: Header_render, staticRenderFns: Header_staticRenderFns }
/* harmony default export */ var app_Header = (Header_esExports);
// CONCATENATED MODULE: ./src/layouts/app/Header.vue
function Header_injectStyle (ssrContext) {
  __webpack_require__("EwH+")
}
var Header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Header___vue_template_functional__ = false
/* styles */
var Header___vue_styles__ = Header_injectStyle
/* scopeId */
var Header___vue_scopeId__ = "data-v-f16d4d7a"
/* moduleIdentifier (server only) */
var Header___vue_module_identifier__ = null
var Header_Component = Header_normalizeComponent(
  Header,
  app_Header,
  Header___vue_template_functional__,
  Header___vue_styles__,
  Header___vue_scopeId__,
  Header___vue_module_identifier__
)

/* harmony default export */ var layouts_app_Header = __webpack_exports__["a"] = (Header_Component.exports);


/***/ }),

/***/ "PEpY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QW8i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R/AT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RHqM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RVXe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SIDS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./src/config/enum/Nationalities.js
var Nationalities = [{ label: 'Afghan', value: 'af', code: '+93', country: 'Afghanistan' }, { label: 'Americain', value: 'am', code: '+1', country: 'Amérique' }, { label: 'Albanais', value: 'ab', code: '+355', country: 'Albanie' }, { label: 'Algérien', value: 'ag', code: '+213', country: 'Algérie' }, { label: 'Allemand', value: 'al', code: '+49', country: 'Allemagne' }, { label: 'Australien', value: 'aus', code: '+61', country: 'Australie' }, { label: 'Autrichien', value: 'aut', code: '+43', country: 'Autriche' }, { label: 'Bolivien', value: 'bo', code: '+591', country: 'Bolivie' }, { label: 'Brésilien', value: 'br', code: '+55', country: 'Brésil' }, { label: 'Bulgare', value: 'bu', code: '+359', country: 'Bulgarie' }, { label: 'Canadien', value: 'ca', code: '+1', country: 'Canada' }, { label: 'Chinois', value: 'ch', code: '+86', country: 'Chine' }, { label: 'Colombien', value: 'col', code: '+57', country: 'Colombie' }, { label: 'Coréen', value: 'cor', code: '+82', country: 'Corée' }, { label: 'Ivoirien', value: 'iv', code: '+225', country: 'Côte d\'ivoire' }, { label: 'Croate', value: 'cr', code: '+385', country: 'Croatie' }, { label: 'Cubain', value: 'cu', code: '+53', country: 'Cuba' }, { label: 'Danois', value: 'da', code: '+45', country: 'Danemark' }, { label: 'Egyptien', value: 'eg', code: '+20', country: 'Egypt' }, { label: 'Espagnol', value: 'es', code: '+34', country: 'Espagne' }, { label: 'Français', value: 'fr', code: '+33', country: 'France' }, { label: 'Grec', value: 'gr', code: '+30', country: 'Grèce' }, { label: 'Indien', value: 'in', code: '+91', country: 'Inde' }, { label: 'Irlandais', value: 'ir', code: '+353', country: 'Irlande' }, { label: 'Italien', value: 'it', code: '+39', country: 'Italie' }, { label: 'Japonais', value: 'ja', code: '+81', country: 'Japon' }, { label: 'Libanais', value: 'li', code: '+231', country: 'Liban' }, { label: 'Marocain', value: 'ma', code: '+212', country: 'Maroc' }, { label: 'Mexicain', value: 'me', code: '+52', country: 'Mexique' }, { label: 'Nigerien', value: 'ni', code: '+234', country: 'Nigeria' }, { label: 'Pakistanais', value: 'pa', code: '+92', country: 'Pakistan' }, { label: 'Néerlandais', value: 'ne', code: '+31', country: 'Pays-Bas' }, { label: 'Polonais', value: 'pol', code: '+48', country: 'Pologne' }, { label: 'Portugais', value: 'por', code: '+351', country: 'Portugal' }, { label: 'Roumain', value: 'ro', code: '+40', country: 'Roumanie' }, { label: 'Britanique', value: 'br', code: '+44', country: 'Grande bretagne' }, { label: 'Russe', value: 'ru', code: '+7', country: 'Russie' }, { label: 'Sénégalais', value: 'sen', code: '+221', country: 'Sénégal' }, { label: 'Serbe', value: 'ser', code: '+381', country: 'Serbie' }, { label: 'Suedois', value: 'sue', code: '+46', country: 'Suède' }, { label: 'Suisse', value: 'sui', code: '+41', country: 'Suisse' }, { label: 'Turque', value: 'tu', code: '+90', country: 'Turquie' }, { lable: 'Tunisien', value: 'tun', code: '+216', country: 'Tunisie' }, { label: 'Vietnamien', value: 'vi', code: '+84', country: 'Vietnam' }];
// EXTERNAL MODULE: ./src/filters/nl2br.js
var nl2br = __webpack_require__("sTpe");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SingleField.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




moment_default.a.locale('fr');

/* harmony default export */ var SingleField = ({
    props: {
        model: {
            required: true
        },
        modelText: {
            required: false
        },
        modelValue: {
            required: false
        },
        type: {
            required: false,
            default: 'text'
        },
        hint: {
            required: false
        },
        options: {
            required: false
        },
        optionText: {
            required: false
        },
        optionValue: {
            required: false
        },
        multiple: {
            required: false,
            default: false
        },
        suffix: {
            required: false
        },
        readonly: {
            required: false,
            default: false
        },
        multiline: {
            required: false
        },
        rows: {
            required: false,
            default: 1
        },
        export_button: {
            required: false,
            default: 'visibility'
        },
        hide_eye: {
            required: false,
            default: false
        },
        special_mask: {
            required: false
        }
    },

    data: function data() {
        return {
            dataLoaded: false,
            isEditable: false,
            loading: false,
            buffer: null,
            formatedBuffer: null,
            error: false,
            localHint: this.hint || null,
            showDatePicker: false,
            show: false,
            code: null,
            prefix: '',
            moment: moment_default.a,
            Nationalities: Nationalities
        };
    },


    computed: {
        // view datas
        view: function view() {
            var _this = this;

            if (this.modelText && this.modelText.indexOf('.') > -1) {
                var path = this.model;
                // if multiples options chosen
                if (typeof_default()(this.model) == 'object' && this.modelText != null) {
                    var z;

                    var _ret = function () {
                        var parts = _this.modelText.split('.');

                        for (z = 0; z < parts.length; z++) {
                            path = path[parts[z]];

                            if (Array.isArray(path) && parts[z + 1] != undefined) {
                                var values = path;
                                var labels = '';

                                values.forEach(function (v, i) {
                                    labels += i > 0 ? ', ' : '';
                                    labels += v[parts[z + 1]];
                                });

                                if (_this.multiple && labels) {
                                    var array = labels.split(',');
                                    return {
                                        v: array
                                    };
                                } else {
                                    return {
                                        v: labels
                                    };
                                }
                            }
                        }
                    }();

                    if ((typeof _ret === 'undefined' ? 'undefined' : typeof_default()(_ret)) === "object") return _ret.v;
                }

                return path;
            } else if (this.modelText) {
                // simple text
                return this.model[this.modelText];
            } else if (this.type == 'select') {
                // simple select
                var selectedOption = this.$_.find(this.options, function (o) {
                    return o[_this.optionValue] == _this.model;
                });
                return selectedOption ? selectedOption[this.optionText] : null;
            } else {
                // other
                return this.model;
            }
        },
        localOptions: function localOptions() {
            // get the options for selects
            if (typeof_default()(this.model) == 'object' && this.model != null) {
                return this.model[this.options];
            } else {
                return this.options;
            }
        },
        mask: function mask() {
            // create mask for tel input
            if (this.type == 'tel') {
                return '+ ## ## ## ## ## ##';
            } else {
                return '';
            }
        }
    },

    methods: {
        // on click on pen -- to edit a field
        switchMode: function switchMode() {
            var _this2 = this;

            if (!this.readonly) {

                var selected = null;

                // Find value of select list width enum
                if (this.$_.find(this.options, function (o) {
                    return o[_this2.optionValue] == _this2.model;
                })) {
                    selected = this.$_.find(this.options, function (o) {
                        return o[_this2.optionValue] == _this2.model;
                    }).value;
                }

                // Put model in buffer
                if (this.model != null && selected == null && !this.multiple) {
                    // Textfield
                    if (this.modelText == undefined) {
                        this.buffer = this.model;
                    }
                    // Select Meta simple
                    else {
                            this.buffer = this.model[this.modelText];
                        }
                }
                // Select Enum simple
                else if (this.model != null && !this.multiple) {
                        this.buffer = selected;
                    }
                // only one field open
                this.$eventHub.$emit('close_field');

                this.isEditable = !this.isEditable;

                // Set focus, if type = select
                if (this.isEditable && this.type == 'select' || this.isEditable && this.type == 'tel') {
                    this.$nextTick(function () {
                        return _this2.$refs.field.$refs.input.focus();
                    });
                }
            }
        },
        setExportMode: function setExportMode() {
            // when click on eye -- visible or not on export
            if (this.model.is_visible == 1) {
                this.buffer = 0;
            } else {
                this.buffer = 1;
            }
            this.$emit('hide', this.buffer);
        },

        // click on cancel
        cancel: function cancel() {
            var _this3 = this;

            // reinit all
            this.isEditable = !this.isEditable;
            this.buffer = this.model;

            if (typeof_default()(this.buffer) == 'object' && this.modelValue != null) {
                this.modelValue.split('.').forEach(function (item) {
                    _this3.buffer = _this3.buffer[item];
                });
            }

            this.error = false;
            this.localHint = this.hint || null;
            this.showDatePicker = false;
            this.loading = false;
        },


        // click on validate
        validate: function validate() {

            this.showDatePicker = false;

            if (this.buffer == this.model) {
                this.isEditable = false;
            } else if (typeof_default()(this.model) == 'object' && this.modelValue != null) {
                var val = this.model;

                this.modelValue.split('.').forEach(function (item) {
                    val = val[item];
                });

                if (this.buffer == val) {
                    this.isEditable = false;
                } else {
                    this.loading = true;
                    this.$emit('validate', this.buffer);
                }
            } else {
                this.loading = true;
                this.$emit('validate', this.buffer);
            }
        },
        setError: function setError(msg) {
            this.error = true;
            this.localHint = msg;
            this.loading = false;
        }
    },

    watch: {
        '$store.state.single.data': {
            handler: function handler(val) {
                var _this4 = this;

                if ((typeof val === 'undefined' ? 'undefined' : typeof_default()(val)) == 'object') {
                    if (!this.dataLoaded) {
                        this.dataLoaded = true;
                        this.buffer = this.model;

                        if (typeof_default()(this.buffer) == 'object' && this.modelValue != null) {
                            this.modelValue.split('.').forEach(function (item) {
                                _this4.buffer = _this4.buffer[item];
                            });
                        }
                    }

                    if (this.isEditable && this.loading) {
                        this.isEditable = !this.isEditable;
                    }

                    this.loading = false;
                }
            },

            deep: true
        },

        buffer: function buffer(val) {
            if (this.type == 'date') {
                this.formatedBuffer = moment_default()(this.buffer).format('L');
            }
        },
        code: function code(val) {
            this.buffer = val + '';
        },

        // Date picker set first screen : year
        showDatePicker: function showDatePicker(val) {
            var _this5 = this;

            val && this.$nextTick(function () {
                return _this5.$refs.pickerInMenu.activePicker = 'YEAR';
            });
        }
    },

    created: function created() {
        var _this6 = this;

        // only one field open
        this.$eventHub.$on('close_field', function () {
            _this6.isEditable = false;
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2cc041e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SingleField.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single-field"},[(_vm.isEditable)?_c('div',{staticClass:"edit-mode"},[_c('div',{staticClass:"input-container",on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key)){ return null; }_vm.cancel($event)}}},[(['text', 'email', 'number', 'link'].includes(_vm.type))?_c('v-text-field',{attrs:{"type":_vm.type,"hint":_vm.localHint,"persistent-hint":_vm.localHint != null,"hide-details":_vm.localHint == null,"mask":_vm.mask,"return-masked-value":true,"disabled":_vm.loading,"multi-line":_vm.multiline != null,"auto-grow":_vm.multiline != null,"rows":_vm.rows,"error":_vm.error,"autofocus":""},nativeOn:{"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.validate($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"tab",9,$event.key)){ return null; }_vm.validate($event)}]},model:{value:(_vm.buffer),callback:function ($$v) {_vm.buffer=$$v},expression:"buffer"}}):(_vm.type == 'date')?[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"slide-y-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},model:{value:(_vm.showDatePicker),callback:function ($$v) {_vm.showDatePicker=$$v},expression:"showDatePicker"}},[_c('v-text-field',{attrs:{"slot":"activator","hint":_vm.localHint,"persistent-hint":_vm.localHint != null,"hide-details":_vm.localHint == null,"disabled":_vm.loading,"error":_vm.error,"readonly":"","autofocus":""},on:{"focus":function($event){_vm.showDatePicker = true}},slot:"activator",model:{value:(_vm.formatedBuffer),callback:function ($$v) {_vm.formatedBuffer=$$v},expression:"formatedBuffer"}}),_vm._v(" "),_c('v-date-picker',{ref:"pickerInMenu",attrs:{"no-title":"","locale":"fr-FR","first-day-of-week":"1","autosave":""},model:{value:(_vm.buffer),callback:function ($$v) {_vm.buffer=$$v},expression:"buffer"}})],1)]:(_vm.type == 'select' && !_vm.multiple)?_c('v-select',{ref:"field",attrs:{"items":_vm.localOptions,"hint":_vm.localHint,"persistent-hint":_vm.localHint != null,"hide-details":_vm.localHint == null,"disabled":_vm.loading,"error":_vm.error,"autocomplete":"","autofocus":"","no-data-text":"Aucune donnée...","item-text":_vm.optionText,"item-value":_vm.optionValue},on:{"input":_vm.validate},model:{value:(_vm.buffer),callback:function ($$v) {_vm.buffer=$$v},expression:"buffer"}}):(_vm.type == 'select' && _vm.multiple)?_c('v-select',{ref:"field",staticClass:"multiple-select",attrs:{"items":_vm.localOptions,"hint":_vm.localHint,"persistent-hint":_vm.localHint != null,"hide-details":_vm.localHint == null,"disabled":_vm.loading,"error":_vm.error,"autocomplete":"","no-data-text":"Aucune donnée...","item-text":_vm.optionText,"item-value":_vm.optionValue,"multiple":""},nativeOn:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"tab",9,$event.key)){ return null; }_vm.validate($event)}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',{key:JSON.stringify(data.item),staticClass:"chip--select-multi",attrs:{"color":"primary","text-color":"white","small":"","selected":data.selected},on:{"input":function($event){data.parent.selectItem(data.item)}}},[_vm._v("\n                        "+_vm._s(data.item.label)+"\n                    ")])]}}]),model:{value:(_vm.buffer),callback:function ($$v) {_vm.buffer=$$v},expression:"buffer"}}):(_vm.type == 'tel')?_c('div',{staticClass:"tel"},[_c('v-select',{ref:"field",attrs:{"items":_vm.Nationalities,"disabled":_vm.loading,"error":_vm.error,"autocomplete":"","autofocus":"","no-data-text":"Aucune donnée...","item-text":"code","item-value":"code"},model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}}),_vm._v(" "),_c('v-text-field',{attrs:{"type":_vm.type,"hint":_vm.localHint,"persistent-hint":_vm.localHint != null,"hide-details":_vm.localHint == null,"mask":_vm.mask,"return-masked-value":true,"prefix":_vm.prefix,"disabled":_vm.loading,"error":_vm.error},nativeOn:{"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.validate($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"tab",9,$event.key)){ return null; }_vm.validate($event)}]},model:{value:(_vm.buffer),callback:function ($$v) {_vm.buffer=$$v},expression:"buffer"}})],1):_c('span',{staticClass:"error--text"},[_vm._v("Type de champ non pris en charge")])],2),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('v-btn',{attrs:{"icon":"","small":""},on:{"click":function($event){$event.stopPropagation();_vm.cancel($event)}}},[_c('v-icon',{attrs:{"color":"error"}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","small":"","loading":_vm.loading},on:{"click":function($event){$event.stopPropagation();_vm.validate($event)}}},[_c('v-icon',{attrs:{"color":"success"}},[_vm._v("check")])],1)],1)]):_c('div',{staticClass:"view-mode",class:{readonly : _vm.readonly}},[_c('div',{staticClass:"data"},[(_vm.type == 'date' && _vm.view != null)?[_vm._v("\n                "+_vm._s(_vm.moment(_vm.view).format('L'))+"\n                "),(_vm.suffix != null)?[_vm._v("\n                    "+_vm._s(_vm.suffix)+"\n                ")]:_vm._e()]:(_vm.multiline != null)?[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$options.filters.nl2br(_vm.view || '-'))}})]:(Array.isArray(_vm.view) && _vm.view.length >= 1)?[_vm._l((_vm.view),function(v,vi){return [(vi < (3))?[_c('v-chip',{attrs:{"color":"primary","text-color":"white","small":""}},[_vm._v(_vm._s(v))])]:_vm._e()]}),_vm._v(" "),_c('v-tooltip',{attrs:{"right":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[(_vm.view.length > 3)?_c('v-chip',{attrs:{"slot":"activator","color":"primary","text-color":"white","small":""},slot:"activator"},[_vm._v("+ "+_vm._s(_vm.view.length - 3))]):_vm._e(),_vm._v(" "),_c('span',_vm._l((_vm.view),function(v,vi){return (vi>=3)?_c('p',{key:vi,staticClass:"mb-0"},[_vm._v(_vm._s(v))]):_vm._e()}))],1)]:(_vm.type == 'link')?[(_vm.view && _vm.view.includes('http'))?_c('a',{attrs:{"href":_vm.view,"target":"_blank"}},[(_vm.view)?[_vm._v(_vm._s('Ouvrir le lien'))]:[_vm._v(" - ")]],2):_c('a',{attrs:{"href":'http://'+_vm.view,"target":"_blank"}},[(_vm.view)?[_vm._v(_vm._s('Ouvrir le lien'))]:void 0],2)]:(_vm.special_mask == 'round')?[(_vm.view)?[_vm._v("\n                    "+_vm._s(Math.round(_vm.view*100)/100)+"\n                ")]:[_vm._v("\n                    '-'\n                ")]]:[_vm._v("\n                "+_vm._s(_vm.view || '-')+"\n\n                "),(_vm.suffix != null)?[_vm._v("\n                    "+_vm._s(_vm.suffix)+"\n                ")]:_vm._e()]],2),_vm._v(" "),(!this.readonly && _vm.$store.state.auth.user.level >= 60)?_c('v-btn',{staticClass:"edit",attrs:{"icon":"","small":""},on:{"click":_vm.switchMode},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.switchMode($event)}}},[_c('v-icon',[_vm._v("mode_edit")])],1):_vm._e(),_vm._v(" "),(!_vm.hide_eye && _vm.$store.state.auth.user.level >= 60)?_c('v-btn',{attrs:{"icon":"","small":""},on:{"click":function($event){_vm.setExportMode()}}},[_c('v-icon',[_vm._v(_vm._s(_vm.export_button))])],1):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_SingleField = (esExports);
// CONCATENATED MODULE: ./src/components/SingleField.vue
function injectStyle (ssrContext) {
  __webpack_require__("u9Bb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e2cc041e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  SingleField,
  components_SingleField,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_SingleField = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SM1q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T4d6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T6DQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TQ6S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TnFP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProjectStatuses; });
var ProjectStatuses = [{ label: 'Etude de marché', value: 'market-survey' }, { label: 'Etude concurrents', value: 'competitor-survey' }, { label: 'Etude fournisseurs', value: 'supplier-survey' }, { label: 'Commercialisé', value: 'marketed' }, { label: 'Archivé', value: 'archived' }];

/***/ }),

/***/ "UVP8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/avatar/UploadAvatar.vue + 2 modules
var UploadAvatar = __webpack_require__("wRGB");

// EXTERNAL MODULE: ./src/components/SingleField.vue + 3 modules
var SingleField = __webpack_require__("SIDS");

// CONCATENATED MODULE: ./src/config/enum/Roles.js
var Roles = [{ label: 'Technicien', value: 2 }, { label: 'Administrateur', value: 1 }];
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/admin/users/single/Single.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Single = ({
	components: {
		UploadAvatar: UploadAvatar["a" /* default */], SingleField: SingleField["a" /* default */]
	},

	data: function data() {
		return {
			Roles: Roles
		};
	},


	computed: {
		data: function data() {
			return this.$store.state.single.data;
		}
	},

	methods: {
		getDataFromApi: function getDataFromApi() {
			var _this = this;

			this.$loading.startLoading('setSingleData');
			this.axios.get('/api/users/' + this.$route.params.id).then(function (res) {
				_this.$store.dispatch('setSingleData', { data: res.data });
				_this.$loading.endLoading('setSingleData');
			}).catch(function (err) {
				return console.log(err.response.data);
			});
		},
		updateField: function updateField(key, value) {
			var _this2 = this;

			var resource = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'users';

			var model = {};
			model[key] = value;

			this.axios.put('/api/' + resource + '/' + this.$route.params.id, model).then(function (res) {
				return _this2.$store.dispatch('updateSingleData', { key: key, value: value });
			}).catch(function (err) {
				return _this2.$refs[key].setError(error.response.data.errors[key][0]);
			});
		}
	},

	created: function created() {
		this.getDataFromApi();
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f27f3d6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/users/single/Single.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single_content"},[(_vm.$loading.isLoading('setSingleData'))?_c('v-loading',{staticClass:"loader",attrs:{"loader":"setSingleData"}},[_c('template',{slot:"spinner"},[_c('div',{staticClass:"loader"},[_c('img',{attrs:{"src":__webpack_require__("bwqQ")}})])])],2):_vm._e(),_vm._v(" "),(!_vm.$loading.isLoading('setSingleData'))?_c('div',{staticClass:"single"},[_c('aside',[_c('div',{staticClass:"top"},[_c('div',{staticClass:"border"}),_vm._v(" "),_c('upload-avatar',{attrs:{"item":_vm.data,"entities":"users","field":"avatar"}})],1),_vm._v(" "),_c('div',{staticClass:"contain"},[_c('div',{staticClass:"name"},[_c('h2',[_vm._v(_vm._s(_vm.data.first_name)+" "+_vm._s(_vm.data.last_name))])]),_vm._v(" "),_c('div',{staticClass:"about"},[_c('v-subheader',[_vm._v("A propos")]),_vm._v(" "),_c('div',{staticClass:"field",attrs:{"data-group":"1"}},[_c('div',{staticClass:"label"},[_vm._v("Prénom :")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('single-field',{ref:"first_name",attrs:{"model":_vm.data.first_name,"hide_eye":true},on:{"validate":function($event){_vm.updateField('first_name', $event)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"field",attrs:{"data-group":"1"}},[_c('div',{staticClass:"label"},[_vm._v("Nom :")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('single-field',{ref:"last_name",attrs:{"model":_vm.data.last_name,"hide_eye":true},on:{"validate":function($event){_vm.updateField('last_name', $event)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"field",attrs:{"data-group":"1"}},[_c('div',{staticClass:"label"},[_vm._v("Email :")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('single-field',{ref:"email",attrs:{"model":_vm.data.email,"hide_eye":true},on:{"validate":function($event){_vm.updateField('email', $event)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"field",attrs:{"data-group":"0"}},[_c('div',{staticClass:"label"},[_vm._v("Niveau :")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('single-field',{ref:"role_id",attrs:{"model":_vm.data.role_id ? _vm.data.role_id: '',"type":"select","options":_vm.Roles,"optionText":"label","optionValue":"value","hide_eye":true},on:{"validate":function($event){_vm.updateField('role_id', $event)}}})],1)])],1)])]),_vm._v(" "),_c('div',{staticClass:"tab"},[_c('v-tabs',{attrs:{"slider-color":"primary","show-arrows":true}},[_c('v-tab',{attrs:{"ripple":"","to":{ name: 'admin-single-user-general' }}},[_vm._v("Mot de passe")])],1),_vm._v(" "),_c('div',{staticClass:"router_view"},[_c('router-view')],1)],1)]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var single_Single = (esExports);
// CONCATENATED MODULE: ./src/views/admin/users/single/Single.vue
function injectStyle (ssrContext) {
  __webpack_require__("ri6U")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8f27f3d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Single,
  single_Single,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var users_single_Single = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Us+Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V28l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/single/SingleCard.vue + 2 modules
var SingleCard = __webpack_require__("teBh");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/admin/sync/single.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var single = ({
    components: { SingleCard: SingleCard["a" /* default */] },
    data: function data() {
        return {
            modal: false
        };
    },

    methods: {
        resync: function resync() {
            var _this = this;

            this.modal = true;
            this.axios.post('/api/dailyResync').then(function (response) {
                _this.modal = false;
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-881cc8de","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/sync/single.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single_content"},[_c('single-card',[_c('template',{slot:"content"},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"subtitle"},[_vm._v(" Synchro ")])])],1),_vm._v(" "),_c('v-layout',[_c('v-btn',{attrs:{"color":"primary","outline":"","round":"","flat":""},on:{"click":_vm.resync}},[_vm._v("Tout resynchroniser")])],1)],1)],2),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px","persistent":""},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('v-card',[_c('div',{staticClass:"loader"},[_c('img',{attrs:{"src":__webpack_require__("bwqQ")}}),_vm._v(" "),_c('p',[_vm._v("Resynchro en cours")])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var sync_single = (esExports);
// CONCATENATED MODULE: ./src/views/admin/sync/single.vue
function injectStyle (ssrContext) {
  __webpack_require__("a+Sw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-881cc8de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  single,
  sync_single,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var admin_sync_single = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "V28u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vs8D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VsOG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WJD/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WxQU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WzoL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XUjY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xax2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/DataTable.vue + 2 modules
var DataTable = __webpack_require__("/WHI");

// EXTERNAL MODULE: ./src/components/avatar/Avatar.vue + 3 modules
var Avatar = __webpack_require__("Be47");

// EXTERNAL MODULE: ./src/config/enum/ProjectStatuses.js
var ProjectStatuses = __webpack_require__("TnFP");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/projects/list/Create.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Create = ({
    components: { Avatar: Avatar["a" /* default */] },

    data: function data() {
        return {
            title: 'Ajouter un projet',
            icon: 'folder',
            isValid: false,

            model: {
                label: null,
                user_id: null,
                status: 'market-survey',
                category_id: null,
                group: null
            },

            rules: {
                label: [function (v) {
                    return !!v || 'Nom obligatoire';
                }],
                user_id: [function (v) {
                    return !!v || 'Gestionnaire obligatoire';
                }],
                super_family: [function (v) {
                    return !!v || 'Super famille obligatoire';
                }],
                family: [function (v) {
                    return !!v || 'Famille obligatoire';
                }],
                category_id: [function (v) {
                    return !!v || 'Sous famille obligatoire';
                }]
            },

            users: [],

            categories: [],
            super_family_id: null,
            family_id: null,

            ProjectStatuses: ProjectStatuses["a" /* ProjectStatuses */]
        };
    },


    computed: {
        superFamilies: function superFamilies() {
            return this.categories.filter(function (c) {
                return c.parent_id == null;
            });
        },
        families: function families() {
            var _this = this;

            return this.categories.filter(function (c) {
                return c.parent_id == _this.super_family_id;
            });
        },
        subFamilies: function subFamilies() {
            var _this2 = this;

            return this.categories.filter(function (c) {
                return c.parent_id == _this2.family_id;
            });
        }
    },

    watch: {
        super_family_id: function super_family_id(val) {
            if (val == null) {
                this.model.group = null;
            } else {
                var code = this.categories.find(function (c) {
                    return c.id == val;
                }).code;

                this.model.group = code == 'S1' ? 'equipment' : 'consumable';
            }
        }
    },

    methods: {
        onClose: function onClose() {
            this.$eventHub.$emit('close-modal');
        },
        onValidate: function onValidate() {
            var _this3 = this;

            if (this.$refs.form.validate()) {
                this.axios.post('/api/projects', this.model).then(function (response) {
                    _this3.$eventHub.$emit('close-modal');
                    _this3.$router.push({ name: 'single-project', params: { id: response.data.id } });
                }).catch(function (err) {
                    return console.log(err);
                });
            } else {
                return false;
                this.$eventHub.$emit('stop_loading');
            }
        }
    },

    created: function created() {
        var _this4 = this;

        this.model.user_id = this.$store.state.auth.user.id;

        this.axios.get('/api/users').then(function (response) {
            _this4.users = response.data;
            _this4.users.forEach(function (item) {
                var obj = item;
                obj.fullName = item.first_name + ' ' + item.last_name;
                _this4.users.push(obj);
            });
        }).catch(function (err) {
            return console.log(error);
        });

        this.axios.get('/api/categories').then(function (res) {
            return _this4.categories = res.data;
        }).catch(function (err) {
            return console.log(err.response.data);
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70179cf0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/projects/list/Create.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();}},model:{value:(_vm.isValid),callback:function ($$v) {_vm.isValid=$$v},expression:"isValid"}},[_c('v-container',{attrs:{"grid-list-xs":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Nom","rules":_vm.rules.label,"required":""},model:{value:(_vm.model.label),callback:function ($$v) {_vm.$set(_vm.model, "label", $$v)},expression:"model.label"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"label":"Statut","autocomplete":"","required":"","chips":"","clearable":"","items":_vm.ProjectStatuses,"item-text":"label","item-value":"value","rules":_vm.rules.status},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',[_vm._v("\n                            "+_vm._s(data.item.label)+"\n                        ")])]}},{key:"item",fn:function(data){return [(typeof data.item === 'object')?[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(data.item.label))])],1)]:_vm._e()]}}]),model:{value:(_vm.model.status),callback:function ($$v) {_vm.$set(_vm.model, "status", $$v)},expression:"model.status"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"label":"Gestionnaire","autocomplete":"","required":"","chips":"","clearable":"","items":_vm.users,"item-text":"fullName","item-value":"id","rules":_vm.rules.user_id},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',[_c('avatar',{attrs:{"size":"3rem","item":data.item}}),_vm._v("\n                            "+_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name)+"\n                        ")],1)]}},{key:"item",fn:function(data){return [(typeof data.item === 'object')?[(data.item)?_c('avatar',{attrs:{"size":"3rem","item":data.item}}):_vm._e(),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name))])],1)]:_vm._e()]}}]),model:{value:(_vm.model.user_id),callback:function ($$v) {_vm.$set(_vm.model, "user_id", $$v)},expression:"model.user_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"label":"Super famille","items":_vm.superFamilies,"item-text":"label","item-value":"id","rules":_vm.rules.super_family,"autocomplete":"","required":"","chips":"","clearable":"","dense":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',[_vm._v("\n                            "+_vm._s(data.item.label)+"\n                        ")])]}},{key:"item",fn:function(data){return [(typeof data.item === 'object')?[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(data.item.label))])],1)]:_vm._e()]}}]),model:{value:(_vm.super_family_id),callback:function ($$v) {_vm.super_family_id=$$v},expression:"super_family_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"label":"Famille","items":_vm.families,"item-text":"label","item-value":"id","rules":_vm.rules.family,"disabled":_vm.super_family_id == null,"autocomplete":"","required":"","chips":"","clearable":"","dense":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',[_vm._v("\n                            "+_vm._s(data.item.label)+"\n                        ")])]}},{key:"item",fn:function(data){return [(typeof data.item === 'object')?[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(data.item.label))])],1)]:_vm._e()]}}]),model:{value:(_vm.family_id),callback:function ($$v) {_vm.family_id=$$v},expression:"family_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"label":"Sous famille","items":_vm.subFamilies,"item-text":"label","item-value":"id","rules":_vm.rules.category_id,"disabled":_vm.family_id == null,"autocomplete":"","required":"","chips":"","clearable":"","dense":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',[_vm._v("\n                            "+_vm._s(data.item.label)+"\n                        ")])]}},{key:"item",fn:function(data){return [(typeof data.item === 'object')?[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(data.item.label))])],1)]:_vm._e()]}}]),model:{value:(_vm.model.category_id),callback:function ($$v) {_vm.$set(_vm.model, "category_id", $$v)},expression:"model.category_id"}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var list_Create = (esExports);
// CONCATENATED MODULE: ./src/views/projects/list/Create.vue
function injectStyle (ssrContext) {
  __webpack_require__("0T99")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-70179cf0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Create,
  list_Create,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var projects_list_Create = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/projects/list/EditStatus.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EditStatus = ({
	props: {
		items: {
			required: false
		},
		params: {
			required: false
		}
	},
	data: function data() {
		return {
			title: 'Changer le status',
			icon: 'edit',

			isValid: false,

			model: {
				status: ''
			},

			rules: {
				status: [function (v) {
					return !!v || 'Statut obligatoire';
				}]
			}
		};
	},


	computed: {
		projectStatuses: function projectStatuses() {
			return ProjectStatuses["a" /* ProjectStatuses */];
		}
	},

	methods: {
		onClose: function onClose() {
			this.$eventHub.$emit('close-modal');
		},
		patchProjectsRec: function patchProjectsRec(index, projects, satus, callback) {
			var _this = this;

			if (projects.length === index) {
				callback();
			} else {
				projects[index].status = satus;
				this.axios.put('/api/projects/' + projects[index].id, {
					status: projects[index].status
				}).then(function (response) {
					_this.patchProjectsRec(++index, projects, satus, callback);
				}).catch(function (err) {
					console.log(err);
					callback();
				});
			}
		},
		onValidate: function onValidate() {
			var _this2 = this;

			this.patchProjectsRec(0, this.$store.state.datatable.projects.selected, this.model.status, function () {
				_this2.$eventHub.$emit('close-modal');
				_this2.$eventHub.$emit('reload-list');
			});
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-195956b4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/projects/list/EditStatus.vue
var EditStatus_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();}},model:{value:(_vm.isValid),callback:function ($$v) {_vm.isValid=$$v},expression:"isValid"}},[_c('v-container',{attrs:{"grid-list-xs":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{ref:"status",attrs:{"label":"Statut","autocomplete":"","required":"","chips":"","clearable":"","items":_vm.projectStatuses},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                            "+_vm._s(data.item.label)+"\n                        ")]}},{key:"item",fn:function(data){return [(typeof data.item === 'object')?[_vm._v("\n                                "+_vm._s(data.item.label)+"\n                            ")]:_vm._e()]}}]),model:{value:(_vm.model.status),callback:function ($$v) {_vm.$set(_vm.model, "status", $$v)},expression:"model.status"}})],1)],1)],1)],1)}
var EditStatus_staticRenderFns = []
var EditStatus_esExports = { render: EditStatus_render, staticRenderFns: EditStatus_staticRenderFns }
/* harmony default export */ var list_EditStatus = (EditStatus_esExports);
// CONCATENATED MODULE: ./src/views/projects/list/EditStatus.vue
function EditStatus_injectStyle (ssrContext) {
  __webpack_require__("ZT3W")
}
var EditStatus_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var EditStatus___vue_template_functional__ = false
/* styles */
var EditStatus___vue_styles__ = EditStatus_injectStyle
/* scopeId */
var EditStatus___vue_scopeId__ = "data-v-195956b4"
/* moduleIdentifier (server only) */
var EditStatus___vue_module_identifier__ = null
var EditStatus_Component = EditStatus_normalizeComponent(
  EditStatus,
  list_EditStatus,
  EditStatus___vue_template_functional__,
  EditStatus___vue_styles__,
  EditStatus___vue_scopeId__,
  EditStatus___vue_module_identifier__
)

/* harmony default export */ var projects_list_EditStatus = (EditStatus_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/projects/list/Delete.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Delete = ({
    data: function data() {
        return {
            title: 'Suppression de projets',
            icon: 'delete',
            warning: true,
            deleteItem: true
        };
    },


    methods: {
        onClose: function onClose() {
            this.$eventHub.$emit('close-modal');
        },
        onValidate: function onValidate() {
            var _this = this;

            if (this.deleteItem == true) {
                this.$store.state.datatable.projects.selected.forEach(function (item, index) {
                    _this.axios.delete('/api/projects/' + item.id).then(function (response) {
                        _this.$eventHub.$emit('close-modal');
                        _this.$eventHub.$emit('reload-list');
                    }).catch(function (err) {
                        return console.log(err.response.data);
                    });
                });
            } else {
                this.$eventHub.$emit('close-modal');
            }
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        if (this.$store.state.datatable.projects.selected) {
            this.$store.state.datatable.projects.selected.forEach(function (item) {
                _this2.axios.get('/api/projects/' + item.id + '?embed=sidamo_products,supplier_products,competitor_products').then(function (response) {
                    if (response.data.supplier_products_count > 0 || response.data.sidamo_products_count > 0 || response.data.competitor_products_count > 0) {
                        _this2.deleteItem = false;
                    }
                });
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42e93136","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/projects/list/Delete.vue
var Delete_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.deleteItem == true)?_c('div',[_c('p',[_vm._v("Êtes-vous sûr de vouloir supprimer les produits suivants :")]),_vm._v(" "),_c('ul',_vm._l((_vm.$store.state.datatable.products.selected),function(project){return _c('li',[_vm._v("\n                "+_vm._s(project.label)+"\n            ")])}))]):_c('div',[_c('p',[_vm._v("Un ou plusieurs projets est lié à un produit, merci de le supprimer afin de procéder à la suppression de ce projet")])])])}
var Delete_staticRenderFns = []
var Delete_esExports = { render: Delete_render, staticRenderFns: Delete_staticRenderFns }
/* harmony default export */ var list_Delete = (Delete_esExports);
// CONCATENATED MODULE: ./src/views/projects/list/Delete.vue
function Delete_injectStyle (ssrContext) {
  __webpack_require__("Vs8D")
}
var Delete_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Delete___vue_template_functional__ = false
/* styles */
var Delete___vue_styles__ = Delete_injectStyle
/* scopeId */
var Delete___vue_scopeId__ = "data-v-42e93136"
/* moduleIdentifier (server only) */
var Delete___vue_module_identifier__ = null
var Delete_Component = Delete_normalizeComponent(
  Delete,
  list_Delete,
  Delete___vue_template_functional__,
  Delete___vue_styles__,
  Delete___vue_scopeId__,
  Delete___vue_module_identifier__
)

/* harmony default export */ var projects_list_Delete = (Delete_Component.exports);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/projects/list/List.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







moment_default.a.locale('fr');

/* harmony default export */ var List = ({
	components: { DataTable: DataTable["a" /* default */], Avatar: Avatar["a" /* default */] },

	props: {
		filter: {
			required: false
		}
	},

	data: function data() {
		var _this = this;

		return {
			datatable: {
				toolbar: [{ icon: 'delete', callback: function callback() {
						_this.$eventHub.$emit('open-modal', projects_list_Delete);
					}, level: 60 }, { icon: 'edit', callback: function callback() {
						_this.$eventHub.$emit('open-modal', projects_list_EditStatus);
					}, level: 60 }],
				actions: [{ text: 'Ajouter un projet', icon: 'add_circle', callback: function callback() {
						_this.$eventHub.$emit('open-modal', projects_list_Create);
					}, level: 60 }],
				views: [{ text: 'Projet en cours', link: 'projects' }, { text: 'Tous les projets', link: 'all-projects' }, { text: 'Mes projets', link: 'my-projects' }, { text: 'Projets archivés', link: 'archived-projects' }],
				headers: [{ text: 'Nom du projet', sortable: true, value: 'label', align: 'left' }, { text: 'Super famille', sortable: true, value: 'category.parent.parent.label', align: 'right' }, { text: 'Famille', sortable: true, value: 'category.parent.label', align: 'right' }, { text: 'Sous Famille', sortable: true, value: 'category.label', align: 'right' }, { text: 'Statut', sortable: true, value: 'status', align: 'right' }, { text: 'Dernère modification', sortable: true, value: 'updated_at', align: 'right' }, { text: 'Gestionnaire', sortable: false, align: 'right' }],
				endpoint: {
					base: '/api/projects',
					filters: this.setFilters,
					embed: 'user,category.parent.parent,group'
				}
			},
			moment: moment_default.a
		};
	},


	methods: {
		rowClick: function rowClick(item) {
			this.$router.push({ name: 'single-project', params: { id: item.id } });
		},
		setFilters: function setFilters() {
			if (this.filter && this.fixed_filters) {
				this.datatable.endpoint.filters = this.fixed_filters + ',' + this.filter;
			} else if (this.filter) {
				this.datatable.endpoint.filters = this.filter;
			} else if (this.fixed_filters) {
				this.datatable.endpoint.filters = this.fixed_filters;
			} else {
				this.datatable.endpoint.filters = '';
			}
		}
	},

	watch: {
		$route: function $route() {
			this.setFilters();
			this.$refs.list.reload();
		}
	},

	created: function created() {
		var _this2 = this;

		this.$eventHub.$on('reload-list', function () {
			if (_this2.$refs.list) {
				_this2.$refs.list.reload();
			}
		});

		this.setFilters();
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f15ff92","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/projects/list/List.vue
var List_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-table',{ref:"list",attrs:{"headers":_vm.datatable.headers,"endpoint":_vm.datatable.endpoint,"toolbar":_vm.datatable.toolbar,"actions":_vm.datatable.actions,"views":_vm.datatable.views,"storeId":"projects","selectable":""},on:{"rowClick":_vm.rowClick},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v("\n            "+_vm._s(props.item.label)+"\n        ")]),_vm._v(" "),(props.item.category && props.item.category.parent && props.item.category.parent.parent)?_c('td',{staticClass:"text-xs-right"},[_vm._v("\n                "+_vm._s(props.item.category.parent.parent.label)+"\n        ")]):_c('td'),_vm._v(" "),(props.item.category && props.item.category.parent )?_c('td',{staticClass:"text-xs-right"},[_vm._v("\n                "+_vm._s(props.item.category.parent.label)+"\n        ")]):_c('td'),_vm._v(" "),(props.item.category)?_c('td',{staticClass:"text-xs-right"},[_vm._v("\n                "+_vm._s(props.item.category.label)+"\n        ")]):_c('td'),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n                "+_vm._s(_vm._f("projectStatus")(props.item.status))+"\n        ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n            "+_vm._s(_vm.moment(props.item.updated_at).format('L'))+"\n        ")]),_vm._v(" "),(props.item.user)?_c('td',{staticClass:"text-xs-right"},[_c('avatar',{attrs:{"item":props.item.user,"tooltip":true}})],1):_c('td')]}}])})}
var List_staticRenderFns = []
var List_esExports = { render: List_render, staticRenderFns: List_staticRenderFns }
/* harmony default export */ var list_List = (List_esExports);
// CONCATENATED MODULE: ./src/views/projects/list/List.vue
function List_injectStyle (ssrContext) {
  __webpack_require__("ru2d")
}
var List_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var List___vue_template_functional__ = false
/* styles */
var List___vue_styles__ = List_injectStyle
/* scopeId */
var List___vue_scopeId__ = "data-v-4f15ff92"
/* moduleIdentifier (server only) */
var List___vue_module_identifier__ = null
var List_Component = List_normalizeComponent(
  List,
  list_List,
  List___vue_template_functional__,
  List___vue_styles__,
  List___vue_scopeId__,
  List___vue_module_identifier__
)

/* harmony default export */ var projects_list_List = __webpack_exports__["default"] = (List_Component.exports);


/***/ }),

/***/ "XyO0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YGX0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/projects/single/CreateProduct.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var CreateProduct = ({
	props: {
		params: {
			required: true
		}
	},
	data: function data() {
		return {
			title: 'Ajouter un produit',
			icon: 'build',
			parent_category: null,
			isValid: false,
			disableEnter: true,

			model: {
				photo: '',
				label: '',
				type: '',
				category_id: '',
				supplier_id: '',
				group: '',
				project_id: '',
				external_link: '',
				user_id: ''
			},
			categories: [],
			suppliers: [],
			keep_selected_supplier: [],

			rules: {
				label: [function (v) {
					return !!v || 'Nom obligatoire';
				}],
				supplier_id: [function (v) {
					return !!v || 'Fournisseur obligatoire';
				}]
			}
		};
	},
	mounted: function mounted() {
		var _this = this;

		this.axios.get('/api/categories?filters=type|=|Super_family&embed=children.children').then(function (response) {
			_this.categories = [];
			var i = void 0,
			    j = void 0,
			    category = void 0,
			    child = void 0;
			for (i = 0; i < response.data.length; i++) {
				category = response.data[i];
				_this.categories.push({ header: category.label });
				for (j = 0; j < category.children.length; j++) {
					child = category.children[j];
					_this.categories.push({ label: child.label, id: child.id, group: 'category.label', children: child.children });
				}
				_this.categories.push({ divider: true });
			}
		}).catch(function (err) {
			return console.log(error);
		});

		this.axios.get('/api/suppliers').then(function (response) {
			_this.suppliers = [];
			var i = void 0,
			    supplier = void 0;
			for (i = 0; i < response.data.length; i++) {
				supplier = response.data[i];
				_this.suppliers.push({ name: supplier.name, id: supplier.id });
			}
		}).catch(function (err) {
			return console.log(error);
		});
	},

	watch: {
		'model.supplier_id': function modelSupplier_id(val) {
			if (val) {
				this.keep_selected_supplier = val;
			}
		}
	},

	methods: {
		onClose: function onClose() {
			this.$eventHub.$emit('close-modal');
		},
		onValidate: function onValidate() {
			var _this2 = this;

			this.model.type = this.params.type;
			this.model.project_id = this.$route.params.id;
			this.model.user_id = this.$store.state.auth.user.id;
			this.model.category_id = this.$store.state.single.data.category_id;
			this.model.group = this.$store.state.single.data.group;

			if (this.$refs.form.validate()) {
				this.axios.post('/api/products', this.model).then(function (response) {
					_this2.$eventHub.$emit('close-modal');
					if (response.status === 200 || response.status === 201) {
						_this2.$eventHub.$emit('reload-single-project');
					}
				}).catch(function (err) {
					return console.log(err);
				});
			} else {
				return false;
			}
		},
		addTag: function addTag(val) {
			var _this3 = this;

			if (this.suppliers.filter(function (s) {
				return s.name == val.target.value;
			}).length == 0) {
				this.axios.post('/api/suppliers', { name: val.target.value }).then(function (response) {
					_this3.suppliers.push(response.data);
					_this3.model.supplier_id = response.data.id;
					if (_this3.$refs.select) {
						_this3.$refs.select.searchValue = null;
					}
				});
			}
		},
		tab: function tab() {
			var _this4 = this;

			setTimeout(function () {
				_this4.model.supplier_id = _this4.keep_selected_supplier;
				_this4.$refs.link.focus();
			}, 0.05);
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bd5fd9e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/projects/single/CreateProduct.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();}},model:{value:(_vm.isValid),callback:function ($$v) {_vm.isValid=$$v},expression:"isValid"}},[_c('v-container',{attrs:{"grid-list-xs":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Nom","rules":_vm.rules.label,"required":""},model:{value:(_vm.model.label),callback:function ($$v) {_vm.$set(_vm.model, "label", $$v)},expression:"model.label"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{ref:"select",attrs:{"label":"Fournisseur","autocomplete":"","required":"","chips":"","clearable":"","items":_vm.suppliers,"item-text":"name","item-value":"id","rules":_vm.rules.supplier_id},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.addTag($event)},"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"tab",9,$event.key)){ return null; }_vm.tab($event)}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',[_vm._v("\n                            "+_vm._s(data.item.name)+"\n                        ")])]}},{key:"item",fn:function(data){return [(typeof data.item === 'object')?[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(data.item.name))])],1)]:_vm._e()]}}]),model:{value:(_vm.model.supplier_id),callback:function ($$v) {_vm.$set(_vm.model, "supplier_id", $$v)},expression:"model.supplier_id"}},[_c('template',{slot:"no-data"},[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Appuyer sur Entrer pour ajouter")])],1)],1)],1)],2)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{ref:"link",attrs:{"label":"Lien externe"},model:{value:(_vm.model.external_link),callback:function ($$v) {_vm.$set(_vm.model, "external_link", $$v)},expression:"model.external_link"}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var single_CreateProduct = (esExports);
// CONCATENATED MODULE: ./src/views/projects/single/CreateProduct.vue
function injectStyle (ssrContext) {
  __webpack_require__("/3V0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4bd5fd9e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  CreateProduct,
  single_CreateProduct,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var projects_single_CreateProduct = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YlpI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZT3W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zw7L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a+Sw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ar7M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bwqQ":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "c8ny":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "cD6D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/files/CreateLinkedFiles.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var CreateLinkedFiles = ({
    data: function data() {
        return {
            title: 'Ajouter un fichier',
            icon: 'file_upload',
            dialog: false,
            warning: false,
            isValid: false,
            disableEnter: false,
            model: {
                label: ''
            },
            file: '',
            rules: {
                name: [function (v) {
                    return !!v || 'Nom du fichier obligatoire';
                }]
            },
            file_name: 'Choisir un fichier',
            tags: [],
            entity: '',
            entity_id: '',
            loading: false
        };
    },

    methods: {
        // when dialog is open
        open: function open(field, entity_id) {
            this.dialog = true;
            this.entity = field;
            this.entity_id = entity_id;
        },

        // when file change on input
        UploadFile: function UploadFile(event) {
            this.file = event.target.files[0];
            this.file_name = this.file.name;
            this.model.label = this.file.name.split('.')[0];
        },

        // when click on btn -- click on input
        openInput: function openInput() {
            this.$refs.fileInput.click();
        },

        // when form is validate
        onValidate: function onValidate() {
            var _this = this;

            if (this.$refs.form.validate()) {
                this.loading = true;
                if (this.entity_id != 0) {
                    this.attachment = this.file;
                    // create data object
                    var data = new FormData();
                    // put the file, a file type (attachment) & size (resize on back)
                    data.append('file', this.attachment);
                    data.append('file_type', 'attachment');
                    data.append('size', 750);
                    // post the data object
                    this.axios.post('/api/' + this.entity + '/' + this.entity_id + '/file', data, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then(function (response) {
                        _this.axios.put('/api/files/' + response.data.id, _this.model).then(function (response) {
                            _this.$emit('added', _this.entity_id, _this.entity);
                            _this.loading = false;
                            _this.onClose();
                        });
                    }).catch(function (error) {});
                }
            }
        },
        onClose: function onClose() {
            // reset form on close
            if (this.$refs.form) {
                this.$refs.form.reset();
                this.$refs.fileInput.value = '';
                this.file_name = 'Choisir un fichier';
            }
            this.dialog = false;
        }
    },
    mounted: function mounted() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bad362e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/files/CreateLinkedFiles.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"750px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary"},[_c('h2',[_c('v-icon',{staticClass:"mr-2",attrs:{"dark":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.title))])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","icon":""},on:{"click":function($event){_vm.onClose()}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("close")])],1)],1),_vm._v(" "),_c('div',{staticClass:"pa-3"},[_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();}},model:{value:(_vm.isValid),callback:function ($$v) {_vm.isValid=$$v},expression:"isValid"}},[_c('v-container',{attrs:{"grid-list-xs":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[_c('v-btn',{attrs:{"color":"primary","outline":"","round":""},nativeOn:{"click":function($event){_vm.openInput($event)}}},[_vm._v("\n                            "+_vm._s(_vm.file_name)+"\n                            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("cloud_upload")])],1),_vm._v(" "),_c('input',{ref:"fileInput",staticStyle:{"display":"none"},attrs:{"type":"file"},on:{"change":_vm.UploadFile}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Nom","rules":_vm.rules.name,"required":"","autofocus":""},model:{value:(_vm.model.label),callback:function ($$v) {_vm.$set(_vm.model, "label", $$v)},expression:"model.label"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","small":"","round":"","outline":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","small":"","round":"","text-color":"white","loading":_vm.loading},on:{"click":_vm.onValidate}},[_vm._v("Valider")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var files_CreateLinkedFiles = (esExports);
// CONCATENATED MODULE: ./src/components/files/CreateLinkedFiles.vue
function injectStyle (ssrContext) {
  __webpack_require__("ujoQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2bad362e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  CreateLinkedFiles,
  files_CreateLinkedFiles,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_files_CreateLinkedFiles = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cdI5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dK9h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dgM2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/components/avatar/Avatar.vue + 3 modules
var Avatar = __webpack_require__("Be47");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./node_modules/vuedraggable/dist/vuedraggable.js
var vuedraggable = __webpack_require__("DAYN");
var vuedraggable_default = /*#__PURE__*/__webpack_require__.n(vuedraggable);

// EXTERNAL MODULE: ./src/config/enum/CommentTypes.js
var CommentTypes = __webpack_require__("22+B");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/products/single/ImportSymbol.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ImportSymbol = ({
    components: { Avatar: Avatar["a" /* default */] },
    props: {
        params: {
            required: true
        }
    },
    data: function data() {
        return {
            moment: moment_default.a,
            title: 'Sélectionnez un symbole',
            supplier_product: '',
            width: '1000px',
            product_code: '',
            model: {},
            valid_button: true,
            next_button: false,
            valid_label: 'Créer à partir de ce symbole',
            selectedIndex: 0,
            loading: true,
            noData: "Chargement des symboles ... ",
            items: [],
            pagination: {
                sortBy: 'updated_at',
                rowsPerPage: 5,
                page: 1,
                descending: true
            },
            per_page: [5, 10, 20, { text: 'Tout', value: -1 }],
            totalItems: 0,
            headers: [{ text: 'Selection', value: '', align: 'left' }, { text: 'Label', value: 'label', align: 'right' }, { text: 'Dernière modification', value: 'updated_at', align: 'right' }, { text: 'Utilisations', value: 'requests_count', align: 'right' }]
        };
    },

    computed: {
        pages: function pages() {
            if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null) return 0;

            return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage);
        }
    },
    methods: {
        onValidate: function onValidate() {
            var _this = this;

            var data = {
                user_id: this.$store.state.auth.user.id,
                type: 'all',
                product_id: this.params.product_id,
                symbol_id: this.items[this.selectedIndex].id,
                position: this.params.position
            };
            this.loading = true;
            this.axios.post('/api/requests', data).then(function (response) {
                _this.loading = false;
                _this.$eventHub.$emit('close-modal2');
                _this.$eventHub.$emit('go-to-request', { id: response.data.id });
            });
        },
        onClose: function onClose() {
            this.$eventHub.$emit('close-modal2');
        },
        loadItem: function loadItem() {
            var _this2 = this;

            this.loading = 'accent';
            this.axios.get('/api/symbols?embed=user,files,requests&page=' + this.pagination.page + '&per_page=' + this.pagination.rowsPerPage).then(function (response) {
                _this2.totalItems = response.data.count;
                if (response.data.data.length) {
                    _this2.items = response.data.data;
                    _this2.items.forEach(function (el) {
                        el.isSelected = false;
                    });
                    _this2.items[0].isSelected = true;
                    _this2.loading = false;
                } else {
                    _this2.noData = "Veuillez créer des symboles";
                    _this2.$eventHub.$emit('open-snackbar', 'warning', 'Il n\'y a pas de symbole dans la bibliothèque');
                    _this2.$eventHub.$emit('close-modal2');
                }
            });
        }
    },
    watch: {
        pagination: function pagination() {
            this.loadItem();
        }
    },
    created: function created() {},
    mounted: function mounted() {
        this.loadItem();
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45341d40","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/single/ImportSymbol.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form"},[_c('v-container',{attrs:{"grid-list-xs":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"table-container",attrs:{"xs12":""}},[_c('v-data-table',{attrs:{"items":_vm.items,"no-data-text":_vm.noData,"headers":_vm.headers,"loading":_vm.loading,"pagination":_vm.pagination,"total-items":_vm.totalItems,"rows-per-page-items":_vm.per_page,"rows-per-page-text":"Eléments par page :"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-right"},[_c('v-radio-group',{model:{value:(_vm.selectedIndex),callback:function ($$v) {_vm.selectedIndex=$$v},expression:"selectedIndex"}},[_c('v-radio',{attrs:{"color":'primary',"value":props.index}})],1)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n                        "+_vm._s(props.item.label)+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-right avatar-container"},[_vm._v("\n                        "+_vm._s(props.item.user.first_name)+" "+_vm._s(props.item.user.last_name)+"\n                        le "+_vm._s(_vm.moment(props.item.updated_at).format('DD/MM/YYYY'))+"\n                        "),_c('avatar',{attrs:{"item":props.item.user}})],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n                        "+_vm._s(props.item.requests_count)+"\n                    ")])]}}])})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var single_ImportSymbol = (esExports);
// CONCATENATED MODULE: ./src/views/products/single/ImportSymbol.vue
function injectStyle (ssrContext) {
  __webpack_require__("ar7M")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-45341d40"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  ImportSymbol,
  single_ImportSymbol,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var products_single_ImportSymbol = (Component.exports);

// EXTERNAL MODULE: ./src/components/files/CreateLinkedFiles.vue + 2 modules
var CreateLinkedFiles = __webpack_require__("cD6D");

// EXTERNAL MODULE: ./src/components/files/DeleteLinkedFiles.vue + 2 modules
var DeleteLinkedFiles = __webpack_require__("/38I");

// EXTERNAL MODULE: ./src/views/symbols/list/Single.vue + 5 modules
var Single = __webpack_require__("3BMk");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/products/single/Unlink.vue
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Unlink = ({
    data: function data() {
        return {
            title: 'Cette demande est liée à un symbole',
            icon: 'autorenew',
            warning: true,
            valid_label: 'Délier la demande de son symbole',
            cancel_label: 'Modifier le symbole'
        };
    },

    props: {
        params: {
            required: true
        }
    },
    methods: {
        onClose: function onClose(type) {
            window.location.hash = '';
            if (type === 'cancel') {
                this.$eventHub.$emit('open-modal', Single["a" /* default */], { id: this.params.symbol_id, isEditing: true });
            }
            this.$eventHub.$emit('close-modal2');
        },
        onValidate: function onValidate() {
            var _this = this;

            this.axios.delete('/api/requests/' + this.params.request_id + '/symbol').then(function (response) {
                _this.$eventHub.$emit('close-modal2');
                _this.$eventHub.$emit('go-to-request', { id: _this.params.request_id });
            }).catch(function (error) {
                console.log(error.response.data || error);
            });
        }
    }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15c7d53b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/single/Unlink.vue
var Unlink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('p',[_vm._v("La demande que vous souhaitez modifier est liée à un symbole.\n             Voulez vous délier cette demande de son symbole afin de la modifier séparement ?")])]],2)}
var Unlink_staticRenderFns = []
var Unlink_esExports = { render: Unlink_render, staticRenderFns: Unlink_staticRenderFns }
/* harmony default export */ var single_Unlink = (Unlink_esExports);
// CONCATENATED MODULE: ./src/views/products/single/Unlink.vue
function Unlink_injectStyle (ssrContext) {
  __webpack_require__("cdI5")
}
var Unlink_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Unlink___vue_template_functional__ = false
/* styles */
var Unlink___vue_styles__ = Unlink_injectStyle
/* scopeId */
var Unlink___vue_scopeId__ = "data-v-15c7d53b"
/* moduleIdentifier (server only) */
var Unlink___vue_module_identifier__ = null
var Unlink_Component = Unlink_normalizeComponent(
  Unlink,
  single_Unlink,
  Unlink___vue_template_functional__,
  Unlink___vue_styles__,
  Unlink___vue_scopeId__,
  Unlink___vue_module_identifier__
)

/* harmony default export */ var products_single_Unlink = (Unlink_Component.exports);

// EXTERNAL MODULE: ./src/filters/nl2br.js
var nl2br = __webpack_require__("sTpe");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/products/single/CreateComment.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ var CreateComment = ({
    components: {
        draggable: vuedraggable_default.a,
        Avatar: Avatar["a" /* default */],
        CreateLinkedFiles: CreateLinkedFiles["a" /* default */],
        DeleteLinkedFile: DeleteLinkedFiles["a" /* default */]
    },
    props: {
        params: {
            required: true
        }
    },
    data: function data() {
        return {
            moment: moment_default.a,
            loading: false,
            imgFullPath: null,
            editedElement: {
                id: null,
                type: ''
            },
            isMenuOpen: false,
            selectedPage: 'requests',
            selectedId: 0,
            isDragging: false,
            isModalOpen: false,
            delayedDragging: false,
            comments: [],
            requests: [],
            product_name: '',
            valid_button: false,
            cancel_button: false,
            fullscreen: true,
            card_text_class: 'fullscreen-modal-text',
            nb_column: 1,
            activeTab: '',
            valid_title: false,
            valid_message: false,
            check_if_error: false,
            confirmRemove: false,
            confirmRemove2: false,
            show_demand: true,
            error_2: false,
            display: true,
            hint_title2: 'Titre du deuxième commentaire',
            hint_message2: 'Contenu du deuxième commentaire',
            loading_file: false,
            symbols: [],
            rules: {
                title: [function (v) {
                    if (v) {
                        if (v.length >= 150) {
                            return 'Le titre ne dois pas contenir plus de 150 caractères';
                        } else {
                            return true;
                        }
                    } else {
                        return 'Titre obligatoire';
                    }
                }],
                title_2: [function (v) {
                    if (v) {
                        if (v.length >= 150) {
                            return 'Le titre ne dois pas contenir plus de 150 caractères';
                        } else {
                            return true;
                        }
                    } else {
                        return true;
                    }
                }]
            }
        };
    },


    computed: {
        items: {
            //get comments or requests in fonction of the selected tab
            get: function get() {
                if (this.selectedPage === 'requests') {
                    return this.requests;
                } else {
                    return this.comments;
                }
            },
            set: function set(value) {
                if (this.selectedPage === 'requests') {
                    this.requests = value;
                } else {
                    this.comments = value;
                }
            }
        },
        // set the drag options
        dragOptions: function dragOptions() {
            return {
                animation: 200,
                sort: true,
                ghostClass: 'ghost',
                chosenClass: 'sortable-chosen'
            };
        },

        commentTypes: function commentTypes() {
            return CommentTypes["a" /* CommentTypes */];
        }
    },

    methods: {
        // view attachment files
        viewFile: function viewFile(item, items) {
            var attachment_items = items.filter(function (i) {
                return i.pivot.file_type == 'attachment';
            });
            this.$eventHub.$emit('view-file', item, attachment_items);
        },

        // delete attachment files
        deleteFile: function deleteFile(entity_id, item_id) {
            this.display = false;
            var index = this.items.findIndex(function (el) {
                return el.id === entity_id;
            });
            var file_index = '';
            if (typeof item_id == 'number') {
                file_index = this.items[index].files.findIndex(function (el) {
                    return el.id === item_id;
                });
            } else {
                file_index = this.items[index].files.findIndex(function (el) {
                    return el.path === item_id.path;
                });
            }
            this.items[index].files.splice(file_index, 1);
            this.display = true;
        },

        // add attachment files
        addFile: function addFile(entity_id, entity) {
            var _this2 = this;

            this.display = false;
            if (entity_id != 0) {
                var index = this.items.findIndex(function (el) {
                    return el.id === entity_id;
                });
                this.axios.get('/api/' + entity + '?embed=files&filters=id|=|' + entity_id).then(function (response) {
                    _this2.items[index].files = response.data[0].files;
                    _this2.loading_file = false;
                    _this2.display = true;
                });
            }
        },

        // open images in the viewer, create galery without attachment files
        openImg: function openImg(file) {
            var _this3 = this;

            var files = null;
            this.items.forEach(function (i) {
                if (_this3.$_.find(i.files, function (f) {
                    return f.id == file.id;
                })) {
                    files = i.files;
                }
            });
            this.$eventHub.$emit('view-file', file, files);
        },
        // get the color of the comment, positive, negative or neutral
        getCommentColor: function getCommentColor(type) {
            var commentType = CommentTypes["a" /* CommentTypes */].find(function (el) {
                return el.value === type;
            });
            return commentType ? commentType.color : '';
        },

        getWritingMode: function getWritingMode(element) {
            return this.editedElement.id === element.id ? 'Edition' : 'Lecture';
        },
        editLabel: function editLabel(element) {
            if (!!element.symbol_id && element.symbol_id !== '') {
                return "Editer le symbole";
            } else {
                return "Editer";
            }
        },

        // select an item
        selectItem: function selectItem(element, index) {
            var _this4 = this;

            this.error_2 = false;
            this.hint_message2 = '';
            this.hint_title2 = '';
            if (index >= 0) {
                if (element && this.editedElement && this.editedElement.id !== null && element.id !== this.editedElement.id) {
                    this.loading = false;
                    console.log('there');
                    return;
                } else {
                    this.selectedId = element.id;
                    element.title_2 || element.message_2 ? this.nb_column = 2 : this.nb_column = 1;
                    // onclick on item, scroll to this one
                    this.$nextTick(function () {
                        if (document.getElementById('element-' + index)) {
                            document.getElementById('element-' + index).scrollIntoView();
                        }
                        _this4.loading = false;
                    });
                }
            }
        },
        swipeEvent: function swipeEvent() {
            var _this5 = this;

            // for scroll with touch screen
            var _this = this;
            //get the positon of the scroll
            var scrollTop = document.querySelector('#scroll-container').scrollTop;
            // create an array woth positon of each items
            var elementsPositions = [];
            this.items.forEach(function (i, index) {
                elementsPositions.push({ id: i.id, scrollTop: document.querySelector('#element-' + index).offsetTop });
            });
            // find the position of the scrolled item and select it
            elementsPositions.forEach(function (i, index) {
                if (elementsPositions[index + 1] != undefined) {
                    if (scrollTop > i.scrollTop && scrollTop < elementsPositions[index + 1].scrollTop) {
                        _this5.selectedId = elementsPositions[index + 1].id;
                        _this5.items[index].title_2 ? _this.nb_column = 2 : _this.nb_column = 1;
                    }
                }
            });
        },
        mouseOverElement: function mouseOverElement(element, index) {
            // select the right item on scroll
            if (!this.isModalOpen) {
                if (this.selectedId === element.id) {
                    return;
                } else {
                    this.selectedId = element.id;
                    if (element.title_2 != null && element.title_2 != '' || element.message_2 != null && element.message_2 != '') {
                        this.nb_column = 2;
                    } else {
                        this.nb_column = 1;
                    }
                }
            }
        },
        deleteElement: function deleteElement() {
            var _this6 = this;

            // delete an item
            this.editedElement.id = null;
            var elementIndex = this.items.findIndex(function (el) {
                return el.id === _this6.selectedId;
            });
            this.items.splice(elementIndex, 1);
            if (this.selectedId === 0) {
                this.updatePositions();
            } else {
                this.axios.delete('/api/' + this.selectedPage + '/' + this.selectedId).then(function (response) {
                    _this6.updatePositions();
                    _this6.$store.dispatch('updateSingleData', { key: _this6.selectedPage + '_count', value: _this6.$store.state.single.data[_this6.selectedPage + '_count'] - 1 });
                });
            }
            this.confirmRemove = false;
        },
        copyElementToEdition: function copyElementToEdition(element) {
            // create a copy of the element that we want update
            this.editedElement = {
                user_id: element.user_id,
                product_id: element.product_id,
                id: element.id,
                title: element.title,
                title_2: element.title_2,
                message: element.message,
                message_2: element.message_2,
                type: element.type,
                files: element.files,
                position: element.position
            };
        },
        setEditedElement: function setEditedElement(element) {
            // set an element to edition
            if (!this.editedElement || this.editedElement.id !== null) {
                alert("element deja en cours d'edition ou de création");
            } else {
                if (element.symbol_id > 0) {
                    this.isModalOpen = true;
                    this.$eventHub.$emit('open-modal2', products_single_Unlink, { symbol_id: element.symbol_id, request_id: element.id });
                } else {
                    var index = this[this.selectedPage].findIndex(function (el) {
                        return el.id == element.id;
                    });
                    var container = this.$el.querySelector("#scroll-container");
                    container.scrollTop = this[this.selectedPage].length > 0 ? container.scrollHeight / this[this.selectedPage].length * index : 0;
                    this.copyElementToEdition(element);
                }
            }
        },
        unsetEditedElement: function unsetEditedElement() {
            var _this7 = this;

            this.check_if_error = false;
            if (this.editedElement.id === 0) {
                this.deleteElement({ id: 0 });
            }
            // delete files imported but not saved
            if (this.$_.find(this.items, function (i) {
                return i.id == _this7.editedElement.id;
            })) {
                this.$_.find(this.items, function (i) {
                    return i.id == _this7.editedElement.id;
                }).files = this.$_.dropWhile(this.$_.find(this.items, function (i) {
                    return i.id == _this7.editedElement.id;
                }).files, function (f) {
                    return !f.id;
                });
            }

            this.editedElement = { id: null };
        },
        updateElement: function updateElement(elementToModify, element) {
            elementToModify.message = element.message;
            elementToModify.message_2 = element.message_2;
            elementToModify.title = element.title;
            elementToModify.title_2 = element.title_2;
            elementToModify.type = element.type;
        },
        saveElement: function saveElement(element) {
            var _this8 = this;

            var LinkFile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (element.type == 'separator' || this.valid_title && this.valid_message) {
                if (this.nb_column == 2 && this.editedElement.message_2 == null) {
                    this.error_2 = true;
                    this.editedElement.titre_2 ? '' : this.hint_title2 = 'Sur 2 colonnes, le titre ne peux pas être vide';
                    this.editedElement.message_2 ? '' : this.hint_message2 = 'Sur 2 colonnes, le message ne peux pas être vide';
                } else {
                    this.loading = true;
                    this.error_2 = false;
                    this.check_if_error = false;
                    var data = {
                        user_id: element.user_id,
                        product_id: element.product_id,
                        message: element.message,
                        message_2: element.message_2,
                        title: element.title,
                        title_2: element.title_2,
                        type: element.type,
                        position: element.position
                        // to upload photos as file when validate
                    };var updatePhotoRec = function updatePhotoRec(files, elementId, index) {
                        if (index < element.files.length) {
                            var file = element.files[index];
                            if (file.toUpdate) {
                                var _data = new FormData();
                                _data.append('file', file.file);
                                _data.append('file_type', null);
                                _data.append('location', file.pivot.location);
                                _data.append('size', 750);
                                if (file.id > 0) {
                                    _this8.axios.delete('/api/' + _this8.selectedPage + '/' + elementId + '/file/' + file.id).then(function (response) {
                                        _this8.axios.post('/api/' + _this8.selectedPage + '/' + elementId + '/file', _data).then(function (response) {
                                            updatePhotoRec(files, elementId, ++index);
                                            _this8.loading = false;
                                        });
                                    });
                                } else {
                                    _this8.axios.post('/api/' + _this8.selectedPage + '/' + elementId + '/file', _data).then(function (response) {
                                        updatePhotoRec(files, elementId, ++index);
                                        _this8.loading = false;
                                    });
                                }
                            } else {
                                updatePhotoRec(files, elementId, ++index);
                            }
                        } else {
                            _this8.axios.get('/api/' + _this8.selectedPage + '/' + elementId + '?embed=user,files').then(function (response) {
                                var elementIndex = _this8.items.findIndex(function (el) {
                                    return el.id === elementId;
                                });
                                _this8.items[elementIndex] = response.data;
                                _this8.items.sort(function (el1, el2) {
                                    return el1.position - el2.position;
                                }); //force recompute
                                _this8.updatePositions(); //force recompute
                                _this8.loading = false;
                            });
                        }
                    };
                    if (element.id === 0) {
                        this.axios.post('/api/' + this.selectedPage, data).then(function (response) {
                            var elementIndex = _this8.items.findIndex(function (el) {
                                return el.id === 0;
                            });
                            _this8.items[elementIndex].id = response.data.id;
                            _this8.updateElement(_this8.items[elementIndex], element);
                            _this8.$store.dispatch('updateSingleData', { key: _this8.selectedPage + '_count', value: _this8.$store.state.single.data[_this8.selectedPage + '_count'] + 1 });
                            updatePhotoRec(_this8.items[elementIndex].files, response.data.id, 0);
                            if (LinkFile == true) {
                                _this8.loading_file = true;
                                _this8.$refs.modal.open(_this8.selectedPage, response.data.id);
                                _this8.loading = false;
                            }
                        });
                    } else {
                        this.axios.put('/api/' + this.selectedPage + '/' + element.id, data).then(function (response) {
                            var elementToModify = _this8.items.find(function (el) {
                                return el.id === element.id;
                            });
                            _this8.updateElement(elementToModify, element);
                            updatePhotoRec(elementToModify.files, elementToModify.id, 0);
                            if (LinkFile == true) {
                                _this8.loading_file = true;
                                _this8.$refs.modal.open(_this8.selectedPage, elementToModify.id);
                                _this8.loading = false;
                            }
                        });
                    }
                    this.editedElement = { id: null };
                }
            } else {
                this.check_if_error = true;
                this.$eventHub.$emit('open-snackar', 'Les champs ne sont pas valides', 'error');
            }
        },
        onFileChange: function onFileChange(evt, elementId, fileIndex, col) {
            // when click input add image
            this.display = false;
            var col_new = evt.target.id.split('-')[1];
            var element = this.items.find(function (el) {
                return el.id === elementId;
            });
            if (fileIndex >= 0) {
                element.files[fileIndex].path = URL.createObjectURL(evt.target.files[0]);
                element.files[fileIndex].file = evt.target.files[0];
                element.files[fileIndex].toUpdate = true;
                element.files[fileIndex].pivot = { file_type: null, location: 'area-' + col };
            } else {
                element.files.push({
                    path: URL.createObjectURL(evt.target.files[0]),
                    file: evt.target.files[0],
                    toUpdate: true,
                    pivot: {
                        file_type: null,
                        location: 'area-' + col_new
                    }
                });
            }
            this.display = true;
        },
        addImgPath: function addImgPath(file) {
            return __webpack_require__("c8ny");
        },
        setColumnNumber: function setColumnNumber(nb_column) {
            if (this.editedElement.title_2 != '' && this.editedElement.title_2 != null) {
                if (this.nb_column == 2) {
                    this.confirmRemove2 = true;
                } else {
                    this.nb_column = nb_column;
                }
            } else if (this.editedElement.message_2 != '' && this.editedElement.message_2 != null) {
                if (this.nb_column == 2) {
                    this.confirmRemove2 = true;
                } else {
                    this.nb_column = nb_column;
                }
            } else {
                this.nb_column = nb_column;
            }
        },
        deleteCol: function deleteCol(id) {
            var _this9 = this;

            if (id != 0) {
                this.axios.put('/api/' + this.selectedPage + '/' + id, {
                    message_2: null,
                    title_2: null
                }).then(function (response) {
                    _this9.editedElement.message_2 = null;
                    _this9.editedElement.title_2 = null;
                    _this9.confirmRemove2 = false;
                    _this9.nb_column = 1;
                });
            } else {
                this.editedElement.message_2 = null;
                this.editedElement.title_2 = null;
                this.confirmRemove2 = false;
                this.nb_column = 1;
            }
        },
        isCol: function isCol(number) {
            return this.nb_column === number;
        },
        clickAdd: function clickAdd() {
            if (this.selectedPage === 'requests') {
                this.openAddMenu();
            } else {
                this.addNewItem();
            }
        },
        openAddMenu: function openAddMenu() {
            this.isMenuOpen = !this.isMenuOpen;
        },
        addItemFromSymbol: function addItemFromSymbol() {
            this.isMenuOpen = false;
            this.isModalOpen = true;
            this.$eventHub.$emit('open-modal2', products_single_ImportSymbol, { product_id: this.params.product_id, position: this.items.length + 1 });
        },
        addNewItem: function addNewItem() {
            var _this10 = this;

            var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var request_type = separator ? 'separator' : 'all';
            this.isMenuOpen = false;
            if (this.items.findIndex(function (el) {
                return el.id === 0;
            }) >= 0) {
                this.loading = false;
                return;
            }
            this.items.splice(this.items.length, 0, {
                id: 0,
                position: this.items.length + 1,
                files: [],
                product_id: this.params.product_id,
                user: this.$store.state.auth.user,
                user_id: this.$store.state.auth.user.id,
                message: '',
                message_2: '',
                type: request_type,
                title: '',
                title_2: '',
                created_at: new Date().toISOString()
            });

            this.copyElementToEdition(this.items[this.items.length - 1]);
            setTimeout(function () {
                _this10.selectItem(_this10.items[_this10.items.length - 1], _this10.items.length - 1);
            }, 20);
        },
        goTo: function goTo(page) {
            var _this11 = this;

            if (this.items.length > 0) {
                this.selectedId = this.items[0].id;
            }

            this.elementsPositions = [];
            this.items.forEach(function (i, index) {
                _this11.elementsPositions.push({ id: i.id, scrollTop: document.querySelector('#element-' + index).offsetTop });
            });
        },
        moveUp: function moveUp(element) {
            // when draggable element is move up
            var elementId = this.items.findIndex(function (el) {
                return el.id === element.id;
            });
            if (elementId > 0) {
                var temp = this.items[elementId];
                this.items[elementId] = this.items[elementId - 1];
                this.items[elementId - 1] = temp;
                this.updatePositions();
                this.items = this.items.sort(function (el1, el2) {
                    return el1.position - el2.position;
                });
                this.selectItem(this.items[elementId - 1], elementId - 1);
            }
        },
        moveDown: function moveDown(element) {
            // when draggable element is move down
            var elementId = this.items.findIndex(function (el) {
                return el.id === element.id;
            });
            if (elementId >= 0 && elementId < this.items.length - 1) {
                var temp = this.items[elementId];
                this.items[elementId] = this.items[elementId + 1];
                this.items[elementId + 1] = temp;
                this.updatePositions();
                this.items = this.items.sort(function (el1, el2) {
                    return el1.position - el2.position;
                });
                this.selectItem(this.items[elementId + 1], elementId + 1);
            }
        },
        onMove: function onMove(evt) {
            var _this12 = this;

            // when draggable element is move
            this.isDragging = false;
            this.updatePositions();
            var elementId = this.items.findIndex(function (el) {
                return el.id === _this12.selectedId;
            });
            this.selectItem(this.items[elementId], elementId);
            return true;
        },
        updatePositions: function updatePositions() {
            var _this13 = this;

            for (var i = 0; i < this.items.length; i++) {
                this.items[i].position = i + 1;
            }
            var updateRec = function updateRec(array, index) {
                if (array.length > index) {
                    if (array[index].id > 0) {
                        _this13.axios.put('/api/' + _this13.selectedPage + '/' + array[index].id, { position: array[index].position }).then(function (response) {
                            updateRec(array, ++index);
                        });
                    } else {
                        updateRec(array, ++index);
                    }
                }
            };
            updateRec(this.items, 0);
        },
        isTitleError: function isTitleError() {
            return this.check_if_error && !this.valid_title;
        },
        isMessageError: function isMessageError() {
            return this.check_if_error && !this.valid_message;
        },
        onClose: function onClose() {
            if (this.params.store_path) {
                this.$store.dispatch('updateSingleData', { key: this.params.store_path, value: this.items });
            }
            this.$eventHub.$emit('close-modal');
            this.$eventHub.$emit('reload-list');
            this.$router.push({ name: this.$route.name });
        },
        getDataFromApi: function getDataFromApi() {
            var _this14 = this;

            // get requests & comment linked to the product ids
            this.axios.get('/api/requests?filters=product_id|=|' + this.params.product_id + '&embed=user,files,symbol.files&order=position|ASC').then(function (response) {
                _this14.requests = response.data;
                _this14.requests.forEach(function (el) {
                    if (el.symbol_id > 0 && el.symbol != null) {
                        var symbol_from = el.symbol;
                        symbol_from.message ? el.message = symbol_from.message : el.message = null;
                        symbol_from.message_2 ? el.message_2 = symbol_from.message_2 : el.message_2 = null;
                        symbol_from.title_2 ? el.title_2 = symbol_from.title_2 : el.title_2 = null;
                        symbol_from.title ? el.title = symbol_from.title : el.title = null;
                        symbol_from.files ? el.files = symbol_from.files : el.files = [];
                    }
                });
                _this14.axios.get('/api/comments?filters=product_id|=|' + _this14.params.product_id + '&embed=user,files&order=position|ASC').then(function (response) {
                    _this14.comments = response.data;
                    if (_this14.params.create_query) {
                        _this14.addNewItem();
                    } else if (_this14.params.id !== undefined && _this14.params.element_type !== undefined) {

                        var indexElementInput = _this14.items.findIndex(function (el) {
                            return el.id === _this14.params.id;
                        });

                        _this14.selectItem(_this14.items[indexElementInput], indexElementInput);
                    }
                });
            });
        },
        onValidate: function onValidate() {
            this.saveElement(this.editedElement);
            if (this.params.store_path) {
                this.$store.dispatch('updateSingleData', { key: this.params.store_path, value: this.items });
            }
            this.$eventHub.$emit('close-modal');
            this.$eventHub.$emit('reload-list');
        }
    },

    created: function created() {
        var _this15 = this;

        this.getDataFromApi();

        if (this.params.element_type !== undefined) {
            if (this.params.element_type === 'comment') {
                this.selectedPage = 'comments';
            } else if (this.params.element_type === 'request') {
                this.selectedPage = 'requests';
            } else {
                console.log('the element type should be comment or request');
            }
        }
        this.product_name = this.params.product_label;

        this.$eventHub.$on('go-to-request', function (params) {

            _this15.axios.get('/api/requests?filters=product_id|=|' + _this15.params.product_id + '&embed=user,files,symbol.files&order=position|ASC').then(function (response) {
                _this15.requests = response.data;
                _this15.requests.forEach(function (el) {
                    if (el.symbol_id > 0 && el.symbol != null) {
                        var symbol_from = el.symbol;
                        symbol_from.message ? el.message = symbol_from.message : el.message = null;
                        symbol_from.message_2 ? el.message_2 = symbol_from.message_2 : el.message_2 = null;
                        symbol_from.title_2 ? el.title_2 = symbol_from.title_2 : el.title_2 = null;
                        symbol_from.title ? el.title = symbol_from.title : el.title = null;
                        symbol_from.files ? el.files = symbol_from.files : el.files = [];
                    }
                });

                var indexElementInput = _this15.items.findIndex(function (el) {
                    return el.id === params.id;
                });

                setTimeout(function () {
                    _this15.selectItem(_this15.items[indexElementInput], _this15.items.length - 1);
                }, 20);

                _this15.isModalOpen = false;
            });
        });
    },
    mounted: function mounted() {
        if (this.params.hide_demand) {
            this.show_demand = false;
        }
        this.loading = true;
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-581deae2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/single/CreateComment.vue
var CreateComment_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-container"},[_c('div',{staticClass:"modal-header"},[_vm._m(0),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","disabled":_vm.editedElement && _vm.editedElement.id != null},nativeOn:{"click":function($event){_vm.onClose($event)}}},[_c('v-icon',[_vm._v("arrow_back")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.product_name))])],1),_vm._v(" "),_c('div',{staticClass:"comments-aside"},[_c('div',{staticClass:"tab"},[_c('v-tabs',{attrs:{"grow":"","slider-color":"primary","show-arrows":true},model:{value:(_vm.selectedPage),callback:function ($$v) {_vm.selectedPage=$$v},expression:"selectedPage"}},[(_vm.show_demand == true)?_c('v-tab',{attrs:{"color":"primary","href":_vm.editedElement && _vm.editedElement.id != null ? '' :'#requests',"ripple":"","disabled":_vm.editedElement.id != null ? true : false},on:{"click":function($event){_vm.goTo('requests')}}},[_vm._v("Demandes")]):_vm._e(),_vm._v(" "),_c('v-tab',{attrs:{"color":"primary","href":_vm.editedElement && _vm.editedElement.id != null ? '' :'#comments',"ripple":"","disabled":_vm.editedElement.id != null ? true : false},on:{"click":function($event){_vm.goTo('comments')}}},[_vm._v("Commentaires")])],1),_vm._v(" "),_c('div',{staticClass:"scroll-y draggable-container",attrs:{"column":"","id":"scroll-target"}},[_c('draggable',{directives:[{name:"scroll",rawName:"v-scroll",value:({target: '#scroll-target'}),expression:"{target: '#scroll-target'}"}],attrs:{"element":"ul","options":_vm.dragOptions},on:{"start":function($event){_vm.isDragging=true},"end":_vm.onMove},model:{value:(_vm.items),callback:function ($$v) {_vm.items=$$v},expression:"items"}},[_c('transition-group',{staticClass:"drag_container",attrs:{"type":"transition","name":'flip-list'}},_vm._l((_vm.items),function(element,index){return _c('li',{key:index,staticClass:"item"},[_c('a',{on:{"click":function($event){_vm.selectItem(element, index)}}},[_c('v-layout',{class:{'current-item': element.id === _vm.selectedId,'item-draggable':true},attrs:{"justify-space-around":"","align-content-space-around":""}},[_c('div',{staticClass:"item-draggable-avatar"},[_c('v-flex',{staticClass:"item-draggable-position"},[_vm._v(_vm._s(element.position))]),_vm._v(" "),(element.type != 'separator')?_c('avatar',{staticClass:"item-draggable-image",attrs:{"item":element.user,"size":"5rem"}}):_c('v-avatar',{staticClass:"grey lighten-2",staticStyle:{"marginBottom":"2px"},attrs:{"size":"5rem"}},[_c('v-icon',[_vm._v("title")])],1),_vm._v(" "),(_vm.selectedPage !== 'requests')?[(_vm.editedElement.id !== element.id)?_c('v-icon',{staticClass:"aside-type-color-round",style:({color: _vm.getCommentColor(element.type)})},[_vm._v("fiber_manual_record")]):_c('v-icon',{staticClass:"aside-type-color-round",staticStyle:{"{color":"none}"}},[_vm._v("fiber_manual_record")])]:_vm._e()],2),_vm._v(" "),_c('v-layout',{staticClass:"item-draggable-text",attrs:{"column":"","justify-space-around":"","align-content-space-around":""}},[_c('v-flex',{staticClass:"item-draggable-title",class:{'bold': element.type == 'separator'}},[_vm._v("\n                                                "+_vm._s(element.title)+"\n                                            ")]),_vm._v(" "),(element.type != 'separator')?_c('v-flex',{staticClass:"item-draggable-user"},[_vm._v("par "+_vm._s(element.user.first_name)+" "+_vm._s(element.user.last_name))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"item-draggable-date"},[(element.type != 'separator')?_c('pre',{staticClass:"item-draggable-line"},[_vm._v("  ")]):_vm._e(),_vm._v("Le "+_vm._s(_vm.moment(element.updated_at).format('DD/MM/YYYY'))+"\n                                            ")])],1),_vm._v(" "),_c('div',{staticClass:"item-draggable-action"},[_c('v-icon',{on:{"click":function($event){$event.stopPropagation();_vm.moveUp(element)}}},[_vm._v("keyboard_arrow_up")]),_vm._v(" "),_c('v-icon',{on:{"click":function($event){$event.stopPropagation();_vm.moveDown(element)}}},[_vm._v("keyboard_arrow_down")])],1)],1)],1),_vm._v(" "),_c('v-divider')],1)}))],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"add-footer",attrs:{"justify-center":"","align-center":""}},[_c('v-btn',{staticClass:"menu-button",class:{ active: _vm.isMenuOpen },attrs:{"disabled":_vm.editedElement && _vm.editedElement.id != null},on:{"click":_vm.clickAdd}},[_vm._v("\n                            Ajouter\n                            "),_c('v-icon',[_vm._v("mode_edit")])],1),_vm._v(" "),(_vm.isMenuOpen)?_c('div',{staticClass:"add-menu",attrs:{"column":""}},[_c('v-flex',{staticClass:"add-menu-item"},[_c('v-btn',{staticClass:"menu-button",on:{"click":function($event){_vm.addNewItem()}}},[_c('v-icon',[_vm._v("add")]),_vm._v(" "),_c('span',[_vm._v("Nouvel Element")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-flex',{staticClass:"add-menu-item"},[_c('v-btn',{staticClass:"menu-button",on:{"click":function($event){_vm.addItemFromSymbol()}}},[_c('v-icon',[_vm._v("autorenew")]),_vm._v(" "),_c('span',[_vm._v("Symbole")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-flex',{staticClass:"add-menu-item"},[_c('v-btn',{staticClass:"menu-button",on:{"click":function($event){_vm.addNewItem('separator')}}},[_c('v-icon',[_vm._v("title")]),_vm._v(" "),_c('span',[_vm._v("Titre")])],1)],1),_vm._v(" "),_c('v-divider')],1):_vm._e()],1)],1)]),_vm._v(" "),_c('div',{class:{'is-editing':(!_vm.editedElement || _vm.editedElement.id) !== null ,'comments-contents':true ,'scroll-y':true},attrs:{"id":"scroll-container"}},_vm._l((_vm.items),function(element,index){return _c('div',{directives:[{name:"scroll",rawName:"v-scroll",value:({target: '#scroll-container'}),expression:"{target: '#scroll-container'}"}],key:index,staticClass:"content-item",attrs:{"id":'element-'+index,"row":"","wrap":""}},[_c('div',{directives:[{name:"touch",rawName:"v-touch:swipe",value:(_vm.swipeEvent),expression:"swipeEvent",arg:"swipe"}],staticClass:"full-element-container",on:{"mouseover":function($event){_vm.mouseOverElement(element, index)}}},[_c('v-alert',{directives:[{name:"show",rawName:"v-show",value:((!_vm.editedElement || _vm.editedElement.id) !== null),expression:"(!editedElement || editedElement.id) !== null"}],attrs:{"value":true,"outline":"","color":"warning","icon":"warning","transition":"scale-transition"}},[_vm._v("\n                  L'élèment est en cours d'édition, enregistrer ou annuler pour continuer\n                ")]),_vm._v(" "),_c('v-flex',{staticClass:"content-toolbar",attrs:{"xs12":""}},[_c('avatar',{staticClass:"item-draggable-avatar",attrs:{"item":element.user,"size":"5rem"}}),_vm._v(" "),(_vm.selectedPage !== 'requests')?[(_vm.editedElement.id !== element.id)?_c('v-icon',{staticClass:"type-color-round",style:({color: _vm.getCommentColor(element.type)})},[_vm._v("fiber_manual_record")]):_c('v-icon',{staticClass:"type-color-round",staticStyle:{"{color":"none}"}},[_vm._v("fiber_manual_record")])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"user-name-container"},[_vm._v("\n                            "+_vm._s(element.user.first_name)+" "+_vm._s(element.user.last_name)+"\n                            "),_c('div',{staticClass:"writing-mode"},[_vm._v("\n                                "+_vm._s(_vm.getWritingMode(element))+"\n                            ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.editedElement.id === element.id)?_c('v-btn',{attrs:{"round":"","small":"","flat":"","color":'primary'},on:{"click":function($event){_vm.unsetEditedElement()}}},[_vm._v("Annuler")]):_vm._e(),_vm._v(" "),(element.id !== 0 && (_vm.$store.state.auth.user.level >= 60 || element.user_id == _vm.$store.state.auth.user.id) )?_c('v-btn',{attrs:{"round":"","small":"","flat":"","color":'primary'},on:{"click":function($event){_vm.confirmRemove = true}}},[_vm._v("Supprimer")]):_vm._e(),_vm._v(" "),(_vm.editedElement.id === element.id && _vm.selectedPage !== 'requests')?_c('div',{staticClass:"contain-type-select"},[_c('v-select',{attrs:{"items":_vm.commentTypes,"item-value":"value"},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-icon',{style:({color: data.item.color})},[_vm._v("fiber_manual_record")]),_vm._v("\n                                        "+_vm._s(data.item.label)+"\n                                ")]}},{key:"item",fn:function(data){return [(typeof data.item === 'object')?[_c('v-list-tile-content',[_c('v-list-tile-title',[_c('v-icon',{style:({color: data.item.color})},[_vm._v("fiber_manual_record")]),_vm._v("\n                                              "+_vm._s(data.item.label)+"\n                                            ")],1)],1)]:_vm._e()]}}]),model:{value:(_vm.editedElement.type),callback:function ($$v) {_vm.$set(_vm.editedElement, "type", $$v)},expression:"editedElement.type"}})],1):_vm._e(),_vm._v(" "),(_vm.editedElement.id !== element.id && (_vm.$store.state.auth.user.level >= 60 || element.user_id == _vm.$store.state.auth.user.id))?_c('v-btn',{attrs:{"round":"","depressed":"","small":"","color":'primary'},on:{"click":function($event){_vm.setEditedElement(element)}}},[_vm._v(_vm._s(_vm.editLabel(element)))]):_vm._e(),_vm._v(" "),(_vm.editedElement.id === element.id && _vm.editedElement.type != 'separator')?_c('v-btn',{attrs:{"outline":"","round":"","depressed":"","small":"","color":'primary',"loading":_vm.loading_file},on:{"click":function($event){_vm.saveElement(_vm.editedElement,true)}}},[_vm._v("Ajouter une pièce jointe")]):_vm._e(),_vm._v(" "),(_vm.editedElement.id === element.id)?_c('v-btn',{attrs:{"round":"","depressed":"","small":"","color":'primary'},on:{"click":function($event){_vm.saveElement(_vm.editedElement)}}},[_vm._v("Enregistrer")]):_vm._e()],2),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loader"},[_c('img',{attrs:{"src":__webpack_require__("bwqQ")}})]):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('div',{staticClass:"center-content",class:[_vm.nb_column == 2 ? 'doublecol' : '']},[(_vm.editedElement.id === element.id)?_c('v-form',{model:{value:(_vm.valid_title),callback:function ($$v) {_vm.valid_title=$$v},expression:"valid_title"}},[_c('v-layout',{staticClass:"title-row",attrs:{"row":""}},[_c('v-flex',{staticClass:"edit-title",attrs:{"xs12":_vm.isCol(1),"md6":_vm.isCol(2),"sm12":_vm.isCol(2)}},[_c('v-text-field',{attrs:{"name":"titre1_text_field","label":"Titre","hint":"Titre de votre commentaire","rules":_vm.rules.title,"required":"","error":_vm.isTitleError(),"autocomplete":"off"},model:{value:(_vm.editedElement.title),callback:function ($$v) {_vm.$set(_vm.editedElement, "title", $$v)},expression:"editedElement.title"}})],1),_vm._v(" "),(_vm.isCol(2) && _vm.editedElement.type != 'separator')?_c('v-flex',{staticClass:"edit-title",attrs:{"md6":"","sm12":""}},[_c('v-text-field',{attrs:{"name":"titre2_text_field","label":"Titre 2","hint":_vm.hint_title2,"persistent-hint":_vm.error_2,"error":_vm.error_2,"rules":_vm.rules.title_2,"autocomplete":"off"},model:{value:(_vm.editedElement.title_2),callback:function ($$v) {_vm.$set(_vm.editedElement, "title_2", $$v)},expression:"editedElement.title_2"}})],1):_vm._e()],1)],1):_c('v-layout',{staticClass:"read",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":_vm.isCol(1),"md6":_vm.isCol(2),"sm12":_vm.isCol(2)}},[_c('div',{staticClass:"comment-title on-left"},[_vm._v("\n                                "+_vm._s(element.title)+"\n                            ")])]),_vm._v(" "),(_vm.isCol(2) && element.type != 'separator')?_c('v-flex',{attrs:{"sm12":"","md6":""}},[_c('div',{staticClass:"comment-title on-right"},[_vm._v("\n                                "+_vm._s(element.title_2)+"\n                            ")])]):_vm._e()],1),_vm._v(" "),(_vm.editedElement.id === element.id && element.type != 'separator')?_c('v-form',{model:{value:(_vm.valid_message),callback:function ($$v) {_vm.valid_message=$$v},expression:"valid_message"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"edit-message",attrs:{"xs12":_vm.isCol(1),"md6":_vm.isCol(2),"sm12":_vm.isCol(2)}},[_c('v-text-field',{attrs:{"name":"message_text_field","label":"Message","hint":"Contenu du message","multi-line":"","error":_vm.isMessageError()},model:{value:(_vm.editedElement.message),callback:function ($$v) {_vm.$set(_vm.editedElement, "message", $$v)},expression:"editedElement.message"}})],1),_vm._v(" "),(_vm.isCol(2))?_c('v-flex',{staticClass:"edit-message",attrs:{"sm12":"","md6":""}},[_c('v-text-field',{attrs:{"name":"message_text_field2","label":"Message 2","hint":_vm.hint_message2,"persistent-hint":_vm.error_2,"error":_vm.error_2,"multi-line":""},model:{value:(_vm.editedElement.message_2),callback:function ($$v) {_vm.$set(_vm.editedElement, "message_2", $$v)},expression:"editedElement.message_2"}})],1):_vm._e()],1)],1):_c('v-layout',{staticClass:"read",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":_vm.isCol(1),"md6":_vm.isCol(2),"sm12":_vm.isCol(2)}},[_c('p',{staticClass:"comment-message on-left scroll-y"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$options.filters.nl2br(element.message))}})])]),_vm._v(" "),(_vm.isCol(2) && element.type != 'separator')?_c('v-flex',{attrs:{"sm12":"","md6":""}},[_c('p',{staticClass:"comment-message on-right scroll-y"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$options.filters.nl2br(element.message_2))}})])]):_vm._e()],1),_vm._v(" "),(_vm.display && element.type != 'separator')?_c('div',{staticClass:"d-flex imgs"},_vm._l((_vm.nb_column),function(col,i){return _c('v-flex',{key:i,class:_vm.nb_column == 2 ? 'sm12 md6' : 'xs12'},[_c('v-layout',{staticClass:"img-layout",attrs:{"wrap":""}},[_vm._l((element.files),function(file,index){return (file.pivot && file.pivot.file_type == null && file.pivot.location == 'area-'+col || file.pivot && file.pivot.file_type == 'null' && file.pivot.location == 'area-'+col)?_c('div',{key:file.id,staticClass:"mr-5",on:{"click":function($event){_vm.editedElement.id !== element.id && _vm.openImg(file)}}},[_c('v-menu',{attrs:{"offset-y":"","content-class":"files"}},[_c('div',{attrs:{"slot":"activator"},slot:"activator"},[_c('label',{staticClass:"comment-image"},[(_vm.editedElement.id === element.id)?_c('v-icon',{staticClass:"hover-alpha"},[_vm._v("mode_edit")]):_vm._e(),_vm._v(" "),_c('img',{attrs:{"src":file.path}})],1)]),_vm._v(" "),(_vm.editedElement.id === element.id)?_c('v-list',[_c('v-list-tile',[_c('label',{attrs:{"for":'file-'+index}},[_vm._v("Modifier l'image")]),_vm._v(" "),_c('input',{staticStyle:{"display":"none"},attrs:{"type":"file","id":'file-'+index},on:{"change":function (event){_vm.onFileChange(event,element.id,index,col)}}})]),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.$refs.deletefile.open(_vm.selectedPage,file,element.id)}}},[_c('v-list-tile-title',[_vm._v("Supprimer l'image")])],1)],1):_vm._e()],1)],1):_vm._e()}),_vm._v(" "),(element.files.filter(function (f) { return f.pivot.location == 'area-'+col; }).length < 2 && _vm.editedElement.id === element.id)?_c('div',[_c('v-menu',{attrs:{"offset-y":"","content-class":"files"}},[_c('div',{attrs:{"slot":"activator"},slot:"activator"},[_c('label',{staticClass:"comment-image"},[_c('img',{staticClass:"add-img",attrs:{"src":_vm.addImgPath()}})])]),_vm._v(" "),(_vm.editedElement.id === element.id)?_c('v-list',[_c('v-list-tile',[_c('label',{attrs:{"for":'input-'+col}},[_vm._v("Ajouter une image")]),_vm._v(" "),_c('input',{staticClass:"input-img",staticStyle:{"display":"none"},attrs:{"id":'input-'+col,"type":"file"},on:{"change":function (event){_vm.onFileChange(event,element.id)}}})])],1):_vm._e()],1)],1):_vm._e()],2)],1)})):_vm._e(),_vm._v(" "),_vm._l((element.files),function(file,index){return (file.pivot && file.pivot.file_type == 'attachment' && _vm.display)?[_c('div',{staticClass:"files-list-container",on:{"click":function($event){_vm.viewFile(file,element.files)}}},[_c('div',{staticClass:"files-list-container-title"},[_vm._v("\n                                Pièces jointes :\n                            ")]),_vm._v(" "),[_vm._v(_vm._s(file.label)+"."+_vm._s(file.type))],_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.editedElement.id === element.id)?_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();_vm.$refs.deletefile.open(_vm.selectedPage,file,element.id)}}},[_c('v-icon',[_vm._v("close")])],1):_vm._e()],2)]:_vm._e()})],2):_vm._e()],1),_vm._v(" "),(_vm.editedElement.id === element.id)?_c('div',{staticClass:"column-display-choice"},[_c('div',{staticClass:"col-choice-title"},[_vm._v("\n                    Affichage :\n                ")]),_vm._v(" "),_c('div',{staticClass:"column-display-buttons"},[_c('div',[_c('div',{staticClass:"image-and-overlay-left",on:{"click":function($event){_vm.setColumnNumber(1)}}},[_c('img',{staticClass:"col-chose-image",attrs:{"src":__webpack_require__("NdJc")}}),_vm._v(" "),(_vm.nb_column === 1)?_c('div',{staticClass:"col-choice-overlay"}):_vm._e()])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"image-and-overlay-right",on:{"click":function($event){_vm.setColumnNumber(2)}}},[_c('img',{staticClass:"col-chose-image",attrs:{"src":__webpack_require__("08vo")}}),_vm._v(" "),(_vm.nb_column === 2)?_c('div',{staticClass:"col-choice-overlay"}):_vm._e()])])]),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"750px"},model:{value:(_vm.confirmRemove2),callback:function ($$v) {_vm.confirmRemove2=$$v},expression:"confirmRemove2"}},[_c('v-card',[_c('v-card-title',{staticClass:"warning"},[_c('h2',[_c('v-icon',{staticClass:"mr-2",attrs:{"dark":""}},[_vm._v("warning")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("Attention")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","icon":""},on:{"click":function($event){_vm.confirmRemove2 = false}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_vm._v("\n                            Voulez vous vraiment supprimer la deuxième colonne ?\n                        ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"round":"","small":"","outline":"","color":"warning"},nativeOn:{"click":function($event){_vm.confirmRemove2 = false;}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"round":"","depressed":"","small":"","color":"warning"},nativeOn:{"click":function($event){_vm.deleteCol(element.id)}}},[_vm._v("Valider")])],1)],1)],1)],1):_vm._e()])})),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"750px"},model:{value:(_vm.confirmRemove),callback:function ($$v) {_vm.confirmRemove=$$v},expression:"confirmRemove"}},[_c('v-card',[_c('v-card-title',{staticClass:"warning"},[_c('h2',[_c('v-icon',{staticClass:"mr-2",attrs:{"dark":""}},[_vm._v("warning")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("Attention")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","icon":""},on:{"click":function($event){_vm.confirmRemove = false}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_vm._v("\n                Voulez vous vraiment supprimer "+_vm._s(_vm.selectedPage === 'requests' ? 'cette demande' : 'ce commentaire')+"\n            ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"round":"","small":"","outline":"","color":"warning"},nativeOn:{"click":function($event){_vm.confirmRemove = false;}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"round":"","depressed":"","small":"","color":"warning"},nativeOn:{"click":function($event){_vm.deleteElement()}}},[_vm._v("Valider")])],1)],1)],1),_vm._v(" "),_c('create-linked-files',{ref:"modal",on:{"added":function (entity_id,entity) { _vm.addFile(entity_id,entity) }}}),_vm._v(" "),_c('delete-linked-file',{ref:"deletefile",on:{"deleted":function (entity_id,item_id) { _vm.deleteFile(entity_id,item_id) }}})],1)}
var CreateComment_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-logo"},[_c('img',{attrs:{"src":__webpack_require__("p91O")}})])}]
var CreateComment_esExports = { render: CreateComment_render, staticRenderFns: CreateComment_staticRenderFns }
/* harmony default export */ var single_CreateComment = (CreateComment_esExports);
// CONCATENATED MODULE: ./src/views/products/single/CreateComment.vue
function CreateComment_injectStyle (ssrContext) {
  __webpack_require__("9Amq")
}
var CreateComment_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CreateComment___vue_template_functional__ = false
/* styles */
var CreateComment___vue_styles__ = CreateComment_injectStyle
/* scopeId */
var CreateComment___vue_scopeId__ = "data-v-581deae2"
/* moduleIdentifier (server only) */
var CreateComment___vue_module_identifier__ = null
var CreateComment_Component = CreateComment_normalizeComponent(
  CreateComment,
  single_CreateComment,
  CreateComment___vue_template_functional__,
  CreateComment___vue_styles__,
  CreateComment___vue_scopeId__,
  CreateComment___vue_module_identifier__
)

/* harmony default export */ var products_single_CreateComment = __webpack_exports__["a"] = (CreateComment_Component.exports);


/***/ }),

/***/ "dj3g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/DataTable.vue + 2 modules
var DataTable = __webpack_require__("/WHI");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/components/avatar/Avatar.vue + 3 modules
var Avatar = __webpack_require__("Be47");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/products/single/Consumables.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Consumables = ({
	components: { DataTable: DataTable["a" /* default */], Avatar: Avatar["a" /* default */] },

	data: function data() {
		return {
			moment: moment_default.a,
			datatable: {
				headers: [{ text: 'Nom', sortable: true, value: 'label', align: 'left' }, { text: 'Code', sortable: true, value: 'code', align: 'right' }],
				endpoint: {
					base: '/api/products',
					filters: 'parents.linked_product.product_id|=|' + this.$route.params.id + ',group|=|linked_consumable'
				}
			},
			hide_demand: false
		};
	},

	methods: {
		rowClick: function rowClick(item) {}
	},
	created: function created() {
		var _this = this;

		this.$eventHub.$on('reload-list', function () {
			if (_this.$refs.list) {
				_this.$refs.list.reload();
			}
		});
	},
	mounted: function mounted() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-715090cd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/single/Consumables.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-table',{ref:"list",attrs:{"headers":_vm.datatable.headers,"toolbar":_vm.datatable.toolbar,"actions":_vm.datatable.actions,"endpoint":_vm.datatable.endpoint,"storeId":"comments"},on:{"rowClick":_vm.rowClick},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left author"},[_c('avatar',{attrs:{"item":props.item,"field":"photo"}}),_vm._v("\n            "+_vm._s(props.item.label)+"\n        ")],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n            "+_vm._s(props.item.code)+"\n        ")])]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var single_Consumables = (esExports);
// CONCATENATED MODULE: ./src/views/products/single/Consumables.vue
function injectStyle (ssrContext) {
  __webpack_require__("qdWo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-715090cd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Consumables,
  single_Consumables,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var products_single_Consumables = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "gNrJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/config/enum/ProductTypes.js
var ProductTypes = __webpack_require__("mdcO");

// EXTERNAL MODULE: ./src/config/enum/CommentTypes.js
var CommentTypes = __webpack_require__("22+B");

// EXTERNAL MODULE: ./src/views/projects/single/DeleteProduct.vue + 2 modules
var DeleteProduct = __webpack_require__("MzQT");

// EXTERNAL MODULE: ./src/views/projects/single/ProductAside.vue + 2 modules
var ProductAside = __webpack_require__("9B81");

// EXTERNAL MODULE: ./src/views/projects/single/CreateProduct.vue + 2 modules
var CreateProduct = __webpack_require__("YGX0");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/projects/single/Suppliers.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var Suppliers = ({
  data: function data() {
    return {
      selected: null
    };
  },

  computed: {
    supplier_products: function supplier_products() {
      return this.$store.state.single.data.supplier_products;
    }
  },
  methods: {
    createProduct: function createProduct() {
      this.$eventHub.$emit('open-modal', CreateProduct["a" /* default */], { type: 'supplier' });
    },

    openProduct: function openProduct(productId, productIndex, productType) {
      if (this.selected === productId) {
        this.$eventHub.$emit('close-aside');
      } else {
        this.$eventHub.$emit('close-aside');
        this.$eventHub.$emit('open-aside', ProductAside["a" /* default */], {
          product_id: productId,
          product_index: productIndex,
          product_type: productType
        });
        this.selected = productId;
      }
    },

    closeProduct: function closeProduct() {
      this.selected = null;
    },

    goToProduct: function goToProduct(productId, groupLabel) {
      this.$router.push({ name: 'single-product', params: { id: productId, group: groupLabel } });
    },

    deleteProduct: function deleteProduct(product) {
      this.$eventHub.$emit('open-modal', DeleteProduct["a" /* default */], { product: product });
    },

    getCommentColor: function getCommentColor(index) {
      return CommentTypes["a" /* CommentTypes */][index].color;
    },

    getCommentCount: function getCommentCount(product, index) {
      return product.comments.reduce(function (sum, el) {
        return el.type === CommentTypes["a" /* CommentTypes */][index].value ? sum + 1 : sum;
      }, 0);
    }
  },
  created: function created() {
    var _this = this;

    this.$eventHub.$on('close-aside', function () {
      _this.selected = null;
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventHub.$emit('close-aside');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75d6bba0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/projects/single/Suppliers.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"test"},[_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('div',{staticClass:"actions"},[(_vm.$store.state.auth.user.level >= 60)?_c('v-btn',{staticClass:"normal",attrs:{"round":"","outline":"","color":"primary","small":""},on:{"click":function($event){_vm.createProduct()}}},[_c('v-icon',{attrs:{"left":"","color":"primary"}},[_vm._v("add_circle")]),_vm._v("\n                        Ajouter un produit\n                    ")],1):_vm._e()],1)]),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","row":""}},_vm._l((_vm.supplier_products),function(product,index){return _c('v-flex',{key:product.id,attrs:{"xs12":"","md6":"","lg3":""}},[_c('v-card',{staticClass:"product-card",class:{'selected-card' : _vm.selected === product.id}},[_c('v-card-media',{on:{"click":function($event){_vm.openProduct(product.id, index, 'supplier')}}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('img',{class:{'have-product-img' : product.photo !== null},attrs:{"src":product.photo === null ? __webpack_require__("jfOg") : product.photo}})])],1),_vm._v(" "),_c('v-card-title',{attrs:{"secondary-title":""},on:{"click":function($event){_vm.openProduct(product.id, index, 'supplier')}}},[_c('div',[_c('p',{staticClass:"product-label mb-0"},[_vm._v(_vm._s(product.label))]),_vm._v(" "),_c('p',{staticClass:"product-supplier"},[(product.supplier)?[_vm._v("\n                            "+_vm._s(product.supplier.name)+"\n                          ")]:_vm._e()],2)])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-menu',[_c('div',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-icon',{attrs:{"flat":""}},[_vm._v("more_horiz")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{staticClass:"li",on:{"click":function($event){_vm.goToProduct(product.id, product.group)}}},[_vm._v("\n                                    Ouvrir la fiche\n                                ")]),_vm._v(" "),(_vm.$store.state.auth.user.level >= 60)?_c('v-list-tile',{on:{"click":function($event){_vm.deleteProduct(product)}}},[_vm._v("\n                                    Supprimer la fiche\n                                ")]):_vm._e()],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right comments-indicator",on:{"click":function($event){_vm.openProduct(product.id, index, 'supplier')}}},[_vm._v("\n                            "+_vm._s(_vm.getCommentCount(product,0))+" "),_c('v-icon',{style:({color:_vm.getCommentColor(0)})},[_vm._v("fiber_manual_record")]),_vm._v("\n                            "+_vm._s(_vm.getCommentCount(product,1))+" "),_c('v-icon',{style:({color:_vm.getCommentColor(1)})},[_vm._v("fiber_manual_record")]),_vm._v("\n                            "+_vm._s(_vm.getCommentCount(product,2))+" "),_c('v-icon',{style:({color:_vm.getCommentColor(2)})},[_vm._v("fiber_manual_record")])],1)],1)],1)],1)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var single_Suppliers = (esExports);
// CONCATENATED MODULE: ./src/views/projects/single/Suppliers.vue
function injectStyle (ssrContext) {
  __webpack_require__("QW8i")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-75d6bba0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Suppliers,
  single_Suppliers,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var projects_single_Suppliers = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "hkv7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/DataTable.vue + 2 modules
var DataTable = __webpack_require__("/WHI");

// EXTERNAL MODULE: ./src/views/products/single/CreateComment.vue + 8 modules
var CreateComment = __webpack_require__("dgM2");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/products/single/ImportRequests.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ImportRequests = ({
    components: { DataTable: DataTable["a" /* default */] },
    data: function data() {
        return {
            step: 1,
            title: 'Importer des demandes',
            icon: 'import_export',
            isValid: false,
            code_ok: false,
            color: 'primary',
            error: false,
            message: null,
            loading: false,
            product_code: '',
            product_id: null,
            requests: [],
            requests_id: [],
            product_requests_count: 0,
            moment: moment_default.a,
            rules: {
                product_code: [function (v) {
                    return !!v && !isNaN(v) && v.length > 5 || 'Code de 6 chiffres obligatoire';
                }]
            },
            datatable: {
                headers: [{ text: 'Demandes', sortable: false, value: 'is_request', align: 'right' }, { text: 'Auteur', sortable: true, value: 'user_id', align: 'right' }, { text: 'Date', sortable: true, value: 'created_at', align: 'right' }, { text: 'Message', sortable: false, align: 'right' }],
                endpoint: {
                    base: '/api/requests',
                    filters: 'product_id|=|',
                    embed: 'user'
                }
            }
        };
    },

    methods: {
        onCodeInput: function onCodeInput() {

            var isValidLength = !!this.product_code && !isNaN(this.product_code) && this.product_code.length > 5;

            if (!isValidLength) {
                this.error = true;
                this.color = 'error';
                this.message = 'Code de 6 chiffres obligatoire';
                return;
            }

            this.checkCode(this.product_code);
        },
        checkCode: function checkCode(code) {
            var _this = this;

            this.loading = true;
            this.axios.get('/api/products?filters=code|=|' + code + '&embed=requests.files').then(function (response) {
                if (response.data.length > 0) {
                    _this.error = false;
                    _this.loading = false;
                    _this.product_id = response.data[0].id;
                    if (response.data[0].requests_count > 0) {
                        _this.color = 'success';
                        _this.message = '';
                        _this.$eventHub.$emit('set-next-button', true);
                        _this.datatable.endpoint.filters = 'product_id|=|' + _this.product_id;
                        _this.product_requests_count = response.data[0].requests_count;
                        _this.requests_id = _this.$_.map(response.data[0].requests, 'id');
                        _this.requests = response.data[0].requests;
                    } else {
                        _this.color = 'error';
                        _this.message = 'Le produit ' + response.data[0].label + ' n\'a pas de demandes';
                    }
                } else {
                    _this.error = true;
                    _this.loading = false;
                    _this.color = 'error';
                    _this.message = 'Ce code n\'existe pas';
                }
            });
        },
        onClose: function onClose() {
            this.$eventHub.$emit('close-modal');
        },
        onValidate: function onValidate() {
            var _this2 = this;

            if (this.requests.length > 0) {
                this.requests.forEach(function (r, index) {
                    var model = r;
                    var count = _this2.product_requests_count;
                    delete model.id;
                    model.product_id = _this2.$store.state.single.data.id;
                    model.position = count + 1;
                    model.user_id = _this2.$store.state.auth.user.id;
                    count++;
                    _this2.axios.post('/api/requests', model).then(function (response) {
                        if (_this2.requests[index + 1] == undefined) {
                            _this2.$eventHub.$emit('reload-list');
                            _this2.$store.dispatch('updateSingleData', { key: 'requests_count', value: count });
                            _this2.onClose();
                        }
                    });
                });
            }
        },
        onNextStep: function onNextStep() {
            this.step++;
            this.$eventHub.$emit('set-valid-button', true);
            this.$eventHub.$emit('set-next-button', false);
        },
        setRequest: function setRequest(item) {
            var index_item = this.requests.findIndex(function (r) {
                return r.id == item.id;
            });

            if (item.request_selected) {
                if (index_item == -1) {
                    this.requests.push(item);
                }
            } else {
                if (index_item > -1) {
                    this.requests.splice(index_item, 1);
                }
            }
        }
    },
    mounted: function mounted() {
        this.$eventHub.$emit('set-valid-button', false);
        this.$eventHub.$emit('set-next-button', false);
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43cdaf7b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/single/ImportRequests.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form"},[_c('v-container',{attrs:{"grid-list-xs":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',[(_vm.step == 1)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-form',{model:{value:(_vm.code_ok),callback:function ($$v) {_vm.code_ok=$$v},expression:"code_ok"}},[_c('v-text-field',{attrs:{"label":"Code article","required":"","color":_vm.color,"loading":_vm.loading,"error":_vm.error,"hint":_vm.message,"rules":_vm.rules.product_code},on:{"input":_vm.onCodeInput},model:{value:(_vm.product_code),callback:function ($$v) {_vm.product_code=$$v},expression:"product_code"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.step==2)?_c('v-flex',{attrs:{"xs12":""}},[_c('data-table',{ref:"list",attrs:{"headers":_vm.datatable.headers,"endpoint":_vm.datatable.endpoint,"storeId":"comments"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-right"},[_c('v-checkbox',{attrs:{"hide-details":"","color":"accent","value":props.item.id},on:{"change":function($event){_vm.setRequest(props.item)}},model:{value:(_vm.requests_id),callback:function ($$v) {_vm.requests_id=$$v},expression:"requests_id"}})],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n                                "+_vm._s(props.item.user.first_name)+" "+_vm._s(props.item.user.last_name)+"\n                            ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n                                "+_vm._s(_vm.moment(props.item.created_at).format('DD/MM/YYYY'))+"\n                            ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n                                "+_vm._s(props.item.message)+"\n                            ")])]}}])})],1):_vm._e()],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var single_ImportRequests = (esExports);
// CONCATENATED MODULE: ./src/views/products/single/ImportRequests.vue
function injectStyle (ssrContext) {
  __webpack_require__("lDmc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43cdaf7b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  ImportRequests,
  single_ImportRequests,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var products_single_ImportRequests = (Component.exports);

// EXTERNAL MODULE: ./src/config/enum/CommentTypes.js
var CommentTypes = __webpack_require__("22+B");

// EXTERNAL MODULE: ./src/components/avatar/Avatar.vue + 3 modules
var Avatar = __webpack_require__("Be47");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/products/single/Requests.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var Requests = ({
	components: { DataTable: DataTable["a" /* default */], Avatar: Avatar["a" /* default */] },

	data: function data() {
		var _this = this;

		return {
			moment: moment_default.a,
			datatable: {
				actions: [{ text: 'Ajouter une demande', icon: 'add_circle', callback: function callback() {
						_this.$eventHub.$emit('open-modal', CreateComment["a" /* default */], {
							product_id: _this.$store.state.single.data.id,
							product_label: _this.$store.state.single.data.label,
							element_type: 'request',
							create_query: true
						});
					} }, { text: 'Importer des demandes', icon: 'import_export', callback: function callback() {
						return _this.$eventHub.$emit('open-modal', products_single_ImportRequests);
					}, level: 60 }],
				headers: [{ text: 'Titre', sortable: false, value: 'title', align: 'left' }, { text: 'Message', sortable: false, value: 'message', align: 'right' }, { text: 'Date', sortable: false, value: 'created_at', align: 'right' }, { text: 'Auteur', sortable: false, value: 'user_id', align: 'right' }],
				endpoint: {
					base: '/api/requests',
					filters: 'product_id|=|' + this.$route.params.id,
					embed: 'user,symbol',
					order: 'position'
				}
			}
		};
	},

	methods: {
		rowClick: function rowClick(item) {
			this.$eventHub.$emit('open-modal', CreateComment["a" /* default */], {
				product_id: this.$store.state.single.data.id,
				product_label: this.$store.state.single.data.label,
				id: item.id,
				element_type: 'request'
			});
		},

		getCommentColor: function getCommentColor(type) {
			var commentType = CommentTypes["a" /* CommentTypes */].find(function (el) {
				return el.value === type;
			});
			return commentType ? commentType.color : '';
		}
	},
	created: function created() {
		var _this2 = this;

		this.$eventHub.$on('reload-list', function () {
			if (_this2.$refs.list) {
				_this2.$refs.list.reload();
			}
		});
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17639848","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/single/Requests.vue
var Requests_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-table',{ref:"list",attrs:{"headers":_vm.datatable.headers,"toolbar":_vm.datatable.toolbar,"actions":_vm.datatable.actions,"endpoint":_vm.datatable.endpoint,"storeId":"requests"},on:{"rowClick":_vm.rowClick},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left message"},[(props.item.type == 'separator')?[_c('b',[_vm._v(_vm._s(props.item.title.length >= 25 ? props.item.title.substring(0,25)+ ' ...' : props.item.title))])]:[(props.item.symbol && props.item.symbol.title)?[_vm._v("\n                    "+_vm._s(props.item.symbol.title.length >= 25 ? props.item.symbol.title.substring(0,25)+ ' ...' : props.item.symbol.title)+"\n                ")]:(props.item.title)?[_vm._v("\n                    "+_vm._s(props.item.title.length >= 25 ? props.item.title.substring(0,25)+ ' ...' : props.item.title)+"\n                ")]:[_vm._v(" - ")]]],2),_vm._v(" "),_c('td',{staticClass:"text-xs-right message"},[(props.item.symbol && props.item.symbol.message)?[_vm._v("\n                "+_vm._s(props.item.symbol.message.length >= 25 ? props.item.symbol.message.substring(0,25)+ ' ...' : props.item.symbol.message)+"\n            ")]:(props.item.message)?[_vm._v("\n                "+_vm._s(props.item.message.length >= 25 ? props.item.message.substring(0,25)+ ' ...' : props.item.message)+"\n            ")]:[_vm._v(" - ")]],2),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n            "+_vm._s(_vm.moment(props.item.created_at).format('DD/MM/YYYY'))+"\n        ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('avatar',{attrs:{"item":props.item.user,"tooltip":true}})],1)]}}])})}
var Requests_staticRenderFns = []
var Requests_esExports = { render: Requests_render, staticRenderFns: Requests_staticRenderFns }
/* harmony default export */ var single_Requests = (Requests_esExports);
// CONCATENATED MODULE: ./src/views/products/single/Requests.vue
function Requests_injectStyle (ssrContext) {
  __webpack_require__("KOwa")
}
var Requests_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Requests___vue_template_functional__ = false
/* styles */
var Requests___vue_styles__ = Requests_injectStyle
/* scopeId */
var Requests___vue_scopeId__ = "data-v-17639848"
/* moduleIdentifier (server only) */
var Requests___vue_module_identifier__ = null
var Requests_Component = Requests_normalizeComponent(
  Requests,
  single_Requests,
  Requests___vue_template_functional__,
  Requests___vue_styles__,
  Requests___vue_scopeId__,
  Requests___vue_module_identifier__
)

/* harmony default export */ var products_single_Requests = __webpack_exports__["default"] = (Requests_Component.exports);


/***/ }),

/***/ "i0v3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ikV/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/config/enum/ProductTypes.js
var ProductTypes = __webpack_require__("mdcO");

// EXTERNAL MODULE: ./src/config/enum/CommentTypes.js
var CommentTypes = __webpack_require__("22+B");

// EXTERNAL MODULE: ./src/views/projects/single/DeleteProduct.vue + 2 modules
var DeleteProduct = __webpack_require__("MzQT");

// EXTERNAL MODULE: ./src/views/projects/single/ProductAside.vue + 2 modules
var ProductAside = __webpack_require__("9B81");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/projects/single/AddSidamoProduct.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var AddSidamoProduct = ({
    data: function data() {
        return {
            title: 'Lier un produit Sidamo',
            icon: 'add_circle',
            isValid: false,
            code_ok: false,
            color: 'primary',
            error: false,
            message: null,
            loading: false,
            product_code: '',
            product_id: null,
            rules: {
                product_code: [function (v) {
                    return !!v && !isNaN(v) && v.length > 5 || 'Code de 6 chiffres obligatoire';
                }]
            }
        };
    },

    methods: {
        onInput: function onInput() {
            var isValidLength = !!this.product_code && !isNaN(this.product_code) && this.product_code.length > 5;

            if (!isValidLength) {
                this.error = true;
                this.color = 'error';
                this.message = 'Code de 6 chiffres obligatoire';
                return;
            }

            this.checkCode(this.product_code);
        },
        checkCode: function checkCode(code) {
            var _this = this;

            this.loading = true;
            this.axios.get('/api/products?filters=code|=|' + code).then(function (response) {
                if (response.data.length > 0) {
                    _this.error = false;
                    _this.loading = false;
                    _this.product_id = response.data[0].id;
                    if (response.data[0].project_id != null) {
                        if (response.data[0].project_id == _this.$store.state.single.data.id) {
                            _this.color = 'error';
                            _this.message = 'Le produit ' + response.data[0].label + ' est déjà lié à ce projet';
                        } else {
                            _this.color = 'warning';
                            _this.message = 'Le produit ' + response.data[0].label + ' est déjà lié à un projet. Êtes vous sûre de vouloir modifier ce produit';
                        }
                    } else {
                        _this.color = 'success';
                        _this.message = '';
                    }
                } else {
                    _this.error = true;
                    _this.loading = false;
                    _this.color = 'error';
                    _this.message = 'Ce produit n\'existe pas';
                }
            });
        },
        onClose: function onClose() {
            this.$eventHub.$emit('close-modal');
        },
        onValidate: function onValidate() {
            var _this2 = this;

            if (this.product_id != null) {
                this.axios.put('/api/products/' + this.product_id, { project_id: this.$store.state.single.data.id }).then(function (response) {
                    _this2.$eventHub.$emit('reload-single-project');
                    _this2.onClose();
                });
            } else {
                this.onClose();
            }
        }
    },
    mounted: function mounted() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27fc70fb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/projects/single/AddSidamoProduct.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form"},[_c('v-container',{attrs:{"grid-list-xs":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-form',{model:{value:(_vm.code_ok),callback:function ($$v) {_vm.code_ok=$$v},expression:"code_ok"}},[_c('v-text-field',{attrs:{"label":"Code article","required":"","color":_vm.color,"loading":_vm.loading,"error":_vm.error,"hint":_vm.message,"rules":_vm.rules.product_code},on:{"input":_vm.onInput},model:{value:(_vm.product_code),callback:function ($$v) {_vm.product_code=$$v},expression:"product_code"}})],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var single_AddSidamoProduct = (esExports);
// CONCATENATED MODULE: ./src/views/projects/single/AddSidamoProduct.vue
function injectStyle (ssrContext) {
  __webpack_require__("LElz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-27fc70fb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  AddSidamoProduct,
  single_AddSidamoProduct,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var projects_single_AddSidamoProduct = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/projects/single/Sidamos.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var Sidamos = ({
    data: function data() {
        return {
            selected: null
        };
    },

    computed: {
        sidamo_products: function sidamo_products() {
            return this.$store.state.single.data.sidamo_products;
        }
    },
    methods: {
        createProduct: function createProduct() {
            this.$eventHub.$emit('open-modal', projects_single_AddSidamoProduct);
        },

        openProduct: function openProduct(productId, productIndex, productType) {
            if (this.selected === productId) {
                this.$eventHub.$emit('close-aside');
            } else {
                this.$eventHub.$emit('close-aside');
                this.$eventHub.$emit('open-aside', ProductAside["a" /* default */], {
                    product_id: productId,
                    product_index: productIndex,
                    product_type: productType
                });
                this.selected = productId;
            }
        },

        closeProduct: function closeProduct() {
            this.selected = null;
        },

        goToProduct: function goToProduct(productId, groupLabel) {
            this.$router.push({ name: 'single-product', params: { id: productId, group: groupLabel } });
        }
    },
    created: function created() {
        var _this = this;

        this.$eventHub.$on('close-aside', function () {
            _this.selected = null;
        });
    },
    beforeDestroy: function beforeDestroy() {
        this.$eventHub.$emit('close-aside');
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b6d3686","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/projects/single/Sidamos.vue
var Sidamos_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"test"},[_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('div',{staticClass:"actions"},[(_vm.$store.state.auth.user.level >= 60)?_c('v-btn',{staticClass:"normal",attrs:{"round":"","outline":"","color":"primary","small":""},on:{"click":function($event){_vm.createProduct()}}},[_c('v-icon',{attrs:{"left":"","color":"primary"}},[_vm._v("add_circle")]),_vm._v("\n                        Lier un produit Sidamo\n                    ")],1):_vm._e()],1)]),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","row":""}},_vm._l((_vm.sidamo_products),function(product,index){return _c('v-flex',{key:product.id,attrs:{"xs12":"","md6":"","lg3":""}},[_c('v-card',{staticClass:"product-card",class:{'selected-card' : _vm.selected === product.id}},[_c('v-card-media',{on:{"click":function($event){_vm.openProduct(product.id, index, 'sidamo')}}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('img',{class:{'have-product-img' : product.photo !== null},attrs:{"src":product.photo === null ? __webpack_require__("jfOg") : product.photo}})])],1),_vm._v(" "),_c('v-card-title',{attrs:{"secondary-title":""},on:{"click":function($event){_vm.openProduct(product.id, index, 'sidamo')}}},[_c('div',[_c('p',{staticClass:"product-label mb-0"},[_vm._v(_vm._s(product.label))]),_vm._v(" "),_c('p',{staticClass:"product-supplier"},[(product.supplier)?[_vm._v("\n                            "+_vm._s(product.supplier.name)+"\n                          ")]:(product.category)?[_vm._v("\n                            "+_vm._s(product.category.label)+"\n                          ")]:_vm._e()],2)])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","small":""},on:{"click":function($event){_vm.goToProduct(product.id, product.group)}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("open_in_new")])],1)],1)],1)],1)}))],1)}
var Sidamos_staticRenderFns = []
var Sidamos_esExports = { render: Sidamos_render, staticRenderFns: Sidamos_staticRenderFns }
/* harmony default export */ var single_Sidamos = (Sidamos_esExports);
// CONCATENATED MODULE: ./src/views/projects/single/Sidamos.vue
function Sidamos_injectStyle (ssrContext) {
  __webpack_require__("2HSc")
}
var Sidamos_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Sidamos___vue_template_functional__ = false
/* styles */
var Sidamos___vue_styles__ = Sidamos_injectStyle
/* scopeId */
var Sidamos___vue_scopeId__ = "data-v-1b6d3686"
/* moduleIdentifier (server only) */
var Sidamos___vue_module_identifier__ = null
var Sidamos_Component = Sidamos_normalizeComponent(
  Sidamos,
  single_Sidamos,
  Sidamos___vue_template_functional__,
  Sidamos___vue_styles__,
  Sidamos___vue_scopeId__,
  Sidamos___vue_module_identifier__
)

/* harmony default export */ var projects_single_Sidamos = __webpack_exports__["default"] = (Sidamos_Component.exports);


/***/ }),

/***/ "j0mG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/layouts/app/Content.vue
//
//
//
//
//
//

/* harmony default export */ var Content = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44d7bd22","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/app/Content.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"app-content"},[_c('router-view',{attrs:{"name":"app_content"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var app_Content = (esExports);
// CONCATENATED MODULE: ./src/layouts/app/Content.vue
function injectStyle (ssrContext) {
  __webpack_require__("0iIH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44d7bd22"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Content,
  app_Content,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var layouts_app_Content = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jfOg":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "jwTm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kGbq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./src/config/enum/ProjectStatuses.js
var ProjectStatuses = __webpack_require__("TnFP");

// CONCATENATED MODULE: ./src/filters/projectStatus.js



vue_esm["a" /* default */].filter('projectStatus', function (value) {
    var projectStatus = ProjectStatuses["a" /* ProjectStatuses */].find(function (el) {
        return el.value === value;
    });
    return projectStatus ? projectStatus.label : '';
});
// EXTERNAL MODULE: ./src/filters/pluralize.js
var pluralize = __webpack_require__("21OC");

// EXTERNAL MODULE: ./src/components/avatar/Avatar.vue + 3 modules
var Avatar = __webpack_require__("Be47");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/avatar/MultiAvatar.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MultiAvatar = ({

    components: { Avatar: Avatar["a" /* default */] },

    props: {
        size: {
            type: String,
            required: false,
            default: '5rem'
        },
        item: {
            type: Array,
            required: true
        },
        isFaker: {
            type: Boolean,
            required: false,
            default: false
        },
        itemKey: {
            type: String,
            required: false,
            default: null
        },
        number: {
            type: Number,
            required: false,
            default: 3
        }
    },

    data: function data() {
        return {};
    },


    computed: {
        count: function count() {
            return this.item.length - this.number;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f32da922","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/avatar/MultiAvatar.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"multi-avatar"},[_vm._l((_vm.item),function(single,index){return [(index < (_vm.number))?[(_vm.itemKey != null)?[_c('avatar',{attrs:{"item":single[_vm.itemKey],"size":_vm.size,"isFaker":_vm.isFaker}})]:[_c('avatar',{attrs:{"item":single,"size":_vm.size,"isFaker":_vm.isFaker}})]]:_vm._e()]}),_vm._v(" "),(_vm.count>0)?_c('span',[_vm._v(" + "+_vm._s(_vm.count))]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var avatar_MultiAvatar = (esExports);
// CONCATENATED MODULE: ./src/components/avatar/MultiAvatar.vue
function injectStyle (ssrContext) {
  __webpack_require__("u84t")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f32da922"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MultiAvatar,
  avatar_MultiAvatar,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_avatar_MultiAvatar = (Component.exports);

// EXTERNAL MODULE: ./src/components/SingleField.vue + 3 modules
var SingleField = __webpack_require__("SIDS");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/projects/single/Delete.vue
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Delete = ({
    data: function data() {
        return {
            title: 'Supression d\'un projet',
            icon: 'delete',
            warning: true,
            deleteItem: true
        };
    },


    methods: {
        onClose: function onClose() {
            this.$eventHub.$emit('close-modal');
        },
        onValidate: function onValidate() {
            var _this = this;

            if (this.deleteItem == true) {
                this.axios.delete('/api/projects/' + this.$store.state.single.data.id).then(function (response) {
                    _this.$eventHub.$emit('close-modal');
                    _this.$router.push({ name: 'projects' });
                }).catch(function (error) {
                    console.log(error.response.data || error);
                });
            } else {
                this.$eventHub.$emit('close-modal');
            }
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        this.axios.get('/api/projects/' + this.$store.state.single.data.id + '?embed=sidamo_products,supplier_products,competitor_products').then(function (response) {
            if (response.data.supplier_products_count > 0 || response.data.sidamo_products_count > 0 || response.data.competitor_products_count > 0) {
                _this2.deleteItem = false;
            }
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f182048","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/projects/single/Delete.vue
var Delete_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.deleteItem == true)?[_c('p',[_vm._v("Êtes-vous sûr de vouloir supprimer ce projet ?")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$store.state.single.data.label))])])]:[_c('p',[_vm._v("Ce projets est lié à un ou plusieurs produits, merci de le(s) supprimer afin de procéder à la suppression de ce projet")])]],2)}
var Delete_staticRenderFns = []
var Delete_esExports = { render: Delete_render, staticRenderFns: Delete_staticRenderFns }
/* harmony default export */ var single_Delete = (Delete_esExports);
// CONCATENATED MODULE: ./src/views/projects/single/Delete.vue
function Delete_injectStyle (ssrContext) {
  __webpack_require__("lEMC")
}
var Delete_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Delete___vue_template_functional__ = false
/* styles */
var Delete___vue_styles__ = Delete_injectStyle
/* scopeId */
var Delete___vue_scopeId__ = "data-v-4f182048"
/* moduleIdentifier (server only) */
var Delete___vue_module_identifier__ = null
var Delete_Component = Delete_normalizeComponent(
  Delete,
  single_Delete,
  Delete___vue_template_functional__,
  Delete___vue_styles__,
  Delete___vue_scopeId__,
  Delete___vue_module_identifier__
)

/* harmony default export */ var projects_single_Delete = (Delete_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/projects/single/UpdateManager.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var UpdateManager = ({
    components: { Avatar: Avatar["a" /* default */] },

    data: function data() {
        return {
            title: 'Changer le Gestionnaire',
            icon: 'mdi-bullhorn',

            isValid: false,

            manager_id: '',

            rules: {
                manager_id: [function (v) {
                    return !!v || 'Gestionnaire obligatoire';
                }]
            },

            managers: []
        };
    },


    methods: {
        onClose: function onClose() {
            this.$eventHub.$emit('close-modal');
        },
        onValidate: function onValidate() {
            var _this = this;

            if (this.$refs.form.validate()) {
                this.axios.put('/api/projects/' + this.$store.state.single.data.id, { user_id: this.manager_id }).then(function (response) {
                    _this.$eventHub.$emit('close-modal');
                    _this.$store.dispatch('updateSingleData', { key: 'user_id', value: _this.manager_id });
                    _this.$store.dispatch('updateSingleData', { key: 'user', value: _this.$_.find(_this.managers, function (m) {
                            return m.id == _this.manager_id;
                        }) });
                }).catch(function (error) {
                    console.log(error.response.data);
                });
            } else {
                return false;
            }
        }
    },

    mounted: function mounted() {
        var _this2 = this;

        this.manager_id = this.$store.state.single.data.user_id;

        this.axios.get('/api/users').then(function (response) {
            _this2.managers = response.data;
            _this2.managers.forEach(function (item) {
                var obj = item;
                obj.fullName = item.first_name + ' ' + item.last_name;
                _this2.managers.push(obj);
            });
        }).catch(function (error) {
            console.log(error.response.data);
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d4d4249","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/projects/single/UpdateManager.vue
var UpdateManager_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form",model:{value:(_vm.isValid),callback:function ($$v) {_vm.isValid=$$v},expression:"isValid"}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"label":"Gestionnaire","autocomplete":"","required":"","chips":"","clearable":"","items":_vm.managers,"item-text":"fullName","item-value":"id","rules":_vm.rules.manager_id,"autofocus":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',[_c('avatar',{attrs:{"size":"3rem","item":data.item}}),_vm._v("\n                        "+_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name)+"\n                    ")],1)]}},{key:"item",fn:function(data){return [(typeof data.item === 'object')?[_c('avatar',{attrs:{"size":"3rem","item":data.item}}),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name))])],1)]:_vm._e()]}}]),model:{value:(_vm.manager_id),callback:function ($$v) {_vm.manager_id=$$v},expression:"manager_id"}})],1)],1)],1)}
var UpdateManager_staticRenderFns = []
var UpdateManager_esExports = { render: UpdateManager_render, staticRenderFns: UpdateManager_staticRenderFns }
/* harmony default export */ var single_UpdateManager = (UpdateManager_esExports);
// CONCATENATED MODULE: ./src/views/projects/single/UpdateManager.vue
function UpdateManager_injectStyle (ssrContext) {
  __webpack_require__("2w37")
}
var UpdateManager_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UpdateManager___vue_template_functional__ = false
/* styles */
var UpdateManager___vue_styles__ = UpdateManager_injectStyle
/* scopeId */
var UpdateManager___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UpdateManager___vue_module_identifier__ = null
var UpdateManager_Component = UpdateManager_normalizeComponent(
  UpdateManager,
  single_UpdateManager,
  UpdateManager___vue_template_functional__,
  UpdateManager___vue_styles__,
  UpdateManager___vue_scopeId__,
  UpdateManager___vue_module_identifier__
)

/* harmony default export */ var projects_single_UpdateManager = (UpdateManager_Component.exports);

// EXTERNAL MODULE: ./src/components/DataTable.vue + 2 modules
var DataTable = __webpack_require__("/WHI");

// EXTERNAL MODULE: ./src/config/enum/CommentTypes.js
var CommentTypes = __webpack_require__("22+B");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/projects/single/ConvertProject.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var ConvertProject = ({
    components: { DataTable: DataTable["a" /* default */] },
    props: {
        params: {
            required: true
        }
    },
    data: function data() {
        return {
            moment: moment_default.a,
            title: 'Convertir un Projet',
            width: '1000px',
            supplier_product: '',
            product_code: '',
            model: {},
            code_ok: false,
            code_accepted: false,

            ERP_color: 'primary',
            ERP_error: false,
            ERP_message: null,
            ERP_loading: false,

            step: 1,
            valid_button: false,
            next_button: true,
            comments: [],
            requests: [],
            created_product_id: '',
            rules: {
                supplier_product: [function (v) {
                    return !!v || 'Produit Fournisseur obligatoire';
                }],
                product_code: [function (v) {
                    return !!v && !isNaN(v) && v.length > 5 || 'Code de 6 chiffres obligatoire';
                }]
            },
            datatable: {
                headers: [{ text: 'Demandes', sortable: false, value: 'is_request', align: 'right' }, { text: 'Commentaires', sortable: false, value: 'is_comment', align: 'right' }, { text: 'Auteur', sortable: true, value: 'user_id', align: 'right' }, { text: 'Date', sortable: true, value: 'created_at', align: 'right' }, { text: 'Tonalite', sortable: false, value: 'type', align: 'center' }, { text: 'Message', sortable: false, align: 'right' }],
                endpoint: {
                    base: '/api/comments',
                    filters: 'product_id|=|',
                    embed: 'user'
                }
            }
        };
    },
    created: function created() {
        this.$eventHub.$emit('set-valid-button', false);
    },

    computed: {
        supplier_products: function supplier_products() {
            return this.$store.state.single.data.supplier_products;
        }
    },
    watch: {
        code_ok: function code_ok(val) {
            if (val) {
                this.sendCode(this.product_code);
            }
        }
    },

    methods: {
        supplier_product_avatar: function supplier_product_avatar(data) {
            if (data.item.photo === null) {
                return __webpack_require__("jfOg");
            } else {
                return data.item.photo;
            }
        },
        sendCode: function sendCode(value) {
            var _this = this;

            this.ERP_loading = true;

            this.axios.get('/api/products/erp-synchro/' + value).then(function (res) {
                _this.ERP_error = false;
                _this.ERP_color = 'success';
                _this.ERP_loading = false;
                _this.ERP_message = res.data.label;

                _this.code_accepted = true;
                _this.$eventHub.$emit('set-next-button', true);
            }).catch(function (err) {
                if (err.response.data.status_code == 422) {
                    _this.ERP_color = 'primary';
                    _this.ERP_error = true;
                    _this.ERP_loading = false;
                    _this.ERP_message = err.response.data.message;
                } else {
                    console.log(err.response.data);
                }

                _this.$eventHub.$emit('set-next-button', false);
                _this.code_accepted = false;
            });
        },
        setComment: function setComment(item) {
            var index = this.comments.indexOf(item.id);

            if (item.comment_selected) {
                if (index == -1) {
                    this.comments.push(item.id);
                }
            } else {
                if (index > -1) {
                    this.comments.splice(index, 1);
                }
            }
        },
        setRequest: function setRequest(item) {
            var index = this.requests.indexOf(item.id);

            if (item.request_selected) {
                if (index == -1) {
                    this.requests.push(item.id);
                }
            } else {
                if (index > -1) {
                    this.requests.splice(index, 1);
                }
            }
        },


        getCommentColor: function getCommentColor(type) {
            var commentType = CommentTypes["a" /* CommentTypes */].find(function (el) {
                return el.value === type;
            });
            return commentType ? commentType.color : '';
        },

        onClose: function onClose() {
            this.$eventHub.$emit('close-modal');
        },
        onNextStep: function onNextStep() {
            if (this.step === 1 && this.supplier_product !== null && this.supplier_product !== '') {
                this.step++;
                this.$eventHub.$emit('set-next-button', false);
                this.datatable.endpoint.filters += this.supplier_product;
            } else if (this.step === 2 && this.code_accepted) {
                this.$eventHub.$emit('set-next-button', false);
                this.$eventHub.$emit('set-valid-button', true);

                this.step++;
            }
        },
        onValidate: function onValidate() {
            var _this2 = this;

            this.step++;
            this.$eventHub.$emit('hide-modal-actions');

            this.axios.post('/api/products/erp-synchro', {
                num: this.product_code,
                root_product_id: this.supplier_product,
                comment_ids: this.comments,
                request_ids: this.requests
            }).then(function (res) {

                var interval = setInterval(function () {

                    _this2.axios.get('/api/products/' + res.data.id).then(function (r) {
                        if (!r.data.is_syncing) {
                            clearInterval(interval);

                            _this2.$eventHub.$emit('close-modal');

                            _this2.$router.push({
                                name: 'single-product',
                                params: {
                                    super_family: _this2.$store.state.single.data.category.parent.parent.label,
                                    id: res.data.id
                                }
                            });
                        }
                    });
                }, 3000);
            }).catch(function (err) {
                return console.log(err.response.data);
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d81102ac","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/projects/single/ConvertProject.vue
var ConvertProject_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form"},[_c('v-container',{attrs:{"grid-list-xs":""}},[_c('v-layout',{attrs:{"wrap":""}},[(this.step===1)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"label":"Produit Fournisseur","autocomplete":"","required":"","chips":"","clearable":"","items":_vm.supplier_products,"item-text":"label","item-value":"id","rules":_vm.rules.supplier_product},on:{"change":function($event){}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n\n                        "+_vm._s(data.item.label)+"\n\n                    ")]}},{key:"item",fn:function(data){return [(typeof data.item === 'object')?[_c('v-avatar',[_c('img',{attrs:{"src":_vm.supplier_product_avatar(data)}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(data.item.label))])],1)]:_vm._e()]}}]),model:{value:(_vm.supplier_product),callback:function ($$v) {_vm.supplier_product=$$v},expression:"supplier_product"}})],1):_vm._e(),_vm._v(" "),(_vm.step===2)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-form',{model:{value:(_vm.code_ok),callback:function ($$v) {_vm.code_ok=$$v},expression:"code_ok"}},[_c('v-text-field',{attrs:{"label":"Code article","required":"","color":_vm.ERP_color,"loading":_vm.ERP_loading,"error":_vm.ERP_error,"hint":_vm.ERP_message,"rules":_vm.rules.product_code},model:{value:(_vm.product_code),callback:function ($$v) {_vm.product_code=$$v},expression:"product_code"}})],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.step===3)?_c('v-flex',{attrs:{"xs12":""}},[_c('data-table',{ref:"list",attrs:{"headers":_vm.datatable.headers,"endpoint":_vm.datatable.endpoint,"storeId":"comments"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-right"},[_c('v-checkbox',{attrs:{"hide-details":"","color":"accent"},on:{"change":function($event){_vm.setRequest(props.item)}},model:{value:(props.item.request_selected),callback:function ($$v) {_vm.$set(props.item, "request_selected", $$v)},expression:"props.item.request_selected"}})],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('v-checkbox',{attrs:{"hide-details":"","color":"accent"},on:{"change":function($event){_vm.setComment(props.item)}},model:{value:(props.item.comment_selected),callback:function ($$v) {_vm.$set(props.item, "comment_selected", $$v)},expression:"props.item.comment_selected"}})],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n                        "+_vm._s(props.item.user.first_name)+" "+_vm._s(props.item.user.last_name)+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n                        "+_vm._s(_vm.moment(props.item.created_at).format('DD/MM/YYYY'))+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-icon',{style:({color: _vm.getCommentColor(props.item.type)})},[_vm._v("fiber_manual_record")])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n                        "+_vm._s(props.item.message)+"\n                    ")])]}}])})],1):_vm._e(),_vm._v(" "),(_vm.step === 4)?_c('div',{staticClass:"loader"},[_c('img',{attrs:{"src":__webpack_require__("bwqQ")}}),_vm._v(" "),_c('p',[_vm._v("Conversion du projet en cours")])]):_vm._e()],1)],1)],1)}
var ConvertProject_staticRenderFns = []
var ConvertProject_esExports = { render: ConvertProject_render, staticRenderFns: ConvertProject_staticRenderFns }
/* harmony default export */ var single_ConvertProject = (ConvertProject_esExports);
// CONCATENATED MODULE: ./src/views/projects/single/ConvertProject.vue
function ConvertProject_injectStyle (ssrContext) {
  __webpack_require__("JLdM")
}
var ConvertProject_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ConvertProject___vue_template_functional__ = false
/* styles */
var ConvertProject___vue_styles__ = ConvertProject_injectStyle
/* scopeId */
var ConvertProject___vue_scopeId__ = "data-v-d81102ac"
/* moduleIdentifier (server only) */
var ConvertProject___vue_module_identifier__ = null
var ConvertProject_Component = ConvertProject_normalizeComponent(
  ConvertProject,
  single_ConvertProject,
  ConvertProject___vue_template_functional__,
  ConvertProject___vue_styles__,
  ConvertProject___vue_scopeId__,
  ConvertProject___vue_module_identifier__
)

/* harmony default export */ var projects_single_ConvertProject = (ConvertProject_Component.exports);

// EXTERNAL MODULE: ./src/components/single/MoreActions.vue + 2 modules
var MoreActions = __webpack_require__("n2Fp");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/projects/single/Single.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ var Single = ({
	components: { Avatar: Avatar["a" /* default */], SingleField: SingleField["a" /* default */], MultiAvatar: components_avatar_MultiAvatar, MoreActions: MoreActions["a" /* default */] },

	data: function data() {
		var _this = this;

		return {
			moment: moment_default.a,
			ProjectStatuses: ProjectStatuses["a" /* ProjectStatuses */],
			project: {},
			scrollPosition: '',
			Delete: projects_single_Delete,
			UpdateManager: projects_single_UpdateManager,
			actions: [{ text: 'Exporter les produits fournisseurs', callback: function callback() {
					return _this.exportProducts('supplier');
				} }, { text: 'Exporter les produits concurrents', callback: function callback() {
					return _this.exportProducts('competitor');
				} }, { text: 'Supprimer', callback: function callback() {
					return _this.$eventHub.$emit('open-modal', projects_single_Delete);
				}, level: 60 }],

			showStatus: false,
			menuStatus: false
		};
	},


	computed: {
		data: function data() {
			return this.$store.state.single.data;
		},
		routeName: function routeName() {
			var name = this.$route.path.split('/');
			return name[1];
		}
	},

	methods: {
		updateField: function updateField(key, value) {
			var _this2 = this;

			var resource = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'projects';

			var model = {};
			model[key] = value;

			this.axios.put('/api/' + resource + '/' + this.$route.params.id, model).then(function (response) {
				_this2.$store.dispatch('updateSingleData', { key: key, value: value });
			}).catch(function (error) {
				_this2.$refs[key].setError(error.response.data.errors[key][0]);
			});
		},
		updateMeta: function updateMeta(meta, value) {
			var _this3 = this;

			var model = { metas: [] };

			if (meta.options != undefined) {
				if (typeof value == 'number') {
					model.metas.push({ meta_id: meta.id, meta_value_id: [value] });
				} else {
					model.metas.push({ meta_id: meta.id, meta_value_id: value });
				}
			} else {
				model.metas.push({ meta_id: meta.id, value: value });
			}

			this.axios.put('/api/projects/' + this.$route.params.id, model).then(function (response) {
				_this3.$store.dispatch('updateSingleMetaData', { meta: meta, value: value });
			}).catch(function (error) {
				_this3.$refs[meta.slug].setError(error.response.data.errors[meta.slug][0]);
			});
		},
		updateStatus: function updateStatus(value) {
			var _this4 = this;

			this.axios.put('/api/projects/' + this.$route.params.id, { status: value }).then(function (res) {
				return _this4.$store.dispatch('updateSingleData', { key: 'status', value: value });
			}).catch(function (err) {
				return console.log(err);
			});
		},
		getDataFromApi: function getDataFromApi() {
			var _this5 = this;

			var load = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

			load == false ? '' : this.$loading.startLoading('setSingleData');
			this.axios.get('/api/projects/' + this.$route.params.id + '?embed=user,sidamo_products.category.parent,sidamo_products.fields,competitor_products.comments.user,supplier_products.comments.user,competitor_products.category.parent.parent,competitor_products.supplier,supplier_products.category.parent.parent,supplier_products.supplier,category.parent.parent,supplier_products.fields,competitor_products.fields,files').then(function (response) {
				_this5.project = response.data;
				_this5.$store.dispatch('setSingleData', { data: _this5.project });
				if (_this5.project.supplier_products_count > 0) {
					var index = _this5.actions.findIndex(function (a) {
						return a.text == 'Convertir';
					});
					if (index == -1) {
						_this5.actions.push({ text: 'Convertir', callback: function callback() {
								return _this5.$eventHub.$emit('open-modal', projects_single_ConvertProject);
							}, level: 60 });
					}
				}
				_this5.$loading.endLoading('setSingleData');
			});
		},
		onScroll: function onScroll(e) {
			this.scrollPosition = e.target.scrollTop;
		},
		exportProducts: function exportProducts(type) {
			this.axios.post('/api/projects/' + this.$route.params.id + '/export', { type: type }).then(function (res) {
				var a = document.createElement('A');
				a.href = res.data;
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
			});
		}
	},

	watch: {
		$route: function $route(to, from) {
			this.getDataFromApi(false);
		}
	},

	created: function created() {
		var _this6 = this;

		this.$eventHub.$on('reload-single-project', function () {
			_this6.getDataFromApi(false);
		});
	},
	mounted: function mounted() {
		this.getDataFromApi();
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80b68280","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/projects/single/Single.vue
var Single_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single_content"},[_c('v-breadcrumbs',{staticClass:"back",attrs:{"id":"breadcrumbs"}},[_c('v-icon',{attrs:{"slot":"divider"},slot:"divider"},[_vm._v("chevron_right")]),_vm._v(" "),_c('v-breadcrumbs-item',[_c('router-link',{staticClass:"back",attrs:{"to":{ name: 'projects'}}},[_vm._v(" "+_vm._s(_vm.routeName)+" ")])],1),_vm._v(" "),_c('v-breadcrumbs-item',[_vm._v("\n\t\t\t\t"+_vm._s(_vm.data.label)+"\n\t\t\t")])],1),_vm._v(" "),(_vm.$loading.isLoading('setSingleData'))?_c('v-loading',{staticClass:"loader",attrs:{"loader":"setSingleData"}},[_c('template',{slot:"spinner"},[_c('div',{staticClass:"loader"},[_c('img',{attrs:{"src":__webpack_require__("bwqQ")}})])])],2):_vm._e(),_vm._v(" "),(!_vm.$loading.isLoading('setSingleData'))?_c('div',{directives:[{name:"scroll",rawName:"v-scroll",value:({target: '#scroll-target', callback: this.onScroll}),expression:"{target: '#scroll-target', callback: this.onScroll}"}],staticClass:"single",class:{'fixed': _vm.scrollPosition > 90}},[_c('aside',[_c('div',{staticClass:"top"},[_c('div',{staticClass:"border"},[_c('more-actions',{attrs:{"actions":_vm.actions}})],1)]),_vm._v(" "),_c('div',{staticClass:"contain"},[_c('div',{staticClass:"name"},[_c('h2',[_vm._v(_vm._s(_vm.data.label))]),_vm._v(" "),(_vm.data.category)?_c('p',[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.data.category.parent.parent.label)+" - "+_vm._s(_vm.data.category.parent.label)+" - "+_vm._s(_vm.data.category.label)+"\n\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(_vm.data.status)?[_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","round":"","color":"primary"},slot:"activator"},[_vm._v("\n\t                            \t"+_vm._s(_vm.$_.find(_vm.ProjectStatuses, function (s) { return s.value == _vm.data.status; }).label)+"\n\t\t\t\t\t\t\t\t\t"),_c('v-icon',[_vm._v("arrow_drop_down")])],1),_vm._v(" "),_c('v-list',_vm._l((_vm.ProjectStatuses),function(status,index){return _c('v-list-tile',{key:index,staticClass:"li",on:{"click":function($event){_vm.updateStatus(status.value)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(status.label))])],1)}))],1)]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"numbers"},[_c('div',{on:{"click":function($event){$event.stopPropagation();_vm.$router.push({ name: 'project-products-competitors' })}}},[_c('span',[_vm._v(_vm._s(_vm.data.competitor_products_count))]),_vm._v(" "+_vm._s(_vm._f("pluralize")(_vm.data.competitor_products_count,'Produit'))+" "+_vm._s(_vm._f("pluralize")(_vm.data.competitor_products_count,'Concurrent'))+"\n\t\t\t\t\t\t")]),_vm._v(" "),_c('div',{on:{"click":function($event){$event.stopPropagation();_vm.$router.push({ name: 'project-products-suppliers' })}}},[_c('span',[_vm._v(_vm._s(_vm.data.supplier_products_count))]),_vm._v(" "+_vm._s(_vm._f("pluralize")(_vm.data.supplier_products_count,'Produit'))+" "+_vm._s(_vm._f("pluralize")(_vm.data.supplier_products_count,'Fournisseur'))+"\n\t\t\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"about"},[(_vm.data.sidamo_product)?_c('div',{staticClass:"field mb-1",attrs:{"data-group":"0"}},[_c('div',{staticClass:"label"},[_vm._v("Produit Sidamo")]),_vm._v(" "),(_vm.data.sidamo_product)?_c('div',{staticClass:"value"},[_c('router-link',{attrs:{"to":{ name: 'single-product', params: { super_family: _vm.data.category.parent.parent.label, id: _vm.data.sidamo_product.id }}}},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.data.sidamo_product.label)+"\n\t\t\t\t\t\t\t\t")])],1):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"field mb-1",attrs:{"data-group":"0"}},[_c('div',{staticClass:"label"},[_vm._v("Date de modif.")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(_vm.moment(_vm.data.updated_at).format('DD/MM/YYYY'))+"\n\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"field mb-1",attrs:{"data-group":"0"}},[_c('div',{staticClass:"label"},[_vm._v("Date de créa.")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(_vm.moment(_vm.data.created_at).format('DD/MM/YYYY'))+"\n\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"field mb-1",attrs:{"data-group":"0"}},[_c('div',{staticClass:"label"},[_vm._v("Gestionnaire")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.data.user)?[_c('avatar',{attrs:{"item":_vm.data.user}}),_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.data.user ? _vm.data.user.first_name : '')+" "+_vm._s(_vm.data.user ? _vm.data.user.last_name :'')+"\n\t\t\t\t\t\t\t\t")]:_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"edit",attrs:{"icon":"","small":"","disabled":_vm.$store.state.auth.user.level < 60},on:{"click":function($event){_vm.$eventHub.$emit('open-modal', _vm.UpdateManager)}}},[_c('v-icon',[_vm._v("mode_edit")])],1)],2)])])])]),_vm._v(" "),_c('div',{staticClass:"tab"},[_c('v-tabs',{attrs:{"slider-color":"primary","show-arrows":true}},[_c('v-tab',{attrs:{"ripple":"","to":{ name: 'project-products-suppliers' }}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm._f("pluralize")(_vm.data.supplier_products_count,'Produit fournisseur','Produits fournisseurs'))+"\n\t\t\t\t\t\t("+_vm._s(_vm.data.supplier_products_count)+")\n\t\t\t\t\t")]),_vm._v(" "),_c('v-tab',{attrs:{"ripple":"","to":{ name: 'project-products-competitors' }}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm._f("pluralize")(_vm.data.competitor_products_count,'Produit concurrent', 'Produits concurrents'))+"\n\t\t\t\t\t\t("+_vm._s(_vm.data.competitor_products_count)+")\n\t\t\t\t\t")]),_vm._v(" "),_c('v-tab',{attrs:{"ripple":"","to":{ name: 'project-products-sidamos' }}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm._f("pluralize")(_vm.data.sidamo_products_count,'Produit sidamo', 'Produits sidamos'))+"\n\t\t\t\t\t\t("+_vm._s(_vm.data.sidamo_products_count)+")\n\t\t\t\t\t")]),_vm._v(" "),_c('v-tab',{attrs:{"ripple":"","to":{ name: 'project-files' }}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm._f("pluralize")(_vm.data.files_count,'Fichier'))+" ("+_vm._s(_vm.data.files_count)+")\n\t\t\t\t\t")])],1),_vm._v(" "),_c('div',{staticClass:"router_view"},[_c('router-view')],1)],1)]):_vm._e()],1)}
var Single_staticRenderFns = []
var Single_esExports = { render: Single_render, staticRenderFns: Single_staticRenderFns }
/* harmony default export */ var single_Single = (Single_esExports);
// CONCATENATED MODULE: ./src/views/projects/single/Single.vue
function Single_injectStyle (ssrContext) {
  __webpack_require__("/bO6")
}
var Single_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Single___vue_template_functional__ = false
/* styles */
var Single___vue_styles__ = Single_injectStyle
/* scopeId */
var Single___vue_scopeId__ = "data-v-80b68280"
/* moduleIdentifier (server only) */
var Single___vue_module_identifier__ = null
var Single_Component = Single_normalizeComponent(
  Single,
  single_Single,
  Single___vue_template_functional__,
  Single___vue_styles__,
  Single___vue_scopeId__,
  Single___vue_module_identifier__
)

/* harmony default export */ var projects_single_Single = __webpack_exports__["default"] = (Single_Component.exports);


/***/ }),

/***/ "kKnX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/avatar/UploadAvatar.vue + 2 modules
var UploadAvatar = __webpack_require__("wRGB");

// EXTERNAL MODULE: ./src/components/single/MoreActions.vue + 2 modules
var MoreActions = __webpack_require__("n2Fp");

// EXTERNAL MODULE: ./src/components/avatar/Avatar.vue + 3 modules
var Avatar = __webpack_require__("Be47");

// EXTERNAL MODULE: ./src/config/enum/ProductTypes.js
var ProductTypes = __webpack_require__("mdcO");

// EXTERNAL MODULE: ./src/components/SingleField.vue + 3 modules
var SingleField = __webpack_require__("SIDS");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/products/single/Delete.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Delete = ({
    data: function data() {
        return {
            title: 'Supression d\'un produit',
            icon: 'delete',
            warning: true
        };
    },


    methods: {
        onClose: function onClose() {
            this.$eventHub.$emit('close-modal');
        },
        onValidate: function onValidate() {
            var _this = this;

            this.axios.delete('/api/products/' + this.$store.state.single.data.id).then(function (response) {
                _this.$eventHub.$emit('close-modal');
                _this.$router.push({ name: 'products' });
            }).catch(function (error) {
                console.log(error.response.data || error);
            });
        }
    }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-672aa3fa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/single/Delete.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('p',[_vm._v("Êtes-vous sûr de vouloir supprimer ce produit ?")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$store.state.single.data.label))])])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var single_Delete = (esExports);
// CONCATENATED MODULE: ./src/views/products/single/Delete.vue
function injectStyle (ssrContext) {
  __webpack_require__("qXE/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-672aa3fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Delete,
  single_Delete,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var products_single_Delete = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/products/single/UpdateManager.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var UpdateManager = ({
    components: { Avatar: Avatar["a" /* default */] },

    data: function data() {
        return {
            title: 'Changer le Gestionnaire',
            icon: 'mdi-bullhorn',

            isValid: false,

            manager_id: '',

            rules: {
                manager_id: [function (v) {
                    return !!v || 'Gestionnaire obligatoire';
                }]
            },

            managers: []
        };
    },


    methods: {
        onClose: function onClose() {
            this.$eventHub.$emit('close-modal');
        },
        onValidate: function onValidate() {
            var _this = this;

            if (this.$refs.form.validate()) {
                this.axios.put('/api/products/' + this.$store.state.single.data.id, { user_id: this.manager_id }).then(function (response) {
                    _this.$eventHub.$emit('close-modal');
                    _this.$store.dispatch('updateSingleData', { key: 'user_id', value: _this.manager_id });
                    _this.$store.dispatch('updateSingleData', { key: 'user', value: _this.$_.find(_this.managers, function (m) {
                            return m.id == _this.manager_id;
                        }) });
                }).catch(function (error) {
                    console.log(error.response.data);
                });
            } else {
                return false;
            }
        }
    },

    mounted: function mounted() {
        var _this2 = this;

        this.manager_id = this.$store.state.single.data.user_id;

        this.axios.get('/api/users').then(function (response) {
            _this2.managers = response.data;
            _this2.managers.forEach(function (item) {
                var obj = item;
                obj.fullName = item.first_name + ' ' + item.last_name;
                _this2.managers.push(obj);
            });
        }).catch(function (error) {
            console.log(error.response.data);
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b27f916","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/single/UpdateManager.vue
var UpdateManager_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form",model:{value:(_vm.isValid),callback:function ($$v) {_vm.isValid=$$v},expression:"isValid"}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"label":"Gestionnaire","autocomplete":"","required":"","chips":"","clearable":"","items":_vm.managers,"item-text":"fullName","item-value":"id","rules":_vm.rules.manager_id,"autofocus":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',[_c('avatar',{attrs:{"size":"3rem","item":data.item}}),_vm._v("\n                        "+_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name)+"\n                    ")],1)]}},{key:"item",fn:function(data){return [(typeof data.item === 'object')?[_c('avatar',{attrs:{"size":"3rem","item":data.item}}),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name))])],1)]:_vm._e()]}}]),model:{value:(_vm.manager_id),callback:function ($$v) {_vm.manager_id=$$v},expression:"manager_id"}})],1)],1)],1)}
var UpdateManager_staticRenderFns = []
var UpdateManager_esExports = { render: UpdateManager_render, staticRenderFns: UpdateManager_staticRenderFns }
/* harmony default export */ var single_UpdateManager = (UpdateManager_esExports);
// CONCATENATED MODULE: ./src/views/products/single/UpdateManager.vue
function UpdateManager_injectStyle (ssrContext) {
  __webpack_require__("T4d6")
}
var UpdateManager_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UpdateManager___vue_template_functional__ = false
/* styles */
var UpdateManager___vue_styles__ = UpdateManager_injectStyle
/* scopeId */
var UpdateManager___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UpdateManager___vue_module_identifier__ = null
var UpdateManager_Component = UpdateManager_normalizeComponent(
  UpdateManager,
  single_UpdateManager,
  UpdateManager___vue_template_functional__,
  UpdateManager___vue_styles__,
  UpdateManager___vue_scopeId__,
  UpdateManager___vue_module_identifier__
)

/* harmony default export */ var products_single_UpdateManager = (UpdateManager_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/products/single/ResyncProduct.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ResyncProduct = ({
    data: function data() {
        return {
            title: 'Synchronisation d\'un produit',
            icon: 'sync',
            step: 1
        };
    },


    methods: {
        onClose: function onClose() {
            this.$eventHub.$emit('close-modal');
        },
        onValidate: function onValidate() {
            var _this = this;

            this.step++;
            this.$eventHub.$emit('hide-modal-actions');

            this.axios.put('/api/products/erp-synchro/' + this.$route.params.id).then(function (res) {
                var interval = setInterval(function () {

                    _this.axios.get('/api/products/' + res.data.id).then(function (r) {
                        if (!r.data.is_syncing) {
                            clearInterval(interval);
                            _this.$eventHub.$emit('close-modal');
                            _this.$eventHub.$emit('reload-single');
                        }
                    });
                }, 3000);
            }).catch(function (err) {
                return console.log(err);
            });
        }
    }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b57192c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/single/ResyncProduct.vue
var ResyncProduct_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[[(_vm.step === 1)?[_c('p',[_vm._v("Êtes-vous sûr de vouloir resynchroniser ce produit ?")])]:_vm._e(),_vm._v(" "),(_vm.step === 2)?_c('div',{staticClass:"loader"},[_c('img',{attrs:{"src":__webpack_require__("bwqQ")}}),_vm._v(" "),_c('p',[_vm._v("Synchronisation du produit en cours")])]):_vm._e()]],2)}
var ResyncProduct_staticRenderFns = []
var ResyncProduct_esExports = { render: ResyncProduct_render, staticRenderFns: ResyncProduct_staticRenderFns }
/* harmony default export */ var single_ResyncProduct = (ResyncProduct_esExports);
// CONCATENATED MODULE: ./src/views/products/single/ResyncProduct.vue
function ResyncProduct_injectStyle (ssrContext) {
  __webpack_require__("KsjB")
}
var ResyncProduct_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ResyncProduct___vue_template_functional__ = false
/* styles */
var ResyncProduct___vue_styles__ = ResyncProduct_injectStyle
/* scopeId */
var ResyncProduct___vue_scopeId__ = "data-v-7b57192c"
/* moduleIdentifier (server only) */
var ResyncProduct___vue_module_identifier__ = null
var ResyncProduct_Component = ResyncProduct_normalizeComponent(
  ResyncProduct,
  single_ResyncProduct,
  ResyncProduct___vue_template_functional__,
  ResyncProduct___vue_styles__,
  ResyncProduct___vue_scopeId__,
  ResyncProduct___vue_module_identifier__
)

/* harmony default export */ var products_single_ResyncProduct = (ResyncProduct_Component.exports);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/products/single/LoadPDF.vue
//
//
//
//
//
//
//
//
//
//
//
//
//


moment_default.a.locale('fr');
/* harmony default export */ var LoadPDF = ({
    data: function data() {
        return {
            title: 'Création d\'une fiche produit',
            icon: 'sync',
            moment: moment_default.a
        };
    },


    methods: {
        onClose: function onClose() {
            this.$eventHub.$emit('close-modal');
        },
        onValidate: function onValidate() {
            this.onClose();
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.$eventHub.$emit('hide-modal-actions');

        var downloadLink = document.createElement('A');
        this.axios.get('/api/generate-pdf/' + this.$route.params.id, {
            responseType: 'blob'
        }).then(function (response) {
            _this.onClose();
            var data = window.URL.createObjectURL(response.data);

            downloadLink.href = data;
            downloadLink.download = _this.$store.state.single.data.code + "-V" + _this.$store.state.single.data.version + ".zip";
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
            _this.axios.post('/api/delete-zip');
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48d8feed","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/single/LoadPDF.vue
var LoadPDF_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[[_vm._m(0)]],2)}
var LoadPDF_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('img',{attrs:{"src":__webpack_require__("bwqQ")}}),_vm._v(" "),_c('p',[_vm._v("Génération du PDF en cours")])])}]
var LoadPDF_esExports = { render: LoadPDF_render, staticRenderFns: LoadPDF_staticRenderFns }
/* harmony default export */ var single_LoadPDF = (LoadPDF_esExports);
// CONCATENATED MODULE: ./src/views/products/single/LoadPDF.vue
function LoadPDF_injectStyle (ssrContext) {
  __webpack_require__("61XD")
}
var LoadPDF_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LoadPDF___vue_template_functional__ = false
/* styles */
var LoadPDF___vue_styles__ = LoadPDF_injectStyle
/* scopeId */
var LoadPDF___vue_scopeId__ = "data-v-48d8feed"
/* moduleIdentifier (server only) */
var LoadPDF___vue_module_identifier__ = null
var LoadPDF_Component = LoadPDF_normalizeComponent(
  LoadPDF,
  single_LoadPDF,
  LoadPDF___vue_template_functional__,
  LoadPDF___vue_styles__,
  LoadPDF___vue_scopeId__,
  LoadPDF___vue_module_identifier__
)

/* harmony default export */ var products_single_LoadPDF = (LoadPDF_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/products/single/UpdateProject.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var UpdateProject = ({
    data: function data() {
        return {
            title: 'Modifier le projet',
            icon: 'folder',
            isValid: false,
            projects: [],
            project_id: null,
            loading: false
        };
    },

    methods: {
        onClose: function onClose() {
            this.$eventHub.$emit('close-modal');
        },
        onValidate: function onValidate() {
            var _this = this;

            if (this.$refs.form.validate()) {
                this.axios.put('/api/products/' + this.$store.state.single.data.id, { project_id: this.project_id }).then(function (response) {
                    _this.$store.dispatch('updateSingleData', { key: 'project_id', value: _this.project_id });
                    _this.$store.dispatch('updateSingleData', { key: 'project', value: _this.$_.find(_this.projects, function (p) {
                            return p.id == _this.project_id;
                        }) });
                    _this.onClose();
                });
            } else {
                this.onClose();
            }
        },
        getProjects: function getProjects() {
            var _this2 = this;

            this.axios.get('/api/projects').then(function (response) {
                _this2.projects = response.data;
                if (_this2.$store.state.single.data.project_id != null) {
                    _this2.project_id = _this2.$store.state.single.data.project_id;
                }
                _this2.loading = false;
            });
        }
    },
    mounted: function mounted() {
        this.loading = true;
        this.getProjects();
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c30f3e4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/single/UpdateProject.vue
var UpdateProject_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form",model:{value:(_vm.isValid),callback:function ($$v) {_vm.isValid=$$v},expression:"isValid"}},[_c('v-container',{attrs:{"grid-list-xs":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.projects,"label":"Projet","item-text":"label","item-value":"id","autocomplete":"","autofocus":"","clearable":"","loading":_vm.loading},model:{value:(_vm.project_id),callback:function ($$v) {_vm.project_id=$$v},expression:"project_id"}})],1)],1)],1)],1)],1)],1)}
var UpdateProject_staticRenderFns = []
var UpdateProject_esExports = { render: UpdateProject_render, staticRenderFns: UpdateProject_staticRenderFns }
/* harmony default export */ var single_UpdateProject = (UpdateProject_esExports);
// CONCATENATED MODULE: ./src/views/products/single/UpdateProject.vue
function UpdateProject_injectStyle (ssrContext) {
  __webpack_require__("q36h")
}
var UpdateProject_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UpdateProject___vue_template_functional__ = false
/* styles */
var UpdateProject___vue_styles__ = UpdateProject_injectStyle
/* scopeId */
var UpdateProject___vue_scopeId__ = "data-v-0c30f3e4"
/* moduleIdentifier (server only) */
var UpdateProject___vue_module_identifier__ = null
var UpdateProject_Component = UpdateProject_normalizeComponent(
  UpdateProject,
  single_UpdateProject,
  UpdateProject___vue_template_functional__,
  UpdateProject___vue_styles__,
  UpdateProject___vue_scopeId__,
  UpdateProject___vue_module_identifier__
)

/* harmony default export */ var products_single_UpdateProject = (UpdateProject_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/products/single/UpdateSupplier.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var UpdateSupplier = ({
    data: function data() {
        return {
            title: 'Modifier le fournisseur',
            icon: 'find_replace',
            isValid: false,
            suppliers: [],
            supplier_id: null,
            loading: false,
            disableEnter: true
        };
    },

    methods: {
        onClose: function onClose() {
            this.$eventHub.$emit('close-modal');
        },
        onValidate: function onValidate() {
            var _this = this;

            if (this.$refs.form.validate()) {
                this.axios.put('/api/products/' + this.$store.state.single.data.id, { supplier_id: this.supplier_id }).then(function (response) {
                    _this.$store.dispatch('updateSingleData', { key: 'supplier_id', value: _this.supplier_id });
                    _this.$store.dispatch('updateSingleData', { key: 'supplier', value: _this.$_.find(_this.suppliers, function (p) {
                            return p.id == _this.supplier_id;
                        }) });
                    _this.onClose();
                });
            } else {
                this.onClose();
            }
        },
        addTag: function addTag(val) {
            var _this2 = this;

            if (val.target.value != "" && this.suppliers.filter(function (s) {
                return s.name == val.target.value;
            }).length == 0) {
                this.axios.post('/api/suppliers', { name: val.target.value }).then(function (response) {
                    _this2.suppliers.push(response.data);
                    _this2.supplier_id = response.data.id;
                    if (_this2.$refs.select) {
                        _this2.$refs.select.searchValue = null;
                    }
                });
            }
        },
        getSuppliers: function getSuppliers() {
            var _this3 = this;

            this.axios.get('/api/suppliers').then(function (response) {
                _this3.suppliers = response.data;
                if (_this3.$store.state.single.data.supplier_id != null) {
                    _this3.project_id = _this3.$store.state.single.data.supplier_id;
                }
                _this3.loading = false;
            });
        }
    },
    mounted: function mounted() {
        this.loading = true;
        this.getSuppliers();
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28ced891","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/single/UpdateSupplier.vue
var UpdateSupplier_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();}},model:{value:(_vm.isValid),callback:function ($$v) {_vm.isValid=$$v},expression:"isValid"}},[_c('v-container',{attrs:{"grid-list-xs":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{ref:"select",attrs:{"items":_vm.suppliers,"label":"Fournisseur","item-text":"name","item-value":"id","autocomplete":"","autofocus":"","clearable":"","loading":_vm.loading},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.addTag($event)}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',[_vm._v("\n                                "+_vm._s(data.item.name)+"\n                            ")])]}},{key:"item",fn:function(data){return [(typeof data.item === 'object')?[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(data.item.name))])],1)]:_vm._e()]}}]),model:{value:(_vm.supplier_id),callback:function ($$v) {_vm.supplier_id=$$v},expression:"supplier_id"}},[_c('template',{slot:"no-data"},[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Appuyer sur Entrer pour ajouter")])],1)],1)],1)],2)],1)],1)],1)],1)],1)],1)}
var UpdateSupplier_staticRenderFns = []
var UpdateSupplier_esExports = { render: UpdateSupplier_render, staticRenderFns: UpdateSupplier_staticRenderFns }
/* harmony default export */ var single_UpdateSupplier = (UpdateSupplier_esExports);
// CONCATENATED MODULE: ./src/views/products/single/UpdateSupplier.vue
function UpdateSupplier_injectStyle (ssrContext) {
  __webpack_require__("zySI")
}
var UpdateSupplier_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UpdateSupplier___vue_template_functional__ = false
/* styles */
var UpdateSupplier___vue_styles__ = UpdateSupplier_injectStyle
/* scopeId */
var UpdateSupplier___vue_scopeId__ = "data-v-28ced891"
/* moduleIdentifier (server only) */
var UpdateSupplier___vue_module_identifier__ = null
var UpdateSupplier_Component = UpdateSupplier_normalizeComponent(
  UpdateSupplier,
  single_UpdateSupplier,
  UpdateSupplier___vue_template_functional__,
  UpdateSupplier___vue_styles__,
  UpdateSupplier___vue_scopeId__,
  UpdateSupplier___vue_module_identifier__
)

/* harmony default export */ var products_single_UpdateSupplier = (UpdateSupplier_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/products/single/UpdateVersion.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


moment_default.a.locale('fr');
/* harmony default export */ var UpdateVersion = ({
    data: function data() {
        return {
            title: 'Changer la version du produit',
            icon: 'sync',
            moment: moment_default.a,
            step: 1,
            version: 0

        };
    },


    methods: {
        onClose: function onClose() {
            this.$eventHub.$emit('close-modal');
        },
        onValidate: function onValidate() {
            var _this = this;

            this.step++;
            this.axios.put('/api/products/' + this.$store.state.single.data.id, { version: this.version }).then(function (response) {
                _this.$store.dispatch('updateSingleData', { key: 'version', value: _this.version });
                _this.$store.dispatch('updateSingleData', { key: 'files_count', value: _this.$store.state.single.data.files_count + 1 });
                _this.$eventHub.$emit('reload-list');
                _this.onClose();
            });
        },
        updateVersion: function updateVersion(action) {
            if (action == '-') {
                this.version--;
            } else {
                this.version++;
            }
        }
    },
    mounted: function mounted() {
        this.version = this.$store.state.single.data.version;
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17eb2417","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/single/UpdateVersion.vue
var UpdateVersion_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[[(_vm.step == 1)?_c('div',{staticClass:"numbers"},[_c('div',[_c('v-btn',{attrs:{"flat":"","disabled":_vm.version <= 1},on:{"click":function($event){_vm.updateVersion('-')}}},[_c('v-icon',[_vm._v("remove")])],1),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.version))]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.updateVersion('+')}}},[_c('v-icon',[_vm._v("add")])],1)],1)]):_vm._e(),_vm._v(" "),(_vm.step==2)?_c('div',{staticClass:"loader"},[_c('img',{attrs:{"src":__webpack_require__("bwqQ")}}),_vm._v(" "),_c('p',[_vm._v("Changement de version")])]):_vm._e()]],2)}
var UpdateVersion_staticRenderFns = []
var UpdateVersion_esExports = { render: UpdateVersion_render, staticRenderFns: UpdateVersion_staticRenderFns }
/* harmony default export */ var single_UpdateVersion = (UpdateVersion_esExports);
// CONCATENATED MODULE: ./src/views/products/single/UpdateVersion.vue
function UpdateVersion_injectStyle (ssrContext) {
  __webpack_require__("R/AT")
}
var UpdateVersion_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UpdateVersion___vue_template_functional__ = false
/* styles */
var UpdateVersion___vue_styles__ = UpdateVersion_injectStyle
/* scopeId */
var UpdateVersion___vue_scopeId__ = "data-v-17eb2417"
/* moduleIdentifier (server only) */
var UpdateVersion___vue_module_identifier__ = null
var UpdateVersion_Component = UpdateVersion_normalizeComponent(
  UpdateVersion,
  single_UpdateVersion,
  UpdateVersion___vue_template_functional__,
  UpdateVersion___vue_styles__,
  UpdateVersion___vue_scopeId__,
  UpdateVersion___vue_module_identifier__
)

/* harmony default export */ var products_single_UpdateVersion = (UpdateVersion_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/products/single/Single.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ var Single = ({
	components: { UploadAvatar: UploadAvatar["a" /* default */], MoreActions: MoreActions["a" /* default */], SingleField: SingleField["a" /* default */], Avatar: Avatar["a" /* default */] },

	data: function data() {
		var _this = this;

		return {
			moment: moment_default.a,
			product: {},
			scrollPosition: '',
			Delete: products_single_Delete,
			UpdateManager: products_single_UpdateManager,
			ProductTypes: ProductTypes["a" /* ProductTypes */],
			LoadPDF: products_single_LoadPDF,
			UpdateProject: products_single_UpdateProject,
			UpdateSupplier: products_single_UpdateSupplier,
			UpdateVersion: products_single_UpdateVersion,

			actions: [{ text: 'Exporter', callback: function callback() {
					return _this.export();
				} }, { text: 'Supprimer', callback: function callback() {
					return _this.$eventHub.$emit('open-modal', products_single_Delete);
				}, level: 60 }]
		};
	},


	computed: {
		data: function data() {
			return this.$store.state.single.data;
		},
		getCategory: function getCategory() {
			return !!this.$store.state.single.data.category ? this.$store.state.single.data.category.label : '';
		},
		getParentCategory: function getParentCategory() {
			return !!this.$store.state.single.data.category ? this.$store.state.single.data.category.parent.label : '';
		},
		routeName: function routeName() {
			var name = this.$route.path.split('/');
			return name[1] + ' ' + decodeURIComponent(name[2]);
		}
	},

	methods: {
		userLoded: function userLoded() {
			return !!this.$store.state.single.data.user;
		},
		updateField: function updateField(key, value) {
			var _this2 = this;

			var resource = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'products';

			var model = {};
			model[key] = value;

			this.axios.put('/api/' + resource + '/' + this.$route.params.id, model).then(function (response) {
				_this2.$store.dispatch('updateSingleData', { key: key, value: value });
			}).catch(function (error) {
				_this2.$refs[key].setError(error.response.data.errors[key][0]);
			});
		},
		updateMeta: function updateMeta(meta, value) {
			var _this3 = this;

			var model = { metas: [] };

			if (meta.options != undefined) {
				if (typeof value == 'number') {
					model.metas.push({ meta_id: meta.id, meta_value_id: [value] });
				} else {
					model.metas.push({ meta_id: meta.id, meta_value_id: value });
				}
			} else {
				model.metas.push({ meta_id: meta.id, value: value });
			}

			this.axios.put('/api/projects/' + this.$route.params.id, model).then(function (response) {
				_this3.$store.dispatch('updateSingleMetaData', { meta: meta, value: value });
			}).catch(function (error) {
				_this3.$refs[meta.slug].setError(error.response.data.errors[meta.slug][0]);
			});
		},
		getDataFromApi: function getDataFromApi() {
			var _this4 = this;

			var load = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

			load == false ? '' : this.$loading.startLoading('setSingleData');
			this.axios.get('/api/products/' + this.$route.params.id + '?embed=comments,requests,supplier,user,category.parent.parent,fields,features,tests,project,files,accessories').then(function (response) {
				_this4.product = response.data;
				if (_this4.product.fields && _this4.product.fields.length > 0) {
					_this4.product.fields = _this4.$_.orderBy(_this4.product.fields, function (f) {
						return f.pivot.position;
					});
				}
				_this4.$store.dispatch('setSingleData', { data: _this4.product });
				if (_this4.product.type === 'sidamo') {
					_this4.actions = [{ text: 'Resynchroniser', callback: function callback() {
							return _this4.$eventHub.$emit('open-modal', products_single_ResyncProduct);
						}, level: 60 }, { text: 'Changer la version', callback: function callback() {
							return _this4.$eventHub.$emit('open-modal', products_single_UpdateVersion);
						}, level: 60 }, { text: 'Exporter', callback: function callback() {
							return _this4.export();
						} }, { text: 'Exporter le pdf', callback: function callback() {
							return _this4.$eventHub.$emit('open-modal', products_single_LoadPDF);
						} }, { text: 'Supprimer', callback: function callback() {
							return _this4.$eventHub.$emit('open-modal', products_single_Delete);
						}, level: 60 }];
				} else {
					_this4.actions = [
					// { text: 'Exporter', 	callback: () => this.export() },
					// { text: 'Exporter le pdf', 	callback: () => this.$eventHub.$emit('open-modal', LoadPDF) },
					{ text: 'Supprimer', callback: function callback() {
							return _this4.$eventHub.$emit('open-modal', products_single_Delete);
						}, level: 60 }];
				}
				_this4.$loading.endLoading('setSingleData');
			});
		},
		onScroll: function onScroll(e) {
			this.scrollPosition = e.target.scrollTop;
		},
		export: function _export() {
			this.axios.post('/api/products/' + this.$route.params.id + '/export', {}).then(function (res) {
				var a = document.createElement('A');
				a.href = res.data;
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
			});
		}
	},

	watch: {
		$route: function $route(to, from) {
			this.getDataFromApi(false);
		}
	},

	created: function created() {
		var _this5 = this;

		this.$eventHub.$on('reload-single', function () {
			_this5.getDataFromApi();
		});
	},
	mounted: function mounted() {
		this.getDataFromApi();
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cad97db","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/single/Single.vue
var Single_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single_content"},[_c('v-breadcrumbs',{staticClass:"back",attrs:{"id":"breadcrumbs"}},[_c('v-icon',{attrs:{"slot":"divider"},slot:"divider"},[_vm._v("chevron_right")]),_vm._v(" "),_c('v-breadcrumbs-item',[_c('router-link',{staticClass:"back",attrs:{"to":{ name: 'products', params: { super_family: decodeURIComponent(_vm.$route.path.split('/')[2]) }}}},[_vm._v(" "+_vm._s(_vm.routeName)+" ")])],1),_vm._v(" "),_c('v-breadcrumbs-item',[_vm._v("\n\t\t\t\t"+_vm._s(_vm.data.label)+"\n\t\t\t")])],1),_vm._v(" "),(_vm.$loading.isLoading('setSingleData'))?_c('v-loading',{staticClass:"loader",attrs:{"loader":"setSingleData"}},[_c('template',{slot:"spinner"},[_c('div',{staticClass:"loader"},[_c('img',{attrs:{"src":__webpack_require__("bwqQ")}})])])],2):_vm._e(),_vm._v(" "),(!_vm.$loading.isLoading('setSingleData'))?_c('div',{directives:[{name:"scroll",rawName:"v-scroll",value:({target: '#scroll-target', callback: this.onScroll}),expression:"{target: '#scroll-target', callback: this.onScroll}"}],staticClass:"single",class:{'fixed': _vm.scrollPosition > 90}},[_c('aside',[_c('div',{staticClass:"top"},[_c('div',{staticClass:"border"},[_c('more-actions',{attrs:{"actions":_vm.actions}})],1),_vm._v(" "),(_vm.product.type == 'sidamo')?_c('div',{staticClass:"zoom",on:{"click":function($event){_vm.$eventHub.$emit('view-file', _vm.product.photo, 'avatar')}}},[_c('avatar',{attrs:{"item":_vm.product,"size":"10rem","field":"photo"}})],1):_c('upload-avatar',{attrs:{"defaultImg":__webpack_require__("jfOg"),"item":_vm.product,"entities":"products","field":"photo"}})],1),_vm._v(" "),_c('div',{staticClass:"contain"},[_c('div',{staticClass:"name"},[_c('h2',[_vm._v(_vm._s(_vm.data.label))])]),_vm._v(" "),(_vm.data.supplier)?_c('div',{staticClass:"name"},[_c('h3',[_vm._v(_vm._s(_vm.data.supplier.name))])]):_vm._e(),_vm._v(" "),(_vm.data.version)?_c('div',[_vm._v("\n\t\t\t\t\t\tV"+_vm._s(_vm.data.version)+"\n\t\t\t\t\t ")]):_vm._e(),_vm._v(" "),(_vm.data.category)?_c('div',[_vm._v("\n\t\t\t\t\t\t "+_vm._s(_vm.data.category.parent.parent.label)+"\n\t\t\t\t\t ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"numbers"},[_c('div',{on:{"click":function($event){$event.stopPropagation();_vm.$router.push({ name: 'product-comments' })}}},[_c('span',[_vm._v(_vm._s(_vm.data.comments_count))]),_vm._v(" "+_vm._s(_vm._f("pluralize")(_vm.data.comments_count,'Commentaire'))+"\n\t\t\t\t\t\t ")]),_vm._v(" "),_c('div',{on:{"click":function($event){$event.stopPropagation();_vm.$router.push({ name: 'product-files' })}}},[_c('span',[_vm._v(_vm._s(_vm.data.files_count))]),_vm._v(" "+_vm._s(_vm._f("pluralize")(_vm.data.files_count,'Fichier'))+"\n\t\t\t\t\t\t ")])]),_vm._v(" "),_c('div',{staticClass:"about"},[_c('div',{staticClass:"field mb-1",attrs:{"data-group":"0"}},[_c('div',{staticClass:"label"},[_vm._v("Type")]),_vm._v(" "),(_vm.data.type)?_c('div',{staticClass:"value"},[_vm._v("\n\t\t\t\t\t\t\t\t Produit "+_vm._s(_vm.$_.find(_vm.ProductTypes, function (p) { return p.value == _vm.data.type; }).label)+"\n\t\t\t\t\t\t\t ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"field mb-1",attrs:{"data-group":"0"}},[_c('div',{staticClass:"label"},[_vm._v("Projet")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.data.project)?_c('router-link',{attrs:{"to":{ name : 'single-project', params: {id: _vm.data.project.id }}}},[_vm._v(_vm._s(_vm.data.project.label))]):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"edit",attrs:{"icon":"","small":"","disabled":_vm.$store.state.auth.user.level < 60},on:{"click":function($event){_vm.$eventHub.$emit('open-modal', _vm.UpdateProject)}}},[_c('v-icon',[_vm._v("mode_edit")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"field mb-1",attrs:{"data-group":"0"}},[_c('div',{staticClass:"label"},[_vm._v("Fournisseur")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.data.supplier)?[_vm._v(_vm._s(_vm.data.supplier.name))]:_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"edit",attrs:{"icon":"","small":"","disabled":_vm.$store.state.auth.user.level < 60},on:{"click":function($event){_vm.$eventHub.$emit('open-modal', _vm.UpdateSupplier)}}},[_c('v-icon',[_vm._v("mode_edit")])],1)],2)]),_vm._v(" "),_c('div',{staticClass:"field mb-1",attrs:{"data-group":"0"}},[_c('div',{staticClass:"label"},[_vm._v("Famille")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("\n \t\t\t\t\t\t\t\t"+_vm._s(_vm.getParentCategory)+"\n \t\t\t\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"field mb-1",attrs:{"data-group":"0"}},[_c('div',{staticClass:"label"},[_vm._v("Sous famille")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("\n \t\t\t\t\t\t\t\t"+_vm._s(_vm.getCategory)+"\n \t\t\t\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"field mb-1",attrs:{"data-group":"0"}},[_c('div',{staticClass:"label"},[_vm._v("Code article")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('single-field',{ref:"code",attrs:{"model":_vm.data.code,"type":"text","hide_eye":true,"readonly":true},on:{"validate":function($event){_vm.updateField('code', $event)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"field mb-1",attrs:{"data-group":"0"}},[_c('div',{staticClass:"label"},[_vm._v("Code ean")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('single-field',{ref:"code",attrs:{"model":_vm.data.ean,"type":"text","readonly":true,"hide_eye":true},on:{"validate":function($event){_vm.updateField('ean', $event)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"field mb-1",attrs:{"data-group":"0"}},[_c('div',{staticClass:"label"},[_vm._v("Date de modif.")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(_vm.moment(_vm.data.updated_at).format('DD/MM/YYYY'))+"\n\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"field mb-1",attrs:{"data-group":"0"}},[_c('div',{staticClass:"label"},[_vm._v("Date de créa.")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(_vm.moment(_vm.data.created_at).format('DD/MM/YYYY'))+"\n\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"field mb-1",attrs:{"data-group":"0"}},[_c('div',{staticClass:"label"},[_vm._v("Lien externe")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('single-field',{ref:"external_link",attrs:{"model":_vm.data.external_link,"type":"link","hide_eye":true},on:{"validate":function($event){_vm.updateField('external_link', $event)}}})],1)]),_vm._v(" "),_c('div',{staticClass:"field mb-1",attrs:{"data-group":"0"}},[_c('div',{staticClass:"label"},[_vm._v("Gestionnaire")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.data.user)?[_c('avatar',{attrs:{"item":_vm.data.user,"size":"4rem"}}),_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.data.user ? _vm.data.user.first_name : '')+" "+_vm._s(_vm.data.user ? _vm.data.user.last_name :'')+"\n\t\t\t\t\t\t\t\t")]:_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"edit",attrs:{"icon":"","small":"","disabled":_vm.$store.state.auth.user.level < 60},on:{"click":function($event){_vm.$eventHub.$emit('open-modal', _vm.UpdateManager)}}},[_c('v-icon',[_vm._v("mode_edit")])],1)],2)])])])]),_vm._v(" "),_c('div',{staticClass:"tab"},[_c('v-tabs',{attrs:{"slider-color":"primary","show-arrows":true}},[_c('v-tab',{attrs:{"ripple":"","to":{ name: 'product-data-sheet'}}},[_vm._v("Fiche technique")]),_vm._v(" "),_c('v-tab',{attrs:{"ripple":"","to":{ name: 'product-files' }}},[_vm._v(_vm._s(_vm._f("pluralize")(_vm.data.files_count,'Fichier'))+" ("+_vm._s(_vm.data.files_count)+")")]),_vm._v(" "),_c('v-tab',{attrs:{"ripple":"","to":{ name: 'product-comments' }}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm._f("pluralize")(_vm.data.comments_count,'Commentaire'))+"\n\t\t\t\t\t\t\t("+_vm._s(_vm.data.comments_count)+")\n\t\t\t\t\t\t")]),_vm._v(" "),(_vm.data.type == 'sidamo')?_c('v-tab',{attrs:{"ripple":"","to":{ name: 'product-requests' }}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm._f("pluralize")(_vm.data.requests_count,'Demande'))+"\n\t\t\t\t\t\t\t("+_vm._s(_vm.data.requests_count)+")\n\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(_vm.data.type == 'sidamo')?_c('v-tab',{attrs:{"ripple":"","to":{ name: 'product-tests' }}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm._f("pluralize")(_vm.data.tests_count,'Contrôle'))+"\n\t\t\t\t\t\t\t("+_vm._s(_vm.data.tests_count)+")\n\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(_vm.data.type == 'sidamo')?_c('v-tab',{attrs:{"ripple":"","to":{ name: 'product-components' }}},[_vm._v("Pièces détachées")]):_vm._e(),_vm._v(" "),(_vm.data.type == 'sidamo')?_c('v-tab',{attrs:{"ripple":"","to":{ name: 'product-accessories' }}},[_vm._v("Accessoires")]):_vm._e(),_vm._v(" "),(_vm.data.type == 'sidamo')?_c('v-tab',{attrs:{"ripple":"","to":{ name: 'product-consumables' }}},[_vm._v("Consommables")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"router_view"},[_c('router-view')],1)],1)]):_vm._e()],1)}
var Single_staticRenderFns = []
var Single_esExports = { render: Single_render, staticRenderFns: Single_staticRenderFns }
/* harmony default export */ var single_Single = (Single_esExports);
// CONCATENATED MODULE: ./src/views/products/single/Single.vue
function Single_injectStyle (ssrContext) {
  __webpack_require__("VsOG")
}
var Single_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Single___vue_template_functional__ = false
/* styles */
var Single___vue_styles__ = Single_injectStyle
/* scopeId */
var Single___vue_scopeId__ = "data-v-4cad97db"
/* moduleIdentifier (server only) */
var Single___vue_module_identifier__ = null
var Single_Component = Single_normalizeComponent(
  Single,
  single_Single,
  Single___vue_template_functional__,
  Single___vue_styles__,
  Single___vue_scopeId__,
  Single___vue_module_identifier__
)

/* harmony default export */ var products_single_Single = __webpack_exports__["default"] = (Single_Component.exports);


/***/ }),

/***/ "lDmc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lEMC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lH7U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mdcO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductTypes; });
var ProductTypes = [{ label: 'Sidamo', value: 'sidamo' }, { label: 'Fournisseur', value: 'supplier' }, { label: 'Concurrent', value: 'competitor' }];

/***/ }),

/***/ "mjAP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "msiX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/DataTable.vue + 2 modules
var DataTable = __webpack_require__("/WHI");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/admin/users/list/Create.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Create = ({
    props: {
        params: {
            required: false
        }
    },

    data: function data() {
        return {
            title: 'Ajouter un utilisateur',
            icon: 'mdi-account-settings-variant',

            isValid: false,

            model: {
                first_name: '',
                last_name: '',
                email: '',
                password: '',
                role_id: ''
            },

            rules: {
                first_name: [function (v) {
                    return !!v || 'Prénom obligatoire';
                }],
                last_name: [function (v) {
                    return !!v || 'Nom obligatoire';
                }],
                email: [function (v) {
                    return !!v || 'Email obligatoire';
                }, function (v) {
                    return (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Adresse email non valide'
                    );
                }],
                password: [function (v) {
                    return !!v || 'Mot de passe obligatoire';
                }],
                role_id: [function (v) {
                    return !!v || 'Rôle obligatoire';
                }]
            },

            roles: []
        };
    },


    methods: {
        onClose: function onClose() {
            this.$eventHub.$emit('close-modal');
        },
        onValidate: function onValidate() {
            var _this = this;

            if (this.$refs.form.validate()) {
                if (this.params.user) {
                    this.axios.put('/api/users/' + this.params.user.id, this.model).then(function (response) {
                        _this.$eventHub.$emit('close-modal');
                        _this.$eventHub.$emit('reload-list');
                    }).catch(function (err) {
                        return console.log(err.response.data);
                    });
                } else {
                    this.axios.post('/api/users', this.model).then(function (response) {
                        _this.$eventHub.$emit('close-modal');
                        _this.$eventHub.$emit('reload-list');
                    }).catch(function (err) {
                        return console.log(err.response.data);
                    });
                }
            } else {
                return false;
            }
        }
    },

    created: function created() {
        var _this2 = this;

        if (this.params.user) {
            this.model.first_name = this.params.user.first_name;
            this.model.last_name = this.params.user.last_name;
            this.model.email = this.params.user.email;
            this.model.role_id = this.params.user.role_id;
        }

        this.axios.get('/api/roles').then(function (res) {
            return _this2.roles = res.data;
        }).catch(function (err) {
            return console.log(err.response.data);
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b784c82","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/users/list/Create.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form",model:{value:(_vm.isValid),callback:function ($$v) {_vm.isValid=$$v},expression:"isValid"}},[_c('v-container',{attrs:{"grid-list-xs":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Prénom","rules":_vm.rules.first_name,"required":""},model:{value:(_vm.model.first_name),callback:function ($$v) {_vm.$set(_vm.model, "first_name", $$v)},expression:"model.first_name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Nom","rules":_vm.rules.last_name,"required":""},model:{value:(_vm.model.last_name),callback:function ($$v) {_vm.$set(_vm.model, "last_name", $$v)},expression:"model.last_name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Email","rules":_vm.rules.email,"required":""},model:{value:(_vm.model.email),callback:function ($$v) {_vm.$set(_vm.model, "email", $$v)},expression:"model.email"}})],1),_vm._v(" "),(!_vm.params.user)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Mot de passe","type":"password","rules":_vm.rules.password,"required":""},model:{value:(_vm.model.password),callback:function ($$v) {_vm.$set(_vm.model, "password", $$v)},expression:"model.password"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"rules":_vm.rules.role_id,"label":"Rôle","items":_vm.roles,"item-text":"label","item-value":"id","clearable":"","dense":"","required":""},model:{value:(_vm.model.role_id),callback:function ($$v) {_vm.$set(_vm.model, "role_id", $$v)},expression:"model.role_id"}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var list_Create = (esExports);
// CONCATENATED MODULE: ./src/views/admin/users/list/Create.vue
function injectStyle (ssrContext) {
  __webpack_require__("yZFr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0b784c82"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Create,
  list_Create,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var users_list_Create = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/admin/users/list/Delete.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Delete = ({
    data: function data() {
        return {
            title: 'Suppression d\'utilisateurs',
            icon: 'delete',
            warning: true,
            undeletable: []
        };
    },


    methods: {
        onClose: function onClose() {
            this.$eventHub.$emit('close-modal');
        },
        onValidate: function onValidate() {
            var _this = this;

            this.$store.state.datatable.users.selected.forEach(function (item, index) {
                _this.axios.delete('/api/users/' + item.id).then(function (response) {
                    _this.$eventHub.$emit('close-modal');
                    _this.$eventHub.$emit('reload-list');
                }).catch(function (err) {
                    return console.log(err.response.data);
                });
            });
        }
    },

    created: function created() {
        var _this2 = this;

        var ids = '';
        this.$store.state.datatable.users.selected.forEach(function (item, index) {
            ids += index > 0 ? ';' : '';
            ids += item.id;
        });

        this.axios.get('/api/users?filters=id|in|' + ids + '&embed=carts,orders,contacts').then(function (response) {
            response.data.forEach(function (item, index) {
                var u = { id: item.id, first_name: item.first_name, last_name: item.last_name, counts: [] };

                if (item.carts_count) {
                    u.counts.push({ label: 'paniers', 'count': item.carts_count });
                }

                if (item.orders_count) {
                    u.counts.push({ label: 'commandes', 'count': item.orders_count });
                }

                if (item.contacts_count) {
                    u.counts.push({ label: 'contacts', 'count': item.contacts_count });
                }

                if (u.counts.length) {
                    _this2.undeletable.push(u);
                    _this2.$eventHub.$emit('hide-modal-actions');
                }
            });
        }).catch(function (error) {
            console.log(error.response.data);
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d30e075e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/users/list/Delete.vue
var Delete_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.undeletable.length)?[_c('p',[_vm._v("Vous devez supprimer les entités liées à ces utilisateurs avant des pouvoir les supprimer :")]),_vm._v(" "),_c('ul',_vm._l((_vm.undeletable),function(user){return _c('li',[_c('strong',[_vm._v(_vm._s(user.first_name)+" "+_vm._s(user.last_name))]),_vm._v(" :\n\n                "),_vm._l((user.counts),function(entity,index){return [(index > 0)?[_vm._v(", ")]:_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(entity.count)+" "+_vm._s(entity.label))])]})],2)}))]:[_c('p',[_vm._v("Êtes-vous sûr de vouloir supprimer les utilisateurs suivants :")]),_vm._v(" "),_c('ul',_vm._l((_vm.$store.state.datatable.users.selected),function(user){return _c('li',[_vm._v("\n                "+_vm._s(user.first_name)+" "+_vm._s(user.last_name)+"\n            ")])}))]],2)}
var Delete_staticRenderFns = []
var Delete_esExports = { render: Delete_render, staticRenderFns: Delete_staticRenderFns }
/* harmony default export */ var list_Delete = (Delete_esExports);
// CONCATENATED MODULE: ./src/views/admin/users/list/Delete.vue
function Delete_injectStyle (ssrContext) {
  __webpack_require__("85XS")
}
var Delete_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Delete___vue_template_functional__ = false
/* styles */
var Delete___vue_styles__ = Delete_injectStyle
/* scopeId */
var Delete___vue_scopeId__ = "data-v-d30e075e"
/* moduleIdentifier (server only) */
var Delete___vue_module_identifier__ = null
var Delete_Component = Delete_normalizeComponent(
  Delete,
  list_Delete,
  Delete___vue_template_functional__,
  Delete___vue_styles__,
  Delete___vue_scopeId__,
  Delete___vue_module_identifier__
)

/* harmony default export */ var users_list_Delete = (Delete_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/admin/users/list/List.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var List = ({
    components: { DataTable: DataTable["a" /* default */] },

    data: function data() {
        var _this = this;

        return {
            datatable: {
                toolbar: [{ icon: 'delete', callback: function callback() {
                        _this.$eventHub.$emit('open-modal', users_list_Delete);
                    }, level: 60 }],
                actions: [{ text: 'Ajouter un utilisateur', icon: 'add_circle', callback: function callback() {
                        _this.$eventHub.$emit('open-modal', users_list_Create);
                    }, level: 60 }],
                headers: [{ text: 'Prénom', sortable: true, value: 'first_name', align: 'left' }, { text: 'Nom', sortable: true, value: 'last_name' }, { text: 'Email', sortable: true, value: 'email' }, { text: 'Role', sortable: false, value: 'role' }],
                endpoint: {
                    base: '/api/users',
                    embed: 'role'
                }
            }
        };
    },


    methods: {
        rowClick: function rowClick(item) {
            //this.$eventHub.$emit('open-modal', Create, { user: item })
            this.$router.push({ name: 'admin-single-user', params: { id: item.id } });
        }
    },

    created: function created() {
        var _this2 = this;

        this.$eventHub.$on('reload-list', function () {
            _this2.$refs.list.reload();
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44802c5d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/users/list/List.vue
var List_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"price-groups"},[_c('h2',[_vm._v("Utilisateurs")]),_vm._v(" "),_c('data-table',{ref:"list",attrs:{"headers":_vm.datatable.headers,"endpoint":_vm.datatable.endpoint,"toolbar":_vm.datatable.toolbar,"actions":_vm.datatable.actions,"storeId":"users","selectable":""},on:{"rowClick":_vm.rowClick},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.first_name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.last_name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.email))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[(props.item.role)?[_vm._v("\n                    "+_vm._s(props.item.role.label)+"\n                ")]:_vm._e()],2)]}}])})],1)}
var List_staticRenderFns = []
var List_esExports = { render: List_render, staticRenderFns: List_staticRenderFns }
/* harmony default export */ var list_List = (List_esExports);
// CONCATENATED MODULE: ./src/views/admin/users/list/List.vue
function List_injectStyle (ssrContext) {
  __webpack_require__("DT1r")
}
var List_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var List___vue_template_functional__ = false
/* styles */
var List___vue_styles__ = List_injectStyle
/* scopeId */
var List___vue_scopeId__ = "data-v-44802c5d"
/* moduleIdentifier (server only) */
var List___vue_module_identifier__ = null
var List_Component = List_normalizeComponent(
  List,
  list_List,
  List___vue_template_functional__,
  List___vue_styles__,
  List___vue_scopeId__,
  List___vue_module_identifier__
)

/* harmony default export */ var users_list_List = __webpack_exports__["default"] = (List_Component.exports);


/***/ }),

/***/ "n2Fp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/single/MoreActions.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var MoreActions = ({

    props: {
        actions: {
            required: true,
            type: Array
        }
    },

    data: function data() {
        return {};
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63949102","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/single/MoreActions.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"more-actions"},[_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{staticClass:"unfocus",attrs:{"slot":"activator","icon":"","dark":""},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',_vm._l((_vm.actions),function(action,index){return ((action.level && action.level <= _vm.$store.state.auth.user.level) || !action.level)?_c('v-list-tile',{key:index,staticClass:"li",on:{"click":action.callback}},[_c('v-list-tile-title',[_vm._v(_vm._s(action.text))])],1):_vm._e()}))],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var single_MoreActions = (esExports);
// CONCATENATED MODULE: ./src/components/single/MoreActions.vue
function injectStyle (ssrContext) {
  __webpack_require__("udw/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MoreActions,
  single_MoreActions,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_single_MoreActions = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ogdx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "otcH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p91O":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "pYO/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/avatar/Avatar.vue + 3 modules
var Avatar = __webpack_require__("Be47");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/components/files/DeleteLinkedFiles.vue + 2 modules
var DeleteLinkedFiles = __webpack_require__("/38I");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/symbols/list/Create.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Create = ({
    components: {
        Avatar: Avatar["a" /* default */],
        DeleteLinkedFile: DeleteLinkedFiles["a" /* default */]
    },
    data: function data() {
        return {
            moment: moment_default.a,
            nb_column: 1,
            symbol: {
                title: '',
                title_2: null,
                message: '',
                message_2: null,
                files_1: [],
                files_2: [],
                files: []
            },
            files: [],
            fullscreen: true,
            card_text_class: 'fullscreen-modal-text',
            valid_button: false,
            cancel_button: false,
            valid_title: false,
            valid_message: false,
            error_2: false,
            error: false,
            removeCol: false,
            display: true,
            loading: false,
            rules: {
                title: [function (v) {
                    if (v) {
                        if (v.length >= 150) {
                            return 'Le titre ne dois pas contenir plus de 150 caractères';
                        } else {
                            return true;
                        }
                    } else {
                        return 'Titre obligatoire';
                    }
                }],
                title_2: [function (v) {
                    if (v) {
                        if (v.length >= 150) {
                            return 'Le titre ne dois pas contenir plus de 150 caractères';
                        } else {
                            return true;
                        }
                    } else {
                        return true;
                    }
                }]
            }
        };
    },

    computed: {
        user: function user() {
            return this.$store.state.auth.user;
        }
    },
    methods: {
        deleteFile: function deleteFile(entity, item) {
            var index = this.symbol[entity].findIndex(function (el) {
                return el.path === item;
            });
            this.symbol[entity].splice(index, 1);
        },
        onFileChange: function onFileChange(evt, fileArray, fileIndex, col) {
            var array = this.symbol['files_' + fileArray];
            if (fileIndex >= 0) {
                array[fileIndex].path = URL.createObjectURL(evt.target.files[0]);
                array[fileIndex].file = evt.target.files[0];
                array[fileIndex].toUpdate = true;
            } else {
                fileIndex = array.length;
                array.push({
                    path: URL.createObjectURL(evt.target.files[0]),
                    file: evt.target.files[0],
                    toUpdate: true
                });
            }
        },
        deleteCol: function deleteCol() {
            this.symbol.message_2 = null;
            this.symbol.title_2 = null;
            this.removeCol = false;
            this.nb_column = 1;
        },
        addImgPath: function addImgPath() {
            return __webpack_require__("c8ny");
        },
        setColumnNumber: function setColumnNumber(nb_column) {
            if (this.symbol.title_2 != '' && this.symbol.title_2 != null) {
                if (this.nb_column == 2) {
                    this.removeCol = true;
                } else {
                    this.nb_column = nb_column;
                    this.error_2 = false;
                }
            } else if (this.symbol.message_2 != '' && this.symbol.message_2 != null) {
                if (this.nb_column == 2) {
                    this.removeCol = true;
                } else {
                    this.nb_column = nb_column;
                    this.error_2 = false;
                }
            } else {
                this.nb_column = nb_column;
                this.error_2 = false;
            }
        },
        isCol: function isCol(number) {
            if (this.nb_column === number) {
                return true;
            } else {
                return false;
            }
        },

        cancel: function cancel() {
            this.$eventHub.$emit('close-modal');
        },
        onClose: function onClose() {
            this.$eventHub.$emit('close-modal');
        },

        saveElement: function saveElement() {
            var _this = this;

            if (this.valid_title && this.valid_message) {
                if (this.nb_column == 2 && this.symbol.title_2 == null && this.symbol.message_2 == null) {
                    this.error_2 = true;
                } else {
                    this.loading = true;
                    var savePhotoRec = function savePhotoRec(symboleId, arrayId, index, callback) {
                        if (arrayId < 3) {
                            if (index < _this.symbol['files_' + arrayId].length) {
                                var file = _this.symbol['files_' + arrayId][index];
                                var data = new FormData();
                                data.append('file', file.file), data.append('location', 'area-' + arrayId);

                                _this.axios.post('/api/symbols/' + symboleId + '/file', data).then(function (response) {
                                    savePhotoRec(symboleId, arrayId, ++index, callback);
                                });
                            } else {
                                savePhotoRec(symboleId, ++arrayId, 0, callback);
                            }
                        } else {
                            callback();
                        }
                    };
                    this.axios.post('/api/symbols', {
                        label: this.symbol.title,
                        title: this.symbol.title,
                        title_2: this.symbol.title_2,
                        message: this.symbol.message,
                        message_2: this.symbol.message_2,
                        user_id: this.user.id
                    }).then(function (response) {
                        savePhotoRec(response.data.id, 1, 0, function () {
                            _this.$eventHub.$emit('close-modal');
                            _this.$eventHub.$emit('reload-list');
                            _this.loading = false;
                        });
                    });
                }
            } else {
                this.error = true;
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80b56ee6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/symbols/list/Create.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"create-container"},[_c('v-toolbar',{staticClass:"modal-header"},[_c('div',{staticClass:"app-logo"},[_c('img',{attrs:{"src":__webpack_require__("p91O")}})]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.onClose($event)}}},[_c('v-icon',[_vm._v("arrow_back")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Symbole")])],1),_vm._v(" "),_c('v-toolbar',{staticClass:"create-toolbar",attrs:{"flat":""}},[_c('avatar',{staticClass:"create-avatar",attrs:{"item":_vm.user,"size":"5rem"}}),_vm._v(" "),_c('v-layout',{attrs:{"column":"","justify-space-around":"","align-content-space-around":""}},[_c('v-flex',[_c('b',[_vm._v(_vm._s(_vm.user.first_name)+" "+_vm._s(_vm.user.last_name))])]),_vm._v(" "),_c('div',{staticClass:"date"},[_c('pre',{staticClass:"date-line"},[_vm._v("  ")]),_vm._v("Le "+_vm._s(_vm.moment().format('DD/MM/YYYY'))+"\n            ")])],1),_vm._v(" "),_c('v-btn',{attrs:{"round":"","small":"","flat":"","color":'primary'},on:{"click":function($event){_vm.cancel()}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"round":"","depressed":"","small":"","color":'primary',"loading":_vm.loading},on:{"click":function($event){_vm.saveElement()}}},[_vm._v("Enregistrer")])],1),_vm._v(" "),_c('div',{staticClass:"center-content",class:[_vm.nb_column == 2 ? 'doubleCol' : '']},[_c('v-form',{model:{value:(_vm.valid_title),callback:function ($$v) {_vm.valid_title=$$v},expression:"valid_title"}},[_c('v-layout',{staticClass:"title-row",attrs:{"row":""}},[_c('v-flex',{staticClass:"edit-title",attrs:{"xs12":_vm.isCol(1),"sm12":_vm.isCol(2),"md6":_vm.isCol(2)}},[_c('v-text-field',{attrs:{"name":"titre1_text_field","label":"Titre","hint":"Titre de votre commentaire","rules":_vm.rules.title,"error":_vm.error,"persistent-hint":_vm.error},model:{value:(_vm.symbol.title),callback:function ($$v) {_vm.$set(_vm.symbol, "title", $$v)},expression:"symbol.title"}})],1),_vm._v(" "),(_vm.isCol(2))?_c('v-flex',{staticClass:"edit-title",attrs:{"sm12":"","md6":""}},[_c('v-text-field',{attrs:{"name":"titre2_text_field","label":"Titre 2","hint":"Deuxième titre","error":_vm.error_2,"rules":_vm.rules.title_2,"persistent-hint":_vm.error_2},model:{value:(_vm.symbol.title_2),callback:function ($$v) {_vm.$set(_vm.symbol, "title_2", $$v)},expression:"symbol.title_2"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('v-form',{model:{value:(_vm.valid_message),callback:function ($$v) {_vm.valid_message=$$v},expression:"valid_message"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"edit-message",attrs:{"xs12":_vm.isCol(1),"sm12":_vm.isCol(2),"md6":_vm.isCol(2)}},[_c('v-text-field',{attrs:{"name":"message_text_field","label":"Message","hint":"Contenu du message","multi-line":"","error":_vm.error,"persistent-hint":_vm.error},model:{value:(_vm.symbol.message),callback:function ($$v) {_vm.$set(_vm.symbol, "message", $$v)},expression:"symbol.message"}})],1),_vm._v(" "),(_vm.isCol(2))?_c('v-flex',{staticClass:"edit-message",attrs:{"md6":"","sm12":""}},[_c('v-text-field',{attrs:{"name":"message_text_field2","label":"Message 2","multi-line":"","hint":"Contenu du deuxième message","error":_vm.error_2,"persistent-hint":_vm.error_2},model:{value:(_vm.symbol.message_2),callback:function ($$v) {_vm.$set(_vm.symbol, "message_2", $$v)},expression:"symbol.message_2"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-layout',{attrs:{"xs12":_vm.isCol(1),"sm12":_vm.isCol(2),"md6":_vm.isCol(2)}},[_vm._l((_vm.symbol.files_1),function(file,index){return _c('v-flex',{key:file.id},[_c('v-menu',{attrs:{"offset-y":"","content-class":"files"}},[_c('div',{attrs:{"slot":"activator"},slot:"activator"},[_c('label',{staticClass:"comment-image"},[_c('v-icon',{staticClass:"hover-alpha"},[_vm._v("mode_edit")]),_vm._v(" "),_c('img',{attrs:{"src":file.path}})],1)]),_vm._v(" "),_c('v-list',[_c('v-list-tile',{staticClass:"li"},[_c('label',{attrs:{"for":'file1-'+index}},[_vm._v("Modifier l'image")]),_vm._v(" "),_c('input',{staticClass:"input-img",staticStyle:{"display":"none"},attrs:{"id":'file1-'+index,"type":"file"},on:{"change":function (event){_vm.onFileChange(event,1,index)}}})]),_vm._v(" "),_c('v-list-tile',{staticClass:"li",on:{"click":function($event){_vm.$refs.deletefile.open('symbols',file,'files_1')}}},[_c('v-list-tile-title',[_vm._v("Supprimer l'image")])],1)],1)],1)],1)}),_vm._v(" "),(_vm.symbol.files_1.length < 2)?_c('v-flex',[_c('v-menu',{attrs:{"offset-y":"","content-class":"files"}},[_c('div',{attrs:{"slot":"activator"},slot:"activator"},[_c('label',{staticClass:"comment-image"},[_c('img',{staticClass:"add-img",attrs:{"src":_vm.addImgPath()}})])]),_vm._v(" "),_c('v-list',[_c('v-list-tile',[_c('label',{attrs:{"for":'file1-input'}},[_vm._v("Ajouter une image")]),_vm._v(" "),_c('input',{staticClass:"input-img",staticStyle:{"display":"none"},attrs:{"id":"file1-input","type":"file"},on:{"change":function (event){_vm.onFileChange(event,1)}}})])],1)],1)],1):_vm._e()],2),_vm._v(" "),(_vm.isCol(2))?_c('v-layout',{attrs:{"sm12":"","md6":""}},[_vm._l((_vm.symbol.files_2),function(file,index){return _c('v-flex',{key:file.id},[_c('v-menu',{attrs:{"offset-y":"","content-class":"files"}},[_c('div',{attrs:{"slot":"activator"},slot:"activator"},[_c('label',{staticClass:"comment-image"},[_c('v-icon',{staticClass:"hover-alpha"},[_vm._v("mode_edit")]),_vm._v(" "),_c('img',{attrs:{"src":file.path}})],1)]),_vm._v(" "),_c('v-list',[_c('v-list-tile',[_c('label',{attrs:{"for":'file2-'+index}},[_vm._v("Modifier l'image")]),_vm._v(" "),_c('input',{staticClass:"input-img",staticStyle:{"display":"none"},attrs:{"id":'file2-'+index,"type":"file"},on:{"change":function (event){_vm.onFileChange(event,2,index)}}})]),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.$refs.deletefile.open('symbols',file,'files_2')}}},[_c('v-list-tile-title',[_vm._v("Supprimer l'image")])],1)],1)],1)],1)}),_vm._v(" "),(_vm.isCol(2) && _vm.symbol.files_2.length < 2)?_c('v-flex',[_c('v-menu',{attrs:{"offset-y":"","content-class":"files"}},[_c('div',{attrs:{"slot":"activator"},slot:"activator"},[_c('label',{staticClass:"comment-image"},[_c('img',{staticClass:"add-img",attrs:{"src":_vm.addImgPath()}})])]),_vm._v(" "),_c('v-list',[_c('v-list-tile',[_c('label',{attrs:{"for":'file2-input'}},[_vm._v("Ajouter une image")]),_vm._v(" "),_c('input',{staticClass:"input-img",staticStyle:{"display":"none"},attrs:{"id":"file2-input","type":"file"},on:{"change":function (event){_vm.onFileChange(event,2)}}})])],1)],1)],1):_vm._e()],2):_vm._e()],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"column-display-choice"},[_c('div',{staticClass:"col-choice-title"},[_vm._v("\n            Affichage :\n        ")]),_vm._v(" "),_c('div',{staticClass:"column-display-buttons"},[_c('div',[_c('div',{staticClass:"image-and-overlay-left",on:{"click":function($event){_vm.setColumnNumber(1)}}},[_c('img',{staticClass:"col-chose-image",attrs:{"src":__webpack_require__("NdJc")}}),_vm._v(" "),(_vm.nb_column===1)?_c('div',{staticClass:"col-choice-overlay"}):_vm._e()])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"image-and-overlay-right",on:{"click":function($event){_vm.setColumnNumber(2)}}},[_c('img',{staticClass:"col-chose-image",attrs:{"src":__webpack_require__("08vo")}}),_vm._v(" "),(_vm.nb_column===2)?_c('div',{staticClass:"col-choice-overlay"}):_vm._e()])])])]),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"750px"},model:{value:(_vm.removeCol),callback:function ($$v) {_vm.removeCol=$$v},expression:"removeCol"}},[_c('v-card',[_c('v-card-title',{staticClass:"warning"},[_c('h2',[_c('v-icon',{staticClass:"mr-2",attrs:{"dark":""}},[_vm._v("warning")]),_vm._v(" "),_c('span',{staticClass:"white--text"},[_vm._v("Attention")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","icon":""},on:{"click":function($event){_vm.removeCol = false}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_vm._v("\n                Voulez vous vraiment supprimer la deuxième colonne ?\n            ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"round":"","small":"","outline":"","color":"warning"},nativeOn:{"click":function($event){_vm.removeCol = false;}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"round":"","depressed":"","small":"","color":"warning"},nativeOn:{"click":function($event){_vm.deleteCol()}}},[_vm._v("Valider")])],1)],1)],1),_vm._v(" "),_c('delete-linked-file',{ref:"deletefile",on:{"deleted":function (entity_id,item_id) { _vm.deleteFile(entity_id,item_id) }}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var list_Create = (esExports);
// CONCATENATED MODULE: ./src/views/symbols/list/Create.vue
function injectStyle (ssrContext) {
  __webpack_require__("PEpY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-80b56ee6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Create,
  list_Create,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var symbols_list_Create = (Component.exports);

// EXTERNAL MODULE: ./src/views/symbols/list/Single.vue + 5 modules
var Single = __webpack_require__("3BMk");

// EXTERNAL MODULE: ./src/components/DataTable.vue + 2 modules
var DataTable = __webpack_require__("/WHI");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/symbols/list/List.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




moment_default.a.locale('fr');



/* harmony default export */ var List = ({
	components: { DataTable: DataTable["a" /* default */], Avatar: Avatar["a" /* default */] },

	props: {
		filter: {
			required: false
		}
	},

	data: function data() {
		var _this = this;

		return {
			moment: moment_default.a,
			datatable: {
				actions: [{
					text: 'Ajouter un nouveau symbole', icon: 'add_circle', callback: function callback() {
						_this.$eventHub.$emit('open-modal', symbols_list_Create);
					}, level: 60
				}],
				views: [{ text: 'Tous les symboles', link: 'list-symbols' }],
				headers: [{ text: 'Nom du symbole', sortable: true, value: 'label', align: 'left', width: '40%' }, { text: 'Dernière modification', sortable: true, value: 'updated_at', align: 'left' }, { text: 'Nombre de produits liés', sortable: true, value: 'label', align: 'center' }],
				endpoint: {
					base: '/api/symbols',
					filters: this.setFilters,
					embed: 'user,requests,products,linked_products'
				}
			}
		};
	},


	methods: {
		rowClick: function rowClick(item) {
			this.$eventHub.$emit('open-modal', Single["a" /* default */], { id: item.id });
		}
	},
	created: function created() {
		var _this2 = this;

		this.$eventHub.$on('reload-list', function () {
			if (_this2.$refs.list) {
				_this2.$refs.list.reload();
			}
		});
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a3d29e2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/symbols/list/List.vue
var List_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-table',{ref:"list",attrs:{"headers":_vm.datatable.headers,"endpoint":_vm.datatable.endpoint,"actions":_vm.datatable.actions,"views":_vm.datatable.views,"storeId":"symbols"},on:{"rowClick":_vm.rowClick},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v("\n            "+_vm._s(props.item.label)+"\n        ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-left last-modif"},[_c('avatar',{attrs:{"item":props.item.user,"size":"4rem"}}),_vm._v(" "),_c('span',{staticClass:"highlight-name"},[_vm._v(_vm._s(props.item.user.first_name)+" "+_vm._s(props.item.user.last_name))]),_vm._v(" le "+_vm._s(_vm.moment(props.item.updated_at).format('DD/MM/YYYY'))+"\n        ")],1),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v("\n            "+_vm._s(props.item.requests.length)+"\n        ")])]}}])})}
var List_staticRenderFns = []
var List_esExports = { render: List_render, staticRenderFns: List_staticRenderFns }
/* harmony default export */ var list_List = (List_esExports);
// CONCATENATED MODULE: ./src/views/symbols/list/List.vue
function List_injectStyle (ssrContext) {
  __webpack_require__("XyO0")
}
var List_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var List___vue_template_functional__ = false
/* styles */
var List___vue_styles__ = List_injectStyle
/* scopeId */
var List___vue_scopeId__ = "data-v-4a3d29e2"
/* moduleIdentifier (server only) */
var List___vue_module_identifier__ = null
var List_Component = List_normalizeComponent(
  List,
  list_List,
  List___vue_template_functional__,
  List___vue_styles__,
  List___vue_scopeId__,
  List___vue_module_identifier__
)

/* harmony default export */ var symbols_list_List = __webpack_exports__["default"] = (List_Component.exports);


/***/ }),

/***/ "q36h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qOfq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qXE/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qdWo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qqvJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/DataTable.vue + 2 modules
var DataTable = __webpack_require__("/WHI");

// EXTERNAL MODULE: ./src/views/products/single/CreateComment.vue + 8 modules
var CreateComment = __webpack_require__("dgM2");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/config/enum/CommentTypes.js
var CommentTypes = __webpack_require__("22+B");

// EXTERNAL MODULE: ./src/components/avatar/Avatar.vue + 3 modules
var Avatar = __webpack_require__("Be47");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/products/single/LoadPDFComments.vue
//
//
//
//
//
//
//
//
//
//
//
//
//


moment_default.a.locale('fr');
/* harmony default export */ var LoadPDFComments = ({
    data: function data() {
        return {
            title: 'Création d\'une fiche commentaires',
            icon: 'sync',
            moment: moment_default.a
        };
    },


    methods: {
        onClose: function onClose() {
            this.$eventHub.$emit('close-modal');
        },
        onValidate: function onValidate() {
            this.onClose();
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.$eventHub.$emit('hide-modal-actions');

        var downloadLink = document.createElement('A');
        this.axios.get('/api/generate-pdf-comments/' + this.$route.params.id, {
            responseType: 'blob'
        }).then(function (response) {
            _this.onClose();
            var data = window.URL.createObjectURL(response.data);

            downloadLink.href = data;
            downloadLink.download = "Commentaires.pdf";
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-468b714d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/single/LoadPDFComments.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[[_vm._m(0)]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('img',{attrs:{"src":__webpack_require__("bwqQ")}}),_vm._v(" "),_c('p',[_vm._v("Génération du PDF en cours")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var single_LoadPDFComments = (esExports);
// CONCATENATED MODULE: ./src/views/products/single/LoadPDFComments.vue
function injectStyle (ssrContext) {
  __webpack_require__("s99n")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-468b714d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  LoadPDFComments,
  single_LoadPDFComments,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var products_single_LoadPDFComments = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/products/single/Comments.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var Comments = ({
	components: { DataTable: DataTable["a" /* default */], Avatar: Avatar["a" /* default */] },

	data: function data() {
		var _this = this;

		return {
			moment: moment_default.a,
			LoadPDFComments: products_single_LoadPDFComments,
			datatable: {
				actions: [{ text: 'Ajouter un commentaire', icon: 'add_circle', callback: function callback() {
						_this.$eventHub.$emit('open-modal', CreateComment["a" /* default */], {
							product_id: _this.$store.state.single.data.id,
							product_label: _this.$store.state.single.data.label,
							element_type: 'comment',
							create_query: true,
							hide_demand: _this.hide_demand
						});
					} }, { text: 'Exporter le pdf', icon: 'import_export', callback: function callback() {
						return _this.$eventHub.$emit('open-modal', products_single_LoadPDFComments);
					} }],
				headers: [{ text: 'Message', sortable: false, align: 'left' }, { text: 'Tonalite', sortable: false, value: 'type', align: 'right' }, { text: 'Date', sortable: false, value: 'created_at', align: 'right' }, { text: 'Auteur', sortable: false, value: 'user_id', align: 'right' }],
				endpoint: {
					base: '/api/comments',
					filters: 'product_id|=|' + this.$route.params.id,
					embed: 'user',
					sortBy: 'position',
					cDescending: true
				}
			},
			hide_demand: false
		};
	},

	methods: {
		rowClick: function rowClick(item) {
			this.$eventHub.$emit('open-modal', CreateComment["a" /* default */], {
				product_id: this.$store.state.single.data.id,
				product_label: this.$store.state.single.data.label,
				id: item.id,
				element_type: 'comment',
				hide_demand: this.hide_demand
			});
		},

		getCommentColor: function getCommentColor(type) {
			var commentType = CommentTypes["a" /* CommentTypes */].find(function (el) {
				return el.value === type;
			});
			return commentType ? commentType.color : '';
		}
	},
	created: function created() {
		var _this2 = this;

		this.$eventHub.$on('reload-list', function () {
			if (_this2.$refs.list) {
				_this2.$refs.list.reload();
			}
		});
	},
	mounted: function mounted() {
		if (this.$store.state.single.data.type == 'supplier') {
			this.hide_demand = true;
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35f0e38c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/single/Comments.vue
var Comments_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-table',{ref:"list",attrs:{"headers":_vm.datatable.headers,"toolbar":_vm.datatable.toolbar,"actions":_vm.datatable.actions,"endpoint":_vm.datatable.endpoint,"storeId":"comments"},on:{"rowClick":_vm.rowClick},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_vm._v("\n            "+_vm._s(props.item.title)+"\n        ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('v-icon',{style:({color: _vm.getCommentColor(props.item.type)})},[_vm._v("fiber_manual_record")])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n            "+_vm._s(_vm.moment(props.item.created_at).format('DD/MM/YYYY'))+"\n        ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('avatar',{attrs:{"item":props.item.user,"tooltip":true}})],1)]}}])})}
var Comments_staticRenderFns = []
var Comments_esExports = { render: Comments_render, staticRenderFns: Comments_staticRenderFns }
/* harmony default export */ var single_Comments = (Comments_esExports);
// CONCATENATED MODULE: ./src/views/products/single/Comments.vue
function Comments_injectStyle (ssrContext) {
  __webpack_require__("rKcT")
}
var Comments_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Comments___vue_template_functional__ = false
/* styles */
var Comments___vue_styles__ = Comments_injectStyle
/* scopeId */
var Comments___vue_scopeId__ = "data-v-35f0e38c"
/* moduleIdentifier (server only) */
var Comments___vue_module_identifier__ = null
var Comments_Component = Comments_normalizeComponent(
  Comments,
  single_Comments,
  Comments___vue_template_functional__,
  Comments___vue_styles__,
  Comments___vue_scopeId__,
  Comments___vue_module_identifier__
)

/* harmony default export */ var products_single_Comments = __webpack_exports__["default"] = (Comments_Component.exports);


/***/ }),

/***/ "rKcT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "reDO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/layouts/app/Content.vue + 2 modules
var Content = __webpack_require__("j0mG");

// EXTERNAL MODULE: ./src/layouts/app/Header.vue + 11 modules
var Header = __webpack_require__("O/Lb");

// EXTERNAL MODULE: ./src/config/enum/Groups.js
var Groups = __webpack_require__("Lf0E");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/layouts/app/Nav.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Nav = ({
    computed: {
        groups: function groups() {
            return Groups["a" /* Groups */];
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0220e10f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/app/Nav.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"app-nav"},[_vm._m(0),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'projects' }}},[_c('v-icon',[_vm._v("folder")])],1),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'products-group' ,params:{group:_vm.groups[0].label} }}},[_c('i',{staticClass:"icon consumable"})]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'products-group' ,params:{group:_vm.groups[1].label} }}},[_c('i',{staticClass:"icon equipment"})]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'products-group' ,params:{group:_vm.groups[2].label} }}},[_c('i',{staticClass:"icon accessory"})]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'list-symbols' }}},[_c('i',{staticClass:"icon symbol"})]),_vm._v(" "),_c('p',{staticClass:"version"},[_vm._v("V1")])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-logo"},[_c('img',{attrs:{"src":__webpack_require__("t/EI")}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var app_Nav = (esExports);
// CONCATENATED MODULE: ./src/layouts/app/Nav.vue
function injectStyle (ssrContext) {
  __webpack_require__("WzoL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0220e10f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Nav,
  app_Nav,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var layouts_app_Nav = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/layouts/app/Aside.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Aside = ({
    data: function data() {
        return {
            isOpen: false,
            currentView: null,
            params: null
        };
    },
    created: function created() {
        var _this = this;

        // when called, we open the aisde, and fill the content of this one with the component given
        this.$eventHub.$on('open-aside', function (component, params) {
            if (_this.isOpen && _this.currentView == component) {
                _this.isOpen = false;
            } else {
                _this.isOpen = true;
                _this.currentView = component;
                _this.params = params;
            }
        });

        this.$eventHub.$on('close-aside', function () {
            _this.currentView = null;
            _this.params = null;
            _this.isOpen = false;
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7d84f4c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/app/Aside.vue
var Aside_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{staticClass:"app-aside",attrs:{"fixed":"","right":"","light":"","hide-overlay":"","touchless":"","stateless":"","permanent":_vm.isOpen},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[(_vm.currentView != null)?[_c('v-list',{staticClass:"head"},[_c('v-list-tile',{staticClass:"li"},[_c('v-list-tile-title',[(_vm.currentView.data().icon)?_c('v-icon',[_vm._v(_vm._s(_vm.currentView.data().icon))]):_vm._e(),_vm._v("\n                    "+_vm._s(_vm.currentView.data().title)+"\n                ")],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();_vm.$eventHub.$emit('close-aside')}}},[_c('v-icon',[_vm._v("close")])],1)],1)],1),_vm._v(" "),_c(_vm.currentView,{ref:"currentView",tag:"component",attrs:{"params":_vm.params}})]:_vm._e()],2)}
var Aside_staticRenderFns = []
var Aside_esExports = { render: Aside_render, staticRenderFns: Aside_staticRenderFns }
/* harmony default export */ var app_Aside = (Aside_esExports);
// CONCATENATED MODULE: ./src/layouts/app/Aside.vue
function Aside_injectStyle (ssrContext) {
  __webpack_require__("GIJl")
}
var Aside_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Aside___vue_template_functional__ = false
/* styles */
var Aside___vue_styles__ = Aside_injectStyle
/* scopeId */
var Aside___vue_scopeId__ = "data-v-b7d84f4c"
/* moduleIdentifier (server only) */
var Aside___vue_module_identifier__ = null
var Aside_Component = Aside_normalizeComponent(
  Aside,
  app_Aside,
  Aside___vue_template_functional__,
  Aside___vue_styles__,
  Aside___vue_scopeId__,
  Aside___vue_module_identifier__
)

/* harmony default export */ var layouts_app_Aside = (Aside_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/layouts/app/Snackbar.vue
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Snackbar = ({
    data: function data() {
        return {
            snackbar: false,
            snackText: '',
            snackColor: '',
            timeout: 2000
        };
    },
    created: function created() {
        var _this = this;

        this.$eventHub.$on('open-snackbar', function (color, text, timeout) {
            _this.snackbar = true;
            _this.snackColor = color;
            _this.snackText = text;
            if (timeout) {
                timeout == ' ' ? _this.timeout = null : _this.timeout = timeout;
            } else {
                _this.timeout = 2000;
            }
        });
        this.$eventHub.$on('close-snackbar', function () {
            if (_this.snackbar == true) {
                _this.snackbar = false;
            }
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09b47d78","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/app/Snackbar.vue
var Snackbar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{attrs:{"timeout":_vm.timeout,"color":_vm.snackColor},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.snackText)+"\n    "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_vm._v("Close")])],1)}
var Snackbar_staticRenderFns = []
var Snackbar_esExports = { render: Snackbar_render, staticRenderFns: Snackbar_staticRenderFns }
/* harmony default export */ var app_Snackbar = (Snackbar_esExports);
// CONCATENATED MODULE: ./src/layouts/app/Snackbar.vue
function Snackbar_injectStyle (ssrContext) {
  __webpack_require__("XUjY")
}
var Snackbar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Snackbar___vue_template_functional__ = false
/* styles */
var Snackbar___vue_styles__ = Snackbar_injectStyle
/* scopeId */
var Snackbar___vue_scopeId__ = "data-v-09b47d78"
/* moduleIdentifier (server only) */
var Snackbar___vue_module_identifier__ = null
var Snackbar_Component = Snackbar_normalizeComponent(
  Snackbar,
  app_Snackbar,
  Snackbar___vue_template_functional__,
  Snackbar___vue_styles__,
  Snackbar___vue_scopeId__,
  Snackbar___vue_module_identifier__
)

/* harmony default export */ var layouts_app_Snackbar = (Snackbar_Component.exports);

// EXTERNAL MODULE: ./src/layouts/app/Modal.vue + 2 modules
var Modal = __webpack_require__("w+IP");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/layouts/app/Modal2.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Modal2 = ({
    data: function data() {
        return {
            isOpen: false,
            currentView: null,
            more_action: null,
            params: {},
            title: null,
            icon: null,
            width: null,
            warning: false,
            loading: false,
            actions: true,
            next_button: false,
            valid_button: true,
            valid_label: "Valider",
            cancel_label: "Annuler",
            cancel_button: true,
            fullscreen: false,
            card_text_class: ''
        };
    },


    methods: {
        close: function close(type) {
            this.$refs.currentView.onClose(type);
        },
        validate: function validate() {
            this.loading = true;

            if (!this.$refs.currentView.onValidate()) {
                this.loading = false;
            }
        },
        next_step: function next_step() {
            this.loading = true;

            if (!this.$refs.currentView.onNextStep()) {
                this.loading = false;
            }
        }
    },

    created: function created() {
        var _this = this;

        this.$eventHub.$on('open-modal2', function (component) {
            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            _this.isOpen = true;
            _this.currentView = component;
            _this.params = params;

            _this.title = _this.currentView.data().title || null;
            _this.icon = _this.currentView.data().icon || null;
            _this.width = _this.currentView.data().width || '750px';
            _this.fullscreen = _this.currentView.data().fullscreen || false;
            _this.warning = _this.currentView.data().warning || false;
            _this.more_action = _this.currentView.data().more_action || null;
            _this.actions = _this.currentView.data().actions || true;
            _this.next_button = _this.currentView.data().next_button || false;
            _this.cancel_button = _this.currentView.data().cancel_button === false ? false : true;
            _this.valid_button = _this.currentView.data().valid_button === false ? false : true;
            _this.valid_label = _this.currentView.data().valid_label ? _this.currentView.data().valid_label : "Valider";
            _this.cancel_label = _this.currentView.data().cancel_label ? _this.currentView.data().cancel_label : "Annuler";
            _this.card_text_class = _this.currentView.data().card_text_class || 'small-modal-text';
        });

        this.$eventHub.$on('close-modal2', function () {
            _this.loading = false;
            _this.isOpen = false;

            setTimeout(function () {
                _this.currentView = null;
            }, 500);
        });

        this.$eventHub.$on('hide-modal2-actions', function () {
            _this.actions = false;
        });

        this.$eventHub.$on('set-next-button', function (params) {
            _this.next_button = params;
        });

        this.$eventHub.$on('set-valid-button', function (params) {
            _this.valid_button = params;
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09d0163a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/app/Modal2.vue
var Modal2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":_vm.width,"fullscreen":_vm.fullscreen,"persistent":true},on:{"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.warning ? _vm.close('close') : _vm.validate()},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key)){ return null; }_vm.close($event)}]},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_c('v-card',[(_vm.title != null)?_c('v-card-title',{class:{ 'warning' : _vm.warning }},[_c('h2',[(_vm.warning)?_c('v-icon',[_vm._v("warning")]):_vm._e(),_vm._v(" "),(!_vm.warning && _vm.icon)?_c('v-icon',[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.title))])],1),_vm._v(" "),_c('v-btn',{attrs:{"small":"","icon":""},on:{"click":_vm.close}},[_c('v-icon',[_vm._v("close")])],1)],1):_vm._e(),_vm._v(" "),_c('v-card-text',{class:_vm.card_text_class},[(_vm.currentView)?[_c(_vm.currentView,{ref:"currentView",tag:"component",attrs:{"params":_vm.params}})]:_vm._e()],2),_vm._v(" "),(_vm.currentView != null && _vm.actions === true)?_c('v-card-actions',[(_vm.cancel_button)?_c('v-btn',{attrs:{"round":"","small":"","flat":"","color":_vm.warning ? 'warning' : 'primary'},nativeOn:{"click":function($event){_vm.close('cancel')}}},[_vm._v(_vm._s(_vm.cancel_label))]):_vm._e(),_vm._v(" "),(_vm.valid_button)?_c('v-btn',{attrs:{"round":"","depressed":"","small":"","color":_vm.warning ? 'warning' : 'primary',"loading":_vm.loading},nativeOn:{"click":function($event){_vm.validate()}}},[_vm._v(_vm._s(_vm.valid_label))]):_vm._e(),_vm._v(" "),(_vm.next_button)?_c('v-btn',{attrs:{"round":"","depressed":"","small":"","color":_vm.warning ? 'warning' : 'primary',"loading":_vm.loading},nativeOn:{"click":function($event){_vm.next_step()}}},[_vm._v("Suivant")]):_c('div'),_vm._v(" "),(_vm.more_action)?_c('v-btn',{attrs:{"round":"","depressed":"","small":"","color":"primary","loading":_vm.loading},nativeOn:{"click":function($event){_vm.validate_add(false, _vm.currentView)}}},[_vm._v(_vm._s(_vm.more_action))]):_vm._e()],1):_vm._e()],1)],1)}
var Modal2_staticRenderFns = []
var Modal2_esExports = { render: Modal2_render, staticRenderFns: Modal2_staticRenderFns }
/* harmony default export */ var app_Modal2 = (Modal2_esExports);
// CONCATENATED MODULE: ./src/layouts/app/Modal2.vue
function Modal2_injectStyle (ssrContext) {
  __webpack_require__("qOfq")
}
var Modal2_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Modal2___vue_template_functional__ = false
/* styles */
var Modal2___vue_styles__ = Modal2_injectStyle
/* scopeId */
var Modal2___vue_scopeId__ = "data-v-09d0163a"
/* moduleIdentifier (server only) */
var Modal2___vue_module_identifier__ = null
var Modal2_Component = Modal2_normalizeComponent(
  Modal2,
  app_Modal2,
  Modal2___vue_template_functional__,
  Modal2___vue_styles__,
  Modal2___vue_scopeId__,
  Modal2___vue_module_identifier__
)

/* harmony default export */ var layouts_app_Modal2 = (Modal2_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/files/ViewFiles.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ViewFiles = ({
    components: {},
    data: function data() {
        return {
            loading: false,
            dialog: false,
            gallery: [],
            title: '',
            fullscreen: false,
            avatar: null
        };
    },

    methods: {
        // when modal is open
        open: function open(item, items) {
            // open the dialog of file can be viewed on a modal
            if (item.type == 'pdf' || item.type == 'jpg' || item.type == 'JPG' || item.type == 'jpeg' || item.type == 'png' || item.type == 'gif' || item.type == undefined) {
                this.dialog = true;
            }
            // for avatar just fill the avatar data
            if (typeof items == 'string' && items == "avatar") {
                this.avatar = item;
            } else {
                // else, load item & create galery whit files that can be viewed
                this.loadItem(item);
                if (items) {
                    this.gallery = items.filter(function (g) {
                        return g.type == 'pdf' || g.type == 'jpeg' || item.type == 'jpg' || item.type == 'JPG' || g.type == 'png' || g.type == 'gif';
                    });
                } else {
                    this.gallery = item;
                }
            }
        },
        next: function next() {
            // when click on next arrow
            var active = document.querySelector('.frame').id;
            var activeIndex = null;
            this.gallery.forEach(function (i, index) {
                if (i.id == active) {
                    activeIndex = index;
                }
            });
            if (this.gallery[activeIndex + 1]) {
                this.loadItem(this.gallery[activeIndex + 1]);
            } else {
                this.loadItem(this.gallery[0]);
            }
        },
        back: function back() {
            // when click on back arrow
            var active = document.querySelector('.frame').id;
            var activeIndex = null;
            this.gallery.forEach(function (i, index) {
                if (i.id == active) {
                    activeIndex = index;
                }
            });
            if (this.gallery[activeIndex - 1]) {
                this.loadItem(this.gallery[activeIndex - 1]);
            } else {
                this.loadItem(this.gallery[this.gallery.length - 1]);
            }
        },
        loadItem: function loadItem(item) {
            // loading items
            this.loading = true;
            this.title = '';
            // if file can be viewed, just fill the iframe data
            if (item.type == 'pdf' || item.type == 'jpeg' || item.type == 'jpg' || item.type == 'JPG' || item.type == 'png' || item.type == 'gif') {
                // if galery given, with multiple item
                if ((typeof item === 'undefined' ? 'undefined' : typeof_default()(item)) == 'object') {
                    document.querySelector('.frame').id = item.id;
                    document.querySelector('.frame').src = item.path;
                    this.title = item.label;
                } else {
                    // if only one item given
                    document.querySelector('.frame').src = item;
                }
                this.loading = false;
            } else {
                // if file can't be viewed on lightbox, use the download link
                document.querySelector('#link').href = item.path;
                document.querySelector('#link').download = item.label + '.' + item.type;
                document.querySelector('#link').click();
            }
        },
        close: function close() {
            // when dialog is close, reset all
            this.dialog = false;
            this.avatar = null;
            this.fullscreen = false;
            if (document.querySelector('.frame')) {
                document.querySelector('.frame').src = '';
            }
        }
    },
    created: function created() {
        var _this = this;

        // create a bus, to open this viewer from anywhere
        this.$eventHub.$on('view-file', function (item, items) {
            _this.open(item, items);
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-177af3bc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/files/ViewFiles.vue
var ViewFiles_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"link",attrs:{"id":"link","download":"","hidden":""}}),_vm._v(" "),_c('v-dialog',{ref:"modal",attrs:{"max-width":"750px","content-class":"fileView","fullscreen":_vm.fullscreen},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('h2',[_c('span',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!_vm.fullscreen)?_c('v-btn',{attrs:{"small":"","icon":""},on:{"click":function($event){_vm.fullscreen = true}}},[_c('v-icon',[_vm._v("fullscreen")])],1):_c('v-btn',{attrs:{"small":"","icon":""},on:{"click":function($event){_vm.fullscreen = false}}},[_c('v-icon',[_vm._v("fullscreen_exit")])],1),_vm._v(" "),_c('v-btn',{attrs:{"small":"","icon":""},on:{"click":function($event){_vm.close()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('div',{staticClass:"content"},[(_vm.loading)?_c('div',{staticClass:"loader"},[_c('img',{attrs:{"src":__webpack_require__("bwqQ")}})]):_vm._e(),_vm._v(" "),(_vm.avatar == null)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}]},[(this.gallery && this.gallery.length > 0)?_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.back}},[_c('v-icon',[_vm._v("keyboard_arrow_left")])],1):_vm._e(),_vm._v(" "),_c('iframe',{staticClass:"frame",attrs:{"id":"frame"}}),_vm._v(" "),(this.gallery && this.gallery.length > 0)?_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.next}},[_c('v-icon',[_vm._v("keyboard_arrow_right")])],1):_vm._e()],1):_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],staticClass:"img_container"},[(_vm.avatar != null)?_c('img',{attrs:{"src":_vm.avatar}}):_vm._e()])])],1)],1)],1)}
var ViewFiles_staticRenderFns = []
var ViewFiles_esExports = { render: ViewFiles_render, staticRenderFns: ViewFiles_staticRenderFns }
/* harmony default export */ var files_ViewFiles = (ViewFiles_esExports);
// CONCATENATED MODULE: ./src/components/files/ViewFiles.vue
function ViewFiles_injectStyle (ssrContext) {
  __webpack_require__("N0FO")
  __webpack_require__("WxQU")
}
var ViewFiles_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ViewFiles___vue_template_functional__ = false
/* styles */
var ViewFiles___vue_styles__ = ViewFiles_injectStyle
/* scopeId */
var ViewFiles___vue_scopeId__ = "data-v-177af3bc"
/* moduleIdentifier (server only) */
var ViewFiles___vue_module_identifier__ = null
var ViewFiles_Component = ViewFiles_normalizeComponent(
  ViewFiles,
  files_ViewFiles,
  ViewFiles___vue_template_functional__,
  ViewFiles___vue_styles__,
  ViewFiles___vue_scopeId__,
  ViewFiles___vue_module_identifier__
)

/* harmony default export */ var components_files_ViewFiles = (ViewFiles_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/layouts/app/Layout.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var Layout = ({
    components: { AppContent: Content["a" /* default */], AppHeader: Header["a" /* default */], AppNav: layouts_app_Nav, AppAside: layouts_app_Aside, AppModal: Modal["a" /* default */], AppModal2: layouts_app_Modal2, AppSnackbar: layouts_app_Snackbar, ViewFiles: components_files_ViewFiles }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-204fda46","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/app/Layout.vue
var Layout_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-layout"},[_c('app-nav'),_vm._v(" "),_c('div',{staticClass:"app-body",attrs:{"id":"scroll-target"}},[_c('app-header'),_vm._v(" "),_c('app-content')],1),_vm._v(" "),_c('app-aside'),_vm._v(" "),_c('app-snackbar'),_vm._v(" "),_c('app-modal'),_vm._v(" "),_c('app-modal2'),_vm._v(" "),_c('view-files')],1)}
var Layout_staticRenderFns = []
var Layout_esExports = { render: Layout_render, staticRenderFns: Layout_staticRenderFns }
/* harmony default export */ var app_Layout = (Layout_esExports);
// CONCATENATED MODULE: ./src/layouts/app/Layout.vue
function Layout_injectStyle (ssrContext) {
  __webpack_require__("I8Uc")
}
var Layout_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Layout___vue_template_functional__ = false
/* styles */
var Layout___vue_styles__ = Layout_injectStyle
/* scopeId */
var Layout___vue_scopeId__ = "data-v-204fda46"
/* moduleIdentifier (server only) */
var Layout___vue_module_identifier__ = null
var Layout_Component = Layout_normalizeComponent(
  Layout,
  app_Layout,
  Layout___vue_template_functional__,
  Layout___vue_styles__,
  Layout___vue_scopeId__,
  Layout___vue_module_identifier__
)

/* harmony default export */ var layouts_app_Layout = __webpack_exports__["default"] = (Layout_Component.exports);


/***/ }),

/***/ "ri6U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ru2d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s99n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sKkj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sTpe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('nl2br', function (str) {
    if (str) {
        return str.replace(/\n/g, "<br />");
    } else {
        return null;
    }
});

/***/ }),

/***/ "sgbh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t/EI":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "teBh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/entries.js
var entries = __webpack_require__("W3Iv");
var entries_default = /*#__PURE__*/__webpack_require__.n(entries);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/single/SingleCard.vue

//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var SingleCard = ({
    props: {
        title: {
            required: false
        }
    },

    methods: {
        setLabelWidth: function setLabelWidth() {
            // calculate the label width of fields inside a card
            // goal => align labels in cols, with the data-group
            // ex data_group = 1 :  col 1 etc ...
            // and calcultae the number of col to set the size of a field  
            var groups = [];

            entries_default()(this.$el.getElementsByClassName('field')).forEach(function (entry) {
                var el = entry[1];
                var groupId = el.attributes['data-group'].value;

                if (!groups.filter(function (o) {
                    return o.group == groupId;
                }).length) {
                    groups.push({ group: groupId, width: 0 });
                }

                if (el.getElementsByClassName('label') && el.getElementsByClassName('label')[0]) {
                    var labelWidth = el.getElementsByClassName('label')[0].clientWidth;
                    if (labelWidth > groups.filter(function (o) {
                        return o.group == groupId;
                    })[0].width) {
                        groups.filter(function (o) {
                            return o.group == groupId;
                        })[0].width = labelWidth;
                    }
                }
            });

            entries_default()(this.$el.getElementsByClassName('field')).forEach(function (entry) {
                var el = entry[1];
                var groupId = el.attributes['data-group'].value;
                var groupWidth = groups.filter(function (o) {
                    return o.group == groupId;
                })[0].width;
                if (el.getElementsByClassName('label') && el.getElementsByClassName('label')[0]) {
                    var labelWidth = el.getElementsByClassName('label')[0].clientWidth;

                    if (labelWidth < groupWidth) {
                        el.getElementsByClassName('label')[0].style.width = groupWidth + 'px';
                    }
                }
            });
        }
    },

    mounted: function mounted() {
        this.setLabelWidth();
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ec97ba4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/single/SingleCard.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"single-card elevation-0"},[(_vm.title)?_c('v-card-title',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),_c('v-card-text',[_vm._t("content")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var single_SingleCard = (esExports);
// CONCATENATED MODULE: ./src/components/single/SingleCard.vue
function injectStyle (ssrContext) {
  __webpack_require__("i0v3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7ec97ba4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  SingleCard,
  single_SingleCard,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_single_SingleCard = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "twT4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/DataTable.vue + 2 modules
var DataTable = __webpack_require__("/WHI");

// EXTERNAL MODULE: ./src/components/files/DeleteFiles.vue + 2 modules
var DeleteFiles = __webpack_require__("MJ/k");

// EXTERNAL MODULE: ./src/components/files/CreateFiles.vue + 2 modules
var CreateFiles = __webpack_require__("/iAd");

// EXTERNAL MODULE: ./src/components/files/UpdateFiles.vue + 2 modules
var UpdateFiles = __webpack_require__("Hhha");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/products/single/Files.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






moment_default.a.locale('fr');

/* harmony default export */ var Files = ({

    components: { DataTable: DataTable["a" /* default */], UpdateFiles: UpdateFiles["a" /* default */], CreateFiles: CreateFiles["a" /* default */], DeleteFiles: DeleteFiles["a" /* default */] },

    data: function data() {
        var _this = this;

        return {
            moment: moment_default.a,
            datatable: {
                toolbar: [{ icon: 'delete', callback: function callback() {
                        _this.$eventHub.$emit('open-modal', DeleteFiles["a" /* default */], { entity: 'products' });
                    }, level: 60 }],
                actions: [{ text: 'Ajouter un fichier', icon: "add_circle", callback: function callback() {
                        _this.$eventHub.$emit('open-modal', CreateFiles["a" /* default */], { entity: 'products' });
                    }, level: 60 }],
                headers: [{ text: 'Nom', sortable: true, value: 'name', align: 'left' }, { text: 'Date de l\'ajout', sortable: true, value: 'created_at', align: 'right' }, { text: 'Auteur', sortable: false, value: 'created_by', align: 'right' }, { text: 'Type', sortable: true, value: 'type', align: 'right' }, { text: 'Action', sortable: false, value: 'action' }],
                endpoint: {
                    base: '/api/files',
                    filters: 'products.id|=|' + this.$route.params.id,
                    embed: ''
                }
            },
            users: [],
            items: []
        };
    },


    methods: {
        rowClick: function rowClick(item) {
            this.$eventHub.$emit('view-file', item, this.items);
        },
        update_count: function update_count(count) {
            this.$store.dispatch('updateSingleData', { key: 'files_count', value: count });
            this.$store.dispatch('updateSingleData', { key: 'files', value: this.$refs.list.items });
        }
    },
    created: function created() {
        var _this2 = this;

        this.$eventHub.$on('reload-list', function () {
            if (_this2.$refs.list) {
                _this2.$refs.list.reload();
            }
        });
        this.$eventHub.$on('getItems', function (items) {
            _this2.items = items;
        });
    },
    mounted: function mounted() {
        var _this3 = this;

        this.axios.get('/api/users').then(function (response) {
            _this3.users = response.data;
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f028ccd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/single/Files.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-files"},[_c('data-table',{ref:"list",attrs:{"headers":_vm.datatable.headers,"endpoint":_vm.datatable.endpoint,"toolbar":_vm.datatable.toolbar,"actions":_vm.datatable.actions,"views":_vm.datatable.views,"storeId":"files","selectable":"","isFixed":false},on:{"rowClick":_vm.rowClick,"total_updated":_vm.update_count},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v("\n                "+_vm._s(props.item.label)+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n                "+_vm._s(_vm.moment(props.item.created_at).format('L'))+"\n            ")]),_vm._v(" "),(_vm.$_.find(_vm.users,function (u) { return u.id == props.item.created_by; }))?_c('td',{staticClass:"text-xs-right"},[_vm._v("\n                "+_vm._s(_vm.$_.find(_vm.users,function (u) { return u.id == props.item.created_by; }).first_name)+" "+_vm._s(_vm.$_.find(_vm.users,function (u) { return u.id == props.item.created_by; }).last_name)+"\n            ")]):_c('td',{staticClass:"text-xs-right"},[_vm._v("\n                -\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v("\n                "+_vm._s(props.item.type)+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-btn',{attrs:{"small":"","icon":"","disabled":_vm.$store.state.auth.user.level < 60},on:{"click":function($event){$event.stopPropagation();_vm.$refs.updatefile.open(props.item)}}},[_c('v-icon',[_vm._v("mode_edit")])],1)],1)]}}])}),_vm._v(" "),_c('update-files',{ref:"updatefile",attrs:{"entity":"products"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var single_Files = (esExports);
// CONCATENATED MODULE: ./src/views/products/single/Files.vue
function injectStyle (ssrContext) {
  __webpack_require__("2zFI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1f028ccd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Files,
  single_Files,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var products_single_Files = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "u84t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u9Bb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uOwT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/config/enum/ProductTypes.js
var ProductTypes = __webpack_require__("mdcO");

// EXTERNAL MODULE: ./src/config/enum/CommentTypes.js
var CommentTypes = __webpack_require__("22+B");

// EXTERNAL MODULE: ./src/views/projects/single/DeleteProduct.vue + 2 modules
var DeleteProduct = __webpack_require__("MzQT");

// EXTERNAL MODULE: ./src/views/projects/single/ProductAside.vue + 2 modules
var ProductAside = __webpack_require__("9B81");

// EXTERNAL MODULE: ./src/views/projects/single/CreateProduct.vue + 2 modules
var CreateProduct = __webpack_require__("YGX0");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/projects/single/Competitors.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var Competitors = ({
	data: function data() {
		return {
			selected: null
		};
	},

	computed: {
		competitor_products: function competitor_products() {
			return this.$store.state.single.data.competitor_products;
		}
	},
	methods: {
		createProduct: function createProduct() {
			this.$eventHub.$emit('open-modal', CreateProduct["a" /* default */], { type: 'competitor', project_id: this.$store.state.single.data.id });
		},
		openProduct: function openProduct(productId, productIndex, productType) {
			if (this.selected === productId) {
				this.$eventHub.$emit('close-aside');
			} else {
				this.$eventHub.$emit('close-aside');
				this.$eventHub.$emit('open-aside', ProductAside["a" /* default */], {
					product_id: productId,
					product_index: productIndex,
					product_type: productType
				});
				this.selected = productId;
			}
		},
		goToProduct: function goToProduct(productId, groupLabel) {
			this.$router.push({ name: 'single-product', params: { id: productId, group: groupLabel } });
		},
		deleteProduct: function deleteProduct(product) {
			this.$eventHub.$emit('open-modal', DeleteProduct["a" /* default */], { product: product });
		},
		getCommentColor: function getCommentColor(index) {
			return CommentTypes["a" /* CommentTypes */][index].color;
		},
		getCommentCount: function getCommentCount(product, index) {
			return product.comments.reduce(function (sum, el) {
				return el.type === CommentTypes["a" /* CommentTypes */][index].value ? sum + 1 : sum;
			}, 0);
		}
	},
	created: function created() {
		var _this = this;

		this.$eventHub.$on('close-aside', function () {
			_this.selected = null;
		});
	},
	beforeDestroy: function beforeDestroy() {
		this.$eventHub.$emit('close-aside');
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd74d6a4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/projects/single/Competitors.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"test"},[_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('div',{staticClass:"actions"},[(_vm.$store.state.auth.user.level >= 60)?_c('v-btn',{staticClass:"normal",attrs:{"round":"","outline":"","color":"primary","small":""},on:{"click":function($event){_vm.createProduct()}}},[_c('v-icon',{attrs:{"left":"","color":"primary"}},[_vm._v("add_circle")]),_vm._v("\n                        Ajouter un produit\n                    ")],1):_vm._e()],1)]),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","row":""}},_vm._l((_vm.competitor_products),function(product,index){return _c('v-flex',{key:product.id,attrs:{"xs12":"","md6":"","lg3":""}},[_c('v-card',{staticClass:"product-card",class:{'selected-card' : _vm.selected === product.id}},[_c('v-card-media',{on:{"click":function($event){_vm.openProduct(product.id, index, 'competitor')}}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('img',{class:{'have-product-img' : product.photo !== null},attrs:{"src":product.photo === null ? __webpack_require__("jfOg") : product.photo}})])],1),_vm._v(" "),_c('v-card-title',{attrs:{"secondary-title":""},on:{"click":function($event){_vm.openProduct(product.id, index, 'competitor')}}},[_c('div',[_c('p',{staticClass:"product-label mb-0"},[_vm._v(_vm._s(product.label))]),_vm._v(" "),_c('p',{staticClass:"product-supplier"},[(product.supplier)?[_vm._v("\n                                    "+_vm._s(product.supplier.name)+"\n                                ")]:_vm._e()],2)])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-menu',[_c('div',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-icon',{attrs:{"flat":""}},[_vm._v("more_horiz")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{staticClass:"li",on:{"click":function($event){_vm.goToProduct(product.id, product.group)}}},[_vm._v("\n                                    Ouvrir la fiche\n                                ")]),_vm._v(" "),(_vm.$store.state.auth.user.level >= 60)?_c('v-list-tile',{staticClass:"li",on:{"click":function($event){_vm.deleteProduct(product)}}},[_vm._v("\n                                    Supprimer la fiche\n                                ")]):_vm._e()],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right comments-indicator",on:{"click":function($event){_vm.openProduct(product.id, index, 'competitor')}}},[_vm._v("\n                            "+_vm._s(_vm.getCommentCount(product,0))+" "),_c('v-icon',{style:({color:_vm.getCommentColor(0)})},[_vm._v("fiber_manual_record")]),_vm._v("\n                            "+_vm._s(_vm.getCommentCount(product,1))+" "),_c('v-icon',{style:({color:_vm.getCommentColor(1)})},[_vm._v("fiber_manual_record")]),_vm._v("\n                            "+_vm._s(_vm.getCommentCount(product,2))+" "),_c('v-icon',{style:({color:_vm.getCommentColor(2)})},[_vm._v("fiber_manual_record")])],1)],1)],1)],1)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var single_Competitors = (esExports);
// CONCATENATED MODULE: ./src/views/projects/single/Competitors.vue
function injectStyle (ssrContext) {
  __webpack_require__("wcVS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bd74d6a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Competitors,
  single_Competitors,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var projects_single_Competitors = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "udw/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ufes":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo_sidamo.f69cedc.png";

/***/ }),

/***/ "ujoQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "um4F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "vwCv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w+IP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/layouts/app/Modal.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Modal = ({
    data: function data() {
        return {
            isOpen: false,
            currentView: null,
            more_action: null,
            params: {},
            title: null,
            icon: null,
            width: null,
            warning: false,
            loading: false,
            actions: true,
            next_button: false,
            valid_button: true,
            valid_label: "Valider",
            cancel_button: true,
            fullscreen: false,
            card_text_class: '',
            disableEnter: false
        };
    },


    methods: {
        close: function close() {
            // on click validate, call tha close action of the component given
            this.$refs.currentView.onClose();
        },
        validate: function validate() {
            // on click validate, call tha validate action of the component given
            this.loading = true;

            if (!this.$refs.currentView.onValidate()) {
                // this.loading = false
            }
        },
        next_step: function next_step() {
            // on click validate, call tha validate action of the component given
            this.loading = true;

            if (!this.$refs.currentView.onNextStep()) {
                // this.loading = false
            }
        }
    },

    created: function created() {
        var _this = this;

        // on open modal, initate data = get the title, the icon ... from the component given
        this.$eventHub.$on('open-modal', function (component) {
            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            _this.isOpen = true;
            _this.currentView = component;
            _this.params = params;

            _this.title = _this.currentView.data().title || null;
            _this.icon = _this.currentView.data().icon || null;
            _this.width = _this.currentView.data().width || '750px';
            _this.fullscreen = _this.currentView.data().fullscreen || false;
            _this.warning = _this.currentView.data().warning || false;
            _this.more_action = _this.currentView.data().more_action || null;
            _this.actions = _this.currentView.data().actions || true;
            _this.next_button = _this.currentView.data().next_button || false;
            _this.cancel_button = _this.currentView.data().cancel_button === false ? false : true;
            _this.valid_button = _this.currentView.data().valid_button === false ? false : true;
            _this.valid_label = _this.currentView.data().valid_label ? _this.currentView.data().valid_label : "Valider";
            _this.card_text_class = _this.currentView.data().card_text_class || 'small-modal-text';
            _this.disableEnter = _this.currentView.data().disableEnter || false;
        });

        // on close reinit
        this.$eventHub.$on('close-modal', function () {
            _this.loading = false;
            _this.isOpen = false;

            setTimeout(function () {
                _this.currentView = null;
            }, 500);
        });

        // to hide actions of the modal
        this.$eventHub.$on('hide-modal-actions', function () {
            _this.actions = false;
        });

        // to show actions of the modal
        this.$eventHub.$on('show-modal-actions', function () {
            _this.actions = true;
        });
        // set the next button (for the convert modal)
        this.$eventHub.$on('set-next-button', function (params) {
            _this.next_button = params;
            _this.loading = false;
        });
        // show the validation button (convert modal)
        this.$eventHub.$on('set-valid-button', function (params) {
            _this.valid_button = params;
        });
        // stop loading
        this.$eventHub.$on('stop_loading', function () {
            _this.loading = false;
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-441d003e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/app/Modal.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":_vm.width,"fullscreen":_vm.fullscreen,"persistent":true},on:{"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.warning ? _vm.close() : _vm.disableEnter ? '' : _vm.validate()},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key)){ return null; }_vm.close($event)}]},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_c('v-card',[(_vm.title != null)?_c('v-card-title',{class:{ 'warning' : _vm.warning }},[_c('h2',[(_vm.warning)?_c('v-icon',[_vm._v("warning")]):_vm._e(),_vm._v(" "),(!_vm.warning && _vm.icon)?_c('v-icon',[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.title))])],1),_vm._v(" "),_c('v-btn',{attrs:{"small":"","icon":""},on:{"click":_vm.close}},[_c('v-icon',[_vm._v("close")])],1)],1):_vm._e(),_vm._v(" "),_c('v-card-text',{class:_vm.card_text_class},[(_vm.currentView)?[_c(_vm.currentView,{ref:"currentView",tag:"component",attrs:{"params":_vm.params}})]:_vm._e()],2),_vm._v(" "),(_vm.currentView != null && _vm.actions === true)?_c('v-card-actions',[(_vm.cancel_button)?_c('v-btn',{attrs:{"round":"","small":"","flat":"","color":_vm.warning ? 'warning' : 'primary'},nativeOn:{"click":function($event){_vm.close($event)}}},[_vm._v("Annuler")]):_vm._e(),_vm._v(" "),(_vm.valid_button)?_c('v-btn',{attrs:{"round":"","depressed":"","small":"","color":_vm.warning ? 'warning' : 'primary',"loading":_vm.loading},nativeOn:{"click":function($event){_vm.validate()}}},[_vm._v(_vm._s(_vm.valid_label))]):_vm._e(),_vm._v(" "),(_vm.next_button)?_c('v-btn',{attrs:{"round":"","depressed":"","small":"","color":_vm.warning ? 'warning' : 'primary',"loading":_vm.loading},nativeOn:{"click":function($event){_vm.next_step()}}},[_vm._v("Suivant")]):_c('div'),_vm._v(" "),(_vm.more_action)?_c('v-btn',{attrs:{"round":"","depressed":"","small":"","color":"primary","loading":_vm.loading},nativeOn:{"click":function($event){_vm.validate_add(false, _vm.currentView)}}},[_vm._v(_vm._s(_vm.more_action))]):_vm._e()],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var app_Modal = (esExports);
// CONCATENATED MODULE: ./src/layouts/app/Modal.vue
function injectStyle (ssrContext) {
  __webpack_require__("6cZL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-441d003e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Modal,
  app_Modal,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var layouts_app_Modal = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wRGB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/components/avatar/Avatar.vue + 3 modules
var Avatar = __webpack_require__("Be47");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/avatar/UploadAvatar.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var UploadAvatar = ({
    components: { Avatar: Avatar["a" /* default */] },

    props: {
        size: {
            type: String,
            required: false,
            default: '10rem'
        },
        item: {
            type: Object,
            required: true
        },
        isEditable: {
            type: Boolean,
            required: false,
            default: false
        },
        entities: {
            type: String,
            required: true
        },
        field: {
            type: String,
            required: true
        },
        itemId: {
            type: Number,
            required: false
        },
        defaultImg: {
            required: false
        },
        storeKey: {
            required: false
        }
    },

    data: function data() {
        return {
            show: false,
            items: [],
            confirmRemove: false
        };
    },

    methods: {
        // change the menu if image already here or not
        changeMenu: function changeMenu() {
            var actualData = void 0;
            if (this.storeKey) {

                var path = this.$store.state.single.data;
                var split = this.storeKey.split('.');

                split.forEach(function (item, index) {
                    if (index + 1 < split.length) {
                        var start = item.indexOf('[');
                        var end = item.indexOf(']');
                        if (start > -1 && end > -1) {
                            var i = item.substring(start + 1, end);
                            path = path[item.substring(0, start)];
                            path = path[i];
                        } else {
                            path = path[item];
                        }
                    } else {
                        actualData = path[item];
                    }
                });
            } else {
                actualData = this.$store.state.single.data[this.field];
            }

            if (actualData != null) {
                this.items = [{ title: 'Sélectionner une nouvelle image', action: 'updateImg' }, { title: 'Supprimer l\'image actuelle', action: 'deleteImg' }];
            } else {
                this.items = [{ title: 'Sélectionner une image', action: 'updateImg' }];
            }
            this.show = true;
        },

        // click on menu item
        menuActions: function menuActions(item) {
            if (item.action == 'updateImg') {
                this.$refs.fileInput.click();
            } else if (item.action == "deleteImg") {
                this.confirmRemove = true;
            }
        },

        // when file is charged
        onFileChange: function onFileChange(event) {
            var _this = this;

            var acceptType = ['image/png', 'image/jpeg', 'image/gif'];
            var file = event.target.files[0];
            if (acceptType.includes(file.type)) {
                this.attachment = file;
                this.selectedImg = file.name;
                // created data element
                var data = new FormData();
                // put the file & size (resize on back)
                data.append('file', this.attachment);
                data.append('size', 750);
                // post the data item
                this.axios.post('/api/' + this.entities + '/' + (this.itemId ? this.itemId : this.$route.params.id) + '/file/field/' + this.field, data, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(function (response) {
                    _this.$store.dispatch('updateSingleData', { key: _this.storeKey != null ? _this.storeKey : _this.field, value: response.data });
                }).catch(function (error) {
                    _this.$eventHub.$emit('open-snackbar', 'error', 'Un problème est survenu');
                });
            }
        },

        // method to remove file
        removeFile: function removeFile() {
            var _this2 = this;

            this.axios.delete('/api/' + this.entities + '/' + (this.itemId ? this.itemId : this.$route.params.id) + '/file/field/' + this.field).then(function (response) {
                _this2.$store.dispatch('updateSingleData', { key: _this2.storeKey != null ? _this2.storeKey : _this2.field, value: null });
                _this2.confirmRemove = false;
            }).catch(function (error) {
                _this2.$eventHub.$emit('open-snackbar', 'error', 'Un problème est survenu');
            });
        }
    }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32717f8e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/avatar/UploadAvatar.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single-avatar"},[_c('v-menu',{attrs:{"offset-y":""}},[_c('div',{attrs:{"slot":"activator"},slot:"activator"},[_c('avatar',{attrs:{"defaultImg":_vm.defaultImg,"field":_vm.field,"size":_vm.size,"item":_vm.item},nativeOn:{"click":function($event){_vm.changeMenu()}}}),_vm._v(" "),_c('div',{staticClass:"overlay",style:('width: ' + _vm.size + '; height: ' + _vm.size + ';')},[_c('v-icon',[_vm._v("mode_edit")])],1)],1),_vm._v(" "),_c('v-list',_vm._l((_vm.items),function(item){return _c('v-list-tile',{key:item.title,staticClass:"li",on:{"click":function($event){_vm.menuActions(item)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))])],1)}))],1),_vm._v(" "),_c('input',{ref:"fileInput",staticStyle:{"display":"none"},attrs:{"type":"file"},on:{"change":_vm.onFileChange}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"750px"},model:{value:(_vm.confirmRemove),callback:function ($$v) {_vm.confirmRemove=$$v},expression:"confirmRemove"}},[_c('v-card',[_c('v-card-title',{staticClass:"warning"},[_c('h2',[_c('v-icon',[_vm._v("warning")]),_vm._v(" "),_c('span',[_vm._v("Attention")])],1),_vm._v(" "),_c('v-btn',{attrs:{"small":"","icon":""},on:{"click":function($event){_vm.confirmRemove = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_vm._v("\n                 Voulez vous vraiment supprimer l'avatar ?\n             ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"round":"","small":"","outline":"","color":"warning"},nativeOn:{"click":function($event){_vm.confirmRemove = false;}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"round":"","depressed":"","small":"","color":"warning"},nativeOn:{"click":function($event){_vm.removeFile($event)}}},[_vm._v("Valider")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var avatar_UploadAvatar = (esExports);
// CONCATENATED MODULE: ./src/components/avatar/UploadAvatar.vue
function injectStyle (ssrContext) {
  __webpack_require__("RVXe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-32717f8e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  UploadAvatar,
  avatar_UploadAvatar,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_avatar_UploadAvatar = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wcVS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xb2K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yZFr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yaQ0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zySI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.2ecf2d633367dbacc896.js